// v3 - world standard fixes
import { useState, useEffect, useRef, useCallback } from "react";

// Force favicon - permanently overrides React default
(function(){
  const FAVICON = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAEpElEQVR4nO2dQXLUMBBFv0lOwCIcgWITihtwII6TFafJDaiw4whhQXGAUGITTZSJZzy2u1vdrf92U5WyZf2v3z3y2AEIIYQQQgghhBBCCCH5mXoPwIpSSlnz99M0DTE3aS9yreBLZDVEmouaE/zH+48ix/7y59erz5nMEP5CWuGlBD/HsRmA2IYIO3DgRXwL4U8R3RBhBtriQfhTRDOE24HNYR33Eng3hJuBLBFR/DlaQ3gwQvcBXEIW8Vu8GMG9ATKK39L7K6ZrA2QX/5geqeDWAKOJ32JphHeaB9/KyOIDr69Zekv7GHcGGF38itW1uzIAxZ9HMwXcGIDiv8WiFLgwAMU/jbYJuhqgPFM/U/x5NOflWu3IC1D4bZRSiuRXwy4JQPHXo1UKzA1A8bejMV+mBqD4+6nzJpUCZgag+PJImMC8BFD8/Uj2AyYG0N7PHhGphaRuAEa/HhL9gKoBKL4dW01gUgIovh5751bNAKz7duwpBSoGYPTHQbUEUHz/qBmA4sdA3ACs/X3Y2geo3Q6+vf+rdWgiiItfBJF+qBjg388PGoclCogagPW/H1e3jwDWP0jCEjA4NMDgiBmgxj/rfyyYAAnYWv8BYQNw9cdDxADs/vtRV/9Whi8B159/9x6CCFsfFtltADZ//di7+oHBE6Cu/ogp0Iq/51GxoQ2Qgb3PCe42QB2ARBxZEnHVVyTnmgnwTBRDSEV/ZUgDRBH7HFKPiIsYIGoZiIbG/A6XAOdWf5RkkHxBRLc3hGggIeAlx3h6uNl9Hi+IJYCHMmAhTG/xpd8cmioBgBeBpOO8t/BaCyttDyApWG/xNRE1gId/gNAiIVxm8QGFt4V7vTm0tiR4E/7q9lFlgaUtAcesEdSj+FoMYwAyj7gBvPUBlTUlIMqGkARqCcBtYTk0+6mhS8DTw427en+OdG8Lt2Iu0lvh54wwShlQMYCHbeFTnFv1kdJAivQJ0K7kSwRuDeIpBbT6ADUDePo2sKXWe00D6T5AVSSvu4JR2fMI2CnSlwByHlUDeG4GI1KTNPR/DCG+UDeAp2YwA9IpYJYALAM+MTEAU0AWyRQw7QGYAv4w+1HoNE1TKaVcf/9kdcrUlLugj4aVu3vrU6ZDcg5NDcBeQA5XzwauhSmwHem5MzdAdS5NsJ46Z7wXMCBaC6aLAZgC62jnSbqPYgI4R1N8oKMBmALLaIsPMAHcYiE+oPyLoEto97Onb187jsQPVuIDDgxQqUYY2QSWwh/OY3GSNYxqhB7iAw4NALy9zZnZDL2EP5zT+oRryN4f9BYfcG4AIG8aeBAfCPA1cHqmfs62b9D7Dql7A1QymUDjps5Wug9gLdFLgpfoP4yh9wC2ErFB9CY+EKgEHBOtJHgUHwhsACCOCbyKDwQ3AOBvQo/xLD6QwACA31vL3sUHkhigxYsJIogPJDKAp34givhAIgMAPkwQSXwg8D7AEtb7BNGEr6RKgBbLNIgqPpA4AVq00iCy8JWQg96CpAmOEyWq+MBABqjsNUKGVd8S/gK2stYImVZ9S4qL2MOSEbIKX0l1MXs59c6dbKKTBTTey08IIYQQQgghhDjgP0SuQldDxCDzAAAAAElFTkSuQmCC";
  function setFavicon(){
    // Remove all existing favicons
    document.querySelectorAll('link[rel*="icon"]').forEach(el=>el.remove());
    // Set new one
    const link = document.createElement('link');
    link.rel = 'icon';
    link.type = 'image/png';
    link.href = FAVICON;
    document.head.appendChild(link);
    // Also set apple touch icon
    const apple = document.createElement('link');
    apple.rel = 'apple-touch-icon';
    apple.href = FAVICON;
    document.head.appendChild(apple);
  }
  // Set immediately and on load
  setFavicon();
  window.addEventListener('load', setFavicon);
})();


// == Tabler Icons ==============================================================
const _tablerLink = document.createElement("link");
_tablerLink.rel = "stylesheet";
_tablerLink.href = "https://cdn.jsdelivr.net/npm/@tabler/icons-webfont@2.44.0/tabler-icons.min.css";
document.head.appendChild(_tablerLink);

// == Leaflet map library =======================================================
const _leafCSS = document.createElement("link");
_leafCSS.rel = "stylesheet";
_leafCSS.href = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";
document.head.appendChild(_leafCSS);
const _clusterCSS1 = document.createElement("link");
_clusterCSS1.rel = "stylesheet";
_clusterCSS1.href = "https://unpkg.com/leaflet.markercluster@1.5.3/dist/MarkerCluster.css";
document.head.appendChild(_clusterCSS1);
const _clusterCSS2 = document.createElement("link");
_clusterCSS2.rel = "stylesheet";
_clusterCSS2.href = "https://unpkg.com/leaflet.markercluster@1.5.3/dist/MarkerCluster.Default.css";
document.head.appendChild(_clusterCSS2);

function loadLeaflet(){
  return new Promise(res=>{
    if(window.L){res(window.L);return;}
    const s=document.createElement("script");
    s.src="https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
    s.onload=()=>res(window.L);
    document.head.appendChild(s);
  });
}
function loadLeafletHeat(){
  return new Promise(res=>{
    if(window.L&&window.L.heatLayer){res();return;}
    const s=document.createElement("script");
    s.src="https://unpkg.com/leaflet.heat@0.2.0/dist/leaflet-heat.js";
    s.onload=()=>res();s.onerror=()=>res();
    document.head.appendChild(s);
  });
}
function loadLeafletCluster(){
  return new Promise(res=>{
    if(window.L&&window.L.markerClusterGroup){res();return;}
    const s=document.createElement("script");
    s.src="https://unpkg.com/leaflet.markercluster@1.5.3/dist/leaflet.markercluster.js";
    s.onload=()=>res();s.onerror=()=>res();
    document.head.appendChild(s);
  });
}

// == API KEY ===================================================================

// == Backend API ===============================================================
const API_BASE = "https://api.mysafeghana.com/api";

// ============================================================================
// == ALERT SYSTEM =============================================================
// ============================================================================

const ALERT_TYPES = [
  { id:"heavy-rain",    label:"Heavy Rainfall",        icon:"ti-cloud-rain",    color:"#1565C0", bg:"#E3F2FD", sound:"rain",    severity:"warning",  desc:"Severe rainfall warning. Risk of flooding and reduced visibility." },
  { id:"flood",         label:"Flash Flood",           icon:"ti-ripple",        color:"#0277BD", bg:"#E1F5FE", sound:"flood",   severity:"critical", desc:"Flash flood alert. Avoid low-lying areas and waterways." },
  { id:"extreme-heat",  label:"Extreme Heat",          icon:"ti-sun-high",      color:"#E65100", bg:"#FFF3E0", sound:"heat",    severity:"warning",  desc:"Dangerous heat conditions. Stay hydrated and avoid direct sun." },
  { id:"harmattan",     label:"Harmattan Dust Storm",  icon:"ti-wind",          color:"#795548", bg:"#EFEBE9", sound:"wind",    severity:"advisory", desc:"Heavy dust haze. Poor visibility. Cover nose and mouth." },
  { id:"wildfire",      label:"Wildfire / Bush Fire",  icon:"ti-flame",         color:"#BF360C", bg:"#FBE9E7", sound:"fire",    severity:"critical", desc:"Active wildfire reported. Evacuate affected areas immediately." },
  { id:"robbery",       label:"Live Robbery",          icon:"ti-alert-triangle",color:"#B71C1C", bg:"#FFEBEE", sound:"crime",   severity:"critical", desc:"Active armed robbery in progress. Avoid the area. Call 191." },
  { id:"shooting",      label:"Shooting / Gunfire",    icon:"ti-crosshair",     color:"#880E4F", bg:"#FCE4EC", sound:"crime",   severity:"critical", desc:"Shots fired reported. Seek shelter immediately. Call 191." },
  { id:"kidnapping",    label:"Kidnapping Alert",      icon:"ti-user-exclamation",color:"#4A148C",bg:"#F3E5F5",sound:"crime",  severity:"critical", desc:"Kidnapping alert issued. Be vigilant. Contact police immediately." },
  { id:"road-accident", label:"Road Accident",         icon:"ti-car-crash",     color:"#F57F17", bg:"#FFFDE7", sound:"accident",severity:"warning",  desc:"Serious road accident. Emergency services deployed. Avoid route." },
  { id:"road-closure",  label:"Road Closure",          icon:"ti-road-off",      color:"#4E342E", bg:"#EFEBE9", sound:"info",    severity:"advisory", desc:"Road closed due to emergency or construction. Seek alternate route." },
  { id:"power-outage",  label:"Power Outage",          icon:"ti-bolt-off",      color:"#37474F", bg:"#ECEFF1", sound:"info",    severity:"advisory", desc:"Widespread power outage reported. ECG is working to restore supply." },
  { id:"gas-leak",      label:"Gas / Chemical Leak",   icon:"ti-droplet-exclamation",color:"#1B5E20",bg:"#E8F5E9",sound:"hazmat",severity:"critical",desc:"Hazardous gas or chemical leak. Evacuate immediately. Do not use fire." },
  { id:"stampede",      label:"Crowd Stampede",        icon:"ti-run",           color:"#6A1B9A", bg:"#F3E5F5", sound:"crime",   severity:"critical", desc:"Crowd crush / stampede reported. Avoid crowded areas." },
  { id:"epidemic",      label:"Disease Outbreak",      icon:"ti-virus",         color:"#2E7D32", bg:"#E8F5E9", sound:"health",  severity:"warning",  desc:"Disease outbreak alert. Follow public health guidelines." },
  { id:"missing-person",label:"Missing Person",        icon:"ti-user-search",   color:"#1565C0", bg:"#E3F2FD", sound:"info",    severity:"advisory", desc:"Missing person alert issued. Contact police with any information." },
  { id:"tsunami",       label:"Tsunami / Coastal Alert",icon:"ti-ripple",        color:"#0D47A1", bg:"#E3F2FD", sound:"flood",   severity:"critical", desc:"Coastal hazard alert. Move inland immediately to higher ground." },
];

// - Translations -
const TRANSLATIONS = {
  en: {
    appTagline:"Your Community Safety Platform · Ghana",
    safetyMap:"Safety Map", report:"Report", alerts:"Alerts", floods:"Floods",
    incidents:"Incidents", cameras:"Cameras", myDashboard:"My Dashboard",
    reportIncident:"Report Incident", signIn:"Sign In", requestDemo:"Request Demo",
    searchPlaceholder:"Search place, Ghana Post, business...",
    search:"Search", allCrimeTypes:"All Crime Types", allSeverities:"All Severities",
    drawPolygon:"Draw Polygon", polygonFilter:"Polygon Filter",
    camerasOn:"Cameras ON", camerasOff:"Cameras OFF",
    floodsOn:"Floods ON", floodsOff:"Floods OFF",
    bordersOn:"Borders ON", bordersOff:"Borders OFF",
    poiOn:"POI ON", poiOff:"POI OFF",
    heatmapOn:"Heatmap ON", heatmapOff:"Heatmap OFF",
    clickToAddPoints:"Click to add points - click 1st point to close",
    cancel:"Cancel", topRiskZones:"TOP RISK ZONES", low:"Low",
    recentIncidents:"Recent Incidents", viewAll:"View all",
    regionalRiskScores:"Regional Risk Scores", floodReports:"Flood Reports",
    totalIncidents:"Total Incidents", highCritical:"High / Critical",
    camerasOnline:"Cameras Online", publicSafetyAlerts:"Public Safety Alerts",
    officialAlerts:"Official alerts from Ghana Police Service, NADMO and Emergency Services",
    getSmsAlerts:"Get SMS alerts on your phone",
    smsSubDesc:"Receive critical safety alerts via SMS even without internet. Ghana numbers only (+233).",
    subscribe:"Subscribe", activeAlerts:"Active Alerts", alertHistory:"Alert History",
    poweredBy:"Powered by", language:"Language",
  },
  tw: { // Twi (Akan)
    appTagline:"Wo Oman Ahotoso Platform · Ghana",
    safetyMap:"Ahotoso Map", report:"Bɔ Amaneɛ", alerts:"Mmra Kɛse", floods:"Nsuyiri",
    incidents:"Asɛm", cameras:"Sihyɛnkamera", myDashboard:"Me Dashboard",
    reportIncident:"Bɔ Asɛm Amaneɛ", signIn:"Wo Kɔ", requestDemo:"Bisa Demo",
    searchPlaceholder:"Hwehwɛ baabi, Ghana Post, adwumayɛbea...",
    search:"Hwehwɛ", allCrimeTypes:"Abɔneɛ nyinaa", allSeverities:"Drɛ nyinaa",
    drawPolygon:"Twa Shape", polygonFilter:"Shape Filter",
    camerasOn:"Sihyɛnkamera WO", camerasOff:"Sihyɛnkamera ADE",
    floodsOn:"Nsuyiri WO", floodsOff:"Nsuyiri ADE",
    bordersOn:"Mmɔdan WO", bordersOff:"Mmɔdan ADE",
    poiOn:"Abaebea WO", poiOff:"Abaebea ADE",
    heatmapOn:"Heatmap WO", heatmapOff:"Heatmap ADE",
    clickToAddPoints:"Klik na yɛde ponente - klik ponente 1st na yɛde",
    cancel:"Gyae", topRiskZones:"ABƆNE BEAE TITIRIW", low:"KumKum",
    recentIncidents:"Asɛm Akyire", viewAll:"Hwɛ nyinaa",
    regionalRiskScores:"Aman Abɔne Nnɔma", floodReports:"Nsuyiri Amanneɛ",
    totalIncidents:"Asɛm Nyinaa", highCritical:"Kɛse / Tia",
    camerasOnline:"Sihyɛnkamera Wɔ Line", publicSafetyAlerts:"Oman Ahotoso Mmra",
    officialAlerts:"Mmra firi Ghana Police, NADMO ne Mmuaeɛhyɛfo",
    getSmsAlerts:"Nya SMS mmra wo fɔn mu",
    smsSubDesc:"Nya mmra kɛse via SMS da biara. Ghana fɔn nkutoo (+233).",
    subscribe:"Kɔ", activeAlerts:"Mmra a Wɔwɔ Hɔ", alertHistory:"Mmra Teteɛ",
    poweredBy:"Asiesɛm firi", language:"Kasa",
  },
  ga: { // Ga
    appTagline:"Ni Mli Hiɛ Saafei Platform · Ghana",
    safetyMap:"Saafei Map", report:"Gbɛi Shi", alerts:"Lɛ Kɛɛ", floods:"Ngmɛi",
    incidents:"Hiɛlɛ", cameras:"Camera", myDashboard:"Mi Dashboard",
    reportIncident:"Gbɛi Hiɛlɛ Shi", signIn:"Tswa Kɛ", requestDemo:"Jɛ Demo",
    searchPlaceholder:"Yiwɔ shi, Ghana Post, adwuma yeli...",
    search:"Yiwɔ", allCrimeTypes:"Gbomo hiɛ nyɛ", allSeverities:"Kɛkɛ nyɛ",
    drawPolygon:"Tɛ Shape", polygonFilter:"Shape Filter",
    camerasOn:"Camera WƆ", camerasOff:"Camera JƆ",
    floodsOn:"Ngmɛi WƆ", floodsOff:"Ngmɛi JƆ",
    bordersOn:"Mmadan WƆ", bordersOff:"Mmadan JƆ",
    poiOn:"Yeli WƆ", poiOff:"Yeli JƆ",
    heatmapOn:"Heatmap WƆ", heatmapOff:"Heatmap JƆ",
    clickToAddPoints:"Klik shikpon yɛ - klik 1st shikpon nɛ gbɔ",
    cancel:"Kɔ", topRiskZones:"GBOMO YELI TITIRI", low:"Kakra",
    recentIncidents:"Hiɛlɛ Akɛ", viewAll:"Hwɛ nyɛ",
    regionalRiskScores:"Mli Gbomo Nnɔma", floodReports:"Ngmɛi Shi",
    totalIncidents:"Hiɛlɛ Nyɛ", highCritical:"Kɛkɛ / Tia",
    camerasOnline:"Camera Wɔ Line", publicSafetyAlerts:"Ni Saafei Lɛ",
    officialAlerts:"Lɛ firi Ghana Police, NADMO kɛ Mmuaeɛhyɛfo",
    getSmsAlerts:"Jɛ SMS lɛ wo fɔn mu",
    smsSubDesc:"Jɛ lɛ kɛkɛ via SMS shikɛkɛ. Ghana fɔn nkutoo (+233).",
    subscribe:"Kɔ", activeAlerts:"Lɛ Wɔ Hɔ", alertHistory:"Lɛ Teteɛ",
    poweredBy:"Yɛ firi", language:"Kasa",
  },
  ee: { // Ewe
    appTagline:"Ame Sidzena Platform · Ghana",
    safetyMap:"Sidzena Map", report:"Ɖo Nu", alerts:"Vovoto", floods:"Tsiɖoɖo",
    incidents:"Nudzedzea", cameras:"Kamera", myDashboard:"Nya Dashboard",
    reportIncident:"Ɖo Nudzedzea Nu", signIn:"Ɖo Ŋu", requestDemo:"Bia Demo",
    searchPlaceholder:"Dii feme, Ghana Post, dɔwɔƒe...",
    search:"Dii", allCrimeTypes:"Wɔwɔ katã", allSeverities:"Ɣeyiɣi katã",
    drawPolygon:"Ŋlɔ Shape", polygonFilter:"Shape Filter",
    camerasOn:"Kamera WO", camerasOff:"Kamera ME",
    floodsOn:"Tsiɖoɖo WO", floodsOff:"Tsiɖoɖo ME",
    bordersOn:"Ƒuƒoƒo WO", bordersOff:"Ƒuƒoƒo ME",
    poiOn:"Feme WO", poiOff:"Feme ME",
    heatmapOn:"Heatmap WO", heatmapOff:"Heatmap ME",
    clickToAddPoints:"Klik aɖe - klik 1lia tso nu",
    cancel:"Ƒu", topRiskZones:"VOVOTO FEME GÃWO", low:"Susu Kakra",
    recentIncidents:"Nudzedzea Yeye", viewAll:"Kpɔ katã",
    regionalRiskScores:"Anyigba Vovoto Ŋɔŋlɔ", floodReports:"Tsiɖoɖo Nu",
    totalIncidents:"Nudzedzea Katã", highCritical:"Gã / Tia",
    camerasOnline:"Kamera Le Line", publicSafetyAlerts:"Ame Sidzena Vovoto",
    officialAlerts:"Vovoto le Ghana Police, NADMO kple Wɔlawo",
    getSmsAlerts:"Xɔ SMS vovoto le wò fɔn me",
    smsSubDesc:"Xɔ vovoto gã via SMS aleke. Ghana fɔn kpeɖeŋu (+233).",
    subscribe:"Ŋlɔ", activeAlerts:"Vovoto Le Gome", alertHistory:"Vovoto Gbɔ",
    poweredBy:"Wɔ le", language:"Gbe",
  },
  ha: { // Hausa
    appTagline:"Tsaron Al'umma Platform · Ghana",
    safetyMap:"Taswirar Tsaro", report:"Rahoto", alerts:"Gargaɗi", floods:"Ambaliyar Ruwa",
    incidents:"Abubuwa", cameras:"Kyamara", myDashboard:"Allon Na",
    reportIncident:"Kai Rahoto", signIn:"Shiga", requestDemo:"Nemi Demo",
    searchPlaceholder:"Nemi wuri, Ghana Post, kasuwanci...",
    search:"Nemi", allCrimeTypes:"Duk Laifuka", allSeverities:"Duk Matakai",
    drawPolygon:"Zana Shape", polygonFilter:"Tace Shape",
    camerasOn:"Kyamara KA", camerasOff:"Kyamara BA",
    floodsOn:"Ambaliya KA", floodsOff:"Ambaliya BA",
    bordersOn:"Iyaka KA", bordersOff:"Iyaka BA",
    poiOn:"Wurare KA", poiOff:"Wurare BA",
    heatmapOn:"Heatmap KA", heatmapOff:"Heatmap BA",
    clickToAddPoints:"Danna wurare - danna aya 1 don rufe",
    cancel:"Soke", topRiskZones:"MANYAN WURAREN HAƊARI", low:"Ƙarami",
    recentIncidents:"Abubuwa na Kwanan", viewAll:"Duba duka",
    regionalRiskScores:"Matakin Haɗari na Yankuna", floodReports:"Rahoton Ambaliya",
    totalIncidents:"Duk Abubuwa", highCritical:"Babba / Mafi Haɗari",
    camerasOnline:"Kyamara a Layi", publicSafetyAlerts:"Gargaɗin Tsaron Jama'a",
    officialAlerts:"Gargaɗi daga Ghana Police, NADMO da Masu Tsaro",
    getSmsAlerts:"Karɓi gargaɗin SMS a wayarka",
    smsSubDesc:"Karɓi gargaɗi ta SMS ko ba da Intanet. Lambobin Ghana kawai (+233).",
    subscribe:"Yi Rajista", activeAlerts:"Gargaɗi na Yanzu", alertHistory:"Tarihin Gargaɗi",
    poweredBy:"Ƙarfin", language:"Harshe",
  },
};

const SEV_LABEL = { critical:"CRITICAL", warning:"WARNING", advisory:"ADVISORY" };
const SEV_COLOR = { critical:"#B71C1C", warning:"#E65100", advisory:"#1565C0" };
const SEV_BG    = { critical:"#FFEBEE", warning:"#FFF3E0", advisory:"#E3F2FD" };

// == Web Audio sound synthesizer (no external files needed) ===================
function playAlertSound(soundType){
  try{
    const ctx = new (window.AudioContext||window.webkitAudioContext)();
    const patterns = {
      // Critical crime: fast urgent triple beep
      crime:(ctx)=>{
        [0,0.18,0.36].forEach((t,i)=>{
          const o=ctx.createOscillator(),g=ctx.createGain();
          o.connect(g);g.connect(ctx.destination);
          o.type="square";o.frequency.setValueAtTime(880+i*110,ctx.currentTime+t);
          g.gain.setValueAtTime(0.35,ctx.currentTime+t);
          g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+t+0.14);
          o.start(ctx.currentTime+t);o.stop(ctx.currentTime+t+0.14);
        });
        // Low rumble underneath
        const o2=ctx.createOscillator(),g2=ctx.createGain();
        o2.connect(g2);g2.connect(ctx.destination);
        o2.type="sawtooth";o2.frequency.value=110;
        g2.gain.setValueAtTime(0.12,ctx.currentTime);
        g2.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.6);
        o2.start(ctx.currentTime);o2.stop(ctx.currentTime+0.6);
      },
      // Rain: descending soft tone
      rain:(ctx)=>{
        const o=ctx.createOscillator(),g=ctx.createGain();
        o.connect(g);g.connect(ctx.destination);
        o.type="sine";
        o.frequency.setValueAtTime(660,ctx.currentTime);
        o.frequency.exponentialRampToValueAtTime(220,ctx.currentTime+0.8);
        g.gain.setValueAtTime(0.25,ctx.currentTime);
        g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+0.85);
        o.start(ctx.currentTime);o.stop(ctx.currentTime+0.9);
        // Second drop
        const o2=ctx.createOscillator(),g2=ctx.createGain();
        o2.connect(g2);g2.connect(ctx.destination);
        o2.type="sine";
        o2.frequency.setValueAtTime(520,ctx.currentTime+0.5);
        o2.frequency.exponentialRampToValueAtTime(180,ctx.currentTime+1.2);
        g2.gain.setValueAtTime(0.2,ctx.currentTime+0.5);
        g2.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+1.3);
        o2.start(ctx.currentTime+0.5);o2.stop(ctx.currentTime+1.4);
      },
      // Flood: deep rising pulse
      flood:(ctx)=>{
        [0,0.22,0.44,0.66].forEach(t=>{
          const o=ctx.createOscillator(),g=ctx.createGain();
          o.connect(g);g.connect(ctx.destination);
          o.type="sawtooth";
          o.frequency.setValueAtTime(120+t*60,ctx.currentTime+t);
          o.frequency.linearRampToValueAtTime(240+t*60,ctx.currentTime+t+0.18);
          g.gain.setValueAtTime(0.3,ctx.currentTime+t);
          g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+t+0.2);
          o.start(ctx.currentTime+t);o.stop(ctx.currentTime+t+0.22);
        });
      },
      // Heat: slow rising alarm
      heat:(ctx)=>{
        const o=ctx.createOscillator(),g=ctx.createGain();
        o.connect(g);g.connect(ctx.destination);
        o.type="triangle";
        o.frequency.setValueAtTime(440,ctx.currentTime);
        o.frequency.linearRampToValueAtTime(880,ctx.currentTime+0.5);
        o.frequency.linearRampToValueAtTime(440,ctx.currentTime+1.0);
        g.gain.setValueAtTime(0.28,ctx.currentTime);
        g.gain.setValueAtTime(0.28,ctx.currentTime+0.9);
        g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+1.1);
        o.start(ctx.currentTime);o.stop(ctx.currentTime+1.1);
      },
      // Wind: noise-like wobble
      wind:(ctx)=>{
        const o=ctx.createOscillator(),g=ctx.createGain();
        const lfo=ctx.createOscillator(),lgain=ctx.createGain();
        lfo.connect(lgain);lgain.connect(o.frequency);
        o.connect(g);g.connect(ctx.destination);
        lfo.frequency.value=6;lgain.gain.value=80;
        o.type="sawtooth";o.frequency.value=220;
        g.gain.setValueAtTime(0.2,ctx.currentTime);
        g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+1.2);
        lfo.start(ctx.currentTime);o.start(ctx.currentTime);
        lfo.stop(ctx.currentTime+1.2);o.stop(ctx.currentTime+1.2);
      },
      // Fire: crackle burst
      fire:(ctx)=>{
        [0,0.1,0.2,0.35,0.5].forEach((t,i)=>{
          const o=ctx.createOscillator(),g=ctx.createGain();
          o.connect(g);g.connect(ctx.destination);
          o.type=i%2===0?"sawtooth":"square";
          o.frequency.value=200+Math.sin(i)*300;
          g.gain.setValueAtTime(0.22,ctx.currentTime+t);
          g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+t+0.09);
          o.start(ctx.currentTime+t);o.stop(ctx.currentTime+t+0.1);
        });
      },
      // Accident: two-tone horn
      accident:(ctx)=>{
        [[440,0],[370,0.3],[440,0.6],[370,0.9]].forEach(([freq,t])=>{
          const o=ctx.createOscillator(),g=ctx.createGain();
          o.connect(g);g.connect(ctx.destination);
          o.type="square";o.frequency.value=freq;
          g.gain.setValueAtTime(0.3,ctx.currentTime+t);
          g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+t+0.25);
          o.start(ctx.currentTime+t);o.stop(ctx.currentTime+t+0.28);
        });
      },
      // Hazmat: long warbling siren
      hazmat:(ctx)=>{
        const o=ctx.createOscillator(),g=ctx.createGain();
        o.connect(g);g.connect(ctx.destination);
        o.type="sawtooth";
        for(let i=0;i<8;i++){
          o.frequency.setValueAtTime(i%2===0?660:440,ctx.currentTime+i*0.15);
        }
        g.gain.setValueAtTime(0.3,ctx.currentTime);
        g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+1.3);
        o.start(ctx.currentTime);o.stop(ctx.currentTime+1.4);
      },
      // Health: two soft ascending tones
      health:(ctx)=>{
        [[523,0],[659,0.25],[784,0.5]].forEach(([f,t])=>{
          const o=ctx.createOscillator(),g=ctx.createGain();
          o.connect(g);g.connect(ctx.destination);
          o.type="sine";o.frequency.value=f;
          g.gain.setValueAtTime(0.22,ctx.currentTime+t);
          g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+t+0.22);
          o.start(ctx.currentTime+t);o.stop(ctx.currentTime+t+0.25);
        });
      },
      // Info: single gentle chime
      info:(ctx)=>{
        [[880,0],[1108,0.15]].forEach(([f,t])=>{
          const o=ctx.createOscillator(),g=ctx.createGain();
          o.connect(g);g.connect(ctx.destination);
          o.type="sine";o.frequency.value=f;
          g.gain.setValueAtTime(0.18,ctx.currentTime+t);
          g.gain.exponentialRampToValueAtTime(0.001,ctx.currentTime+t+0.35);
          o.start(ctx.currentTime+t);o.stop(ctx.currentTime+t+0.4);
        });
      },
    };
    const fn = patterns[soundType]||patterns.info;
    fn(ctx);
  }catch(e){ console.warn("Audio not available",e); }
}

// == Ghana Post helpers ========================================================
const GHANA_POST_PREFIXES = {
  "greater-accra":["GA","GE","GN","GS","GW"],
  "ashanti":      ["AK","AM","AS","AT","AW"],
  "eastern":      ["EA","EB","EK","EN","ES"],
  "central":      ["CA","CE","CK","CN","CS"],
  "western":      ["WA","WE","WS","WW"],
  "volta":        ["VA","VE","VN","VS","VW"],
  "northern":     ["NA","NN","NS","NW"],
  "upper-east":   ["UE"],
  "upper-west":   ["UW"],
  "bono":         ["BA","BN","BS","BW"],
  "bono-east":    ["BE"],
  "ahafo":        ["AH"],
  "savannah":     ["SV"],
  "north-east":   ["NE"],
  "oti":          ["OT"],
  "western-north":["WN"],
};
function regionFromGhanaPost(code){
  if(!code||code.length<2)return null;
  const p=code.substring(0,2).toUpperCase();
  for(const[r,ps]of Object.entries(GHANA_POST_PREFIXES))if(ps.includes(p))return r;
  return null;
}
function isValidGhanaPost(code){ return /^[A-Za-z]{2}-\d{4}-\d{4}$/.test((code||"").trim()); }
function ghanaPostToCoords(code,region){
  const base=GHANA_REGIONS.find(r=>r.id===region);if(!base)return null;
  const digits=code.replace(/\D/g,"");
  const n1=parseInt(digits.substring(0,4))||0;
  const n2=parseInt(digits.substring(4,8))||0;
  return{lat:base.lat+((n1%100)/100-0.5)*0.6,lng:base.lng+((n2%100)/100-0.5)*0.6};
}

// == Static Data ===============================================================
const GHANA_REGIONS = [
  {id:"greater-accra", name:"Greater Accra", capital:"Accra",       lat:5.6037, lng:-0.187,  crimeScore:92},
  {id:"ashanti",       name:"Ashanti",       capital:"Kumasi",      lat:6.6885, lng:-1.6244, crimeScore:85},
  {id:"eastern",       name:"Eastern",       capital:"Koforidua",   lat:6.0942, lng:-0.2618, crimeScore:68},
  {id:"central",       name:"Central",       capital:"Cape Coast",  lat:5.1053, lng:-1.2466, crimeScore:62},
  {id:"western",       name:"Western",       capital:"Takoradi",    lat:4.8968, lng:-1.7564, crimeScore:58},
  {id:"volta",         name:"Volta",         capital:"Ho",          lat:6.6011, lng:0.4714,  crimeScore:44},
  {id:"northern",      name:"Northern",      capital:"Tamale",      lat:9.4008, lng:-0.8393, crimeScore:55},
  {id:"upper-east",    name:"Upper East",    capital:"Bolgatanga",  lat:10.7854,lng:-0.8518, crimeScore:38},
  {id:"upper-west",    name:"Upper West",    capital:"Wa",          lat:10.0601,lng:-2.5099, crimeScore:32},
  {id:"bono",          name:"Bono",          capital:"Sunyani",     lat:7.3349, lng:-2.3266, crimeScore:41},
  {id:"bono-east",     name:"Bono East",     capital:"Techiman",    lat:7.5921, lng:-1.9388, crimeScore:47},
  {id:"ahafo",         name:"Ahafo",         capital:"Goaso",       lat:6.7971, lng:-2.5215, crimeScore:36},
  {id:"savannah",      name:"Savannah",      capital:"Damongo",     lat:9.0881, lng:-1.8198, crimeScore:29},
  {id:"north-east",    name:"North East",    capital:"Nalerigu",    lat:10.5284,lng:-0.3534, crimeScore:31},
  {id:"oti",           name:"Oti",           capital:"Dambai",      lat:8.0766, lng:0.1836,  crimeScore:35},
  {id:"western-north", name:"Western North", capital:"Sefwi Wiawso",lat:6.2117, lng:-2.4857, crimeScore:40},
];
// Fallback only — used if /api/incident-types can't be reached (see the
// incidentTypes state + fetch in the load-data effect below). Admins can
// add/retire types via the admin app; this hardcoded list exists purely so
// the report form and filters still work if that endpoint is ever down.
const CRIME_TYPES=["Robbery","Assault","Burglary","Fraud/Cybercrime","Drug Trafficking","Vehicle Theft","Domestic Violence","Armed Robbery","Kidnapping","Vandalism"];
const SEED_INCIDENTS=[
  {id:1, type:"Armed Robbery",    region:"greater-accra",area:"Madina",          ghanaPost:"GA-182-6027",lat:5.672, lng:-0.168,date:"2025-11-12",time:"22:30",severity:"high",    status:"under-investigation",description:"Armed men robbed a mobile money vendor at gunpoint near the Madina Market.",aiClassification:"Violent Crime = Level 3",        mediaCount:2,upvotes:47, verified:true },
  {id:2, type:"Burglary",         region:"ashanti",      area:"Adum, Kumasi",    ghanaPost:"AK-459-3821",lat:6.701, lng:-1.617,date:"2025-11-08",time:"03:15",severity:"medium",  status:"reported",            description:"Residence broken into while occupants were asleep. Electronics and cash stolen.",aiClassification:"Property Crime = Level 2",       mediaCount:1,upvotes:23, verified:true },
  {id:3, type:"Fraud/Cybercrime", region:"greater-accra",area:"Osu",             ghanaPost:"GA-144-3567",lat:5.556, lng:-0.172,date:"2025-11-14",time:"14:00",severity:"medium",  status:"reported",            description:"Mobile money fraud scheme targeting elderly residents in Osu.",aiClassification:"Financial Crime = Level 2",      mediaCount:0,upvotes:31, verified:false},
  {id:4, type:"Drug Trafficking", region:"western",      area:"Takoradi Harbour",ghanaPost:"WA-211-0044",lat:4.885, lng:-1.755,date:"2025-10-30",time:"01:45",severity:"high",    status:"arrested",            description:"Large quantity of narcotics intercepted at the port. Three suspects arrested.",aiClassification:"Drug Offense = Level 3",         mediaCount:3,upvotes:89, verified:true },
  {id:5, type:"Assault",          region:"eastern",      area:"Koforidua Market",ghanaPost:"EA-308-5512",lat:6.102, lng:-0.255,date:"2025-11-10",time:"16:00",severity:"medium",  status:"reported",            description:"Altercation at the market resulting in injuries to two traders.",aiClassification:"Violent Crime = Level 2",        mediaCount:1,upvotes:18, verified:false},
  {id:6, type:"Vehicle Theft",    region:"greater-accra",area:"Tema Comm. 25",   ghanaPost:"GE-892-1144",lat:5.641, lng:-0.010,date:"2025-11-13",time:"20:10",severity:"low",     status:"reported",            description:"Toyota Corolla stolen from residential compound. CCTV footage available.",aiClassification:"Property Crime = Level 1",       mediaCount:0,upvotes:12, verified:false},
  {id:7, type:"Domestic Violence",region:"ashanti",      area:"Bantama",         ghanaPost:"AK-120-9034",lat:6.712, lng:-1.641,date:"2025-11-09",time:"19:45",severity:"high",    status:"under-investigation",description:"Serious domestic incident reported by neighbors. Victim hospitalized.",aiClassification:"Violent Crime = Level 3",        mediaCount:0,upvotes:56, verified:true },
  {id:8, type:"Robbery",          region:"northern",     area:"Tamale Central",  ghanaPost:"NA-042-7735",lat:9.412, lng:-0.831,date:"2025-11-05",time:"21:00",severity:"medium",  status:"reported",            description:"Motorcyclist robbed near Tamale Central Mosque late at night.",aiClassification:"Violent Crime = Level 2",        mediaCount:1,upvotes:28, verified:false},
  {id:9, type:"Kidnapping",       region:"greater-accra",area:"East Legon",      ghanaPost:"GA-490-2281",lat:5.634, lng:-0.155,date:"2025-11-01",time:"07:30",severity:"critical",status:"resolved",            description:"Child reported missing; found safe after 48 hours following a community tip-off.",aiClassification:"Violent Crime = Level 4 (Critical)",mediaCount:0,upvotes:134,verified:true },
  {id:10,type:"Vandalism",        region:"volta",        area:"Ho Town",         ghanaPost:"VA-671-4402",lat:6.608, lng:0.469, date:"2025-11-11",time:"23:00",severity:"low",     status:"reported",            description:"Public market stalls vandalized overnight. Damage estimated at GHS 8,000.",aiClassification:"Property Crime = Level 1",       mediaCount:2,upvotes:9,  verified:false},
  {id:11,type:"Armed Robbery",    region:"central",      area:"Cape Coast",      ghanaPost:"CA-053-8891",lat:5.118, lng:-1.239,date:"2025-11-06",time:"23:15",severity:"high",    status:"under-investigation",description:"Gunmen raided a fuel station and fled with cash from the safe.",aiClassification:"Violent Crime = Level 3",        mediaCount:1,upvotes:39, verified:true },
  {id:12,type:"Fraud/Cybercrime", region:"ashanti",      area:"Suame",           ghanaPost:"AK-788-6630",lat:6.734, lng:-1.588,date:"2025-11-03",time:"09:00",severity:"medium",  status:"reported",            description:"Internet banking scam affecting multiple businesses in the Suame auto parts market.",aiClassification:"Financial Crime = Level 2",      mediaCount:0,upvotes:22, verified:false},
  {id:13,type:"Robbery",          region:"greater-accra",area:"Accra Central",   ghanaPost:"GA-210-4401",lat:5.548, lng:-0.201,date:"2025-11-15",time:"18:45",severity:"high",    status:"reported",            description:"Pedestrian mugged at knife-point near Accra Central Market.",aiClassification:"Violent Crime = Level 3",        mediaCount:1,upvotes:19, verified:false},
  {id:14,type:"Assault",          region:"greater-accra",area:"Osu Oxford St",   ghanaPost:"GA-144-3610",lat:5.559, lng:-0.170,date:"2025-11-16",time:"23:10",severity:"medium",  status:"reported",            description:"Brawl outside a nightclub on Oxford Street, Osu. Two injured.",aiClassification:"Violent Crime = Level 2",        mediaCount:0,upvotes:8,  verified:false},
  {id:15,type:"Vehicle Theft",    region:"ashanti",      area:"Kumasi Adum",     ghanaPost:"AK-460-3900",lat:6.699, lng:-1.619,date:"2025-11-14",time:"14:30",severity:"low",     status:"reported",            description:"Motorbike stolen from parking area behind Kejetia Market.",aiClassification:"Property Crime = Level 1",       mediaCount:0,upvotes:5,  verified:false},
];
// == Street Cameras ============================================================
const STREET_CAMERAS = [
  {id:"cam-001",name:"Kwame Nkrumah Circle",      area:"Accra Central",    region:"greater-accra",lat:5.5713,lng:-0.2070,status:"online", resolution:"1080p",fps:30, installed:"2022-03-15",operator:"Ghana Police Service",  coverage:"360=",  incidents_nearby:3, ghanaPost:"GA-044-2201"},
  {id:"cam-002",name:"Osu Oxford Street Junction",area:"Osu",              region:"greater-accra",lat:5.5580,lng:-0.1738,status:"online", resolution:"4K",   fps:30, installed:"2023-07-22",operator:"Accra Metropolitan Assembly",coverage:"180=",  incidents_nearby:2, ghanaPost:"GA-144-3600"},
  {id:"cam-003",name:"Tema Harbour Gate 1",        area:"Tema",            region:"greater-accra",lat:5.6328,lng:-0.0168,status:"online", resolution:"1080p",fps:25, installed:"2021-11-01",operator:"Ghana Ports Authority",    coverage:"360=",  incidents_nearby:1, ghanaPost:"GE-892-1100"},
  {id:"cam-004",name:"Madina Market Roundabout",   area:"Madina",          region:"greater-accra",lat:5.6758,lng:-0.1630,status:"offline",resolution:"720p", fps:25, installed:"2020-06-10",operator:"Ghana Police Service",    coverage:"180=",  incidents_nearby:2, ghanaPost:"GA-182-6000"},
  {id:"cam-005",name:"East Legon Avenue",          area:"East Legon",      region:"greater-accra",lat:5.6375,lng:-0.1492,status:"online", resolution:"4K",   fps:30, installed:"2024-01-08",operator:"Accra Metropolitan Assembly",coverage:"360=",  incidents_nearby:1, ghanaPost:"GA-490-2200"},
  {id:"cam-006",name:"Kejetia Market Entrance",    area:"Kumasi Central",  region:"ashanti",      lat:6.6940,lng:-1.6230,status:"online", resolution:"1080p",fps:25, installed:"2022-09-14",operator:"Kumasi Metropolitan Assembly",coverage:"180=", incidents_nearby:3, ghanaPost:"AK-459-3800"},
  {id:"cam-007",name:"Bantama High Street",        area:"Bantama",         region:"ashanti",      lat:6.7160,lng:-1.6380,status:"online", resolution:"1080p",fps:30, installed:"2023-02-20",operator:"Ghana Police Service",    coverage:"360=",  incidents_nearby:1, ghanaPost:"AK-120-9000"},
  {id:"cam-008",name:"Suame Magazine Roundabout",  area:"Suame",           region:"ashanti",      lat:6.7290,lng:-1.5920,status:"maintenance",resolution:"1080p",fps:25,installed:"2021-05-17",operator:"Kumasi Metropolitan Assembly",coverage:"180=",incidents_nearby:1,ghanaPost:"AK-788-6600"},
  {id:"cam-009",name:"Takoradi Habour Main Gate",  area:"Takoradi Harbour",region:"western",      lat:4.8870,lng:-1.7530,status:"online", resolution:"4K",   fps:30, installed:"2022-12-01",operator:"Ghana Ports Authority",    coverage:"360=",  incidents_nearby:1, ghanaPost:"WA-211-0040"},
  {id:"cam-010",name:"Cape Coast Castle Road",     area:"Cape Coast",      region:"central",      lat:5.1030,lng:-1.2450,status:"online", resolution:"1080p",fps:25, installed:"2023-04-05",operator:"Ghana Tourism Authority",  coverage:"180=",  incidents_nearby:1, ghanaPost:"CA-053-8800"},
  {id:"cam-011",name:"Koforidua Town Centre",      area:"Koforidua",       region:"eastern",      lat:6.0900,lng:-0.2600,status:"online", resolution:"720p", fps:25, installed:"2021-08-22",operator:"Eastern Regional Police",  coverage:"180=",  incidents_nearby:1, ghanaPost:"EA-308-5500"},
  {id:"cam-012",name:"Tamale Central Mosque Rd",   area:"Tamale Central",  region:"northern",     lat:9.4050,lng:-0.8400,status:"online", resolution:"1080p",fps:25, installed:"2022-06-30",operator:"Ghana Police Service",    coverage:"360=",  incidents_nearby:1, ghanaPost:"NA-042-7700"},
  {id:"cam-013",name:"Ho Municipal Market",        area:"Ho Town",         region:"volta",        lat:6.6100,lng:0.4720, status:"offline",resolution:"720p", fps:20, installed:"2020-10-11",operator:"Volta Regional Police",    coverage:"180=",  incidents_nearby:1, ghanaPost:"VA-671-4400"},
  {id:"cam-014",name:"Accra-Tema Motorway Toll",   area:"Tema Motorway",   region:"greater-accra",lat:5.6100,lng:-0.0800,status:"online", resolution:"4K",   fps:30, installed:"2024-03-01",operator:"Ghana Highways Authority",  coverage:"360=",  incidents_nearby:0, ghanaPost:"GE-500-1200"},
  {id:"cam-015",name:"Bolgatanga Market Square",   area:"Bolgatanga",      region:"upper-east",   lat:10.7870,lng:-0.8510,status:"online",resolution:"1080p",fps:25, installed:"2023-09-18",operator:"Upper East Regional Police","coverage":"180=",incidents_nearby:0, ghanaPost:"UE-101-5500"},
];

const GHANA_BUSINESSES = [
  {name:"Absa Bank Ghana",           category:"Bank",         region:"greater-accra",area:"Accra Central",    ghanaPost:"GA-044-2100",lat:5.5500,lng:-0.2100},
  {name:"Access Bank Ghana",         category:"Bank",         region:"greater-accra",area:"Ring Road Central",ghanaPost:"GA-144-1800",lat:5.5700,lng:-0.1950},
  {name:"Agricultural Dev. Bank",    category:"Bank",         region:"greater-accra",area:"Accra",            ghanaPost:"GA-044-3300",lat:5.5510,lng:-0.2120},
  {name:"Barclays Bank Ghana",       category:"Bank",         region:"ashanti",      area:"Kumasi Central",   ghanaPost:"AK-044-2200",lat:6.6900,lng:-1.6200},
  {name:"CalBank Ghana",             category:"Bank",         region:"greater-accra",area:"Osu",              ghanaPost:"GA-144-2000",lat:5.5570,lng:-0.1760},
  {name:"Consolidated Bank Ghana",   category:"Bank",         region:"greater-accra",area:"Accra",            ghanaPost:"GA-044-1600",lat:5.5490,lng:-0.2080},
  {name:"Ecobank Ghana",             category:"Bank",         region:"greater-accra",area:"Airport City",     ghanaPost:"GN-044-5500",lat:5.6100,lng:-0.1760},
  {name:"Fidelity Bank Ghana",       category:"Bank",         region:"greater-accra",area:"Ridge",            ghanaPost:"GA-044-4400",lat:5.5700,lng:-0.1900},
  {name:"GCB Bank",                  category:"Bank",         region:"greater-accra",area:"Accra Central",    ghanaPost:"GA-044-2500",lat:5.5480,lng:-0.2050},
  {name:"GT Bank Ghana",             category:"Bank",         region:"greater-accra",area:"Airport City",     ghanaPost:"GN-044-5600",lat:5.6120,lng:-0.1740},
  {name:"Stanbic Bank Ghana",        category:"Bank",         region:"greater-accra",area:"Accra",            ghanaPost:"GA-044-1200",lat:5.5500,lng:-0.2030},
  {name:"Standard Chartered Ghana",  category:"Bank",         region:"greater-accra",area:"High Street",      ghanaPost:"GA-044-2800",lat:5.5460,lng:-0.2070},
  {name:"UBA Ghana",                 category:"Bank",         region:"greater-accra",area:"Osu",              ghanaPost:"GA-144-2200",lat:5.5590,lng:-0.1720},
  {name:"Zenith Bank Ghana",         category:"Bank",         region:"greater-accra",area:"Accra Central",    ghanaPost:"GA-044-3100",lat:5.5520,lng:-0.2010},
  {name:"37 Military Hospital",      category:"Hospital",     region:"greater-accra",area:"Cantonments",      ghanaPost:"GN-044-6600",lat:5.5950,lng:-0.1830},
  {name:"Accra Regional Hospital",   category:"Hospital",     region:"greater-accra",area:"Ridge",            ghanaPost:"GA-044-4200",lat:5.5720,lng:-0.1880},
  {name:"Cocoa Clinic",              category:"Hospital",     region:"greater-accra",area:"East Ridge",       ghanaPost:"GN-044-7700",lat:5.5900,lng:-0.1800},
  {name:"Komfo Anokye Teaching",     category:"Hospital",     region:"ashanti",      area:"Kumasi",           ghanaPost:"AK-044-3300",lat:6.6970,lng:-1.6310},
  {name:"Korle Bu Teaching Hospital",category:"Hospital",     region:"greater-accra",area:"Korle Bu",         ghanaPost:"GS-044-1100",lat:5.5350,lng:-0.2290},
  {name:"Lister Hospital",           category:"Hospital",     region:"greater-accra",area:"East Legon",       ghanaPost:"GA-490-3300",lat:5.6380,lng:-0.1600},
  {name:"Nyaho Medical Centre",      category:"Hospital",     region:"greater-accra",area:"Airport Residential",ghanaPost:"GN-044-8800",lat:5.6190,lng:-0.1760},
  {name:"Trust Hospital",            category:"Hospital",     region:"greater-accra",area:"Osu",              ghanaPost:"GA-144-3100",lat:5.5560,lng:-0.1790},
  {name:"Accra Marriott Hotel",      category:"Hotel",        region:"greater-accra",area:"Airport City",     ghanaPost:"GN-044-9900",lat:5.6130,lng:-0.1710},
  {name:"Alisa Hotel",               category:"Hotel",        region:"greater-accra",area:"North Ridge",      ghanaPost:"GN-044-2100",lat:5.5810,lng:-0.1970},
  {name:"Kempinski Gold Coast City", category:"Hotel",        region:"greater-accra",area:"Airport City",     ghanaPost:"GN-044-7500",lat:5.6140,lng:-0.1730},
  {name:"La Palm Royal Beach Hotel", category:"Hotel",        region:"greater-accra",area:"Labadi",           ghanaPost:"GE-044-1100",lat:5.5600,lng:-0.1290},
  {name:"Movenpick Ambassador Hotel",category:"Hotel",        region:"greater-accra",area:"Accra",            ghanaPost:"GA-044-5500",lat:5.5560,lng:-0.1950},
  {name:"Tang Palace Hotel",         category:"Hotel",        region:"greater-accra",area:"Airport West",     ghanaPost:"GN-044-6600",lat:5.6080,lng:-0.1770},
  {name:"Coconut Grove Regency",     category:"Hotel",        region:"greater-accra",area:"Accra Central",    ghanaPost:"GA-044-1900",lat:5.5490,lng:-0.2060},
  {name:"Golden Tulip Kumasi City",  category:"Hotel",        region:"ashanti",      area:"Kumasi",           ghanaPost:"AK-044-5500",lat:6.6930,lng:-1.6240},
  {name:"Accra Mall",                category:"Shopping Mall",region:"greater-accra",area:"Spintex",          ghanaPost:"GE-044-3300",lat:5.6370,lng:-0.0950},
  {name:"Achimota Retail Centre",    category:"Shopping Mall",region:"greater-accra",area:"Achimota",         ghanaPost:"GN-044-4400",lat:5.6370,lng:-0.2320},
  {name:"A&C Mall",                  category:"Shopping Mall",region:"greater-accra",area:"East Legon",       ghanaPost:"GA-490-1100",lat:5.6360,lng:-0.1630},
  {name:"Kejetia Market",            category:"Market",       region:"ashanti",      area:"Kumasi",           ghanaPost:"AK-044-1100",lat:6.6960,lng:-1.6230},
  {name:"Kumasi City Mall",          category:"Shopping Mall",region:"ashanti",      area:"Kumasi",           ghanaPost:"AK-044-6600",lat:6.6890,lng:-1.6060},
  {name:"Makola Market",             category:"Market",       region:"greater-accra",area:"Accra Central",    ghanaPost:"GA-044-2200",lat:5.5500,lng:-0.2100},
  {name:"Osu Oxford Street",         category:"Shopping Area",region:"greater-accra",area:"Osu",              ghanaPost:"GA-144-3500",lat:5.5580,lng:-0.1740},
  {name:"West Hills Mall",           category:"Shopping Mall",region:"greater-accra",area:"Weija",            ghanaPost:"GW-044-1100",lat:5.5580,lng:-0.3110},
  {name:"GOIL Filling Station Accra",category:"Fuel Station", region:"greater-accra",area:"Accra Central",    ghanaPost:"GA-044-2600",lat:5.5510,lng:-0.2020},
  {name:"Shell Accra Airport",       category:"Fuel Station", region:"greater-accra",area:"Airport",          ghanaPost:"GN-044-3300",lat:5.6050,lng:-0.1690},
  {name:"Star Oil Kumasi",           category:"Fuel Station", region:"ashanti",      area:"Kumasi",           ghanaPost:"AK-044-4400",lat:6.6910,lng:-1.6180},
  {name:"Total Tema Filling Station",category:"Fuel Station", region:"greater-accra",area:"Tema",             ghanaPost:"GE-044-5500",lat:5.6290,lng:-0.0110},
  {name:"Accra Technical University",category:"University",   region:"greater-accra",area:"Accra Central",    ghanaPost:"GA-044-3800",lat:5.5560,lng:-0.2090},
  {name:"Ashesi University",         category:"University",   region:"eastern",      area:"Berekuso",         ghanaPost:"EA-044-1100",lat:5.7598,lng:-0.2233},
  {name:"GIMPA",                     category:"University",   region:"greater-accra",area:"Greenhill",        ghanaPost:"GA-044-7700",lat:5.6260,lng:-0.1880},
  {name:"Kwame Nkrumah University",  category:"University",   region:"ashanti",      area:"Kumasi",           ghanaPost:"AK-044-7700",lat:6.6732,lng:-1.5709},
  {name:"University of Ghana Legon", category:"University",   region:"greater-accra",area:"Legon",            ghanaPost:"GA-044-8800",lat:5.6516,lng:-0.1862},
  {name:"Barcelos Ghana",            category:"Restaurant",   region:"greater-accra",area:"Osu",              ghanaPost:"GA-144-3700",lat:5.5575,lng:-0.1762},
  {name:"Chicken Republic Accra",    category:"Fast Food",    region:"greater-accra",area:"Osu",              ghanaPost:"GA-144-3900",lat:5.5569,lng:-0.1755},
  {name:"KFC Accra Mall",            category:"Fast Food",    region:"greater-accra",area:"Spintex",          ghanaPost:"GE-044-3100",lat:5.6365,lng:-0.0963},
  {name:"KFC Osu",                   category:"Fast Food",    region:"greater-accra",area:"Osu",              ghanaPost:"GA-144-4100",lat:5.5571,lng:-0.1748},
  {name:"Mr Biggs Accra",            category:"Fast Food",    region:"greater-accra",area:"Accra Central",    ghanaPost:"GA-044-2900",lat:5.5505,lng:-0.2030},
  {name:"Pizza Inn Accra",           category:"Fast Food",    region:"greater-accra",area:"Ring Road",        ghanaPost:"GA-044-6600",lat:5.5680,lng:-0.1910},
  {name:"Tasty Tom Kumasi",          category:"Restaurant",   region:"ashanti",      area:"Kumasi",           ghanaPost:"AK-044-8800",lat:6.6920,lng:-1.6220},
  {name:"Ghana Police Headquarters", category:"Government",   region:"greater-accra",area:"Ring Road East",   ghanaPost:"GA-044-5100",lat:5.5712,lng:-0.1889},
  {name:"Ministry of Interior",      category:"Government",   region:"greater-accra",area:"Accra",            ghanaPost:"GA-044-4900",lat:5.5680,lng:-0.1920},
  {name:"National Fire Service HQ",  category:"Government",   region:"greater-accra",area:"Accra",            ghanaPost:"GA-044-4100",lat:5.5650,lng:-0.1930},
  {name:"Passport Application Office",category:"Government",  region:"greater-accra",area:"Ministries",       ghanaPost:"GA-044-5800",lat:5.5660,lng:-0.1870},
  {name:"AirtelTigo Ghana HQ",       category:"Telecom",      region:"greater-accra",area:"Accra",            ghanaPost:"GA-044-6100",lat:5.5690,lng:-0.1860},
  {name:"MTN Ghana Head Office",     category:"Telecom",      region:"greater-accra",area:"Accra",            ghanaPost:"GA-044-6300",lat:5.5700,lng:-0.1850},
  {name:"Vodafone Ghana HQ",         category:"Telecom",      region:"greater-accra",area:"Accra",            ghanaPost:"GA-044-6200",lat:5.5695,lng:-0.1855},
  {name:"Kotoka International Airport",category:"Airport",    region:"greater-accra",area:"Airport City",     ghanaPost:"GN-044-1100",lat:5.6052,lng:-0.1668},
  {name:"Tema Container Terminal",   category:"Port",         region:"greater-accra",area:"Tema Harbour",     ghanaPost:"GE-892-2200",lat:5.6330,lng:-0.0150},
  // == Schools ==
  {name:"Achimota School",            category:"School",       region:"greater-accra",area:"Achimota",         ghanaPost:"GN-044-1200",lat:5.6210,lng:-0.2270},
  {name:"Ghana National College",     category:"School",       region:"central",      area:"Cape Coast",       ghanaPost:"CA-053-1100",lat:5.1080,lng:-1.2440},
  {name:"Mfantsipim School",          category:"School",       region:"central",      area:"Cape Coast",       ghanaPost:"CA-053-1200",lat:5.1050,lng:-1.2500},
  {name:"Prempeh College",            category:"School",       region:"ashanti",      area:"Kumasi",           ghanaPost:"AK-044-2300",lat:6.6850,lng:-1.6270},
  {name:"Adisadel College",           category:"School",       region:"central",      area:"Cape Coast",       ghanaPost:"CA-053-1300",lat:5.1100,lng:-1.2460},
  {name:"Wesley Girls High School",   category:"School",       region:"central",      area:"Cape Coast",       ghanaPost:"CA-053-1400",lat:5.1060,lng:-1.2420},
  {name:"Accra High School",          category:"School",       region:"greater-accra",area:"Accra",            ghanaPost:"GA-044-9100",lat:5.5590,lng:-0.2140},
  {name:"Opoku Ware School",          category:"School",       region:"ashanti",      area:"Kumasi",           ghanaPost:"AK-044-2400",lat:6.6870,lng:-1.6140},
  // == Churches ==
  {name:"Accra International Conference Centre",category:"Church",region:"greater-accra",area:"Accra",        ghanaPost:"GA-044-5200",lat:5.5560,lng:-0.2000},
  {name:"Action Chapel International",category:"Church",        region:"greater-accra",area:"Airport Hills",   ghanaPost:"GN-044-3400",lat:5.6220,lng:-0.1850},
  {name:"Calvary Baptist Church",     category:"Church",        region:"greater-accra",area:"Adabraka",        ghanaPost:"GA-044-7100",lat:5.5640,lng:-0.2050},
  {name:"Central Assemblies of God",  category:"Church",        region:"greater-accra",area:"Tesano",          ghanaPost:"GN-044-2200",lat:5.5880,lng:-0.2200},
  {name:"Holy Trinity Cathedral",     category:"Church",        region:"greater-accra",area:"Accra Central",   ghanaPost:"GA-044-2300",lat:5.5490,lng:-0.2080},
  {name:"Lighthouse Chapel International",category:"Church",    region:"greater-accra",area:"Dansoman",        ghanaPost:"GS-044-2200",lat:5.5590,lng:-0.2480},
  {name:"Perez Chapel International", category:"Church",        region:"greater-accra",area:"East Legon",      ghanaPost:"GA-490-4400",lat:5.6430,lng:-0.1540},
  {name:"St Paul's Methodist Cathedral",category:"Church",      region:"ashanti",      area:"Kumasi",          ghanaPost:"AK-044-3100",lat:6.6910,lng:-1.6210},
  // == Mosques ==
  {name:"Central Mosque Accra",       category:"Mosque",        region:"greater-accra",area:"Fadama",          ghanaPost:"GA-044-8100",lat:5.5620,lng:-0.2130},
  {name:"Madina Central Mosque",      category:"Mosque",        region:"greater-accra",area:"Madina",          ghanaPost:"GA-182-7000",lat:5.6740,lng:-0.1600},
  {name:"Tamale Central Mosque",      category:"Mosque",        region:"northern",     area:"Tamale",          ghanaPost:"NA-042-7800",lat:9.4050,lng:-0.8420},
  {name:"Ho Central Mosque",          category:"Mosque",        region:"volta",        area:"Ho",              ghanaPost:"VA-671-4500",lat:6.6090,lng:0.4700},
  {name:"Kumasi Central Mosque",      category:"Mosque",        region:"ashanti",      area:"Kumasi",          ghanaPost:"AK-044-1200",lat:6.6930,lng:-1.6260},
  // == Police Stations ==
  {name:"Accra Central Police",       category:"Police Station",region:"greater-accra",area:"Accra Central",   ghanaPost:"GA-044-3500",lat:5.5480,lng:-0.2060},
  {name:"Cantonments Police Station", category:"Police Station",region:"greater-accra",area:"Cantonments",     ghanaPost:"GN-044-5100",lat:5.5970,lng:-0.1850},
  {name:"East Legon Police Station",  category:"Police Station",region:"greater-accra",area:"East Legon",      ghanaPost:"GA-490-5500",lat:5.6360,lng:-0.1510},
  {name:"Kumasi Central Police",      category:"Police Station",region:"ashanti",      area:"Kumasi",          ghanaPost:"AK-044-4100",lat:6.6930,lng:-1.6200},
  {name:"Madina Police Station",      category:"Police Station",region:"greater-accra",area:"Madina",          ghanaPost:"GA-182-8000",lat:5.6740,lng:-0.1640},
  {name:"Takoradi Police Station",    category:"Police Station",region:"western",      area:"Takoradi",        ghanaPost:"WA-211-1100",lat:4.8980,lng:-1.7530},
  {name:"Tamale Police Station",      category:"Police Station",region:"northern",     area:"Tamale",          ghanaPost:"NA-042-8800",lat:9.4030,lng:-0.8380},
  // == Parks & Recreation ==
  {name:"Accra Zoo & Botanical Gardens",category:"Park",        region:"greater-accra",area:"Achimota",        ghanaPost:"GN-044-6100",lat:5.6240,lng:-0.2200},
  {name:"Aburi Botanical Gardens",    category:"Park",          region:"eastern",      area:"Aburi",           ghanaPost:"EA-044-2200",lat:5.8465,lng:-0.1739},
  {name:"Labadi Beach",               category:"Park",          region:"greater-accra",area:"Labadi",          ghanaPost:"GE-044-2200",lat:5.5570,lng:-0.1300},
  {name:"Kakum National Park",        category:"Park",          region:"central",      area:"Kakum",           ghanaPost:"CA-053-5500",lat:5.3500,lng:-1.3800},
  {name:"Mole National Park",         category:"Park",          region:"northern",     area:"Damongo",         ghanaPost:"SV-044-1100",lat:9.2667,lng:-1.8500},
  // == Stadia ==
  {name:"Accra Sports Stadium",       category:"Stadium",       region:"greater-accra",area:"Accra",           ghanaPost:"GA-044-6700",lat:5.5580,lng:-0.1930},
  {name:"Baba Yara Sports Stadium",   category:"Stadium",       region:"ashanti",      area:"Kumasi",          ghanaPost:"AK-044-9900",lat:6.6810,lng:-1.6090},
  {name:"Cape Coast Stadium",         category:"Stadium",       region:"central",      area:"Cape Coast",      ghanaPost:"CA-053-6600",lat:5.1100,lng:-1.2360},
  {name:"Tamale Stadium",             category:"Stadium",       region:"northern",     area:"Tamale",          ghanaPost:"NA-042-9900",lat:9.4020,lng:-0.8340},
  // == Embassies ==
  {name:"US Embassy Accra",           category:"Embassy",       region:"greater-accra",area:"Cantonments",     ghanaPost:"GN-044-4100",lat:5.5880,lng:-0.1870},
  {name:"British High Commission",    category:"Embassy",       region:"greater-accra",area:"Roman Ridge",     ghanaPost:"GN-044-3100",lat:5.5970,lng:-0.1820},
  {name:"Chinese Embassy Ghana",      category:"Embassy",       region:"greater-accra",area:"Roman Ridge",     ghanaPost:"GN-044-3200",lat:5.5960,lng:-0.1810},
  {name:"Nigerian High Commission",   category:"Embassy",       region:"greater-accra",area:"Roman Ridge",     ghanaPost:"GN-044-3300",lat:5.5950,lng:-0.1800},
];
const BIZ_CATEGORY_ICONS = {
  "Bank":"ti-building-bank",
  "Hospital":"ti-heart-rate-monitor",
  "Hotel":"ti-bed",
  "Shopping Mall":"ti-shopping-bag",
  "Market":"ti-basket",
  "Shopping Area":"ti-shopping-cart",
  "Fuel Station":"ti-gas-station",
  "University":"ti-school",
  "Restaurant":"ti-tools-kitchen-2",
  "Fast Food":"ti-burger",
  "Government":"ti-building-community",
  "Telecom":"ti-antenna",
  "Airport":"ti-plane",
  "Port":"ti-anchor",
  "School":"ti-pencil",
  "Church":"ti-building-church",
  "Mosque":"ti-moon",
  "Police Station":"ti-badge",
  "Park":"ti-trees",
  "Stadium":"ti-trophy",
  "Embassy":"ti-flag",
};

// POI category colours = each distinct
const POI_CATEGORY_COLORS = {
  "Bank":          "#1565C0",
  "Hospital":      "#C62828",
  "Hotel":         "#6A1B9A",
  "Shopping Mall": "#E65100",
  "Market":        "#F57F17",
  "Shopping Area": "#EF6C00",
  "Fuel Station":  "#4E342E",
  "University":    "#283593",
  "Restaurant":    "#AD1457",
  "Fast Food":     "#D84315",
  "Government":    "#37474F",
  "Telecom":       "#00838F",
  "Airport":       "#0277BD",
  "Port":          "#004D40",
  "School":        "#558B2F",
  "Church":        "#4A148C",
  "Mosque":        "#1B5E20",
  "Police Station":"#0D47A1",
  "Park":          "#2E7D32",
  "Stadium":       "#E65100",
  "Embassy":       "#BF360C",
};

// Unicode emoji symbols drawn on canvas for each category
const POI_SYMBOLS = {
  "Bank":"$","Hospital":"+","Hotel":"H","Shopping Mall":"S","Market":"M",
  "Shopping Area":"S","Fuel Station":"⛽","University":"U","Restaurant":"R",
  "Fast Food":"F","Government":"G","Telecom":"T","Airport":"✈","Port":"⚓",
  "School":"S","Church":"✝","Mosque":"☽","Police Station":"P","Park":"🌳",
  "Stadium":"⬟","Embassy":"E",
};

// == Ghana Region Boundary Polygons (simplified outlines) =====================
// Each polygon is an array of [lng, lat] pairs tracing the region border
const GHANA_REGION_BOUNDS = {
  "greater-accra": [
    [-0.35,5.48],[-0.05,5.48],[ 0.10,5.56],[ 0.22,5.65],[ 0.15,5.72],
    [-0.05,5.78],[-0.22,5.82],[-0.38,5.72],[-0.48,5.62],[-0.45,5.52],[-0.35,5.48]
  ],
  "ashanti": [
    [-2.75,5.78],[-1.40,5.78],[-0.85,6.10],[-0.75,6.45],[-1.00,6.88],
    [-1.35,7.10],[-1.65,7.15],[-2.05,7.05],[-2.40,6.80],[-2.75,6.45],
    [-2.90,6.10],[-2.75,5.78]
  ],
  "eastern": [
    [-0.85,5.78],[-0.22,5.82],[ 0.15,5.95],[ 0.35,6.20],[ 0.22,6.55],
    [-0.10,6.80],[-0.45,7.00],[-0.75,6.88],[-0.75,6.45],[-0.85,6.10],[-0.85,5.78]
  ],
  "western": [
    [-3.25,4.75],[-2.10,4.75],[-1.85,5.00],[-1.75,5.35],[-2.00,5.78],
    [-2.75,5.78],[-2.90,5.50],[-3.10,5.20],[-3.20,4.95],[-3.25,4.75]
  ],
  "western-north": [
    [-2.75,5.78],[-2.00,5.78],[-1.85,6.10],[-2.05,6.50],[-2.40,6.80],
    [-2.75,6.45],[-2.90,6.10],[-2.75,5.78]
  ],
  "central": [
    [-2.10,4.75],[-0.85,4.75],[-0.35,5.00],[-0.35,5.48],[-0.85,5.78],
    [-2.00,5.78],[-1.75,5.35],[-1.85,5.00],[-2.10,4.75]
  ],
  "volta": [
    [ 0.22,5.65],[ 0.60,5.78],[ 1.10,6.10],[ 1.20,6.65],[ 1.00,7.10],
    [ 0.65,7.45],[ 0.35,7.50],[ 0.05,7.30],[-0.10,6.80],[ 0.22,6.55],
    [ 0.35,6.20],[ 0.15,5.95],[ 0.22,5.65]
  ],
  "oti": [
    [ 0.05,7.30],[ 0.35,7.50],[ 0.65,7.45],[ 0.90,7.80],[ 0.85,8.20],
    [ 0.55,8.55],[ 0.10,8.60],[-0.25,8.35],[-0.35,7.90],[-0.10,7.55],
    [ 0.05,7.30]
  ],
  "northern": [
    [-2.40,8.45],[-1.20,8.45],[-0.55,8.45],[-0.25,8.35],[ 0.10,8.60],
    [-0.05,9.10],[-0.25,9.55],[-0.70,9.90],[-1.15,9.90],[-1.60,9.65],
    [-2.10,9.35],[-2.45,8.95],[-2.40,8.45]
  ],
  "savannah": [
    [-2.75,7.80],[-2.40,6.80],[-2.05,7.05],[-1.65,7.15],[-1.25,7.50],
    [-0.90,7.90],[-0.90,8.40],[-1.20,8.45],[-2.40,8.45],[-2.75,8.10],[-2.75,7.80]
  ],
  "bono": [
    [-3.25,7.20],[-2.75,6.45],[-2.40,6.80],[-2.75,7.80],[-2.75,8.10],
    [-3.05,7.90],[-3.25,7.50],[-3.25,7.20]
  ],
  "bono-east": [
    [-1.65,7.15],[-1.35,7.10],[-1.00,6.88],[-0.45,7.00],[-0.10,6.80],
    [-0.35,7.90],[-0.90,7.90],[-0.90,8.40],[-1.20,8.45],[-1.25,7.50],
    [-1.65,7.15]
  ],
  "ahafo": [
    [-2.75,6.45],[-2.40,6.80],[-2.75,7.80],[-3.05,7.90],[-3.25,7.50],
    [-3.25,7.20],[-2.75,6.45]
  ],
  "upper-west": [
    [-3.20,9.55],[-2.75,9.55],[-2.10,9.35],[-1.60,9.65],[-1.60,10.20],
    [-2.00,10.65],[-2.50,10.90],[-3.05,10.70],[-3.20,10.20],[-3.20,9.55]
  ],
  "upper-east": [
    [-1.15,9.90],[-0.70,9.90],[-0.15,10.00],[ 0.25,10.30],[ 0.50,10.60],
    [ 0.15,10.98],[-0.40,11.00],[-0.80,10.90],[-1.15,10.65],[-1.60,10.20],
    [-1.60,9.65],[-1.15,9.90]
  ],
  "north-east": [
    [-0.25,9.55],[-0.05,9.10],[ 0.10,8.60],[ 0.55,8.55],[ 0.85,8.20],
    [ 0.90,8.80],[ 0.70,9.35],[ 0.25,9.70],[-0.15,10.00],[-0.70,9.90],[-0.25,9.55]
  ],
};

// Region colour mapping for boundaries
const REGION_FILL_COLORS = {
  "greater-accra":"rgba(206,17,38,0.08)",
  "ashanti":      "rgba(255,140,0,0.07)",
  "eastern":      "rgba(33,150,243,0.07)",
  "western":      "rgba(76,175,80,0.07)",
  "western-north":"rgba(0,150,136,0.07)",
  "central":      "rgba(156,39,176,0.07)",
  "volta":        "rgba(0,188,212,0.07)",
  "oti":          "rgba(255,193,7,0.07)",
  "northern":     "rgba(244,67,54,0.07)",
  "savannah":     "rgba(121,85,72,0.07)",
  "bono":         "rgba(63,81,181,0.07)",
  "bono-east":    "rgba(233,30,99,0.07)",
  "ahafo":        "rgba(139,195,74,0.07)",
  "upper-west":   "rgba(255,87,34,0.07)",
  "upper-east":   "rgba(0,150,136,0.07)",
  "north-east":   "rgba(103,58,183,0.07)",
};

const REGION_STROKE_COLORS = {
  "greater-accra":"rgba(206,17,38,0.55)",
  "ashanti":      "rgba(255,140,0,0.50)",
  "eastern":      "rgba(33,150,243,0.50)",
  "western":      "rgba(76,175,80,0.50)",
  "western-north":"rgba(0,150,136,0.50)",
  "central":      "rgba(156,39,176,0.50)",
  "volta":        "rgba(0,188,212,0.50)",
  "oti":          "rgba(255,193,7,0.50)",
  "northern":     "rgba(244,67,54,0.45)",
  "savannah":     "rgba(121,85,72,0.50)",
  "bono":         "rgba(63,81,181,0.50)",
  "bono-east":    "rgba(233,30,99,0.50)",
  "ahafo":        "rgba(139,195,74,0.50)",
  "upper-west":   "rgba(255,87,34,0.50)",
  "upper-east":   "rgba(0,150,136,0.50)",
  "north-east":   "rgba(103,58,183,0.50)",
};

const CAM_STATUS_CFG = {
  online:      {color:"#4CAF50",bg:"#E8F5E9",label:"Online",    dot:"#4CAF50"},
  offline:     {color:"#F44336",bg:"#FFEBEE",label:"Offline",   dot:"#F44336"},
  maintenance: {color:"#FF9800",bg:"#FFF3E0",label:"Maintenance",dot:"#FF9800"},
};

// == Flood Reports =============================================================
const SEED_FLOOD_REPORTS = [
  {id:"fl-001",userId:"user-001",userName:"Kofi Mensah",   avatar:"KM",region:"greater-accra",area:"Accra, Odaw River Basin",   ghanaPost:"GA-044-1100",lat:5.5810,lng:-0.2210,depth:"Knee-deep",duration:"3 hours",date:"2025-10-15",time:"14:30",description:"Heavy flooding along the Odaw River. Streets impassable. Several vehicles stranded.",videoName:"flood_odaw_oct15.mp4",videoSize:"18.2 MB",verified:true, severity:"severe",   upvotes:89},
  {id:"fl-002",userId:"user-002",userName:"Ama Boateng",   avatar:"AB",region:"greater-accra",area:"Accra, Dansoman",            ghanaPost:"GS-110-4402",lat:5.5490,lng:-0.2580,depth:"Ankle-deep",duration:"1.5 hours",date:"2025-10-15",time:"15:10",description:"Drainage overflow near Dansoman Market. Shops flooded.",videoName:"dansoman_flood.mp4",videoSize:"14.7 MB",verified:true, severity:"moderate", upvotes:44},
  {id:"fl-003",userId:"user-003",userName:"Kweku Asante",  avatar:"KA",region:"ashanti",      area:"Kumasi, Suame",              ghanaPost:"AK-788-6600",lat:6.7270,lng:-1.5880,depth:"Waist-deep",duration:"5 hours",date:"2025-11-02",time:"08:15",description:"Severe flooding in Suame. Roads completely submerged. Emergency services deployed.",videoName:"kumasi_suame_flood.mp4",videoSize:"19.8 MB",verified:true, severity:"severe",   upvotes:112},
  {id:"fl-004",userId:"user-004",userName:"Abena Darko",   avatar:"AD",region:"central",      area:"Cape Coast, Kotokuraba",     ghanaPost:"CA-053-2200",lat:5.1070,lng:-1.2480,depth:"Ankle-deep",duration:"2 hours",date:"2025-10-28",time:"11:00",description:"Kotokuraba market area flooded after heavy rains. Traders displaced.",videoName:"cape_coast_flood.mp4",videoSize:"12.3 MB",verified:false,severity:"moderate", upvotes:27},
  {id:"fl-005",userId:"user-005",userName:"Yaw Ofori",     avatar:"YO",region:"western",      area:"Takoradi, Effia-Kwesimintsim",ghanaPost:"WA-300-5500",lat:4.9100,lng:-1.7750,depth:"Knee-deep",duration:"4 hours",date:"2025-11-10",time:"16:45",description:"Flash flooding in Effia-Kwesimintsim. Several homes inundated.",videoName:"takoradi_flood.mp4",videoSize:"17.1 MB",verified:true, severity:"severe",   upvotes:67},
  {id:"fl-006",userId:"user-006",userName:"Akosua Frimpong",avatar:"AF",region:"volta",       area:"Ho, Bankoe",                 ghanaPost:"VA-671-3300",lat:6.6050,lng:0.4680, depth:"Ankle-deep",duration:"1 hour",date:"2025-11-08",time:"10:20",description:"Bankoe suburb experienced mild flooding from blocked drains.",videoName:"ho_bankoe_flood.mp4",videoSize:"9.4 MB", verified:false,severity:"mild",     upvotes:15},
  {id:"fl-007",userId:"user-007",userName:"Kojo Agyeman",  avatar:"KG",region:"eastern",      area:"Koforidua, Effiduase",       ghanaPost:"EA-308-4400",lat:6.0880,lng:-0.2620,depth:"Knee-deep",duration:"3 hours",date:"2025-10-20",time:"13:00",description:"Effiduase junction flooded after torrential rain. Traffic diverted.",videoName:"koforidua_flood.mp4",videoSize:"15.6 MB",verified:true, severity:"moderate", upvotes:38},
];

const FLOOD_SEVERITY_CFG = {
  mild:     {color:"#1565C0",bg:"#E3F2FD",label:"Mild",    icon:"ti-droplet"},
  moderate: {color:"#F57F17",bg:"#FFFDE7",label:"Moderate",icon:"ti-ripple"},
  severe:   {color:"#B71C1C",bg:"#FFEBEE",label:"Severe",  icon:"ti-ripple"},
};

// == Registered Users ==========================================================
const SEED_USERS = [
  {id:"user-001",name:"Kofi Mensah",    email:"kofi.mensah@gmail.com",   phone:"+233244123456",region:"greater-accra",joined:"2024-01-15",reports:3,avatar:"KM",verified:true},
  {id:"user-002",name:"Ama Boateng",    email:"ama.boateng@yahoo.com",   phone:"+233208765432",region:"greater-accra",joined:"2024-03-22",reports:1,avatar:"AB",verified:true},
  {id:"user-003",name:"Kweku Asante",   email:"kweku.a@hotmail.com",     phone:"+233277654321",region:"ashanti",      joined:"2024-02-10",reports:2,avatar:"KA",verified:true},
  {id:"user-004",name:"Abena Darko",    email:"abena.d@gmail.com",       phone:"+233243987654",region:"central",      joined:"2024-05-08",reports:1,avatar:"AD",verified:false},
  {id:"user-005",name:"Yaw Ofori",      email:"yaw.ofori@gmail.com",     phone:"+233209876543",region:"western",      joined:"2024-04-14",reports:2,avatar:"YO",verified:true},
  {id:"user-006",name:"Akosua Frimpong",email:"akosua.f@gmail.com",      phone:"+233244556677",region:"volta",        joined:"2024-06-30",reports:1,avatar:"AF",verified:false},
  {id:"user-007",name:"Kojo Agyeman",   email:"kojo.ag@gmail.com",       phone:"+233271234567",region:"eastern",      joined:"2024-07-19",reports:1,avatar:"KG",verified:true},
];

const SEV_CFG={low:{color:"#4CAF50",bg:"#E8F5E9",label:"Low",shape:"●",icon:"ti-circle"},medium:{color:"#FF9800",bg:"#FFF3E0",label:"Medium",shape:"◆",icon:"ti-diamond"},high:{color:"#F44336",bg:"#FFEBEE",label:"High",shape:"▲",icon:"ti-triangle"},critical:{color:"#9C27B0",bg:"#F3E5F5",label:"Critical",shape:"!",icon:"ti-alert-octagon"}};
const STAT_CFG={"reported":{color:"#2196F3",label:"Reported"},"under-investigation":{color:"#FF9800",label:"Under Investigation"},"arrested":{color:"#4CAF50",label:"Arrested"},"resolved":{color:"#9E9E9E",label:"Resolved"}};

// == CSS =======================================================================
const GLOBAL_CSS=`
  /* ===== DESIGN TOKENS ===== */
  :root{
    /* Brand colours */
    --c-primary:#0A1628;
    --c-primary-mid:#1A3A5C;
    --c-gold:#FCD116;
    --c-gold-dark:#F9A825;
    --c-red:#CE1126;
    --c-red-dark:#8B0000;
    --c-green:#006B3F;

    /* Severity */
    --c-critical:#9C27B0;
    --c-high:#F44336;
    --c-medium:#FF9800;
    --c-low:#4CAF50;

    /* Neutrals */
    --c-bg:#f0f2f5;
    --c-surface:#ffffff;
    --c-border:#e0e0e0;
    --c-border-light:#f0f0f0;
    --c-text:#111111;
    --c-text-secondary:#555555;
    --c-text-muted:#888888;

    /* Spacing scale (8px base) */
    --sp-1:4px;
    --sp-2:8px;
    --sp-3:12px;
    --sp-4:16px;
    --sp-5:24px;
    --sp-6:32px;

    /* Typography scale */
    --fs-xs:10px;
    --fs-sm:12px;
    --fs-md:14px;
    --fs-lg:16px;
    --fs-xl:20px;
    --fs-2xl:24px;

    /* Border radius */
    --r-sm:6px;
    --r-md:10px;
    --r-lg:16px;
    --r-full:9999px;

    /* Shadows */
    --shadow-sm:0 1px 4px rgba(0,0,0,0.06);
    --shadow-md:0 4px 16px rgba(0,0,0,0.10);
    --shadow-lg:0 8px 32px rgba(0,0,0,0.16);

    /* Transitions */
    --t-fast:0.15s ease;
    --t-base:0.25s ease;
  }
  /* ========================= */
  *,*::before,*::after{box-sizing:border-box;margin:0;padding:0}
  body{font-family:'Segoe UI',system-ui,sans-serif;background:var(--c-bg);color:var(--c-text)}
  select,input,textarea,button{font-family:inherit}
  select,input{background:var(--c-surface);color:var(--c-text);border:1px solid var(--c-border);border-radius:var(--r-sm);padding:var(--sp-2) var(--sp-3);font-size:var(--fs-sm);outline:none}
  textarea{background:var(--c-surface);color:var(--c-text);border:1px solid var(--c-border);border-radius:var(--r-sm);padding:var(--sp-2) var(--sp-3);font-size:var(--fs-md);font-family:inherit;resize:vertical;width:100%}
  select:focus,input:focus,textarea:focus{border-color:#9C27B0}
  button:focus-visible,a:focus-visible,select:focus-visible,input:focus-visible,textarea:focus-visible,[tabindex]:focus-visible{outline:3px solid var(--c-gold)!important;outline-offset:2px!important;}
  .skip-link{position:absolute;top:-999px;left:-999px;background:var(--c-gold);color:var(--c-primary);padding:var(--sp-2) var(--sp-4);font-weight:700;font-size:var(--fs-md);border-radius:0 0 var(--r-sm) 0;z-index:99999}
  .skip-link:focus{top:0;left:0}
  ::-webkit-scrollbar{width:4px}::-webkit-scrollbar-thumb{background:var(--c-border);border-radius:2px}
  .cam-card{background:var(--c-surface);border-radius:var(--r-md);border:0.5px solid var(--c-border);padding:var(--sp-3) var(--sp-4);margin-bottom:var(--sp-2);cursor:pointer;transition:box-shadow var(--t-fast)}
  .cam-card:hover{box-shadow:var(--shadow-md)}
  .flood-card{background:var(--c-surface);border-radius:var(--r-md);border:0.5px solid var(--c-border);padding:var(--sp-3) var(--sp-4);margin-bottom:var(--sp-2);border-left:3px solid #1565C0}
  .gp-input{font-family:monospace;letter-spacing:2px;text-transform:uppercase;font-size:14px!important;padding:9px 12px!important;border:2px solid #006B3F!important;border-radius:8px!important}
  .gp-input:focus{border-color:#FCD116!important;box-shadow:0 0 0 3px rgba(252,209,22,0.2)}
  .gp-valid{border-color:#4CAF50!important;background:#F1F8E9!important}
  .gp-invalid{border-color:#F44336!important;background:#FFF3F3!important}
  .loc-btn{border:2px solid #ddd;border-radius:10px;padding:14px;cursor:pointer;transition:all .2s;background:#fff;text-align:center;width:100%}
  .loc-btn:hover{border-color:#006B3F;background:#F0FAF5}
  .loc-btn.selected{border-color:#006B3F;background:#E8F5E9;box-shadow:0 0 0 3px rgba(0,107,63,0.15)}
  @keyframes spin{to{transform:rotate(360deg)}}
  .spin{animation:spin 1s linear infinite;display:inline-block}
  .map-tooltip{position:absolute;pointer-events:none;background:rgba(8,16,32,0.96);border:1px solid rgba(255,255,255,0.15);border-radius:12px;padding:12px 14px;min-width:220px;max-width:300px;box-shadow:0 8px 32px rgba(0,0,0,0.5);z-index:50;}
  .inc-panel{position:absolute;bottom:12px;left:50%;transform:translateX(-50%);background:rgba(8,16,32,0.97);border:1px solid rgba(255,255,255,0.18);border-radius:14px;padding:14px 16px;width:340px;max-width:90%;box-shadow:0 12px 40px rgba(0,0,0,0.6);z-index:60;}
  .nav-btn{background:rgba(255,255,255,0.1);border:1px solid rgba(255,255,255,0.2);color:#fff;border-radius:6px;padding:5px 10px;cursor:pointer;font-size:12px;transition:background .15s;}
  .nav-btn:hover{background:rgba(255,255,255,0.2)}.nav-btn:disabled{opacity:0.3;cursor:default}
  /* Alert type grid */
  .alert-type-btn{border:2px solid #e0e0e0;border-radius:10px;padding:10px 8px;cursor:pointer;transition:all .15s;background:#fff;text-align:center;width:100%}
  .alert-type-btn:hover{border-color:#CE1126;transform:translateY(-1px);box-shadow:0 4px 12px rgba(0,0,0,0.1)}
  .alert-type-btn.selected{box-shadow:0 4px 16px rgba(0,0,0,0.15);transform:translateY(-1px)}
  /* Active alert banner */
  @keyframes alertSlide{from{transform:translateY(-100%);opacity:0}to{transform:translateY(0);opacity:1}}
  .alert-banner{animation:alertSlide .35s ease-out;position:fixed;top:0;left:0;right:0;z-index:1000;padding:12px 18px;display:flex;align-items:center;gap:12px;box-shadow:0 4px 20px rgba(0,0,0,0.35);}
  @keyframes alertPulse{0%,100%{opacity:1}50%{opacity:0.7}}
  .alert-dot{width:10px;height:10px;border-radius:50%;animation:alertPulse 1s infinite;flex-shrink:0}
  /* Alert history badge */
  .alert-badge{display:inline-flex;align-items:center;gap:4px;font-size:10px;padding:2px 8px;border-radius:10px;font-weight:600}
  /* Camera icons on map */
  @keyframes camPulse{0%,100%{box-shadow:0 0 0 0 rgba(0,220,100,0.7)}70%{box-shadow:0 0 0 7px rgba(0,220,100,0)}}
  .cam-online-pulse{animation:camPulse 2.2s infinite}
  /* Camera icons on map */
  .scanline{position:absolute;left:0;right:0;height:3px;background:linear-gradient(transparent,rgba(0,255,100,0.28),transparent);animation:scanline 3s linear infinite;pointer-events:none}
  @keyframes blink{0%,100%{opacity:1}50%{opacity:0}}
  .rec-dot{width:8px;height:8px;border-radius:50%;background:#F44336;animation:blink 1s infinite;display:inline-block}
  @keyframes feedStatic{0%{opacity:0.04}50%{opacity:0.08}100%{opacity:0.04}}
  .feed-static{animation:feedStatic 0.15s steps(1) infinite}
  /* Flood map blobs */
  @keyframes floodPulse{0%,100%{opacity:0.7;r:18}50%{opacity:1;r:22}}
  @keyframes floodRipple{0%{transform:scale(1);opacity:0.6}100%{transform:scale(2.2);opacity:0}}
  .flood-ripple{animation:floodRipple 2s ease-out infinite}
  /* Registration form */
  .reg-step{background:#f9f9f9;border-radius:10px;padding:14px;border:1px solid #e8e8e8;margin-bottom:12px}
  .reg-step-num{background:#1565C0;color:#fff;width:20px;height:20px;border-radius:50%;display:inline-flex;align-items:center;justify-content:center;font-size:10px;font-weight:700;margin-right:8px}
  /* Video upload zone */
  .video-drop{border:2.5px dashed #90CAF9;border-radius:12px;padding:24px;text-align:center;cursor:pointer;transition:all .2s;background:#E3F2FD}
  .video-drop:hover,.video-drop.dragover{border-color:#1565C0;background:#BBDEFB}
  /* User avatar */
  .user-avatar{width:36px;height:36px;border-radius:50%;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:13px;flex-shrink:0}
  /* Progress bar */
  @keyframes progressAnim{from{width:0}to{width:100%}}
  .upload-progress{height:4px;border-radius:2px;background:#1565C0;animation:progressAnim 2.5s ease-in-out forwards}
  /* Business autocomplete */
  .biz-input-wrap{position:relative;width:100%}
  .biz-dropdown{position:absolute;top:calc(100% + 2px);left:0;right:0;background:#fff;border:1.5px solid #9C27B0;border-radius:0 0 10px 10px;z-index:9999;max-height:220px;overflow-y:auto;box-shadow:0 8px 24px rgba(0,0,0,0.18)}
  .biz-item{padding:9px 12px;cursor:pointer;border-bottom:0.5px solid #f5f5f5;display:flex;align-items:center;gap:8px;transition:background .12s}
  .biz-item:hover,.biz-item:focus{background:#F3E5F5;outline:none}
  .biz-item:last-child{border-bottom:none}
  .biz-badge{font-size:9px;background:#EDE7F6;color:#7B1FA2;padding:2px 6px;border-radius:8px;font-weight:600;white-space:nowrap;flex-shrink:0}
  /* Voice recorder */
  @keyframes voicePulse{0%,100%{transform:scale(1);opacity:1}50%{transform:scale(1.18);opacity:0.7}}
  .voice-pulse{animation:voicePulse 0.7s ease-in-out infinite}
  @keyframes waveBar{0%,100%{height:4px}50%{height:20px}}
  .wave-bar{width:3px;border-radius:2px;background:#CE1126;display:inline-block;margin:0 1.5px;animation:waveBar 0.6s ease-in-out infinite}
  .wave-bar:nth-child(2){animation-delay:0.1s}.wave-bar:nth-child(3){animation-delay:0.2s}
  .wave-bar:nth-child(4){animation-delay:0.3s}.wave-bar:nth-child(5){animation-delay:0.15s}
  .wave-bar:nth-child(6){animation-delay:0.25s}.wave-bar:nth-child(7){animation-delay:0.05s}
  .voice-tab-btn{border:2px solid #e0e0e0;border-radius:8px;padding:7px 12px;cursor:pointer;font-size:12px;background:#fff;transition:all .15s;display:flex;align-items:center;gap:6px}
  .voice-tab-btn:hover{border-color:#CE1126;color:#CE1126}
  .voice-tab-btn.active{border-color:#CE1126;background:#FFEBEE;color:#CE1126;font-weight:600}
  /* Mobile bottom-sheet */
  @media(max-width:767px){
    .sg-map-two-col{flex-direction:column!important;}
    .sg-map-left{flex:1!important;border-right:none!important;border-bottom:1px solid #e4e7ed;}
    .sg-map-right{position:fixed!important;bottom:0;left:0;right:0;max-height:60vh;overflow-y:auto;border-radius:16px 16px 0 0;box-shadow:0 -4px 24px rgba(0,0,0,0.18);background:#fff;z-index:800;transform:translateY(100%);transition:transform .3s cubic-bezier(.4,0,.2,1);}
    .sg-map-right.sheet-open{transform:translateY(0)!important;}
    .sg-sheet-handle{width:40px;height:4px;background:#e0e0e0;border-radius:2px;margin:10px auto 0;cursor:pointer;}
    .sg-sheet-toggle{position:fixed;bottom:16px;right:16px;z-index:900;background:#0A1628;color:#FCD116;border:none;border-radius:50%;width:52px;height:52px;font-size:22px;cursor:pointer;box-shadow:0 4px 16px rgba(0,0,0,0.3);display:none;align-items:center;justify-content:center;}
  }
  @media(max-width:767px){.sg-sheet-toggle{display:flex!important;}}
  /* Mobile bottom navigation */
  .sg-bottom-nav{display:none;position:fixed;bottom:0;left:0;right:0;height:60px;background:var(--c-primary);border-top:1px solid rgba(255,255,255,0.1);z-index:800;padding-bottom:env(safe-area-inset-bottom);}
  .sg-bottom-nav-item{flex:1;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;border:none;background:transparent;color:#5A7090;cursor:pointer;font-size:9px;padding:8px 4px;transition:color var(--t-fast);}
  .sg-bottom-nav-item i{font-size:20px;display:block;}
  .sg-bottom-nav-item.active{color:var(--c-gold);}
  .sg-bottom-nav-item.report-btn{color:#fff;background:var(--c-red);border-radius:16px;margin:8px 4px;padding:4px 8px;flex:0 0 56px;}
  .sg-bottom-nav-item.sos-btn{color:#fff;background:#B71C1C;border-radius:16px;margin:8px 4px;padding:4px 8px;flex:0 0 56px;}
  @media(max-width:767px){
    .sg-bottom-nav{display:flex!important;}
    .sg-topnav-tabs{display:none!important;}
    body{padding-bottom:60px;}
  }
  /* Unified top nav - single bar with absolute logo/actions */
  .sg-topnav{background:var(--c-primary);border-bottom:1px solid rgba(255,255,255,0.07);position:sticky;top:0;z-index:700;box-shadow:var(--shadow-md);height:52px;}
  .sg-topnav-logo{position:absolute;left:var(--sp-3);top:0;height:52px;display:flex;align-items:center;gap:var(--sp-2);z-index:2;}
  .sg-topnav-actions{position:absolute;right:var(--sp-3);top:0;height:52px;display:flex;align-items:center;gap:var(--sp-1);z-index:2;}
  .sg-topnav-tabs{display:flex;align-items:stretch;height:52px;justify-content:center;}
  .sg-tabnav-btn{display:flex!important;flex-direction:column!important;align-items:center!important;justify-content:center!important;gap:var(--sp-1);padding:0 14px;border:none;background:transparent;color:#5A7090;border-bottom:3px solid transparent;border-top:3px solid transparent;cursor:pointer;font-weight:400;white-space:nowrap;transition:color var(--t-fast);outline:none;font-size:var(--fs-xs);}
  .sg-tabnav-btn i{font-size:14px;display:block;}
  .sg-tabnav-btn--active{color:var(--c-gold)!important;font-weight:700!important;border-bottom:3px solid var(--c-gold)!important;}
  @keyframes shimmer{0%{background-position:-400px 0}100%{background-position:400px 0}}
  .skeleton{background:linear-gradient(90deg,#e8eaf0 25%,#f5f6fa 50%,#e8eaf0 75%);background-size:400px 100%;animation:shimmer 1.4s ease-in-out infinite;border-radius:6px;display:block;}
  .skeleton-dark{background:linear-gradient(90deg,#1A2744 25%,#243354 50%,#1A2744 75%);background-size:400px 100%;animation:shimmer 1.4s ease-in-out infinite;border-radius:6px;display:block;}
  /* Accessibility */
  .skip-link{position:absolute;top:-40px;left:8px;background:#FCD116;color:#0A1628;padding:6px 12px;border-radius:0 0 8px 8px;font-weight:700;font-size:13px;z-index:9999;text-decoration:none;transition:top .15s;}
  .skip-link:focus{top:0;}
  *:focus-visible{outline:3px solid #FCD116!important;outline-offset:2px!important;border-radius:4px;}
  button:focus-visible,a:focus-visible,[role="button"]:focus-visible{outline:3px solid #FCD116!important;outline-offset:2px!important;}
  @media(prefers-reduced-motion:reduce){*,*::before,*::after{animation-duration:0.01ms!important;animation-iteration-count:1!important;transition-duration:0.01ms!important;}}
  [role="button"]{cursor:pointer;}
  [role="button"]:focus{outline:3px solid #FCD116;outline-offset:2px;}
`;
function injectCSS(css){if(document.getElementById("safeghana-css"))return;const s=document.createElement("style");s.id="safeghana-css";s.textContent=css;document.head.appendChild(s);}
function seedHash(str){let h=0;for(let i=0;i<str.length;i++)h=(Math.imul(31,h)+str.charCodeAt(i))|0;return h;}
function incRadius(sev){return sev==="critical"?72:sev==="high"?52:sev==="medium"?36:22;}
function incColor(sev){return sev==="critical"?"147,0,255":sev==="high"?"220,40,40":sev==="medium"?"255,130,0":"50,180,80";}
function incHex(sev){return sev==="critical"?"#9C27B0":sev==="high"?"#F44336":sev==="medium"?"#FF9800":"#4CAF50";}

// =============================================================================
export default function App(){
  injectCSS(GLOBAL_CSS);

  const [tab,setTabRaw]          = useState(()=>{
    const p=new URLSearchParams(window.location.search);
    const t=p.get("tab");
    return["map","report","alerts","floods","incidents","cameras","mydash"].includes(t)?t:"map";
  });
  const [prevTab,setPrevTab]     = useState("map");
  function setTab(t){setPrevTab(tab);setTabRaw(t);}
  function goBack(){setTabRaw(prevTab);setPrevTab("map");}
  const [incidents,setIncidents] = useState([]);
  // Admin-manageable incident types (Report form + filter dropdowns), fetched
  // from /api/incident-types on mount. Starts as the hardcoded fallback so
  // the UI is usable before that fetch resolves.
  const [incidentTypes,setIncidentTypes] = useState(CRIME_TYPES);
  const [incidentsLoading,setIncidentsLoading] = useState(true);
  const [mapStatsLoading,setMapStatsLoading] = useState(true);
  const [lastFetched,setLastFetched] = useState(null);
  const [upvotedIds,setUpvotedIds] = useState(()=>new Set(JSON.parse(localStorage.getItem("sg_upvoted")||"[]")));
  const [confirmedIds,setConfirmedIds] = useState(()=>new Set(JSON.parse(localStorage.getItem("sg_confirmed")||"[]")));
  const [ft,setFt]               = useState("All");
  const [fr,setFr]               = useState("All");
  const [fs,setFs]               = useState("All");
  const [selInc,setSelInc]       = useState(null);
  const [aiSel,setAiSel]         = useState("");
  const [aiRes,setAiRes]         = useState(null);
  const [aiLoading,setAiLoading] = useState(false);
  const [dbFilter,setDbFilter]   = useState("All");

  // == Business autocomplete ==
  const [bizQuery,setBizQuery]               = useState("");
  const [bizDropOpen,setBizDropOpen]         = useState(false);
  const [bizMatches,setBizMatches]           = useState([]);
  const [floodBizQuery,setFloodBizQuery]     = useState("");
  const [floodBizDropOpen,setFloodBizDropOpen] = useState(false);
  const [floodBizMatches,setFloodBizMatches] = useState([]);

  function handleBizChange(raw,setter,matchSetter,dropSetter){
    setter(raw);
    if(raw.startsWith("b/")&&raw.length>=3){
      const q=raw.slice(2).toLowerCase();
      matchSetter(GHANA_BUSINESSES.filter(b=>b.name.toLowerCase().startsWith(q)).slice(0,12));
      dropSetter(true);
    } else {
      dropSetter(false);matchSetter([]);
    }
  }

  function chooseBiz(biz,dropSetter,matchSetter,setter,formSetter,areaKey){
    setter(biz.name);
    dropSetter(false);matchSetter([]);
    formSetter(p=>({...p,[areaKey]:biz.name,
      ...(biz.region?{region:biz.region}:{}),
      ...(biz.ghanaPost?{ghanaPost:biz.ghanaPost}:{}),
    }));
  }

  // == Custom Dashboard state ==
  const WIDGET_LIBRARY = [
    {id:"safety_score",    label:"My Area Safety",       icon:"ti-shield-check",     desc:"Safety score for your registered area"},
    {id:"recent_incidents",label:"Nearby Incidents",     icon:"ti-alert-triangle",   desc:"Latest incidents near your location"},
    {id:"active_alerts",   label:"Active Alerts",        icon:"ti-bell-ringing",     desc:"Current public safety alerts in Ghana"},
    {id:"flood_summary",   label:"Flood Warnings",       icon:"ti-ripple",            desc:"Active flood zones by severity"},
    {id:"crime_type_bar",  label:"Incident Types",       icon:"ti-chart-bar",        desc:"What types of incidents are being reported"},
    {id:"top_risk",        label:"High Risk Areas",      icon:"ti-map-2",            desc:"Regions with highest safety concerns"},
    {id:"camera_status",   label:"Safety Cameras",       icon:"ti-video",            desc:"Active CCTV cameras in your area"},
    {id:"flood_video_count",label:"Flood Reports",       icon:"ti-video-plus",       desc:"Community flood reports with video evidence"},
    {id:"verified_rate",   label:"Report Accuracy",      icon:"ti-circle-check",     desc:"How many community reports have been verified"},
    {id:"alert_history",   label:"Alert History",        icon:"ti-history",          desc:"Recent public safety alerts"},
  ];
  const DEFAULT_WIDGETS = ["safety_score","recent_incidents","active_alerts","flood_summary"];
  const [myWidgets,setMyWidgets]         = useState(DEFAULT_WIDGETS);
  const [showWidgetPicker,setShowWidgetPicker] = useState(false);
  const [dashSaved,setDashSaved]         = useState(false);
  const [dragIdx,setDragIdx]             = useState(null);
  const [dragOverIdx,setDragOverIdx]     = useState(null);
  const [dashUserTab,setDashUserTab]     = useState("profile");
  const [savedLocations,setSavedLocations] = useState(()=>{try{return JSON.parse(localStorage.getItem('sg_saved_locs')||'[]');}catch(e){return[];}});
  const [notifPrefs,setNotifPrefs]       = useState(()=>{try{return JSON.parse(localStorage.getItem('sg_notif_prefs')||'{"floods":true,"crime":true,"fire":true,"alerts":true,"email":true,"sms":false}');}catch(e){return{floods:true,crime:true,fire:true,alerts:true,email:true,sms:false};}});
  const [editingProfile,setEditingProfile] = useState(false);
  const [profileForm,setProfileForm]     = useState({});
  const [avatarUploading,setAvatarUploading] = useState(false);

  function saveDashboard(){
    try{localStorage.setItem("safeghana_dashboard",JSON.stringify(myWidgets));}catch{}
    setDashSaved(true);setTimeout(()=>setDashSaved(false),2000);
  }
  function loadDashboard(){
    try{const s=localStorage.getItem("safeghana_dashboard");if(s)setMyWidgets(JSON.parse(s));}catch{}
  }

  // == Alert state ==
  const [showAlertModal,setShowAlertModal] = useState(false);
  const [alertType,setAlertType]           = useState(null);  // selected ALERT_TYPES entry
  const [alertRegions,setAlertRegions]     = useState([]);    // target regions
  const [alertMsg,setAlertMsg]             = useState("");    // custom message
  const [alertSending,setAlertSending]     = useState(false);
  const [activeAlerts,setActiveAlerts]     = useState([]);    // fired alerts
  const [alertHistory,setAlertHistory]     = useState([]);    // all past alerts
  const [shownBanner,setShownBanner]       = useState(null);  // currently visible banner
  const bannerTimer                        = useRef(null);

  // == Map state ==
  const [tooltip,setTooltip]   = useState(null);
  const [panel,setPanel]       = useState(null);
  const [panelIdx,setPanelIdx] = useState(0);
  const canvasRef              = useRef(null);
  const mapWrapRef             = useRef(null);
  const mapElRef               = useRef(null);   // div for Leaflet
  const leafMapRef             = useRef(null);   // L.map instance
  const leafReadyRef           = useRef(false);  // Leaflet loaded?
  const markersRef             = useRef({incidents:[],floods:[],cameras:[],pois:[],polygon:null,polyLayer:null,incCluster:null,camCluster:null,poiCluster:null});
  const dotsRef                = useRef([]);
  const mapMetaRef             = useRef({W:1,H:1,latMin:4.4,latMax:11.3,lngMin:-3.4,lngMax:1.3});
  const camDotsRef             = useRef([]); // canvas compat (unused by leaflet)

  // == Zoom / pan state ==
  const [zoom,setZoom]             = useState(1);     // 1 = full Ghana, max 8
  const [pan,setPan]               = useState({x:0,y:0}); // offset in normalised coords
  const isPanningRef               = useRef(false);
  const panStartRef                = useRef({mx:0,my:0,px:0,py:0});
  const zoomRef                    = useRef(1);
  const panRef                     = useRef({x:0,y:0});

  // == Legend filter state ==
  const [legendSevFilter,setLegendSevFilter] = useState(null);
  const [legendCamFilter,setLegendCamFilter] = useState(null);
  const [legendFloodFilter,setLegendFloodFilter] = useState(null);

  // == Fullscreen map ==
  const [mapFullscreen,setMapFullscreen]   = useState(false);
  const [mobileSheetOpen,setMobileSheetOpen] = useState(false);
  const [isMobile,setIsMobile]             = useState(window.innerWidth < 768);
  useEffect(()=>{
    const fn=()=>setIsMobile(window.innerWidth<768);
    window.addEventListener('resize',fn);
    return()=>window.removeEventListener('resize',fn);
  },[]);

  // == Polygon draw state ==
  const [drawMode,setDrawMode]             = useState(false);
  const [polyPoints,setPolyPoints]         = useState([]);
  const polyPointsRef                      = useRef([]);
  const [polyClosed,setPolyClosed]         = useState(false);
  const [polyEvents,setPolyEvents]         = useState(null);
  const [polyFilteredList,setPolyFilteredList] = useState([]);
  const [showPolyPanel,setShowPolyPanel]   = useState(false);
  const overlayCvRef                       = useRef(null);

  // == Camera state ==
  const [showCameras,setShowCameras]   = useState(true);
  const [cameras,setCameras]           = useState(STREET_CAMERAS); // live-updated from API
  const [selectedCam,setSelectedCam]  = useState(null);  // camera viewer modal
  const [camFilter,setCamFilter]       = useState("all"); // all|online|offline|maintenance
  const [camFeedPlaying,setCamFeedPlaying] = useState(false);
  const [camDownloading,setCamDownloading] = useState(false);
  const [camDownloadProgress,setCamDownloadProgress] = useState(0);
  const feedCanvasRef                 = useRef(null);
  const feedAnimRef                   = useRef(null);

  // == Report state ==
  const [form,setForm]               = useState({type:"",region:"",area:"",description:"",severity:"medium",date:new Date().toISOString().split("T")[0],time:"12:00"});
  const [uploadedFiles,setUploadedFiles] = useState([]);
  const [locStep,setLocStep]         = useState("ask");
  const [useCurrentLoc,setUseCurrentLoc] = useState(null);
  const [gpsCoords,setGpsCoords]     = useState(null);
  const [gpsGhanaPost,setGpsGhanaPost] = useState("");
  const [gpsAddress,setGpsAddress]   = useState("");
  const [manualPost,setManualPost]   = useState("");
  const [postError,setPostError]     = useState("");
  const [gpsError,setGpsError]       = useState("");

  // == Flood reports state ==
  const [floodReports,setFloodReports]   = useState([]);
  const [users,setUsers]                 = useState([]);
  const [showFloodLayer,setShowFloodLayer] = useState(true);
  const [showHeatmap,setShowHeatmap]       = useState(false);
  const heatLayerRef                       = useRef(null);
  const [floodDotsRef_]                  = useState({current:[]});
  const floodDotsRef                     = floodDotsRef_;
  const poiDotsRef                       = useRef([]);  // POI hit-test positions

  // == POI layer state ==
  const [showPOI,setShowPOI]                 = useState(true);
  const [showBoundaries,setShowBoundaries]   = useState(true);
  const [activePOICategories,setActivePOICategories] = useState([]); // empty array = show all
  const [selectedPOI,setSelectedPOI]         = useState(null); // clicked POI detail
  const [selectedFlood,setSelectedFlood] = useState(null);   // flood detail modal
  const [floodFilter,setFloodFilter]     = useState("all");  // all|mild|moderate|severe

  // == Registration state ==
  const [showRegModal,setShowRegModal]   = useState(false);
  const [regStep,setRegStep]             = useState(1);       // 1=account 2=location 3=video
  const [regForm,setRegForm]             = useState({name:"",email:"",phone:"",password:"",region:"",ghanaPost:"",area:""});
  const [regErrors,setRegErrors]         = useState({});
  const [verifyCode,setVerifyCode]       = useState("");
  const [verifyError,setVerifyError]     = useState("");
  const [verifyLoading,setVerifyLoading] = useState(false);
  const [pendingUser,setPendingUser]     = useState(null);
  const [loggedInUser,setLoggedInUserRaw] = useState(()=>{
    try{const u=localStorage.getItem('sg_user');return u?JSON.parse(u):null;}catch(e){return null;}
  });
  function setLoggedInUser(user){
    setLoggedInUserRaw(user);
    try{
      if(user) localStorage.setItem('sg_user',JSON.stringify(user));
      else localStorage.removeItem('sg_user');
    }catch(e){}
  }
  const isAdmin = loggedInUser?.role==="admin" || loggedInUser?.email==="clickitsystemsltd@gmail.com";
  const [showDemoModal,setShowDemoModal] = useState(false);
  const [demoForm,setDemoForm]           = useState({name:"",org:"",email:"",phone:"",message:""});
  const [demoSent,setDemoSent]           = useState(false);
  const [demoSending,setDemoSending]     = useState(false);
  const [showSplash,setShowSplash]       = useState(true);
  const [showOnboarding,setShowOnboarding] = useState(false);
  const [installPrompt,setInstallPrompt] = useState(null);
  const [showInstallBanner,setShowInstallBanner] = useState(false);
  useEffect(()=>{
    const handler=(e)=>{e.preventDefault();setInstallPrompt(e);setShowInstallBanner(true);};
    window.addEventListener('beforeinstallprompt',handler);
    return()=>window.removeEventListener('beforeinstallprompt',handler);
  },[]);
  const [lang,setLang]                   = useState(()=>localStorage.getItem("sg_lang")||"en");
  const t = (key) => (TRANSLATIONS[lang]||TRANSLATIONS.en)[key] || (TRANSLATIONS.en)[key] || key;
  const setLanguage = (l) => { setLang(l); localStorage.setItem("sg_lang",l); };
  const [showLogin,setShowLogin]         = useState(false);
  const [loginForm,setLoginForm]         = useState({email:"",password:""});
  const [loginError,setLoginError]       = useState("");
  const [loginView,setLoginView]         = useState("signin"); // "signin" | "forgot" | "reset"
  const [resetEmail,setResetEmail]       = useState("");
  const [resetCode,setResetCode]         = useState("");
  const [resetPassword,setResetPassword] = useState("");
  const [resetConfirm,setResetConfirm]   = useState("");
  const [resetMsg,setResetMsg]           = useState("");
  const [resetLoading,setResetLoading]   = useState(false);

  // == Flood report submission state ==
  const [showFloodModal,setShowFloodModal] = useState(false);
  const [floodForm,setFloodForm]         = useState({area:"",ghanaPost:"",region:"",depth:"Ankle-deep",duration:"",description:"",severity:"moderate"});
  const [floodVideo,setFloodVideo]       = useState(null);   // {name, size, url, duration}
  const [floodVideoError,setFloodVideoError] = useState("");
  const [floodGPS,setFloodGPS]           = useState(null);
  const [floodGPSLoading,setFloodGPSLoading] = useState(false);
  const [floodUploading,setFloodUploading] = useState(false);
  const [floodUploadProgress,setFloodUploadProgress] = useState(0);
  const [floodPostError,setFloodPostError] = useState("");

  // == Map search state ==
  const [mapSearchQuery,setMapSearchQuery]       = useState("");
  const [mapSearchResults,setMapSearchResults]   = useState([]);
  const [mapSearchOpen,setMapSearchOpen]         = useState(false);
  const [mapSearchStatus,setMapSearchStatus]     = useState("idle");
  const [mapSearchMsg,setMapSearchMsg]           = useState("");
  const searchMouseDownRef                       = useRef(false);
  const searchInputRef                           = useRef(null);
  const [searchRect,setSearchRect]               = useState(null);

  // == Voice state ==
  const [descMode,setDescMode]           = useState("text");      // "text" | "voice"
  const [voiceStatus,setVoiceStatus]     = useState("idle");      // idle|recording|processing|done|error
  const [voiceTranscript,setVoiceTranscript] = useState("");      // AI-transcribed text
  const [voiceError,setVoiceError]       = useState("");
  const [voiceDuration,setVoiceDuration] = useState(0);
  const mediaRecorderRef                 = useRef(null);
  const audioChunksRef                   = useRef([]);
  const voiceTimerRef                    = useRef(null);

  // == Derived ==
  const filtered = incidents.filter(i=>(ft==="All"||i.type===ft)&&(fr==="All"||i.region===fr)&&(fs==="All"||i.severity===fs));
  const typeCounts = incidentTypes.reduce((a,t)=>{a[t]=incidents.filter(i=>i.type===t).length;return a},{});
  const sevCounts={low:0,medium:0,high:0,critical:0};
  incidents.forEach(i=>{sevCounts[i.severity]=(sevCounts[i.severity]||0)+1;});

  // == Send alert ==============================================================
  function sendAlert(){
    if(!alertType)return;
    setAlertSending(true);
    setTimeout(()=>{
      const regions = alertRegions.length>0 ? alertRegions : ["All regions"];
      const newAlert = {
        id: Date.now(),
        type: alertType,
        regions,
        message: alertMsg || alertType.desc,
        timestamp: new Date(),
        active: true,
      };
      // Play unique sound
      playAlertSound(alertType.sound);
      setActiveAlerts(prev=>[newAlert,...prev]);
      setAlertHistory(prev=>[newAlert,...prev]);
      setShownBanner(newAlert);
      // Auto-dismiss banner after 8 seconds
      clearTimeout(bannerTimer.current);
      bannerTimer.current=setTimeout(()=>setShownBanner(null),8000);
      setAlertSending(false);
      setShowAlertModal(false);
      setAlertType(null);setAlertRegions([]);setAlertMsg("");
    },800);
  }

  function dismissAlert(id){
    setActiveAlerts(prev=>prev.filter(a=>a.id!==id));
    if(shownBanner?.id===id)setShownBanner(null);
  }

  function replaySound(alert){ playAlertSound(alert.type.sound); }

  // == Map draw ================================================================
  // Flood severity colours = distinct, clearly separated
  const FLOOD_COLOURS={
    severe:  {rgb:"183,28,28",  hex:"#B71C1C", wave:"rgba(229,115,115,0.5)", label:"Severe"},  // deep red
    moderate:{rgb:"230,81,0",   hex:"#E65100", wave:"rgba(255,183,77,0.5)",  label:"Moderate"}, // deep orange
    mild:    {rgb:"27,94,32",   hex:"#1B5E20", wave:"rgba(102,187,106,0.5)", label:"Mild"},     // deep green
  };

  const drawMap=useCallback(()=>{
    const c=canvasRef.current;if(!c)return;
    // Use parent container dimensions (canvas is position:absolute, height:100%)
    const parent=c.parentElement;
    const W=c.width=(parent?parent.offsetWidth:c.offsetWidth)||800;
    const H=c.height=(parent?parent.offsetHeight:c.offsetHeight)||480;
    const z=zoomRef.current,px=panRef.current.x,py=panRef.current.y;
    // Compute visible lat/lng window based on zoom & pan
    const BASE={latMin:4.4,latMax:11.3,lngMin:-3.4,lngMax:1.3};
    const latRange=(BASE.latMax-BASE.latMin)/z;
    const lngRange=(BASE.lngMax-BASE.lngMin)/z;
    const latCtr=(BASE.latMin+BASE.latMax)/2 + py;
    const lngCtr=(BASE.lngMin+BASE.lngMax)/2 + px;
    const latMin=latCtr-latRange/2,latMax=latCtr+latRange/2;
    const lngMin=lngCtr-lngRange/2,lngMax=lngCtr+lngRange/2;
    mapMetaRef.current={W,H,latMin,latMax,lngMin,lngMax};
    const ctx=c.getContext("2d");ctx.clearRect(0,0,W,H);
    const tX=lng=>((lng-lngMin)/(lngMax-lngMin))*W;
    const tY=lat=>H-((lat-latMin)/(latMax-latMin))*H;

    // == Draw Ghana country outline (outer border) ==
    ctx.beginPath();
    // Approximate outer Ghana border
    const outerBorder=[
      [-3.25,4.75],[-0.85,4.75],[ 0.10,4.80],[ 0.60,5.00],[ 1.10,6.10],
      [ 1.20,6.65],[ 1.00,7.10],[ 0.65,7.45],[ 0.90,7.80],[ 0.85,8.20],
      [ 0.55,8.55],[ 0.50,10.60],[ 0.15,10.98],[-0.40,11.00],[-0.80,10.90],
      [-1.15,10.65],[-2.00,10.65],[-2.50,10.90],[-3.05,10.70],[-3.20,10.20],
      [-3.20,9.55],[-3.20,7.50],[-3.25,7.20],[-3.25,5.20],[-3.25,4.75]
    ];
    outerBorder.forEach(([lng,lat],i)=>i===0?ctx.moveTo(tX(lng),tY(lat)):ctx.lineTo(tX(lng),tY(lat)));
    ctx.closePath();
    ctx.fillStyle="rgba(8,18,38,0.6)";ctx.fill();
    ctx.strokeStyle="rgba(100,160,255,0.25)";ctx.lineWidth=1.5;ctx.stroke();

    // == Draw region boundaries ==============================================
    if(showBoundaries){
      Object.entries(GHANA_REGION_BOUNDS).forEach(([regionId,coords])=>{
        if(coords.length<3)return;
        ctx.beginPath();
        coords.forEach(([lng,lat],i)=>i===0?ctx.moveTo(tX(lng),tY(lat)):ctx.lineTo(tX(lng),tY(lat)));
        ctx.closePath();
        ctx.fillStyle=REGION_FILL_COLORS[regionId]||"rgba(255,255,255,0.03)";
        ctx.fill();
        ctx.strokeStyle=REGION_STROKE_COLORS[regionId]||"rgba(255,255,255,0.3)";
        ctx.lineWidth=1.2;ctx.setLineDash([]);ctx.stroke();
        // Region label at centroid
        const lats=coords.map(c=>c[1]),lngs=coords.map(c=>c[0]);
        const clat=lats.reduce((a,b)=>a+b,0)/lats.length;
        const clng=lngs.reduce((a,b)=>a+b,0)/lngs.length;
        const cx=tX(clng),cy=tY(clat);
        const reg=GHANA_REGIONS.find(r=>r.id===regionId);
        if(reg&&cx>0&&cx<W&&cy>0&&cy<H){
          const rname=reg.name.replace(" Region","");
          const fontSize=Math.max(8,Math.min(11,z*9));
          ctx.font=`600 ${fontSize}px sans-serif`;
          ctx.fillStyle="rgba(180,210,255,0.7)";
          ctx.textAlign="center";ctx.textBaseline="middle";
          ctx.fillText(rname,cx,cy);
        }
      });
    }

    // == Subtle grid lines (lat/lng graticule) ==
    ctx.strokeStyle="rgba(0,0,0,0.05)";ctx.lineWidth=0.5;ctx.setLineDash([]);
    for(let lat=5;lat<=11;lat++){
      const y=tY(lat);if(y<0||y>H)continue;
      ctx.beginPath();ctx.moveTo(0,y);ctx.lineTo(W,y);ctx.stroke();
    }
    for(let lng=-3;lng<=1;lng++){
      const x=tX(lng);if(x<0||x>W)continue;
      ctx.beginPath();ctx.moveTo(x,0);ctx.lineTo(x,H);ctx.stroke();
    }

    // == Crime incidents (respects legendSevFilter) ==
    const sevFilterActive=legendSevFilter;
    const visFiltered=sevFilterActive?filtered.filter(i=>i.severity===sevFilterActive):filtered;
    const dots=[];
    const clusterDist=Math.max(8,18/z); // tighter clustering when zoomed in
    visFiltered.forEach((inc,idx)=>{
      let lat,lng;
      if(inc.lat&&inc.lng){lat=inc.lat;lng=inc.lng;}
      else{const r=GHANA_REGIONS.find(x=>x.id===inc.region);if(!r)return;
        const s=seedHash(String(inc.id)+idx);
        lat=r.lat+((s%100)/100-0.5)*0.65;lng=r.lng+(((s>>8)%100)/100-0.5)*0.65;}
      const ppx=tX(lng),ppy=tY(lat);
      const nearby=dots.find(d=>Math.hypot(d.x-ppx,d.y-ppy)<clusterDist);
      if(nearby)nearby.incidents.push(inc);
      else dots.push({x:ppx,y:ppy,incidents:[inc],severity:inc.severity});
    });
    const order=["critical","high","medium","low"];
    dots.forEach(d=>{d.severity=d.incidents.reduce((w,i)=>order.indexOf(i.severity)<order.indexOf(w)?i.severity:w,"low");});
    dots.forEach(d=>{
      const radius=incRadius(d.severity),col=incColor(d.severity);
      const g=ctx.createRadialGradient(d.x,d.y,0,d.x,d.y,radius);
      g.addColorStop(0,`rgba(${col},0.62)`);g.addColorStop(0.4,`rgba(${col},0.28)`);g.addColorStop(1,`rgba(${col},0)`);
      ctx.fillStyle=g;ctx.beginPath();ctx.arc(d.x,d.y,radius,0,Math.PI*2);ctx.fill();
    });
    dots.forEach(d=>{
      const count=d.incidents.length,hex=incHex(d.severity),r=count>9?13:10;
      ctx.beginPath();ctx.arc(d.x,d.y,r,0,Math.PI*2);
      ctx.fillStyle=hex;ctx.fill();
      ctx.strokeStyle="rgba(255,255,255,0.9)";ctx.lineWidth=1.5;ctx.stroke();
      ctx.fillStyle="#fff";ctx.font=`bold ${count>9?9:10}px sans-serif`;
      ctx.textAlign="center";ctx.textBaseline="middle";ctx.fillText(count,d.x,d.y);
    });
    dotsRef.current=dots;

    // == Cameras (respects legendCamFilter) ==
    if(showCameras){
      const camDots=[];
      const visCams=legendCamFilter?cameras.filter(c=>c.status===legendCamFilter):cameras;
      visCams.forEach(cam=>{
        const cx=tX(cam.lng),cy=tY(cam.lat);
        camDots.push({x:cx,y:cy,cam});
        const col=cam.status==="online"?"#00C853":cam.status==="offline"?"#F44336":"#FF9800";
        ctx.beginPath();ctx.arc(cx,cy,9,0,Math.PI*2);
        ctx.fillStyle=cam.status==="online"?"rgba(0,180,80,0.2)":cam.status==="offline"?"rgba(220,40,40,0.2)":"rgba(255,140,0,0.2)";
        ctx.fill();
        ctx.beginPath();ctx.arc(cx,cy,6,0,Math.PI*2);
        ctx.fillStyle=col;ctx.fill();
        ctx.strokeStyle="rgba(255,255,255,0.9)";ctx.lineWidth=1.5;ctx.stroke();
        ctx.fillStyle="#fff";ctx.beginPath();ctx.arc(cx,cy,2.5,0,Math.PI*2);ctx.fill();
        ctx.fillStyle="rgba(255,255,255,0.85)";ctx.font="7px sans-serif";
        ctx.textAlign="center";ctx.textBaseline="top";ctx.fillText(cam.id.replace("cam-","#"),cx,cy+8);
      });
      camDotsRef.current=camDots;
    } else { camDotsRef.current=[]; }

    // == Flood zones (respects legendFloodFilter, distinct colours per severity) ==
    if(showFloodLayer){
      const fDots=[];
      const visFloods=(floodFilter!=="all"?floodReports.filter(f=>f.severity===floodFilter):floodReports)
        .filter(f=>!legendFloodFilter||f.severity===legendFloodFilter);
      visFloods.forEach(flood=>{
        const fx=tX(flood.lng),fy=tY(flood.lat);
        const hasVideo=!!(flood.videoUrl||flood.videoName);
        fDots.push({x:fx,y:fy,flood});
        const fc=FLOOD_COLOURS[flood.severity]||FLOOD_COLOURS.mild;
        const sevRadius=(flood.severity==="severe"?55:flood.severity==="moderate"?40:28);
        // Outer glow
        const rg=ctx.createRadialGradient(fx,fy,0,fx,fy,sevRadius+18);
        rg.addColorStop(0,`rgba(${fc.rgb},0.32)`);
        rg.addColorStop(0.6,`rgba(${fc.rgb},0.10)`);
        rg.addColorStop(1,`rgba(${fc.rgb},0)`);
        ctx.fillStyle=rg;ctx.beginPath();ctx.arc(fx,fy,sevRadius+18,0,Math.PI*2);ctx.fill();
        // Inner zone
        const ig=ctx.createRadialGradient(fx,fy,0,fx,fy,sevRadius);
        ig.addColorStop(0,`rgba(${fc.rgb},0.55)`);ig.addColorStop(1,`rgba(${fc.rgb},0.08)`);
        ctx.fillStyle=ig;ctx.beginPath();ctx.arc(fx,fy,sevRadius,0,Math.PI*2);ctx.fill();
        // Wave rings
        [0.4,0.65,0.88].forEach((r,i)=>{
          ctx.beginPath();ctx.arc(fx,fy,sevRadius*r,0,Math.PI*2);
          ctx.strokeStyle=fc.wave.replace("0.5",(0.4-i*0.12).toFixed(2));
          ctx.lineWidth=1;ctx.stroke();
        });
        // Badge
        ctx.beginPath();ctx.arc(fx,fy,9,0,Math.PI*2);
        ctx.fillStyle=fc.hex;ctx.fill();
        ctx.strokeStyle="rgba(255,255,255,0.9)";ctx.lineWidth=1.5;ctx.stroke();
        ctx.fillStyle="#fff";ctx.font="bold 9px sans-serif";ctx.textAlign="center";ctx.textBaseline="middle";
        ctx.fillText("~",fx,fy);
        // FLOOD label
        ctx.fillStyle=fc.hex;ctx.font="bold 7px sans-serif";
        ctx.textAlign="center";ctx.textBaseline="top";ctx.fillText("FLOOD",fx,fy+11);
        // == VIDEO indicator badge ==
        if(hasVideo){
          const vx=fx+8,vy=fy-14;
          ctx.beginPath();ctx.arc(vx,vy,6,0,Math.PI*2);
          ctx.fillStyle="#FCD116";ctx.fill();
          ctx.strokeStyle="#0A1628";ctx.lineWidth=1;ctx.stroke();
          // Play triangle
          ctx.fillStyle="#0A1628";ctx.beginPath();
          ctx.moveTo(vx-2,vy-3);ctx.lineTo(vx-2,vy+3);ctx.lineTo(vx+3,vy);
          ctx.closePath();ctx.fill();
        }
      });
      floodDotsRef.current=fDots;
    } else { floodDotsRef.current=[]; }

    // == Zoom level indicator ==
    if(z>1){
      ctx.fillStyle="rgba(255,255,255,0.15)";ctx.fillRect(W-52,H-22,48,16);
      ctx.fillStyle="#fff";ctx.font="bold 9px monospace";ctx.textAlign="center";ctx.textBaseline="middle";
      ctx.fillText(`${z.toFixed(1)}x zoom`,W-28,H-14);
    }
    // == Draw Places of Interest (drawn LAST so they appear on top) ======
    if(showPOI){
      const visPOIs=activePOICategories.length===0
        ? GHANA_BUSINESSES
        : GHANA_BUSINESSES.filter(b=>activePOICategories.includes(b.category));
      const pDots=[];
      const z=zoomRef.current;

      visPOIs.forEach(poi=>{
        if(!poi.lat||!poi.lng)return;
        const px=tX(poi.lng),py=tY(poi.lat);
        // Skip if outside visible canvas area
        if(px<-20||px>W+20||py<-20||py>H+20)return;
        pDots.push({x:px,y:py,poi});
        const col=POI_CATEGORY_COLORS[poi.category]||"#607D8B";

        // Outer glow
        const grad=ctx.createRadialGradient(px,py,0,px,py,16);
        grad.addColorStop(0,col+"55");grad.addColorStop(1,col+"00");
        ctx.fillStyle=grad;ctx.beginPath();ctx.arc(px,py,16,0,Math.PI*2);ctx.fill();

        // Scale marker size with zoom
        const mSz=Math.max(5,Math.min(9,5+z*1.5));
        // White backing circle
        ctx.beginPath();ctx.arc(px,py,mSz+2,0,Math.PI*2);
        ctx.fillStyle="rgba(5,12,25,0.75)";ctx.fill();

        // Coloured icon circle
        ctx.beginPath();ctx.arc(px,py,mSz,0,Math.PI*2);
        ctx.fillStyle=col;ctx.fill();
        ctx.strokeStyle="#fff";ctx.lineWidth=1.5;ctx.stroke();

        // Category initial / symbol
        ctx.fillStyle="#fff";
        ctx.font="bold 8px sans-serif";
        ctx.textAlign="center";ctx.textBaseline="middle";
        const sym=(POI_SYMBOLS[poi.category]||poi.category[0]).substring(0,1);
        ctx.fillText(sym,px,py);

        // Label = always show short name, fade at very low zoom
        const label=poi.name.length>16?poi.name.substring(0,14)+"=":poi.name;
        ctx.font=`${z>=2?"600":"500"} ${z>=2?10:9}px sans-serif`;
        const tw=ctx.measureText(label).width;
        const lx=px-tw/2-4,ly=py+11;
        // Label background
        ctx.fillStyle="rgba(5,12,25,0.88)";
        ctx.beginPath();
        const lw=tw+8,lh=14,lr=4;
        ctx.moveTo(lx+lr,ly);ctx.lineTo(lx+lw-lr,ly);ctx.quadraticCurveTo(lx+lw,ly,lx+lw,ly+lr);
        ctx.lineTo(lx+lw,ly+lh-lr);ctx.quadraticCurveTo(lx+lw,ly+lh,lx+lw-lr,ly+lh);
        ctx.lineTo(lx+lr,ly+lh);ctx.quadraticCurveTo(lx,ly+lh,lx,ly+lh-lr);
        ctx.lineTo(lx,ly+lr);ctx.quadraticCurveTo(lx,ly,lx+lr,ly);
        ctx.closePath();ctx.fill();
        // Label border in category colour
        ctx.strokeStyle=col+"88";ctx.lineWidth=0.8;ctx.stroke();
        // Label text
        ctx.fillStyle="#fff";ctx.textAlign="center";ctx.textBaseline="middle";
        ctx.fillText(label,px,ly+lh/2);
      });
      poiDotsRef.current=pDots;
    } else {
      poiDotsRef.current=[];
    }

    // Zoom level indicator
    if(zoomRef.current>1){
      ctx.fillStyle="rgba(255,255,255,0.15)";ctx.fillRect(W-60,H-22,56,16);
      ctx.fillStyle="#fff";ctx.font="bold 9px monospace";ctx.textAlign="center";ctx.textBaseline="middle";
      ctx.fillText(`${zoomRef.current.toFixed(1)}x zoom`,W-32,H-14);
    }
  },[filtered,showCameras,floodReports,showFloodLayer,floodFilter,zoom,pan,legendSevFilter,legendCamFilter,legendFloodFilter,showPOI,activePOICategories,showBoundaries]);

  // Keep refs in sync so drawMap closure always has fresh values
  useEffect(()=>{zoomRef.current=zoom;panRef.current=pan;if(tab==="map")drawMap();},[zoom,pan]);
  useEffect(()=>{if(tab==="map")setTimeout(drawMap,60);},[tab,drawMap]);
  useEffect(()=>{
    if(tab==="incidents"){
      setIncidentsLoading(true);
      const t=setTimeout(()=>setIncidentsLoading(false),600);
      return()=>clearTimeout(t);
    }
  },[tab]);
  useEffect(()=>{
    setMapStatsLoading(true);
    const t=setTimeout(()=>setMapStatsLoading(false),800);
    return()=>clearTimeout(t);
  },[incidents]);
  useEffect(()=>{loadDashboard();},[]);  // load saved dashboard on mount

  // Auto-refresh data every 5 minutes
  useEffect(()=>{
    const id=setInterval(()=>{
      fetch(`${API_BASE}/incidents`).then(r=>r.ok?r.json():null).then(d=>{
        if(d?.incidents?.length>0){
          setIncidents(d.incidents.map(r=>({...r,lat:parseFloat(r.lat)||r.lat,lng:parseFloat(r.lng)||r.lng,upvotes:r.upvotes||0,verified:r.verified||false,mediaCount:r.media_count||r.mediaCount||0,aiClassification:r.ai_classification||r.aiClassification||"Pending",ghanaPost:r.ghana_post||r.ghanaPost||""})));
          setLastFetched(new Date());
        }
      }).catch(()=>{});
    },5*60*1000);
    return()=>clearInterval(id);
  },[]);

  function timeAgo(date){
    if(!date)return"";
    const s=Math.floor((new Date()-date)/1000);
    if(s<60)return"just now";
    if(s<3600)return`${Math.floor(s/60)} min ago`;
    if(s<86400)return`${Math.floor(s/3600)}h ago`;
    return date.toLocaleDateString();
  }

  function handleUpvote(incId){
    const id=String(incId);
    if(upvotedIds.has(id))return; // already upvoted
    const newSet=new Set([...upvotedIds,id]);
    setUpvotedIds(newSet);
    localStorage.setItem("sg_upvoted",JSON.stringify([...newSet]));
    setIncidents(prev=>prev.map(i=>String(i.id)===id?{...i,upvotes:(i.upvotes||0)+1}:i));
    // Persist to API
    fetch(`${API_BASE}/incidents/${id}/upvote`,{method:"POST"}).catch(()=>{});
  }

  function handleConfirm(incId){
    const id=String(incId);
    if(confirmedIds.has(id))return;
    const newSet=new Set([...confirmedIds,id]);
    setConfirmedIds(newSet);
    localStorage.setItem("sg_confirmed",JSON.stringify([...newSet]));
    setIncidents(prev=>prev.map(i=>String(i.id)===id?{...i,confirms:(i.confirms||0)+1}:i));
    fetch(`${API_BASE}/incidents/${id}/confirm`,{method:"POST"}).catch(()=>{});
  }

  function getVerificationTier(inc){
    if(inc.verified && inc.official_source) return {label:"Official",color:"#1565C0",bg:"#E3F2FD",icon:"ti-building-bank"};
    if(inc.verified) return {label:"Police Verified",color:"#2E7D32",bg:"#E8F5E9",icon:"ti-shield-check"};
    const confirms=inc.confirms||0;
    const upvotes=inc.upvotes||0;
    if(confirms>=5||upvotes>=30) return {label:"Community Confirmed",color:"#E65100",bg:"#FFF3E0",icon:"ti-users"};
    return {label:"Reported",color:"#888",bg:"#F5F5F5",icon:"ti-clock"};
  }

  // == Load real data from API on mount ========================================
  useEffect(()=>{
    async function loadData(){
      try{
        const [incRes,camRes,floodRes] = await Promise.all([
          fetch(`${API_BASE}/incidents`),
          fetch(`${API_BASE}/cameras`),
          fetch(`${API_BASE}/floods`),
        ]);
        if(incRes.ok){
          const d=await incRes.json();
          const rows=d.incidents||d||[];
          if(rows.length>0){
            setIncidents(rows.map(r=>({
              ...r,
              lat:parseFloat(r.lat)||r.lat,
              lng:parseFloat(r.lng)||r.lng,
              upvotes:r.upvotes||0,
              verified:r.verified||false,
              mediaCount:r.media_count||r.mediaCount||0,
              aiClassification:r.ai_classification||r.aiClassification||"Pending",
              ghanaPost:r.ghana_post||r.ghanaPost||"",
            })));
          } else {
            setIncidents(SEED_INCIDENTS); // fallback to seed if DB empty
          }
        } else { setIncidents(SEED_INCIDENTS); }
      } catch(e){ console.warn("API not reachable, using seed data",e); setIncidents(SEED_INCIDENTS); }
      finally{ setIncidentsLoading(false); setLastFetched(new Date()); }

      try{
        const camRes=await fetch(`${API_BASE}/cameras`);
        if(camRes.ok){
          const d=await camRes.json();
          const rows=d.cameras||d||[];
          if(rows.length>0){
            setCameras(rows.map(r=>({
              ...r,
              lat:parseFloat(r.lat)||r.lat,
              lng:parseFloat(r.lng)||r.lng,
              ghanaPost:r.ghana_post||r.ghanaPost||"",
              incidents_nearby:r.incidents_nearby||0,
            })));
          }
        }
      } catch(e){ console.warn("Cameras API error",e); }

      try{
        const floodRes=await fetch(`${API_BASE}/floods`);
        if(floodRes.ok){
          const d=await floodRes.json();
          const rows=d.floods||d||[];
          if(rows.length>0){
            setFloodReports(rows.map(r=>({
              ...r,
              lat:parseFloat(r.lat)||r.lat,
              lng:parseFloat(r.lng)||r.lng,
              ghanaPost:r.ghana_post||r.ghanaPost||"",
              upvotes:r.upvotes||0,
              verified:r.verified||false,
            })));
          } else { setFloodReports(SEED_FLOOD_REPORTS); }
        } else { setFloodReports(SEED_FLOOD_REPORTS); }
      } catch(e){ console.warn("Floods API error",e); setFloodReports(SEED_FLOOD_REPORTS); }

      try{
        const typesRes=await fetch(`${API_BASE}/incident-types`);
        if(typesRes.ok){
          const d=await typesRes.json();
          if(Array.isArray(d.types)&&d.types.length>0)setIncidentTypes(d.types);
          // else keep the CRIME_TYPES fallback already in state
        }
      } catch(e){ console.warn("Incident types API error, using fallback list",e); }

      // Users are loaded from seed data locally; citizen registration goes to /api/public/register
      setUsers(SEED_USERS);
    }
    loadData();
  },[]);

  // Stop feed when modal closes
  useEffect(()=>{if(!selectedCam){stopFeed();}else if(selectedCam.status==="online"){setTimeout(()=>{if(feedCanvasRef.current)startFeed(selectedCam);},200);}},[selectedCam]);

  function hitTest(mx,my){return dotsRef.current.find(d=>Math.hypot(d.x-mx,d.y-my)<=Math.max(incRadius(d.severity),16))||null;}
  function camHitTest(mx,my){return camDotsRef.current.find(d=>Math.hypot(d.x-mx,d.y-my)<=10)||null;}
  function floodHitTest(mx,my){return floodDotsRef.current.find(d=>Math.hypot(d.x-mx,d.y-my)<=28)||null;}
  function poiHitTest(mx,my){return poiDotsRef.current.find(d=>Math.hypot(d.x-mx,d.y-my)<=12)||null;}
  function onMouseMove(e){
    const rect=canvasRef.current?.getBoundingClientRect();if(!rect)return;
    const mx=e.clientX-rect.left,my=e.clientY-rect.top;
    const cam=camHitTest(mx,my);
    if(cam){canvasRef.current.style.cursor="pointer";let tx=mx+18,ty=my-10;if(tx+310>rect.width)tx=mx-320;if(ty+180>rect.height)ty=rect.height-190;if(ty<0)ty=8;setTooltip({x:tx,y:ty,camDot:cam});return;}
    const fl=floodHitTest(mx,my);
    if(fl){canvasRef.current.style.cursor="pointer";let tx=mx+18,ty=my-10;if(tx+310>rect.width)tx=mx-320;if(ty+180>rect.height)ty=rect.height-190;if(ty<0)ty=8;setTooltip({x:tx,y:ty,floodDot:fl});return;}
    const poi=poiHitTest(mx,my);
    if(poi){canvasRef.current.style.cursor="pointer";let tx=mx+18,ty=my-10;if(tx+310>rect.width)tx=mx-320;if(ty+180>rect.height)ty=rect.height-190;if(ty<0)ty=8;setTooltip({x:tx,y:ty,poiDot:poi});return;}
    const dot=hitTest(mx,my);
    if(dot){canvasRef.current.style.cursor="pointer";let tx=mx+18,ty=my-10;if(tx+310>rect.width)tx=mx-320;if(ty+180>rect.height)ty=rect.height-190;if(ty<0)ty=8;setTooltip({x:tx,y:ty,dot});}
    else{canvasRef.current.style.cursor="default";setTooltip(null);}
  }
  function onMouseLeave(){setTooltip(null);canvasRef.current&&(canvasRef.current.style.cursor="default");}

  // == Zoom helpers =============================================================
  // =======================================================================
  // LEAFLET MAP SYSTEM = replaces canvas drawing
  // =======================================================================
  const SEV_HEX={"critical":"#9C27B0","high":"#F44336","medium":"#FF9800","low":"#4CAF50"};
  const FLOOD_HEX={"severe":"#B71C1C","moderate":"#E65100","mild":"#1B5E20"};

  async function initLeaflet(){
    if(!mapElRef.current||leafMapRef.current||window._sgMapInitializing)return;
    window._sgMapInitializing=true;
    const L=await loadLeaflet();
    await loadLeafletCluster();
    // Guard again after await (StrictMode double-invoke)
    if(leafMapRef.current){window._sgMapInitializing=false;return;}
    // Remove any lingering Leaflet instance on the DOM node
    if(mapElRef.current._leaflet_id){
      mapElRef.current._leaflet_id=null;
    }
    const map=L.map(mapElRef.current,{
      center:[7.9,-1.0],zoom:7,
      zoomControl:false,attributionControl:true,
      preferCanvas:true,
    });
    L.control.zoom({position:"bottomright"}).addTo(map);

    // == Base tile layers =================================================
    const tiles={
      "Streets":L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",{attribution:"© OpenStreetMap",maxZoom:19}),
      "Satellite":L.tileLayer("https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}",{attribution:"© Esri",maxZoom:19}),
      "Topo":L.tileLayer("https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png",{attribution:"© OpenTopoMap",maxZoom:17}),
      "CartoDB":L.tileLayer("https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",{attribution:"© CartoDB",maxZoom:19}),
    };
    tiles["CartoDB"].addTo(map);
    L.control.layers(tiles,{},{position:"topright",collapsed:true}).addTo(map);

    leafMapRef.current=map;
    leafReadyRef.current=true;
    window._sgMapInitializing=false;
    map.whenReady(()=>{
      setTimeout(()=>{
        try{map.invalidateSize();}catch(e){}
        renderLeafletMarkers();
      },300);
    });
  }

  function makeIncidentIcon(L,sev,count){
    const col=SEV_HEX[sev]||"#607D8B";
    const sevShape={"critical":"!","high":"▲","medium":"◆","low":"●"};
    const shape=sevShape[sev]||"●";
    return L.divIcon({className:"",iconAnchor:[10,22],popupAnchor:[0,-22],
      html:`<div style="width:20px;height:26px;position:relative" role="img" aria-label="${sev} severity">
        <svg viewBox="0 0 20 26" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:100%">
          <path d="M10 0 C4.5 0 0 4.5 0 10 C0 17 10 26 10 26 C10 26 20 17 20 10 C20 4.5 15.5 0 10 0Z" fill="${col}" stroke="#fff" stroke-width="1.5"/>
        </svg>
        <span style="position:absolute;top:4px;left:50%;transform:translateX(-50%);color:#fff;font-size:8px;font-weight:700;line-height:1">${count>1?count:shape}</span>
      </div>`});
  }
  function makeFloodIcon(L,sev){
    const col=FLOOD_HEX[sev]||"#1565C0";
    return L.divIcon({className:"",iconAnchor:[10,22],popupAnchor:[0,-22],
      html:`<div style="width:20px;height:26px;position:relative">
        <svg viewBox="0 0 20 26" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:100%">
          <path d="M10 0 C4.5 0 0 4.5 0 10 C0 17 10 26 10 26 C10 26 20 17 20 10 C20 4.5 15.5 0 10 0Z" fill="${col}" stroke="#fff" stroke-width="1.5"/>
        </svg>
        <span style="position:absolute;top:5px;left:50%;transform:translateX(-50%);font-size:9px;line-height:1">🌊</span>
      </div>`});
  }
  function makeCamIcon(L,status){
    const col=status==="online"?"#4CAF50":status==="offline"?"#F44336":"#FF9800";
    return L.divIcon({className:"",iconAnchor:[10,22],popupAnchor:[0,-22],
      html:`<div style="width:20px;height:26px;position:relative">
        <svg viewBox="0 0 20 26" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:100%">
          <path d="M10 0 C4.5 0 0 4.5 0 10 C0 17 10 26 10 26 C10 26 20 17 20 10 C20 4.5 15.5 0 10 0Z" fill="${col}" stroke="#fff" stroke-width="1.5"/>
        </svg>
        <span style="position:absolute;top:5px;left:50%;transform:translateX(-50%);font-size:9px;line-height:1">📷</span>
      </div>`});
  }
  function makePOIIcon(L,cat){
    const col=POI_CATEGORY_COLORS[cat]||"#607D8B";
    const ic=BIZ_CATEGORY_ICONS[cat]||"ti-building";
    return L.divIcon({className:"",iconAnchor:[10,22],popupAnchor:[0,-22],
      html:`<div style="width:20px;height:26px;position:relative">
        <svg viewBox="0 0 20 26" xmlns="http://www.w3.org/2000/svg" style="width:100%;height:100%">
          <path d="M10 0 C4.5 0 0 4.5 0 10 C0 17 10 26 10 26 C10 26 20 17 20 10 C20 4.5 15.5 0 10 0Z" fill="${col}" stroke="#fff" stroke-width="1.5"/>
        </svg>
        <i class="ti ${ic}" style="position:absolute;top:4px;left:50%;transform:translateX(-50%);color:#fff;font-size:8px;line-height:1"></i>
      </div>`});
  }

  async function renderLeafletMarkers(){
    const L=window.L;const map=leafMapRef.current;
    if(!L||!map||!map.getContainer||!map.getContainer())return;
    try{map.getSize();}catch(e){return;}
    // Wait for map to be fully ready
    if(!map._loaded)return;
    // Ensure cluster plugin is loaded
    if(!L.markerClusterGroup){await loadLeafletCluster();}
    if(!L.markerClusterGroup){console.warn("markercluster not available");}
    const M=markersRef.current;

    // Clear existing markers
    M.incidents.forEach(m=>map.removeLayer(m));M.incidents=[];
    M.floods.forEach(m=>map.removeLayer(m));M.floods=[];
    M.cameras.forEach(m=>map.removeLayer(m));M.cameras=[];
    M.pois.forEach(m=>map.removeLayer(m));M.pois=[];
    // Remove old cluster groups
    if(M.incCluster){map.removeLayer(M.incCluster);M.incCluster=null;}
    if(M.camCluster){map.removeLayer(M.camCluster);M.camCluster=null;}
    if(M.poiCluster){map.removeLayer(M.poiCluster);M.poiCluster=null;}

    // == Incidents - MarkerClusterGroup =====================================
    const sevOrder=["critical","high","medium","low"];
    const visInc=(legendSevFilter?incidents.filter(i=>i.severity===legendSevFilter):incidents)
      .filter(i=>ft==="All"||i.type===ft).filter(i=>fs==="All"||i.severity===fs);

    const incCluster = window.L.markerClusterGroup&&window.L.markerClusterGroup({
      maxClusterRadius:80,
      showCoverageOnHover:false,
      zoomToBoundsOnClick:true,
      spiderfyOnMaxZoom:true,
      disableClusteringAtZoom:16,
      iconCreateFunction(cluster){
        const markers=cluster.getAllChildMarkers();
        const topSev=markers.reduce((w,mk)=>{
          const s=mk.options._sev||"low";
          return sevOrder.indexOf(s)<sevOrder.indexOf(w)?s:w;
        },"low");
        const col=SEV_HEX[topSev]||"#607D8B";
        const count=cluster.getChildCount();
        const size=count>=20?44:count>=10?38:32;
        return L.divIcon({
          html:`<div style="width:${size}px;height:${size}px;border-radius:50%;background:${col};border:3px solid #fff;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:${count>=10?11:13}px;color:#fff;box-shadow:0 2px 8px ${col}88;">${count}</div>`,
          className:"",iconSize:[size,size],iconAnchor:[size/2,size/2],
        });
      },
    });
    if(!incCluster){console.warn("markerClusterGroup not available");}

    visInc.forEach(inc=>{
      try{
      const r=GHANA_REGIONS.find(x=>x.id===inc.region);if(!r)return;
      const s=seedHash?.(String(inc.id))||Math.random()*10000;
      const lat=Number(inc.lat)||(r.lat+((s%100)/100-0.5)*0.5);
      const lng=Number(inc.lng)||(r.lng+(((s>>8)%100)/100-0.5)*0.5);
      if(!lat||!lng||isNaN(lat)||isNaN(lng))return;
      const mk=L.marker([lat,lng],{icon:makeIncidentIcon(L,inc.severity,1),_sev:inc.severity});
      mk.bindPopup(`<div style="min-width:200px">
        <div style="font-weight:700;font-size:14px;margin-bottom:4px">${inc.type}</div>
        <div style="color:#666;font-size:12px;margin-bottom:4px"><b>Area:</b> ${inc.area||"-"}</div>
        <div style="color:#666;font-size:12px;margin-bottom:4px"><b>Date:</b> ${inc.date}</div>
        <div style="font-size:11px;margin-bottom:4px">
          <span style="background:${SEV_HEX[inc.severity]}22;color:${SEV_HEX[inc.severity]};padding:2px 8px;border-radius:8px;font-weight:600">${inc.severity?.toUpperCase()}</span>
          ${inc.verified?'<span style="color:#2196F3;margin-left:6px">✓ Verified</span>':""}
        </div>
        <div style="color:#555;font-size:11px;margin-top:6px;font-style:italic">${(inc.description||"").substring(0,80)}${(inc.description||"").length>80?"...":""}</div>
      </div>`,{maxWidth:280});
      if(incCluster)incCluster.addLayer(mk);
      else mk.addTo(map);
      M.incidents.push(mk);
      }catch(e){}
    });
    if(incCluster){map.addLayer(incCluster);M.incCluster=incCluster;}

    // == Flood zones ========================================================
    if(showFloodLayer){
      const visFloods=legendFloodFilter?floodReports.filter(f=>f.severity===legendFloodFilter):floodReports;
      visFloods.forEach(flood=>{
        const flat=parseFloat(flood.lat),flng=parseFloat(flood.lng);
        if(!flat||!flng||isNaN(flat)||isNaN(flng)||flat<4||flat>12||flng<-4||flng>2)return;
        const col=FLOOD_HEX[flood.severity]||"#1565C0";
        // Radius circle
        const circle=L.circle([flat,flng],{
          radius:flood.severity==="severe"?4500:flood.severity==="moderate"?3000:1800,
          color:col,fillColor:col,fillOpacity:0.18,weight:2,opacity:0.7
        }).addTo(map);
        const mk=L.marker([flat,flng],{icon:makeFloodIcon(L,flood.severity)}).addTo(map);
        const popup=`<div style="min-width:190px">
          <div style="font-weight:700;font-size:13px;color:${col};margin-bottom:4px">🌊 Flood Zone = ${flood.severity.toUpperCase()}</div>
          <div style="font-size:12px;color:#555;margin-bottom:3px"><b>Area:</b> ${flood.area}</div>
          <div style="font-size:12px;color:#555;margin-bottom:3px"><b>Depth:</b> ${flood.depth}</div>
          <div style="font-size:12px;color:#555;margin-bottom:6px"><b>Reporter:</b> ${flood.userName}</div>
          ${flood.videoUrl||flood.videoName?'<div style="color:#1565C0;font-size:11px;font-weight:600">📹 Video evidence available</div>':""}
        </div>`;
        mk.bindPopup(popup,{maxWidth:260});
        circle.bindPopup(popup,{maxWidth:260});
        M.floods.push(mk);M.floods.push(circle);
      });
    }

    // == Cameras ============================================================
    if(showCameras){
      const visCams=legendCamFilter?cameras.filter(c=>c.status===legendCamFilter):cameras;
      const camCluster=window.L.markerClusterGroup&&window.L.markerClusterGroup({
        maxClusterRadius:80,showCoverageOnHover:false,disableClusteringAtZoom:16,
        iconCreateFunction(cluster){
          const count=cluster.getChildCount();
          return L.divIcon({html:`<div style="width:30px;height:30px;border-radius:50%;background:#37474F;border:2px solid #fff;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:11px;color:#fff;">📷${count}</div>`,className:"",iconSize:[30,30],iconAnchor:[15,15]});
        },
      });
      visCams.forEach(cam=>{
        const mk=L.marker([cam.lat,cam.lng],{icon:makeCamIcon(L,cam.status)});
        mk.bindPopup(`<div style="min-width:190px">
          <div style="font-weight:700;font-size:13px;margin-bottom:4px">📷 ${cam.name}</div>
          <div style="font-size:12px;color:#555;margin-bottom:2px"><b>Area:</b> ${cam.area}</div>
          <div style="font-size:12px;color:#555;margin-bottom:2px"><b>Resolution:</b> ${cam.resolution} @ ${cam.fps}fps</div>
          <div style="font-size:12px;color:#555;margin-bottom:4px"><b>Operator:</b> ${cam.operator}</div>
          <span style="background:${cam.status==="online"?"#E8F5E9":cam.status==="offline"?"#FFEBEE":"#FFF3E0"};color:${cam.status==="online"?"#2E7D32":cam.status==="offline"?"#C62828":"#E65100"};padding:2px 8px;border-radius:8px;font-size:11px;font-weight:600">${cam.status.toUpperCase()}</span>
        </div>`,{maxWidth:260});
        if(camCluster)camCluster.addLayer(mk);else mk.addTo(map);
        M.cameras.push(mk);
      });
      if(camCluster){map.addLayer(camCluster);M.camCluster=camCluster;}
    }

    // == POIs ==============================================================
    if(showPOI){
      const visPOIs=activePOICategories.length===0?GHANA_BUSINESSES:GHANA_BUSINESSES.filter(b=>activePOICategories.includes(b.category));
      const poiCluster=window.L.markerClusterGroup&&window.L.markerClusterGroup({
        maxClusterRadius:80,showCoverageOnHover:false,disableClusteringAtZoom:16,
        iconCreateFunction(cluster){
          const count=cluster.getChildCount();
          return L.divIcon({html:`<div style="width:28px;height:28px;border-radius:50%;background:#607D8B;border:2px solid #fff;display:flex;align-items:center;justify-content:center;font-weight:700;font-size:10px;color:#fff;">${count}</div>`,className:"",iconSize:[28,28],iconAnchor:[14,14]});
        },
      });
      visPOIs.forEach(poi=>{
        const plat=parseFloat(poi.lat),plng=parseFloat(poi.lng);
        if(!plat||!plng||isNaN(plat)||isNaN(plng))return;
        const mk=L.marker([plat,plng],{icon:makePOIIcon(L,poi.category)});
        mk.bindPopup(`<div style="min-width:180px">
          <div style="font-weight:700;font-size:13px;margin-bottom:3px">${poi.name}</div>
          <div style="margin-bottom:4px"><span style="background:${POI_CATEGORY_COLORS[poi.category]||"#607D8B"}22;color:${POI_CATEGORY_COLORS[poi.category]||"#607D8B"};padding:1px 7px;border-radius:8px;font-size:10px;font-weight:600">${poi.category}</span></div>
          <div style="font-size:11px;color:#666"><b>Area:</b> ${poi.area}</div>
          <div style="font-size:11px;color:#666;font-family:monospace">${poi.ghanaPost||""}</div>
        </div>`,{maxWidth:240});
        if(poiCluster)poiCluster.addLayer(mk);else mk.addTo(map);
        M.pois.push(mk);
      });
      if(poiCluster){map.addLayer(poiCluster);M.poiCluster=poiCluster;}
    }
  }

  async function renderHeatmap(visible){
    const L=window.L;const map=leafMapRef.current;if(!L||!map)return;
    if(heatLayerRef.current){map.removeLayer(heatLayerRef.current);heatLayerRef.current=null;}
    if(!visible)return;
    await loadLeafletHeat();if(!L.heatLayer)return;
    const sevWeight={critical:1.0,high:0.75,medium:0.5,low:0.25};
    const points=[];
    incidents.forEach(inc=>{const lat=Number(inc.lat);const lng=Number(inc.lng);if(!lat||!lng||isNaN(lat)||isNaN(lng))return;points.push([lat,lng,sevWeight[inc.severity]||0.4]);});
    floodReports.forEach(f=>{const lat=Number(f.lat);const lng=Number(f.lng);if(!lat||!lng||isNaN(lat)||isNaN(lng))return;const w=f.severity==="severe"?1.0:f.severity==="moderate"?0.7:0.45;points.push([lat,lng,w]);});
    if(points.length===0)return;
    const heat=L.heatLayer(points,{radius:35,blur:25,maxZoom:14,max:1.0,gradient:{0.0:"#313695",0.2:"#4575B4",0.35:"#74ADD1",0.5:"#FEE090",0.65:"#F46D43",0.8:"#D73027",1.0:"#A50026"}});
    heat.addTo(map);heatLayerRef.current=heat;
  }

  // Re-render markers when relevant state changes
  useEffect(()=>{
    if(leafReadyRef.current){renderLeafletMarkers();renderHeatmap(showHeatmap);}
  },[incidents,floodReports,showFloodLayer,showCameras,showPOI,showHeatmap,
     activePOICategories,legendSevFilter,legendCamFilter,legendFloodFilter,ft,fs]);

  // == Polygon drawing on Leaflet =========================================
  function startLeafletDraw(){
    const L=window.L;const map=leafMapRef.current;if(!L||!map)return;
    setDrawMode(true);setPolyClosed(false);
    setPolyPoints([]);polyPointsRef.current=[];
    setPolyEvents(null);setPolyFilteredList([]);setShowPolyPanel(false);
    const M=markersRef.current;
    if(M.polyLayer){try{map.removeLayer(M.polyLayer);}catch(e){}M.polyLayer=null;}
    map.getContainer().style.cursor="crosshair";

    // Create a plain SVG overlay for drawing preview - no Leaflet renderer needed
    const container=map.getContainer();
    const svg=document.createElementNS("http://www.w3.org/2000/svg","svg");
    svg.style.cssText="position:absolute;inset:0;width:100%;height:100%;pointer-events:none;z-index:499;";
    const polyline=document.createElementNS("http://www.w3.org/2000/svg","polyline");
    polyline.setAttribute("fill","none");
    polyline.setAttribute("stroke","#FF6600");
    polyline.setAttribute("stroke-width","4");
    polyline.setAttribute("stroke-dasharray","8,4");
    polyline.setAttribute("stroke-linecap","round");
    polyline.setAttribute("filter","drop-shadow(0 0 3px rgba(255,102,0,0.8))");
    svg.appendChild(polyline);
    container.appendChild(svg);
    map._sgDrawSVG=svg;

    const latlngs=[];

    function latlngToSVGPoint(ll){
      const zoom=map.getZoom();
      const center=map._lastCenter||map.options.center||L.latLng(7.9,-1.0);
      const size=map.getSize();
      const centerPx=map.project(center,zoom);
      const pt=map.project(ll,zoom);
      return{x:pt.x-centerPx.x+size.x/2, y:pt.y-centerPx.y+size.y/2};
    }

    function updateSVG(){
      const pts=latlngs.map(latlngToSVGPoint);
      polyline.setAttribute("points",pts.map(p=>p.x+","+p.y).join(" "));
    }

    function onDOMClick(e){
      if(e.target.closest&&(e.target.closest('.leaflet-marker-icon')||e.target.closest('.leaflet-popup')))return;
      const rect=container.getBoundingClientRect();
      const cx=e.clientX-rect.left;
      const cy=e.clientY-rect.top;
      const zoom=map.getZoom();
      const center=map._lastCenter||map.options.center||L.latLng(7.9,-1.0);
      const size=map.getSize();
      const centerPx=map.project(center,zoom);
      const latlng=map.unproject(
        L.point(centerPx.x+(cx-size.x/2), centerPx.y+(cy-size.y/2)), zoom
      );
      if(!latlng)return;
      // Snap-to-close
      if(latlngs.length>2){
        const firstPt=latlngToSVGPoint(latlngs[0]);
        if(Math.hypot(cx-firstPt.x,cy-firstPt.y)<16){
          finishLeafletPoly(L,map,latlngs,null);
          return;
        }
      }
      latlngs.push(latlng);
      updateSVG();
      polyPointsRef.current=[...latlngs.map(ll=>({lat:ll.lat,lng:ll.lng,x:0,y:0}))];
      setPolyPoints([...polyPointsRef.current]);
    }
    map._sgPolyDOMClick=onDOMClick;
    map.getContainer().addEventListener("click",onDOMClick);
    map._sgPolyClick=onDOMClick;
  }

  function finishLeafletPoly(L,map,latlngs,_unused){
    if(map._sgPolyDOMClick)map.getContainer().removeEventListener("click",map._sgPolyDOMClick);
    map.off("click",map._sgPolyClick);
    map.getContainer().style.cursor="";
    // Remove SVG preview
    if(map._sgDrawSVG){try{map._sgDrawSVG.remove();}catch(e){}map._sgDrawSVG=null;}
    setDrawMode(false);setPolyClosed(true);
    const M=markersRef.current;
    if(M.polyLayer){try{map.removeLayer(M.polyLayer);}catch(e){}}
    try{
      const poly=L.polygon(latlngs,{color:"#FCD116",weight:2.5,fillColor:"#FCD116",fillOpacity:0.1,dashArray:""}).addTo(map);
      M.polyLayer=poly;
      map.fitBounds(poly.getBounds().pad(0.15));
    }catch(e){console.warn("polygon add failed",e);}
    applyPolygon(latlngs.map(ll=>({lat:ll.lat,lng:ll.lng,x:0,y:0})));
  }

  function clearLeafletPolygon(){
    const map=leafMapRef.current;if(!map)return;
    const M=markersRef.current;
    if(M.polyLayer){try{map.removeLayer(M.polyLayer);}catch(e){}M.polyLayer=null;}
    if(map._sgPolyDOMClick)map.getContainer().removeEventListener("click",map._sgPolyDOMClick);
    map.off("click",map._sgPolyClick);
    if(map._sgDrawSVG){try{map._sgDrawSVG.remove();}catch(e){}map._sgDrawSVG=null;}
    map.getContainer().style.cursor="";
    setDrawMode(false);setPolyClosed(false);
    setPolyPoints([]);polyPointsRef.current=[];
    setPolyEvents(null);setPolyFilteredList([]);setShowPolyPanel(false);
    if(leafMapRef.current)leafMapRef.current.setView([7.9,-1.0],7);
  }

  // == MAP SEARCH ==
  const SEV_HEX2={"critical":"#9C27B0","high":"#F44336","medium":"#FF9800","low":"#4CAF50"};
  const FLOOD_HEX2={"severe":"#B71C1C","moderate":"#E65100","mild":"#1B5E20"};
  const GHANA_POST_REGION_MAP={GA:"greater-accra",GN:"greater-accra",GS:"greater-accra",GE:"greater-accra",GW:"greater-accra",
    AK:"ashanti",EA:"eastern",CA:"central",WA:"western",VA:"volta",NA:"northern",
    UE:"upper-east",UW:"upper-west",SV:"savannah",NE:"north-east",OT:"oti",WN:"western-north",BN:"bono",BE:"bono-east",AH:"ahafo"};

  // Build local results from our own data
  function getLocalResults(q){
    const query=q.trim().toLowerCase();
    const results=[];
    if(isValidGhanaPost(q.trim())){
      const code=q.trim().toUpperCase();
      const region=GHANA_POST_REGION_MAP[code.substring(0,2)]||"greater-accra";
      const coords=ghanaPostToCoords(code,region);
      if(coords) results.push({type:"ghanapost",label:code,sublabel:"Ghana Post · "+(GHANA_REGIONS.find(r=>r.id===region)?.name||region),lat:coords.lat,lng:coords.lng,zoom:16,ghanaPost:code,icon:"ti-map-pin",color:"#006B3F"});
    }
    GHANA_BUSINESSES.filter(b=>b.name.toLowerCase().includes(query)||b.area.toLowerCase().includes(query)||b.category.toLowerCase().includes(query)).slice(0,5)
      .forEach(b=>results.push({type:"poi",label:b.name,sublabel:b.category+" · "+b.area,lat:b.lat,lng:b.lng,zoom:16,ghanaPost:b.ghanaPost||"",icon:BIZ_CATEGORY_ICONS[b.category]||"ti-building",color:POI_CATEGORY_COLORS[b.category]||"#607D8B"}));
    GHANA_REGIONS.filter(r=>r.name.toLowerCase().includes(query)||r.capital.toLowerCase().includes(query)||r.id.replace(/-/g," ").includes(query)).slice(0,3)
      .forEach(r=>results.push({type:"region",label:r.name,sublabel:"Region capital · "+r.capital,lat:r.lat,lng:r.lng,zoom:9,icon:"ti-map-2",color:"#1565C0"}));
    incidents.filter(i=>i.type.toLowerCase().includes(query)||(i.area||"").toLowerCase().includes(query)).slice(0,3)
      .forEach(inc=>{
        const r=GHANA_REGIONS.find(x=>x.id===inc.region);const s=seedHash(String(inc.id));
        results.push({type:"incident",label:inc.type+" – "+(inc.area||inc.region),sublabel:inc.severity+" · "+inc.date,
          lat:Number(inc.lat)||(r?r.lat+((s%100)/100-0.5)*0.5:5.5),
          lng:Number(inc.lng)||(r?r.lng+(((s>>8)%100)/100-0.5)*0.5:-0.2),
          zoom:14,icon:"ti-alert-triangle",color:SEV_HEX2[inc.severity]||"#F44336"});
      });
    cameras.filter(c=>c.name.toLowerCase().includes(query)||c.area.toLowerCase().includes(query)).slice(0,2)
      .forEach(c=>results.push({type:"camera",label:c.name,sublabel:c.area+" · "+c.status,lat:c.lat,lng:c.lng,zoom:16,ghanaPost:c.ghanaPost,icon:"ti-video",color:c.status==="online"?"#4CAF50":"#F44336"}));
    floodReports.filter(f=>(f.area||"").toLowerCase().includes(query)&&f.lat&&f.lng).slice(0,2)
      .forEach(f=>results.push({type:"flood",label:"Flood: "+f.area,sublabel:f.severity+" · "+f.depth,lat:f.lat,lng:f.lng,zoom:14,icon:"ti-ripple",color:FLOOD_HEX2[f.severity]||"#1565C0"}));
    return results;
  }

  // Nominatim geocode - searches OpenStreetMap, restricted to Ghana
  async function geocodeNominatim(q){
    try{
      const url="https://nominatim.openstreetmap.org/search?format=json&limit=5&countrycodes=gh&q="+encodeURIComponent(q)+"&addressdetails=1";
      const res=await fetch(url,{headers:{"Accept-Language":"en","User-Agent":"SafeGhana/1.0"}});
      if(!res.ok)return[];
      const data=await res.json();
      return data.filter(d=>d.lat&&d.lon&&!isNaN(parseFloat(d.lat))).map(d=>({
        type:"geocode",
        label:(d.name||(d.address?.city||d.address?.town||d.address?.village||d.display_name?.split(",")[0])||d.display_name?.split(",")[0]||"Location"),
        sublabel:(d.display_name?.split(",").slice(0,3).join(", ")||"Ghana"),
        lat:parseFloat(d.lat),lng:parseFloat(d.lon),
        zoom:d.type==="administrative"||d.class==="boundary"?10:d.class==="place"?13:15,
        icon:"ti-map-pin",color:"#CE1126"
      }));
    }catch(e){return[];}
  }

  // Main search: find results and show list (no auto-zoom - user clicks to zoom)
  function buildSearchResults(q){
    if(!q||q.trim().length<2){setMapSearchResults([]);setMapSearchStatus("idle");setMapSearchMsg("");return;}
    const local=getLocalResults(q);
    setMapSearchResults(local);
    setMapSearchStatus("searching");
    geocodeNominatim(q).then(geo=>{
      const merged=[...local];
      geo.forEach(g=>{
        const dup=merged.find(m=>Math.abs(m.lat-g.lat)<0.01&&Math.abs(m.lng-g.lng)<0.01);
        if(!dup)merged.push(g);
      });
      setMapSearchResults(merged);
      if(merged.length===0){setMapSearchStatus("error");setMapSearchMsg("No results for \""+q.trim()+"\" in Ghana");}
      else setMapSearchStatus("idle");
    });
  }

  // Fly to a resolved search result - handles tab switching + init timing
  function flyToResult(result){
    // Always coerce to number - Nominatim returns strings
    const lat=parseFloat(result.lat);
    const lng=parseFloat(result.lng);
    const zoom=parseInt(result.zoom)||14;
    if(isNaN(lat)||isNaN(lng)){console.warn("SafeGhana search: invalid coords",result);return;}

    const doFly=(attempts)=>{
      const L=window.L;const map=leafMapRef.current;
      if(!L||!map){
        if(attempts<20)setTimeout(()=>doFly(attempts+1),300);
        else console.warn("SafeGhana: map not ready after retries");
        return;
      }
      try{
        // invalidateSize first to ensure pane transforms are initialized
        try{map.invalidateSize();}catch(e){}
        try{map.setView([lat,lng],zoom,{animate:false});}catch(e){console.warn("map setView error",e);}
        // Add marker
        const icon=L.divIcon({className:"",iconAnchor:[22,22],
          html:`<div style="width:44px;height:44px;border-radius:50%;background:${result.color}22;border:3px solid ${result.color};display:flex;align-items:center;justify-content:center;box-shadow:0 0 20px ${result.color}88;animation:sgPulse 1.2s ease-in-out 4"><i class="ti ${result.icon}" style="color:${result.color};font-size:20px"></i></div>`
        });
        const mk=L.marker([lat,lng],{icon,zIndexOffset:9999}).addTo(map);
        mk.bindPopup(`<div style="min-width:200px">
          <b style="font-size:14px;display:block;margin-bottom:4px">${result.label}</b>
          <div style="font-size:11px;color:#555;margin-bottom:6px">${result.sublabel}</div>
          ${result.ghanaPost?`<div style="font-family:monospace;font-size:11px;background:#E8F5E9;color:#1B5E20;padding:2px 8px;border-radius:5px;display:inline-block;margin-bottom:5px">${result.ghanaPost}</div><br/>`:""}
          <div style="font-size:10px;color:#aaa">${lat.toFixed(6)}, ${lng.toFixed(6)}</div>
        </div>`,{maxWidth:280}).openPopup();
        setTimeout(()=>{try{map.removeLayer(mk);}catch(e){}},12000);
      }catch(err){
        // Retry once after a short delay if pane not ready
        if(attempts<3)setTimeout(()=>doFly(attempts+1),300);
        else console.warn("SafeGhana flyTo error:",err);
      }
    };
    doFly(0);
  }

  function resolveSearchResult(result){
    setMapSearchQuery(result.label);
    setMapSearchOpen(false);
    setMapSearchStatus("ok");
    setMapSearchMsg("Zoomed to: "+result.label+" ("+Number(result.lat).toFixed(4)+", "+Number(result.lng).toFixed(4)+")");
    if(tab!=="map"){
      setTab("map");
      // Wait for map tab to mount and Leaflet to initialize
      setTimeout(()=>flyToResult(result),600);
    } else {
      flyToResult(result);
    }
    setTimeout(()=>{setMapSearchStatus("idle");setMapSearchMsg("");},4000);
  }

  // Search and immediately zoom to best result
  async function handleSearchEnter(q){
    if(!q||q.trim().length<2)return;
    // If we already have local results, zoom to first immediately
    const local=getLocalResults(q);
    if(local.length>0){
      setMapSearchResults(local);
      resolveSearchResult(local[0]);
      return;
    }
    // Otherwise geocode then zoom
    setMapSearchStatus("searching");setMapSearchMsg("Searching...");
    const geo=await geocodeNominatim(q);
    const merged=[...local,...geo.filter(g=>!local.find(l=>Math.abs(l.lat-g.lat)<0.01))];
    setMapSearchResults(merged);
    if(merged.length>0){
      resolveSearchResult(merged[0]);
    } else {
      setMapSearchStatus("error");setMapSearchMsg("No results found for \""+q.trim()+"\" in Ghana");
    }
  }

  function clearMapSearch(){setMapSearchQuery("");setMapSearchResults([]);setMapSearchOpen(false);setMapSearchStatus("idle");setMapSearchMsg("");}

  function clampZoom(z){ return Math.min(8,Math.max(1,z)); }
  function clampPan(px,py,z){
    const maxShift=((z-1)/z)*3.35; // half of lng range scaled
    const maxShiftLat=((z-1)/z)*3.45;
    return{x:Math.max(-maxShift,Math.min(maxShift,px)),y:Math.max(-maxShiftLat,Math.min(maxShiftLat,py))};
  }

  function onWheel(e){
    e.preventDefault();
    const delta=e.deltaY<0?1.15:1/1.15;
    const newZ=clampZoom(zoomRef.current*delta);
    zoomRef.current=newZ;
    const clamped=clampPan(panRef.current.x,panRef.current.y,newZ);
    panRef.current=clamped;
    setZoom(newZ);setPan(clamped);
  }

  function onMouseDown(e){
    if(e.button!==0)return;
    isPanningRef.current=true;
    panStartRef.current={mx:e.clientX,my:e.clientY,px:panRef.current.x,py:panRef.current.y};
    canvasRef.current.style.cursor="grabbing";
  }

  function onPanMove(e){
    if(!isPanningRef.current){onMouseMove(e);return;}
    const rect=canvasRef.current?.getBoundingClientRect();if(!rect)return;
    const dx=e.clientX-panStartRef.current.mx;
    const dy=e.clientY-panStartRef.current.my;
    // Convert pixel delta to lat/lng delta
    const m=mapMetaRef.current;
    const lngDelta=-(dx/m.W)*(m.lngMax-m.lngMin);
    const latDelta= (dy/m.H)*(m.latMax-m.latMin);
    const raw={x:panStartRef.current.px+lngDelta,y:panStartRef.current.py+latDelta};
    const clamped=clampPan(raw.x,raw.y,zoomRef.current);
    panRef.current=clamped;setPan(clamped);
  }

  function onMouseUp(e){
    if(isPanningRef.current){
      isPanningRef.current=false;
      canvasRef.current&&(canvasRef.current.style.cursor="default");
    }
  }

  function zoomIn(){
    const newZ=clampZoom(zoomRef.current*1.4);
    zoomRef.current=newZ;
    const c=clampPan(panRef.current.x,panRef.current.y,newZ);
    panRef.current=c;setZoom(newZ);setPan(c);
  }
  function zoomOut(){
    const newZ=clampZoom(zoomRef.current/1.4);
    zoomRef.current=newZ;
    const c=clampPan(panRef.current.x,panRef.current.y,newZ);
    panRef.current=c;setZoom(newZ);setPan(c);
  }
  function zoomReset(){zoomRef.current=1;panRef.current={x:0,y:0};setZoom(1);setPan({x:0,y:0});}

  // == Polygon helpers ==========================================================
  function pointInPolygon(px,py,poly){
    let inside=false;
    for(let i=0,j=poly.length-1;i<poly.length;j=i++){
      const xi=poly[i].x,yi=poly[i].y,xj=poly[j].x,yj=poly[j].y;
      if(((yi>py)!==(yj>py))&&(px<(xj-xi)*(py-yi)/(yj-yi)+xi))inside=!inside;
    }
    return inside;
  }

  function pixelToLatLng(px,py){
    const m=mapMetaRef.current;
    const lng=m.lngMin+(px/m.W)*(m.lngMax-m.lngMin);
    const lat=m.latMax-((py/m.H)*(m.latMax-m.latMin));
    return{lat,lng};
  }

  function drawPolyOverlay(){
    const c=overlayCvRef.current;if(!c)return;
    const W=c.width=c.offsetWidth||640;const H=c.height=c.offsetHeight||400;
    const ctx=c.getContext("2d");ctx.clearRect(0,0,W,H);
    const pts=polyPointsRef.current;if(pts.length<1)return;
    ctx.beginPath();ctx.moveTo(pts[0].x,pts[0].y);
    pts.slice(1).forEach(p=>ctx.lineTo(p.x,p.y));
    if(pts.length>2)ctx.closePath();
    ctx.strokeStyle="#FCD116";ctx.lineWidth=2.5;ctx.setLineDash([7,4]);ctx.stroke();
    ctx.fillStyle="rgba(252,209,22,0.10)";ctx.fill();
    pts.forEach((p,i)=>{
      ctx.beginPath();ctx.arc(p.x,p.y,i===0?7:5,0,Math.PI*2);
      ctx.fillStyle=i===0?"#FCD116":"rgba(252,209,22,0.85)";ctx.fill();
      ctx.strokeStyle="#0A1628";ctx.lineWidth=1.5;ctx.stroke();
    });
    if(pts.length>2){
      ctx.beginPath();ctx.arc(pts[0].x,pts[0].y,13,0,Math.PI*2);
      ctx.strokeStyle="rgba(252,209,22,0.4)";ctx.lineWidth=1.5;ctx.setLineDash([3,3]);ctx.stroke();
    }
    ctx.setLineDash([]);
  }

  function startDraw(){
    setDrawMode(true);setPolyClosed(false);
    setPolyPoints([]);polyPointsRef.current=[];
    setPolyEvents(null);setPolyFilteredList([]);setShowPolyPanel(false);
    const c=overlayCvRef.current;if(c){const ctx=c.getContext("2d");ctx.clearRect(0,0,c.width,c.height);}
  }

  function cancelDraw(){
    setDrawMode(false);setPolyClosed(false);
    setPolyPoints([]);polyPointsRef.current=[];
    const c=overlayCvRef.current;if(c){const ctx=c.getContext("2d");ctx.clearRect(0,0,c.width,c.height);}
  }

  // Convert lat/lng polygon to pixel coords given current map meta
  function latLngPolyToPixels(llPts){
    const m=mapMetaRef.current;
    return llPts.map(p=>({
      x:((p.lng-m.lngMin)/(m.lngMax-m.lngMin))*m.W,
      y:m.H-((p.lat-m.latMin)/(m.latMax-m.latMin))*m.H,
      lat:p.lat,lng:p.lng,
    }));
  }

  // Point-in-polygon using lat/lng (world coords, not pixels) for zoom-independence
  function pointInPolyLL(lat,lng,llPoly){
    let inside=false;
    for(let i=0,j=llPoly.length-1;i<llPoly.length;j=i++){
      const yi=llPoly[i].lat,yj=llPoly[j].lat;
      const xi=llPoly[i].lng,xj=llPoly[j].lng;
      if(((yi>lat)!==(yj>lat))&&(lng<(xj-xi)*(lat-yi)/(yj-yi)+xi))inside=!inside;
    }
    return inside;
  }

  function applyPolygon(pts){
    const allPts=pts||polyPointsRef.current;
    if(allPts.length<3)return;

    // Use lat/lng for hit-testing (zoom-independent)
    const llPoly=allPts.map(p=>({lat:p.lat,lng:p.lng}));

    // Incidents = test using incident world coords
    const allIncs=[];
    incidents.forEach(inc=>{
      let lat,lng;
      if(inc.lat&&inc.lng){lat=inc.lat;lng=inc.lng;}
      else{
        const r=GHANA_REGIONS.find(x=>x.id===inc.region);
        if(!r)return;
        const s=seedHash(String(inc.id));
        lat=r.lat+((s%100)/100-0.5)*0.65;
        lng=r.lng+(((s>>8)%100)/100-0.5)*0.65;
      }
      if(pointInPolyLL(lat,lng,llPoly))allIncs.push(inc);
    });

    // Cameras
    const allCams=cameras.filter(c=>pointInPolyLL(c.lat,c.lng,llPoly));

    // Flood reports
    const allFloods=floodReports.filter(f=>f.lat&&f.lng&&pointInPolyLL(f.lat,f.lng,llPoly));

    const unified=[
      ...allIncs.map(i=>({kind:"incident",id:i.id,label:i.type,sub:(i.area||"")+" = "+i.severity,color:SEV_CFG[i.severity]?.color||"#999",raw:i})),
      ...allFloods.map(f=>({kind:"flood",id:f.id,label:"Flood Zone",sub:(f.area||"")+" = "+f.severity,color:FLOOD_SEVERITY_CFG[f.severity]?.color||"#1565C0",raw:f})),
      ...allCams.map(c=>({kind:"camera",id:c.id,label:c.name,sub:(c.area||"")+" = "+c.status,color:CAM_STATUS_CFG[c.status]?.color||"#888",raw:c})),
    ];

    setPolyEvents({incidents:allIncs,floods:allFloods,cameras:allCams,total:unified.length});
    setPolyFilteredList(unified);
    setShowPolyPanel(true);
    setDrawMode(false);

    // Zoom Leaflet map to polygon bounding box
    const lats=llPoly.map(p=>p.lat),lngs=llPoly.map(p=>p.lng);
    const latMin=Math.min(...lats),latMax=Math.max(...lats);
    const lngMin=Math.min(...lngs),lngMax=Math.max(...lngs);
    const map=leafMapRef.current;
    if(map){
      try{map.fitBounds([[latMin,lngMin],[latMax,lngMax]],{padding:[40,40]});}catch(e){}
    }
    // Scroll results into view
    setTimeout(()=>document.getElementById("poly-results-panel")?.scrollIntoView({behavior:"smooth",block:"start"}),400);
  }

  function onPolyOverlayClick(e){
    if(!drawMode)return;
    e.stopPropagation();
    const rect=overlayCvRef.current?.getBoundingClientRect();if(!rect)return;
    const mx=e.clientX-rect.left,my=e.clientY-rect.top;
    const pts=polyPointsRef.current;
    // Snap-to-close: click near first point
    if(pts.length>2&&Math.hypot(mx-pts[0].x,my-pts[0].y)<16){
      const finalPts=[...pts];
      polyPointsRef.current=finalPts;
      setPolyClosed(true);
      requestAnimationFrame(drawPolyOverlay);
      applyPolygon(finalPts);
      return;
    }
    const ll=pixelToLatLng(mx,my);
    const newPt={x:mx,y:my,...ll};
    polyPointsRef.current=[...pts,newPt];
    setPolyPoints(prev=>[...prev,newPt]);
    requestAnimationFrame(drawPolyOverlay);
  }

  function removeFromPolyList(id){
    setPolyFilteredList(prev=>prev.filter(ev=>String(ev.id)!==String(id)));
  }

  function addToPolyList(inc){
    const exists=polyFilteredList.find(e=>String(e.id)===String(inc.id));
    if(exists)return;
    setPolyFilteredList(prev=>[...prev,{kind:"incident",id:inc.id,label:inc.type,sub:`${inc.area||""} · ${inc.severity}`,color:SEV_CFG[inc.severity]?.color||"#999",raw:inc}]);
  }

  function clearPolygon(){
    cancelDraw();setPolyEvents(null);setPolyFilteredList([]);setShowPolyPanel(false);
    const c=overlayCvRef.current;if(c){const ctx=c.getContext("2d");ctx.clearRect(0,0,c.width,c.height);}
    zoomReset();
  }

  function onMapClick(e){
    const rect=canvasRef.current?.getBoundingClientRect();if(!rect)return;
    const mx=e.clientX-rect.left,my=e.clientY-rect.top;
    const cam=camHitTest(mx,my);
    if(cam){setSelectedCam(cam.cam);setCamFeedPlaying(false);return;}
    const fl=floodHitTest(mx,my);
    if(fl){setSelectedFlood(fl.flood);return;}
    const poi=poiHitTest(mx,my);
    if(poi){setSelectedPOI(poi.poi);return;}
    const dot=hitTest(mx,my);
    if(dot){setPanel(dot);setPanelIdx(0);}else setPanel(null);
  }

  // == GPS ======================================================================
  function requestGPS(){
    setLocStep("gps-loading");setGpsError("");
    if(!navigator.geolocation){setGpsError("Geolocation not supported.");setLocStep("manual");return;}
    navigator.geolocation.getCurrentPosition(async pos=>{
      const{latitude:lat,longitude:lng}=pos.coords;setGpsCoords({lat,lng});
      try{const res=await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`);const data=await res.json();const addr=data.display_name||`${lat.toFixed(5)},${lng.toFixed(5)}`;setGpsAddress(addr);const mr=matchRegionFromAddress(addr);if(mr){setForm(p=>({...p,region:mr}));setGpsGhanaPost(coordsToGhanaPost(lat,lng,mr));}}catch{setGpsAddress(`${lat.toFixed(5)},${lng.toFixed(5)}`);}
      setLocStep("gps-done");
    },()=>{setGpsError("Could not get location. Enter Ghana Post manually.");setLocStep("manual");},{timeout:10000,enableHighAccuracy:true});
  }
  function matchRegionFromAddress(addr){const l=addr.toLowerCase();const map=[["greater accra","greater-accra"],["accra","greater-accra"],["ashanti","ashanti"],["kumasi","ashanti"],["eastern","eastern"],["koforidua","eastern"],["central","central"],["cape coast","central"],["western north","western-north"],["western","western"],["takoradi","western"],["volta","volta"],["northern","northern"],["tamale","northern"],["upper east","upper-east"],["bolgatanga","upper-east"],["upper west","upper-west"],["bono east","bono-east"],["bono","bono"],["ahafo","ahafo"],["savannah","savannah"],["north east","north-east"],["oti","oti"]];for(const[k,r]of map)if(l.includes(k))return r;return null;}
  function coordsToGhanaPost(lat,lng,region){const p=(GHANA_POST_PREFIXES[region]||["GA"])[0];const n1=Math.abs(Math.round(lat*1000)%9000)+1000;const n2=Math.abs(Math.round(lng*1000)%9000)+1000;return`${p}-${n1}-${n2}`;}
  function handleManualPost(val){setManualPost(val);setPostError("");if(val.length>=10&&!isValidGhanaPost(val))setPostError("Format: XX-XXXX-XXXX");if(isValidGhanaPost(val)){const r=regionFromGhanaPost(val);if(r)setForm(p=>({...p,region:r}));else setPostError("Prefix not matched = select region manually.");}}
  async function submitReport(){
    const post=useCurrentLoc?(gpsGhanaPost||manualPost):manualPost;
    if(!form.type||!form.description)return;if(!isValidGhanaPost(post)){setPostError("Valid Ghana Post required.");return;}
    const region=form.region||regionFromGhanaPost(post)||"greater-accra";
    let lat,lng;if(useCurrentLoc&&gpsCoords){lat=gpsCoords.lat;lng=gpsCoords.lng;}else{const c=ghanaPostToCoords(post,region);lat=c?.lat;lng=c?.lng;}
    const newInc={...form,region,ghanaPost:post,lat,lng,area:form.area||(useCurrentLoc?gpsAddress:post),status:"reported",aiClassification:"Pending AI Classification",mediaCount:uploadedFiles.length,upvotes:0,verified:false};
    try{
      const res=await fetch(`${API_BASE}/incidents`,{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          type:newInc.type, region:newInc.region, area:newInc.area,
          ghana_post:newInc.ghanaPost, lat:newInc.lat, lng:newInc.lng,
          date:newInc.date, time:newInc.time, severity:newInc.severity,
          description:newInc.description, status:newInc.status,
          media_count:newInc.mediaCount,
          user_id:loggedInUser?.id||null,
        }),
      });
      if(res.ok){
        const saved=await res.json();
        setIncidents(prev=>[{...newInc,id:saved.id||saved.incident?.id||Date.now()},...prev]);
      } else {
        // Fallback: optimistic local update if API fails
        setIncidents(prev=>[{...newInc,id:Date.now()},...prev]);
      }
    } catch(e){
      console.warn("Submit report API error, using local",e);
      setIncidents(prev=>[{...newInc,id:Date.now()},...prev]);
    }
    setForm({type:"",region:"",area:"",description:"",severity:"medium",date:new Date().toISOString().split("T")[0],time:"12:00"});
    setUploadedFiles([]);setLocStep("ask");setUseCurrentLoc(null);setGpsCoords(null);setGpsGhanaPost("");setGpsAddress("");setManualPost("");setPostError("");setGpsError("");setTab("incidents");
  }
  // == Flood report helpers =====================================================
  // Mirrors the server-side policy in src/passwordPolicy.js — kept in sync
  // manually since this is a separate frontend with no shared package.
  function checkPasswordPolicy(password){
    const errors=[];
    if(!password||password.length<8)errors.push("at least 8 characters");
    if(!/[A-Z]/.test(password||""))errors.push("one uppercase letter");
    if(!/[a-z]/.test(password||""))errors.push("one lowercase letter");
    if(!/[0-9]/.test(password||""))errors.push("one number");
    if(!/[^A-Za-z0-9]/.test(password||""))errors.push("one symbol");
    return errors;
  }

  function validateReg(){
    const e={};
    if(!regForm.name.trim())e.name="Full name required";
    if(!regForm.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))e.email="Valid email required";
    if(!regForm.phone.match(/^\+?[0-9]{10,13}$/))e.phone="Valid Ghana phone required";
    const pwErrors=checkPasswordPolicy(regForm.password);
    if(pwErrors.length)e.password="Must include: "+pwErrors.join(", ");
    return e;
  }

  async function submitRegistration(){
    const errs=validateReg();
    if(Object.keys(errs).length){setRegErrors(errs);return;}
    const newUser={
      id:"user-"+Date.now(),name:regForm.name,email:regForm.email,
      phone:regForm.phone,region:regForm.region||"greater-accra",
      joined:new Date().toISOString().split("T")[0],reports:0,
      avatar:regForm.name.split(" ").map(w=>w[0]).join("").substring(0,2).toUpperCase(),
      verified:false,
    };
    try{
      const res=await fetch(`${API_BASE}/public/register`,{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({
          name:regForm.name, email:regForm.email,
          phone:regForm.phone, password:regForm.password,
          region:regForm.region||"greater-accra",
          ghana_post:regForm.ghanaPost||"",
          area:regForm.area||"",
        }),
      });
      if(res.ok){
        const saved=await res.json();
        setPendingUser({...newUser,id:saved.id||saved.user?.id||newUser.id});
      } else {
        setPendingUser(newUser);
      }
    } catch(e){
      console.warn("Registration API error, using local",e);
      setPendingUser(newUser);
    }
    // Send verification email via Resend
    try{
      await fetch(`${API_BASE}/public/send-verification`,{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({email:regForm.email, name:regForm.name}),
      });
    } catch(e){ console.warn("Verification email error",e); }
    setRegStep(3);
    setRegErrors({});
  }

  async function submitVerification(){
    if(!verifyCode.trim()){setVerifyError("Please enter the code from your email.");return;}
    setVerifyLoading(true);setVerifyError("");
    try{
      const res=await fetch(`${API_BASE}/public/verify-email`,{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({email:regForm.email, code:verifyCode.trim()}),
      });
      if(res.ok){
        const user={...pendingUser,verified:true};
        setUsers(prev=>[user,...prev]);
        setLoggedInUser(user);
        setShowRegModal(false);
        setRegForm({name:"",email:"",password:"",phone:"",region:"",ghanaPost:"",area:""});
        setRegStep(1);setVerifyCode("");setPendingUser(null);
      } else {
        setVerifyError("Invalid or expired code. Please try again.");
      }
    } catch(e){
      // Offline fallback — accept any 6-digit code
      if(verifyCode.trim().length===6){
        const user={...pendingUser,verified:true};
        setUsers(prev=>[user,...prev]);
        setLoggedInUser(user);
        setShowRegModal(false);
        setRegForm({name:"",email:"",password:"",phone:"",region:"",ghanaPost:"",area:""});
        setRegStep(1);setVerifyCode("");setPendingUser(null);
      } else {
        setVerifyError("Please enter the 6-digit code from your email.");
      }
    }
    setVerifyLoading(false);
  }

  async function resendVerification(){
    try{
      await fetch(`${API_BASE}/public/send-verification`,{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({email:regForm.email, name:regForm.name}),
      });
      setVerifyError("Code resent! Check your inbox.");
    } catch(e){ setVerifyError("Could not resend. Please try again."); }
  }

  async function handleLogin(){
    setLoginError("");
    try{
      const res=await fetch(`${API_BASE}/auth/login`,{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({email:loginForm.email,password:loginForm.password}),
      });
      if(res.ok){
        const d=await res.json();
        const user=d.user||d;
        setLoggedInUser({
          id:user.id,
          name:user.name,
          email:user.email,
          phone:user.phone||"",
          region:user.region||"greater-accra",
          joined:user.joined||user.created_at?.split("T")[0]||"",
          reports:user.reports||0,
          avatar:user.name?.split(" ").map(w=>w[0]).join("").substring(0,2).toUpperCase()||"U",
          verified:user.verified||false,
        });
        setShowLogin(false);setLoginForm({email:"",password:""});
      } else {
        const err=await res.json().catch(()=>({}));
        if(res.status===403){
          setLoginError(err.error||"Email not verified. Check your inbox for the verification code.");
        } else {
          setLoginError(err.error||"Invalid email or password.");
        }
      }
    } catch(e){
      console.warn("Login API error, trying local",e);
      const user=users.find(u=>u.email===loginForm.email);
      if(!user){setLoginError("No account found with this email.");return;}
      setLoggedInUser(user);setShowLogin(false);setLoginForm({email:"",password:""});
    }
  }

  async function handleAvatarUpload(file){
    if(!file||!loggedInUser)return;
    if(file.size>5*1024*1024){alert("Image must be under 5MB");return;}
    setAvatarUploading(true);
    try{
      // Convert to base64 for local preview immediately
      const reader=new FileReader();
      reader.onload=async(e)=>{
        const base64=e.target.result;
        // Update local state immediately for instant preview
        const updated={...loggedInUser,avatarUrl:base64};
        setLoggedInUser(updated);
        // Try to upload to server
        try{
          const formData=new FormData();
          formData.append("avatar",file);
          const res=await fetch(`${API_BASE}/users/${loggedInUser.id}/avatar`,{
            method:"POST",
            body:formData,
          });
          if(res.ok){
            const d=await res.json();
            setLoggedInUser(prev=>({...prev,avatarUrl:d.avatarUrl||base64}));
          }
        }catch(e){
          // Keep base64 preview even if server upload fails
          console.warn("Avatar server upload failed, using local preview",e);
        }
        setAvatarUploading(false);
      };
      reader.readAsDataURL(file);
    }catch(e){
      console.error("Avatar upload error",e);
      setAvatarUploading(false);
    }
  }

  async function handleForgotPassword(){
    if(!resetEmail.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)){setResetMsg("Please enter a valid email address.");return;}
    setResetLoading(true);setResetMsg("");
    try{
      await fetch(`${API_BASE}/public/send-reset`,{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({email:resetEmail}),
      });
      setResetMsg("Code sent! Check your inbox.");
      setLoginView("reset");
    } catch(e){
      setResetMsg("Could not send reset email. Please try again.");
    }
    setResetLoading(false);
  }

  async function handleResetPassword(){
    if(resetCode.trim().length!==6){setResetMsg("Enter the 6-digit code from your email.");return;}
    const pwErrors=checkPasswordPolicy(resetPassword);
    if(pwErrors.length){setResetMsg("Password must include: "+pwErrors.join(", "));return;}
    if(resetPassword!==resetConfirm){setResetMsg("Passwords do not match.");return;}
    setResetLoading(true);setResetMsg("");
    try{
      const res=await fetch(`${API_BASE}/public/reset-password`,{
        method:"POST",
        headers:{"Content-Type":"application/json"},
        body:JSON.stringify({email:resetEmail,code:resetCode.trim(),password:resetPassword}),
      });
      if(res.ok){
        setResetMsg("Password reset! You can now sign in.");
        setTimeout(()=>{
          setLoginView("signin");setResetEmail("");setResetCode("");
          setResetPassword("");setResetConfirm("");setResetMsg("");
        },2000);
      } else {
        setResetMsg("Invalid or expired code. Please try again.");
      }
    } catch(e){
      setResetMsg("Reset failed. Please try again.");
    }
    setResetLoading(false);
  }

  function handleFloodVideo(file){
    setFloodVideoError("");
    // Accept same formats as WhatsApp & Facebook: MP4, MOV, AVI, MKV, 3GP, WebM, WMV, FLV
    const ACCEPTED_TYPES=["video/mp4","video/quicktime","video/avi","video/x-msvideo",
      "video/x-matroska","video/3gpp","video/3gpp2","video/webm",
      "video/x-ms-wmv","video/x-flv","video/ogg","video/"];
    const typeOK=file.type.startsWith("video/")||ACCEPTED_TYPES.some(t=>file.type===t);
    if(!typeOK){setFloodVideoError("Please upload a video file. Supported formats: MP4, MOV, AVI, MKV, 3GP, WebM (same as WhatsApp/Facebook).");return;}
    // Size: WhatsApp cap is 2GB, Facebook is 10GB = we accept up to 2GB like WhatsApp
    const maxGB=2;
    if(file.size>maxGB*1024*1024*1024){setFloodVideoError("Video is too large. Maximum size is 2GB (same as WhatsApp).");return;}
    const sizeMB=(file.size/1024/1024);
    const sizeLabel=sizeMB>=1000?(sizeMB/1024).toFixed(2)+" GB":sizeMB.toFixed(1)+" MB";
    // Load metadata for duration info (no duration limit)
    const url=URL.createObjectURL(file);
    const vid=document.createElement("video");
    vid.src=url;
    vid.onloadedmetadata=()=>{
      const mins=Math.floor(vid.duration/60);
      const secs=Math.round(vid.duration%60);
      const durationLabel=mins>0?`${mins}m ${secs}s`:`${secs}s`;
      setFloodVideo({name:file.name,size:sizeLabel,url,duration:Math.round(vid.duration),durationLabel});
    };
    vid.onerror=()=>{
      // Still accept even if browser can't read metadata
      setFloodVideo({name:file.name,size:sizeLabel,url,duration:null,durationLabel:"Unknown"});
    };
  }

  function getFloodGPS(){
    setFloodGPSLoading(true);
    navigator.geolocation.getCurrentPosition(
      async pos=>{
        const{latitude:lat,longitude:lng}=pos.coords;
        setFloodGPS({lat,lng});
        try{
          const res=await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${lat}&lon=${lng}&format=json`);
          const d=await res.json();
          const mr=matchRegionFromAddress(d.display_name||"");
          setFloodForm(p=>({...p,area:d.display_name?.split(",").slice(0,3).join(",").trim()||"",region:mr||"greater-accra",ghanaPost:coordsToGhanaPost(lat,lng,mr||"greater-accra")}));
        }catch{}
        setFloodGPSLoading(false);
      },
      ()=>{setFloodGPSLoading(false);},
      {timeout:8000,enableHighAccuracy:true}
    );
  }

  function submitFloodReport(){
    if(!floodVideo){setFloodVideoError("Please upload a short video of the flooding.");return;}
    if(!floodForm.ghanaPost||!isValidGhanaPost(floodForm.ghanaPost)){setFloodPostError("Valid Ghana Post address required.");return;}
    setFloodUploading(true);setFloodUploadProgress(0);
    let p=0;
    const interval=setInterval(()=>{
      p+=Math.random()*15+5;
      if(p>=100){
        p=100;setFloodUploadProgress(100);clearInterval(interval);
        setTimeout(()=>{
          const region=floodForm.region||regionFromGhanaPost(floodForm.ghanaPost)||"greater-accra";
          const coords=floodGPS||ghanaPostToCoords(floodForm.ghanaPost,region)||{lat:GHANA_REGIONS.find(r=>r.id===region)?.lat,lng:GHANA_REGIONS.find(r=>r.id===region)?.lng};
          const report={
            id:"fl-"+Date.now(),
            userId:loggedInUser?.id||"anonymous",
            userName:loggedInUser?.name||"Anonymous Citizen",
            avatar:loggedInUser?.avatar||"AC",
            region,area:floodForm.area,ghanaPost:floodForm.ghanaPost,
            lat:coords?.lat,lng:coords?.lng,
            depth:floodForm.depth,duration:floodForm.duration,
            description:floodForm.description,
            severity:floodForm.severity,
            date:new Date().toISOString().split("T")[0],
            time:new Date().toLocaleTimeString("en-GH",{hour:"2-digit",minute:"2-digit"}),
            videoName:floodVideo.name,videoSize:floodVideo.size,
            videoUrl:floodVideo.url,videoDuration:floodVideo.duration,
            verified:false,upvotes:0,
          };
          setFloodReports(prev=>[report,...prev]);
          if(loggedInUser)setUsers(prev=>prev.map(u=>u.id===loggedInUser.id?{...u,reports:u.reports+1}:u));
          // Persist to API
          fetch(`${API_BASE}/floods`,{
            method:"POST",
            headers:{"Content-Type":"application/json"},
            body:JSON.stringify({
              user_id:loggedInUser?.id||null,
              user_name:report.userName,
              region:report.region, area:report.area,
              ghana_post:report.ghanaPost, lat:report.lat, lng:report.lng,
              depth:report.depth, duration:report.duration,
              description:report.description, severity:report.severity,
              video_name:report.videoName, video_size:report.videoSize,
            }),
          }).catch(e=>console.warn("Flood API save failed",e));
          setFloodUploading(false);setFloodUploadProgress(0);
          setShowFloodModal(false);
          setFloodForm({area:"",ghanaPost:"",region:"",depth:"Ankle-deep",duration:"",description:"",severity:"moderate"});
          setFloodVideo(null);setFloodGPS(null);setFloodVideoError("");setFloodPostError("");
        },500);
      } else setFloodUploadProgress(Math.round(p));
    },150);
  }

  // == Camera feed simulator ==================================================
  function startFeed(cam){
    setCamFeedPlaying(true);
    const canvas=feedCanvasRef.current;if(!canvas)return;
    const ctx=canvas.getContext("2d");
    let frame=0;
    const colors=["#0a1628","#0d1f35","#081422","#0f2040"];
    const draw=()=>{
      canvas.width=canvas.offsetWidth;canvas.height=canvas.offsetHeight;
      const W=canvas.width,H=canvas.height;
      // Simulate CCTV feed: dark background with grid overlay
      ctx.fillStyle=colors[frame%colors.length];ctx.fillRect(0,0,W,H);
      // Simulate road/scene
      ctx.fillStyle="rgba(30,50,80,0.4)";ctx.fillRect(0,H*0.55,W,H*0.45);
      ctx.fillStyle="rgba(255,255,255,0.06)";
      // Road markings
      for(let i=0;i<W;i+=60){ctx.fillRect(i+(frame%60),H*0.7,30,4);}
      // Moving car shapes
      const carX=(frame*2)%W;
      ctx.fillStyle="rgba(200,200,200,0.3)";ctx.fillRect(carX,H*0.58,40,18);
      ctx.fillStyle="rgba(255,220,0,0.6)";ctx.fillRect(carX+35,H*0.62,5,6);
      ctx.fillStyle="rgba(255,80,80,0.5)";ctx.fillRect(carX-4,H*0.62,5,6);
      const car2X=W-(frame*1.5)%W;
      ctx.fillStyle="rgba(180,160,140,0.25)";ctx.fillRect(car2X,H*0.63,36,16);
      // Timestamp overlay
      ctx.fillStyle="rgba(0,0,0,0.6)";ctx.fillRect(0,0,W,20);
      ctx.fillStyle="#00e676";ctx.font="10px monospace";ctx.textAlign="left";ctx.textBaseline="middle";
      const now=new Date();
      ctx.fillText(`CAM ${cam.id.toUpperCase()} | ${cam.name.toUpperCase()} | ${now.toLocaleTimeString()} | ${cam.resolution}`,8,10);
      // REC indicator
      ctx.fillStyle="rgba(0,0,0,0.5)";ctx.fillRect(W-52,4,48,14);
      ctx.fillStyle="#F44336";ctx.beginPath();ctx.arc(W-44,11,4,0,Math.PI*2);ctx.fill();
      ctx.fillStyle="#fff";ctx.font="9px monospace";ctx.textAlign="left";ctx.fillText("REC",W-37,11);
      // Noise overlay
      for(let i=0;i<200;i++){const px=Math.random()*W,py=Math.random()*H;ctx.fillStyle=`rgba(255,255,255,${Math.random()*0.03})`;ctx.fillRect(px,py,1,1);}
      // Grid
      ctx.strokeStyle="rgba(0,255,100,0.06)";ctx.lineWidth=0.5;
      for(let x=0;x<W;x+=32){ctx.beginPath();ctx.moveTo(x,0);ctx.lineTo(x,H);ctx.stroke();}
      for(let y=0;y<H;y+=32){ctx.beginPath();ctx.moveTo(0,y);ctx.lineTo(W,y);ctx.stroke();}
      frame++;
      feedAnimRef.current=requestAnimationFrame(draw);
    };
    feedAnimRef.current=requestAnimationFrame(draw);
  }

  function stopFeed(){
    setCamFeedPlaying(false);
    cancelAnimationFrame(feedAnimRef.current);
    const canvas=feedCanvasRef.current;
    if(canvas){const ctx=canvas.getContext("2d");ctx.clearRect(0,0,canvas.width,canvas.height);}
  }

  function downloadFeed(cam){
    setCamDownloading(true);setCamDownloadProgress(0);
    // Simulate chunked download progress
    let progress=0;
    const interval=setInterval(()=>{
      progress+=Math.random()*12+4;
      if(progress>=100){
        progress=100;setCamDownloadProgress(100);
        clearInterval(interval);
        setTimeout(()=>{
          // Generate a text file with feed metadata (real integration would download video)
          const meta=[
            `SafeGhana CCTV Feed Download`,
            `================================`,
            `Camera ID    : ${cam.id.toUpperCase()}`,
            `Name         : ${cam.name}`,
            `Location     : ${cam.area}, ${GHANA_REGIONS.find(r=>r.id===cam.region)?.name}`,
            `Ghana Post   : ${cam.ghanaPost}`,
            `Coordinates  : ${cam.lat.toFixed(5)}, ${cam.lng.toFixed(5)}`,
            `Operator     : ${cam.operator}`,
            `Resolution   : ${cam.resolution} @ ${cam.fps}fps`,
            `Coverage     : ${cam.coverage}`,
            `Status       : ${cam.status.toUpperCase()}`,
            `Installed    : ${cam.installed}`,
            `Download Time: ${new Date().toISOString()}`,
            `Duration     : 00:30:00 (last 30 minutes)`,
            `File Format  : H.264/MP4`,
            ``,
            `NOTE: This is a metadata manifest. In a live deployment,`,
            `this file would be accompanied by the actual video segment.`,
            `Contact the operator (${cam.operator}) for full footage access.`,
          ].join("\n");
          const blob=new Blob([meta],{type:"text/plain"});
          const url=URL.createObjectURL(blob);
          const a=document.createElement("a");
          a.href=url;a.download=`${cam.id}_feed_${Date.now()}.txt`;
          document.body.appendChild(a);a.click();
          document.body.removeChild(a);URL.revokeObjectURL(url);
          setCamDownloading(false);setCamDownloadProgress(0);
        },600);
      } else {
        setCamDownloadProgress(Math.min(Math.round(progress),99));
      }
    },180);
  }

  // == Voice recording & AI transcription ======================================
  async function startRecording(){
    setVoiceError("");setVoiceTranscript("");setVoiceDuration(0);
    try{
      const stream=await navigator.mediaDevices.getUserMedia({audio:true});
      const options=MediaRecorder.isTypeSupported("audio/webm;codecs=opus")
        ?{mimeType:"audio/webm;codecs=opus"}
        :MediaRecorder.isTypeSupported("audio/webm")
        ?{mimeType:"audio/webm"}:{};
      const mr=new MediaRecorder(stream,options);
      mediaRecorderRef.current=mr;audioChunksRef.current=[];
      mr.ondataavailable=e=>{if(e.data.size>0)audioChunksRef.current.push(e.data);};
      mr.onstop=()=>{stream.getTracks().forEach(t=>t.stop());transcribeAudio();};
      mr.start(250);
      setVoiceStatus("recording");
      // Duration counter
      let secs=0;
      voiceTimerRef.current=setInterval(()=>{secs++;setVoiceDuration(secs);if(secs>=120)stopRecording();},1000);
    }catch(err){
      setVoiceError("Microphone access denied. Please allow microphone permission and try again.");
      setVoiceStatus("error");
    }
  }

  function stopRecording(){
    clearInterval(voiceTimerRef.current);
    if(mediaRecorderRef.current&&mediaRecorderRef.current.state!=="inactive"){
      mediaRecorderRef.current.stop();
      setVoiceStatus("processing");
    }
  }

  async function transcribeAudio(){
    setVoiceStatus("processing");
    try{
      const mimeType=audioChunksRef.current[0]?.type||"audio/webm";
      const blob=new Blob(audioChunksRef.current,{type:mimeType});
      const reader=new FileReader();
      reader.onloadend=async()=>{
        const base64Audio=reader.result.split(",")[1];
        // Transcription now runs server-side — the real Anthropic key never reaches the browser.
        const res=await fetch(`${API_BASE}/ai/transcribe-audio`,{
          method:"POST",
          headers:{"Content-Type":"application/json"},
          body:JSON.stringify({audio:base64Audio,mimeType}),
        });
        if(!res.ok){
          fallbackSpeechRecognition();
          return;
        }
        const data=await res.json();
        const text=(data.text||"").trim();
        if(!text){
          fallbackSpeechRecognition();
        } else {
          setVoiceTranscript(text);
          setForm(p=>({...p,description:p.description?(p.description+" "+text):text}));
          setVoiceStatus("done");
        }
      };
      reader.readAsDataURL(blob);
    }catch(err){
      fallbackSpeechRecognition();
    }
  }

  function fallbackSpeechRecognition(){
    // Browser Web Speech API fallback
    const SpeechRecognition=window.SpeechRecognition||window.webkitSpeechRecognition;
    if(!SpeechRecognition){setVoiceError("Could not transcribe audio. Please type your description.");setVoiceStatus("error");return;}
    setVoiceStatus("processing");
    const recognition=new SpeechRecognition();
    recognition.continuous=false;recognition.interimResults=false;recognition.lang="en-GH";
    recognition.onresult=e=>{
      const text=e.results[0][0].transcript;
      setVoiceTranscript(text);
      setForm(p=>({...p,description:p.description?(p.description+" "+text):text}));
      setVoiceStatus("done");
    };
    recognition.onerror=()=>{setVoiceError("Transcription failed. Please type your description manually.");setVoiceStatus("error");};
    recognition.start();
  }

  function clearVoice(){
    setVoiceStatus("idle");setVoiceTranscript("");setVoiceError("");setVoiceDuration(0);
    audioChunksRef.current=[];
  }

  function formatDuration(s){return`${Math.floor(s/60).toString().padStart(2,"0")}:${(s%60).toString().padStart(2,"0")}`;}

  async function runAI(){
    const inc=incidents.find(i=>String(i.id)===aiSel);if(!inc)return;
    setAiLoading(true);setAiRes(null);
    try{const res=await fetch(`${API_BASE}/ai/classify-incident`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({incidentId:inc.id})});if(!res.ok)throw new Error("classification failed");setAiRes(await res.json());}
    catch{setAiRes({classification:"Violent Crime = Level 2",severity:"medium",crimeCategory:inc.type,recommendedAction:"Report to nearest Ghana Police. Dial 191.",riskLevel:6,relatedPatterns:"Urban crime pattern. Community policing advised.",summary:"Classified from available data."});}
    setAiLoading(false);
  }

  // == Shared styles ==========================================================
  const S={
    wrap:{background:"#f0f2f5",minHeight:"100vh",color:"#111"},
    header:{background:"#0A1628",padding:"10px 18px",display:"flex",alignItems:"center",justifyContent:"space-between"},
    logo:{width:34,height:34,borderRadius:8,background:"linear-gradient(135deg,#006B3F 40%,#FCD116)",display:"flex",alignItems:"center",justifyContent:"center"},
    nav:{background:"#111C30",display:"flex",borderBottom:"1px solid rgba(255,255,255,0.07)"},
    content:{padding:14},
    card:{background:"#fff",borderRadius:10,padding:"13px 15px",border:"0.5px solid #e0e0e0",marginBottom:10},
    btn:(bg,fg="#fff")=>({background:bg,color:fg,border:"none",borderRadius:8,padding:"10px 14px",fontSize:13,fontWeight:500,cursor:"pointer",width:"100%"}),
    tag:(bg,color)=>({background:bg,color,fontSize:10,padding:"2px 8px",borderRadius:10,fontWeight:500,whiteSpace:"nowrap"}),
    metric:{background:"#f7f7f7",borderRadius:8,padding:"10px 8px",textAlign:"center",border:"0.5px solid #e8e8e8"},
    lbl:{fontSize:10,color:"#777",display:"block",marginBottom:3},
  };
  const TABS=[{id:"map",icon:"ti-map-2",label:t("safetyMap")},{id:"report",icon:"ti-circle-plus",label:t("report")},{id:"alerts",icon:"ti-bell-ringing",label:t("alerts")},{id:"floods",icon:"ti-ripple",label:t("floods")},{id:"incidents",icon:"ti-list",label:t("incidents")},{id:"cameras",icon:"ti-video",label:t("cameras")},{id:"mydash",icon:"ti-layout-dashboard",label:t("myDashboard")}];
  const canSubmit=form.type&&form.description&&(useCurrentLoc?(isValidGhanaPost(gpsGhanaPost)||isValidGhanaPost(manualPost)):isValidGhanaPost(manualPost));

  // == Dashboard Widget renderer ================================================
  function DashWidget({id,incidents,floodReports,alertHistory,typeCounts,sevCounts,dbFilter,setDbFilter}){
    const S2={row:{display:"flex",alignItems:"center",gap:8,marginBottom:7},bar:{flex:1,height:6,background:"#eee",borderRadius:3,overflow:"hidden"},metric:{textAlign:"center",padding:"8px 4px"},num:{fontSize:22,fontWeight:700},lbl:{fontSize:9,color:"#777",marginTop:2}};
    const statuses=["reported","under-investigation","arrested","resolved"];
    const statColors={"reported":"#2196F3","under-investigation":"#FF9800","arrested":"#4CAF50","resolved":"#9E9E9E"};
    const statLabels={"reported":"Reported","under-investigation":"Under Invest.","arrested":"Arrested","resolved":"Resolved"};

    if(id==="safety_score"){
      const reg=GHANA_REGIONS.find(r=>r.id===(loggedInUser?.region||"greater-accra"));
      const score=reg?reg.crimeScore:50;
      const level=score>80?"High Risk":score>60?"Moderate Risk":score>40?"Low Risk":"Safe";
      const col=score>80?"#F44336":score>60?"#FF9800":score>40?"#FCD116":"#4CAF50";
      return(<div style={{textAlign:"center",padding:"8px 0"}}>
        <div style={{fontSize:48,fontWeight:800,color:col,lineHeight:1}}>{score}</div>
        <div style={{fontSize:13,fontWeight:600,color:col,marginBottom:8}}>{level}</div>
        <div style={{height:8,background:"#f0f0f0",borderRadius:4,overflow:"hidden",margin:"0 16px 8px"}}>
          <div style={{height:"100%",width:score+"%",background:col,borderRadius:4}}/>
        </div>
        <div style={{fontSize:11,color:"#777"}}>{reg?.name||"Greater Accra"} Region</div>
        <div style={{fontSize:10,color:"#aaa",marginTop:4}}>{reg?.capital||"Accra"} · {incidents.filter(i=>i.region===(loggedInUser?.region||"greater-accra")).length} reported incidents</div>
      </div>);
    }

    if(id==="active_alerts") return(
      <div>
        {activeAlerts.length===0
          ?<div style={{textAlign:"center",padding:"12px 0",color:"#4CAF50"}}>
              <i className="ti ti-shield-check" style={{fontSize:32,display:"block",marginBottom:6}}/>
              <div style={{fontSize:12,fontWeight:600}}>No Active Alerts</div>
              <div style={{fontSize:10,color:"#aaa",marginTop:2}}>All clear in Ghana</div>
            </div>
          :activeAlerts.slice(0,4).map(a=>(
            <div key={a.id} style={{display:"flex",alignItems:"center",gap:8,marginBottom:7,padding:"6px 8px",borderRadius:8,background:SEV_BG[a.type.severity]||"#FFEBEE",border:`1px solid ${SEV_COLOR[a.type.severity]||"#F44336"}33`}}>
              <i className={`ti ${a.type.icon}`} style={{fontSize:16,color:SEV_COLOR[a.type.severity]||"#F44336",flexShrink:0}}/>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:11,fontWeight:600,color:"#111"}}>{a.type.label}</div>
                <div style={{fontSize:9,color:"#777"}}>{a.timestamp?.toLocaleTimeString()}</div>
              </div>
            </div>
          ))
        }
      </div>
    );

    if(id==="summary_stats") return(
      <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:8}}>
        {[{l:"Total",v:incidents.length,c:"#2196F3",i:"ti-list"},{l:"High/Critical",v:incidents.filter(i=>["high","critical"].includes(i.severity)).length,c:"#F44336",i:"ti-alert-triangle"},{l:"Verified",v:incidents.filter(i=>i.verified).length,c:"#4CAF50",i:"ti-shield-check"},{l:"Resolved",v:incidents.filter(i=>i.status==="resolved").length,c:"#9E9E9E",i:"ti-circle-check"}].map(s=>(
          <div key={s.l} style={{background:"#f7f7f7",borderRadius:8,padding:"10px 8px",textAlign:"center"}}>
            <i className={`ti ${s.i}`} style={{fontSize:18,color:s.c,display:"block",marginBottom:3}}/>
            <div style={{fontSize:20,fontWeight:700,color:s.c}}>{s.v}</div>
            <div style={{fontSize:9,color:"#777"}}>{s.l}</div>
          </div>
        ))}
      </div>
    );

    if(id==="crime_type_bar"){
      const max=Math.max(...Object.values(typeCounts))||1;
      return(<div>{Object.entries(typeCounts).sort((a,b)=>b[1]-a[1]).slice(0,8).map(([type,count])=>{
        const hi=dbFilter==="All"||dbFilter===type;
        return(<div key={type} style={{marginBottom:7}}>
          <div style={{display:"flex",justifyContent:"space-between",fontSize:10,marginBottom:2}}>
            <span style={{color:hi?"#111":"#bbb"}}>{type}</span>
            <span style={{fontWeight:600,color:hi?"#CE1126":"#ccc"}}>{count}</span>
          </div>
          <div style={S2.bar}><div style={{height:"100%",width:`${(count/max)*100}%`,background:hi?"#CE1126":"#ddd",borderRadius:3}}/></div>
        </div>);
      })}</div>);
    }

    if(id==="severity_pie") return(
      <div>
        {Object.entries(sevCounts).map(([s,c])=>{
          const cfg={low:{color:"#4CAF50",label:"Low"},medium:{color:"#FF9800",label:"Medium"},high:{color:"#F44336",label:"High"},critical:{color:"#9C27B0",label:"Critical"}};
          const max=Math.max(...Object.values(sevCounts))||1;
          return(<div key={s} style={S2.row}>
            <div style={{width:9,height:9,borderRadius:"50%",background:cfg[s].color,flexShrink:0}}/>
            <span style={{fontSize:11,minWidth:65}}>{cfg[s].label}</span>
            <div style={S2.bar}><div style={{height:"100%",width:`${(c/max)*100}%`,background:cfg[s].color,borderRadius:3}}/></div>
            <span style={{fontSize:11,fontWeight:600,color:cfg[s].color,minWidth:24,textAlign:"right"}}>{c}</span>
          </div>);
        })}
      </div>
    );

    if(id==="status_pie") return(
      <div>
        {statuses.map(s=>{
          const c=incidents.filter(i=>i.status===s).length;
          const max=incidents.length||1;
          return(<div key={s} style={S2.row}>
            <div style={{width:9,height:9,borderRadius:"50%",background:statColors[s],flexShrink:0}}/>
            <span style={{fontSize:10,flex:1}}>{statLabels[s]}</span>
            <div style={{...S2.bar,flex:"0 0 80px"}}><div style={{height:"100%",width:`${(c/max)*100}%`,background:statColors[s],borderRadius:3}}/></div>
            <span style={{fontSize:11,fontWeight:600,minWidth:20,textAlign:"right"}}>{c}</span>
          </div>);
        })}
      </div>
    );

    if(id==="region_bars"){
      const di=dbFilter==="All"?incidents:incidents.filter(i=>i.type===dbFilter);
      const counts=GHANA_REGIONS.map(r=>({r,c:di.filter(i=>i.region===r.id).length})).filter(x=>x.c>0).sort((a,b)=>b.c-a.c);
      const max=counts[0]?.c||1;
      return(<div>{counts.map(({r,c})=>{
        const heat=r.crimeScore>80?"#F44336":r.crimeScore>60?"#FF9800":"#4CAF50";
        return(<div key={r.id} style={S2.row}>
          <span style={{fontSize:10,minWidth:95,color:"#444"}}>{r.name}</span>
          <div style={S2.bar}><div style={{height:"100%",width:`${(c/max)*100}%`,background:heat,borderRadius:3}}/></div>
          <span style={{fontSize:11,fontWeight:600,minWidth:18,textAlign:"right"}}>{c}</span>
        </div>);
      })}</div>);
    }

    if(id==="flood_summary"){
      const sevs=["severe","moderate","mild"];
      const cols={"severe":"#B71C1C","moderate":"#E65100","mild":"#1B5E20"};
      return(<div>
        {sevs.map(s=>{
          const c=floodReports.filter(f=>f.severity===s).length;
          return(<div key={s} style={S2.row}>
            <div style={{width:9,height:9,borderRadius:"50%",background:cols[s]}}/>
            <span style={{fontSize:11,flex:1,textTransform:"capitalize"}}>{s}</span>
            <span style={{fontSize:18,fontWeight:700,color:cols[s]}}>{c}</span>
          </div>);
        })}
        <div style={{marginTop:8,padding:"6px 10px",background:"#E3F2FD",borderRadius:7,fontSize:10,color:"#1565C0"}}>
          {floodReports.filter(f=>f.videoUrl||f.videoName).length} reports with video evidence
        </div>
      </div>);
    }

    if(id==="camera_status"){
      const online=cameras.filter(c=>c.status==="online").length;
      const offline=cameras.filter(c=>c.status==="offline").length;
      const maint=cameras.filter(c=>c.status==="maintenance").length;
      return(<div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,textAlign:"center"}}>
        {[["Online",online,"#4CAF50"],["Offline",offline,"#F44336"],["Maint.",maint,"#FF9800"]].map(([l,v,c])=>(
          <div key={l} style={{background:"#f9f9f9",borderRadius:8,padding:"10px 6px"}}>
            <div style={{fontSize:20,fontWeight:700,color:c}}>{v}</div>
            <div style={{fontSize:9,color:"#777"}}>{l}</div>
          </div>
        ))}
      </div>);
    }

    if(id==="alert_history") return(
      <div>{alertHistory.length===0
        ?<div style={{textAlign:"center",color:"#aaa",fontSize:11,padding:"12px 0"}}>No alerts sent yet</div>
        :alertHistory.slice(0,5).map(a=>(
          <div key={a.id} style={{display:"flex",alignItems:"center",gap:8,marginBottom:7,padding:"5px 0",borderBottom:"0.5px solid #f5f5f5"}}>
            <i className={`ti ${a.type.icon}`} style={{fontSize:14,color:SEV_COLOR[a.type.severity],flexShrink:0}}/>
            <div style={{flex:1,minWidth:0}}>
              <div style={{fontSize:11,fontWeight:600,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{a.type.label}</div>
              <div style={{fontSize:9,color:"#999"}}>{a.timestamp.toLocaleTimeString()}</div>
            </div>
            <span style={{fontSize:9,background:SEV_BG[a.type.severity],color:SEV_COLOR[a.type.severity],padding:"2px 6px",borderRadius:8,fontWeight:600,flexShrink:0}}>{SEV_LABEL[a.type.severity]}</span>
          </div>
        ))
      }</div>
    );

    if(id==="top_risk") return(
      <div>{[...GHANA_REGIONS].sort((a,b)=>b.crimeScore-a.crimeScore).slice(0,6).map((r,i)=>{
        const heat=r.crimeScore>80?"#F44336":r.crimeScore>60?"#FF9800":"#4CAF50";
        return(<div key={r.id} style={S2.row}>
          <span style={{fontSize:10,color:"#aaa",minWidth:14}}>{i+1}.</span>
          <span style={{fontSize:11,flex:1}}>{r.name}</span>
          <div style={{...S2.bar,flex:"0 0 70px"}}><div style={{height:"100%",width:`${r.crimeScore}%`,background:heat,borderRadius:3}}/></div>
          <span style={{fontSize:10,fontWeight:600,color:heat,minWidth:26,textAlign:"right"}}>{r.crimeScore}</span>
        </div>);
      })}</div>
    );

    if(id==="verified_rate"){
      const total=incidents.length||1;
      const verified=incidents.filter(i=>i.verified).length;
      const pct=Math.round((verified/total)*100);
      return(<div style={{textAlign:"center"}}>
        <div style={{position:"relative",width:100,height:100,margin:"0 auto 10px"}}>
          <svg viewBox="0 0 36 36" style={{transform:"rotate(-90deg)",width:100,height:100}}>
            <circle cx="18" cy="18" r="15.9" fill="none" stroke="#eee" strokeWidth="3"/>
            <circle cx="18" cy="18" r="15.9" fill="none" stroke="#4CAF50" strokeWidth="3"
              strokeDasharray={`${pct} ${100-pct}`} strokeLinecap="round"/>
          </svg>
          <div style={{position:"absolute",inset:0,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center"}}>
            <span style={{fontSize:20,fontWeight:700,color:"#4CAF50"}}>{pct}%</span>
            <span style={{fontSize:8,color:"#777"}}>verified</span>
          </div>
        </div>
        <div style={{fontSize:11,color:"#555"}}>{verified} of {total} incidents verified</div>
      </div>);
    }

    if(id==="recent_incidents") return(
      <div>{incidents.slice(0,5).map(inc=>{
        const sev={low:{color:"#4CAF50",shape:"●"},medium:{color:"#FF9800",shape:"◆"},high:{color:"#F44336",shape:"▲"},critical:{color:"#9C27B0",shape:"!"}};
        return(<div key={inc.id} style={{display:"flex",alignItems:"center",gap:7,marginBottom:7,padding:"4px 0",borderBottom:"0.5px solid #f5f5f5"}}>
          <div style={{width:8,height:8,borderRadius:"50%",background:sev[inc.severity]?.color||"#999",flexShrink:0}}/>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:11,fontWeight:600,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}}>{inc.type}</div>
            <div style={{fontSize:9,color:"#999"}}>{inc.area} · {inc.date}</div>
          </div>
          {inc.verified&&<i className="ti ti-shield-check" style={{fontSize:11,color:"#2196F3",flexShrink:0}}/>}
        </div>);
      })}</div>
    );

    if(id==="flood_video_count"){
      const withVid=floodReports.filter(f=>f.videoUrl||f.videoName).length;
      const pct=Math.round((withVid/(floodReports.length||1))*100);
      return(<div style={{textAlign:"center",padding:"8px 0"}}>
        <div style={{fontSize:42,fontWeight:700,color:"#1565C0"}}>{withVid}</div>
        <div style={{fontSize:11,color:"#777",marginBottom:6}}>flood videos uploaded</div>
        <div style={{height:6,background:"#eee",borderRadius:3,overflow:"hidden",margin:"0 20px"}}>
          <div style={{height:"100%",width:`${pct}%`,background:"#1565C0",borderRadius:3}}/>
        </div>
        <div style={{fontSize:9,color:"#aaa",marginTop:4}}>{pct}% of {floodReports.length} reports have video</div>
      </div>);
    }

    return <div style={{color:"#aaa",fontSize:11}}>Widget not found</div>;
  }

  // == Flood Tooltip component ================================================
  function POITooltipCard({poi}){
    const col=POI_CATEGORY_COLORS[poi.category]||"#607D8B";
    const icon=BIZ_CATEGORY_ICONS[poi.category]||"ti-building";
    const reg=GHANA_REGIONS.find(r=>r.id===poi.region);
    return(<div>
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
        <div style={{width:28,height:28,borderRadius:7,background:col,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
          <i className={`ti ${icon}`} style={{color:"#fff",fontSize:14}}/>
        </div>
        <div style={{flex:1,minWidth:0}}>
          <div style={{color:"#fff",fontSize:13,fontWeight:700,lineHeight:1.2,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{poi.name}</div>
          <span style={{fontSize:9,background:col+"44",color:col,padding:"1px 6px",borderRadius:8,fontWeight:600,border:`1px solid ${col}55`,marginTop:2,display:"inline-block"}}>{poi.category}</span>
        </div>
      </div>
      <div style={{color:"#9BAEC8",fontSize:11,marginBottom:6}}>
        <i className="ti ti-map-pin" style={{fontSize:11,marginRight:3}}/>{poi.area}{reg?", "+reg.name:""}
        {poi.ghanaPost&&<span style={{marginLeft:6,background:"rgba(0,107,63,0.35)",color:"#80e0a0",padding:"1px 6px",borderRadius:4,fontFamily:"monospace",fontSize:10}}>{poi.ghanaPost}</span>}
      </div>
      <div style={{color:"#9BAEC8",fontSize:9,textAlign:"center"}}>
        <i className="ti ti-mouse" style={{fontSize:9,marginRight:3}}/>Click for details = Report incident here
      </div>
    </div>);
  }

    function FloodTooltipCard({flood}){
    const sev=FLOOD_SEVERITY_CFG[flood.severity]||{color:"#1565C0",bg:"#E3F2FD",label:"Flood",icon:"ti-droplet"};const reg=GHANA_REGIONS.find(r=>r.id===flood.region);
    return(<div>
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
        <i className={`ti ${sev.icon}`} style={{color:sev.color,fontSize:18}}/>
        <span style={{color:"#fff",fontSize:13,fontWeight:600,flex:1}}>Flood Zone</span>
        <span style={{fontSize:10,background:sev.bg+"33",color:sev.color,padding:"2px 8px",borderRadius:10,fontWeight:600,border:`1px solid ${sev.color}44`}}>{sev.label}</span>
      </div>
      <div style={{color:"#9BAEC8",fontSize:11,marginBottom:6}}><i className="ti ti-map-pin" style={{fontSize:11,marginRight:3}}/>{flood.area}, {reg?.name}<span style={{marginLeft:6,background:"rgba(13,71,161,0.4)",color:"#90CAF9",padding:"1px 5px",borderRadius:4,fontFamily:"monospace",fontSize:10}}>{flood.ghanaPost}</span></div>
      <div style={{color:"#ccc",fontSize:11,lineHeight:1.55,marginBottom:8}}>{flood.description.substring(0,100)}{flood.description.length>100?"=":""}</div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:4,marginBottom:8}}>
        {[["Water Depth",flood.depth],["Duration",flood.duration||"N/A"],["Reported",flood.date],["Reporter",flood.userName]].map(([l,v])=>(
          <div key={l} style={{background:"rgba(255,255,255,0.07)",borderRadius:5,padding:"4px 7px"}}><div style={{fontSize:8,color:"#9BAEC8",marginBottom:1}}>{l}</div><div style={{fontSize:10,color:"#fff",fontWeight:500}}>{v}</div></div>
        ))}
      </div>
      <div style={{color:"#90CAF9",fontSize:10,textAlign:"center"}}><i className="ti ti-mouse" style={{fontSize:11,marginRight:4}}/>Click to view flood video</div>
    </div>);
  }

  // == Camera Tooltip component ==============================================
  function CamTooltipCard({cam}){
    const st=CAM_STATUS_CFG[cam.status];const reg=GHANA_REGIONS.find(r=>r.id===cam.region);
    return(<div>
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
        <i className="ti ti-video" style={{color:st.color,fontSize:16}}/>
        <span style={{color:"#fff",fontSize:13,fontWeight:600,flex:1}}>{cam.name}</span>
        <span style={{fontSize:10,background:st.bg+"33",color:st.color,padding:"2px 7px",borderRadius:10,fontWeight:600,border:`1px solid ${st.color}44`}}>{st.label}</span>
      </div>
      <div style={{color:"#9BAEC8",fontSize:11,marginBottom:6}}><i className="ti ti-map-pin" style={{fontSize:11,marginRight:3}}/>{cam.area}, {reg?.name}<span style={{marginLeft:6,background:"rgba(0,107,63,0.4)",color:"#80e0a0",padding:"1px 5px",borderRadius:4,fontFamily:"monospace",fontSize:10}}>{cam.ghanaPost}</span></div>
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:4,marginBottom:8}}>
        {[["Resolution",cam.resolution],["Frame Rate",cam.fps+"fps"],["Coverage",cam.coverage],["Operator",cam.operator.substring(0,20)]].map(([l,v])=>(
          <div key={l} style={{background:"rgba(255,255,255,0.07)",borderRadius:5,padding:"4px 7px"}}><div style={{fontSize:8,color:"#9BAEC8",marginBottom:1}}>{l}</div><div style={{fontSize:10,color:"#fff",fontWeight:500}}>{v}</div></div>
        ))}
      </div>
      {cam.incidents_nearby>0&&<div style={{color:"#FCD116",fontSize:10,marginBottom:6}}><i className="ti ti-alert-triangle" style={{fontSize:10,marginRight:3}}/>{cam.incidents_nearby} incident(s) reported nearby</div>}
      <div style={{color:cam.status==="online"?"#00C853":"#9BAEC8",fontSize:10,textAlign:"center"}}><i className="ti ti-mouse" style={{fontSize:11,marginRight:4}}/>{cam.status==="online"?"Click to view live feed":"Click for camera details"}</div>
    </div>);
  }

  // == Tooltip component ======================================================
  function TooltipCard({dot}){
    const inc=dot.incidents[0];const reg=GHANA_REGIONS.find(r=>r.id===inc.region);const sev=SEV_CFG[inc.severity];const stat=STAT_CFG[inc.status];const extra=dot.incidents.length>1;
    return(<div>
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
        <div style={{width:8,height:8,borderRadius:"50%",background:incHex(dot.severity),flexShrink:0}}/>
        <span style={{color:"#fff",fontSize:13,fontWeight:600}}>{inc.type}</span>
        {extra&&<span style={{marginLeft:"auto",background:"rgba(255,255,255,0.15)",color:"#FCD116",fontSize:10,padding:"2px 7px",borderRadius:10,fontWeight:600}}>+{dot.incidents.length} incidents</span>}
      </div>
      <div style={{color:"#9BAEC8",fontSize:11,marginBottom:6}}><i className="ti ti-map-pin" style={{fontSize:11,marginRight:3}}/>{inc.area}, {reg?.name}{inc.ghanaPost&&<span style={{marginLeft:6,background:"rgba(0,107,63,0.4)",color:"#80e0a0",padding:"1px 5px",borderRadius:4,fontFamily:"monospace",fontSize:10}}>{inc.ghanaPost}</span>}</div>
      <div style={{color:"#ccc",fontSize:11,lineHeight:1.55,marginBottom:8}}>{inc.description.substring(0,110)}{inc.description.length>110?"=":""}</div>
      <div style={{display:"flex",gap:6,flexWrap:"wrap"}}>
        <span style={{...S.tag(sev.bg+"33",sev.color),border:`1px solid ${sev.color}44`}}>{sev.label}</span>
        <span style={{fontSize:10,color:STAT_CFG[inc.status].color,fontWeight:600}}>= {STAT_CFG[inc.status].label}</span>
        <span style={{fontSize:10,color:"#888",marginLeft:"auto"}}>{inc.date}</span>
      </div>
      {extra&&<div style={{marginTop:8,color:"#FCD116",fontSize:10,textAlign:"center"}}><i className="ti ti-mouse" style={{fontSize:11,marginRight:4}}/>Click to browse all {dot.incidents.length} incidents</div>}
    </div>);
  }

  // == Incident panel component ===============================================
  function IncidentPanel({dot,idx,setIdx,onClose}){
    const inc=dot.incidents[idx];const reg=GHANA_REGIONS.find(r=>r.id===inc.region);const sev=SEV_CFG[inc.severity];const total=dot.incidents.length;
    return(<div className="inc-panel">
      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
        <div style={{width:10,height:10,borderRadius:"50%",background:incHex(inc.severity),flexShrink:0}}/>
        <span style={{color:"#fff",fontWeight:600,fontSize:14,flex:1}}>{inc.type}</span>
        {inc.verified&&<i className="ti ti-shield-check" style={{color:"#2196F3",fontSize:14}}/>}
        <button onClick={onClose} style={{background:"none",border:"none",color:"#9BAEC8",cursor:"pointer",fontSize:18,lineHeight:1,padding:0}} aria-label="Close"><i className="ti ti-x"/></button>
      </div>
      <div style={{color:"#9BAEC8",fontSize:11,marginBottom:8}}><i className="ti ti-map-pin" style={{fontSize:11,marginRight:3}}/>{inc.area}, {reg?.name}{inc.ghanaPost&&<span style={{marginLeft:6,background:"rgba(0,107,63,0.35)",color:"#80e0a0",padding:"1px 6px",borderRadius:4,fontFamily:"monospace",fontSize:10}}>{inc.ghanaPost}</span>}<span style={{marginLeft:6,color:"#666"}}>· {inc.date} {inc.time}</span></div>
      <div style={{color:"#ccc",fontSize:12,lineHeight:1.6,marginBottom:10}}>{inc.description}</div>
      <div style={{display:"flex",gap:6,flexWrap:"wrap",marginBottom:10}}>
        <span style={{...S.tag(sev.bg+"33",sev.color),border:`1px solid ${sev.color}55`}}>{sev.label}</span>
        <span style={{fontSize:11,color:STAT_CFG[inc.status].color,fontWeight:600}}>= {STAT_CFG[inc.status].label}</span>
        <span style={{fontSize:9,color:"#9C27B0",background:"rgba(156,39,176,0.2)",padding:"2px 6px",borderRadius:8}}><i className="ti ti-brain" style={{fontSize:9,marginRight:3}}/>{inc.aiClassification}</span>
        {(()=>{const vt=getVerificationTier(inc);return(<span style={{fontSize:9,background:vt.bg,color:vt.color,padding:"2px 7px",borderRadius:8,fontWeight:600,display:"flex",alignItems:"center",gap:3}}><i className={`ti ${vt.icon}`} style={{fontSize:9}}/>{vt.label}</span>);})()}
      </div>
      {/* Verification action row */}
      <div style={{display:"flex",gap:6,marginBottom:10}}>
        <button onClick={()=>handleUpvote(inc.id)} disabled={upvotedIds.has(String(inc.id))}
          style={{flex:1,background:upvotedIds.has(String(inc.id))?"rgba(33,150,243,0.2)":"rgba(255,255,255,0.08)",border:`1px solid ${upvotedIds.has(String(inc.id))?"#2196F3":"rgba(255,255,255,0.15)"}`,color:upvotedIds.has(String(inc.id))?"#64B5F6":"#9BAEC8",borderRadius:7,padding:"6px",fontSize:11,cursor:upvotedIds.has(String(inc.id))?"default":"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:4}}>
          <i className="ti ti-thumb-up" style={{fontSize:12}}/>{inc.upvotes||0} {upvotedIds.has(String(inc.id))?"Upvoted":"Upvote"}
        </button>
        <button onClick={()=>handleConfirm(inc.id)} disabled={confirmedIds.has(String(inc.id))}
          style={{flex:1,background:confirmedIds.has(String(inc.id))?"rgba(76,175,80,0.2)":"rgba(255,255,255,0.08)",border:`1px solid ${confirmedIds.has(String(inc.id))?"#4CAF50":"rgba(255,255,255,0.15)"}`,color:confirmedIds.has(String(inc.id))?"#81C784":"#9BAEC8",borderRadius:7,padding:"6px",fontSize:11,cursor:confirmedIds.has(String(inc.id))?"default":"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:4}}>
          <i className="ti ti-check" style={{fontSize:12}}/>{inc.confirms||0} {confirmedIds.has(String(inc.id))?"Confirmed":"Confirm"}
        </button>
      </div>
      {total>1&&<div style={{borderTop:"1px solid rgba(255,255,255,0.1)",paddingTop:10,display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:10}}>
        <button className="nav-btn" disabled={idx===0} onClick={()=>setIdx(idx-1)}><i className="ti ti-chevron-left" style={{fontSize:12,marginRight:3}}/>Prev</button>
        <span style={{color:"#9BAEC8",fontSize:11}}><span style={{color:"#FCD116",fontWeight:600}}>{idx+1}</span> of <span style={{color:"#fff",fontWeight:600}}>{total}</span></span>
        <button className="nav-btn" disabled={idx===total-1} onClick={()=>setIdx(idx+1)}>Next<i className="ti ti-chevron-right" style={{fontSize:12,marginLeft:3}}/></button>
      </div>}
      <button onClick={()=>{setAiSel(String(inc.id));setTab("ai");setPanel(null);}} style={{...S.btn("#9C27B0"),fontSize:12,padding:"8px"}}><i className="ti ti-brain" style={{fontSize:13,marginRight:5}}/>Deep AI Analysis</button>
    </div>);
  }

  // ===========================================================================
  return(
    <div style={S.wrap}>
      <a href="#main-content" className="skip-link">Skip to main content</a>

      {/* == Active Alert Banner == */}
      {shownBanner&&(
        <div className="alert-banner" role="alert" aria-live="assertive" aria-atomic="true" style={{background:SEV_BG[shownBanner.type.severity],borderBottom:`3px solid ${SEV_COLOR[shownBanner.type.severity]}`}}>
          <div className="alert-dot" style={{background:SEV_COLOR[shownBanner.type.severity]}}/>
          <i className={`ti ${shownBanner.type.icon}`} style={{fontSize:22,color:SEV_COLOR[shownBanner.type.severity],flexShrink:0}}/>
          <div style={{flex:1,minWidth:0}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:2}}>
              <span style={{fontWeight:700,fontSize:13,color:SEV_COLOR[shownBanner.type.severity]}}>{SEV_LABEL[shownBanner.type.severity]} ALERT</span>
              <span style={{fontWeight:600,fontSize:13,color:"#111"}}>{shownBanner.type.label}</span>
            </div>
            <div style={{fontSize:12,color:"#333",lineHeight:1.4}}>{shownBanner.message}</div>
            <div style={{fontSize:10,color:"#666",marginTop:3}}>Regions: {shownBanner.regions.join(", ")}</div>
          </div>
          <button onClick={()=>replaySound(shownBanner)} style={{background:"none",border:`1px solid ${SEV_COLOR[shownBanner.type.severity]}`,borderRadius:6,padding:"4px 8px",cursor:"pointer",color:SEV_COLOR[shownBanner.type.severity],fontSize:11,flexShrink:0}} title="Replay sound">
            <i className="ti ti-volume" style={{fontSize:13}}/>
          </button>
          <button onClick={()=>setShownBanner(null)} style={{background:"none",border:"none",cursor:"pointer",color:"#666",fontSize:20,flexShrink:0,lineHeight:1}}>
            <i className="ti ti-x"/>
          </button>
        </div>
      )}

      {/* Unified Top Navigation Bar */}
      <header role="banner" className="sg-topnav">
        {/* Logo - clickable, returns to splash */}
        <div className="sg-topnav-logo" onClick={()=>setShowSplash(true)} style={{cursor:"pointer"}} role="button" aria-label="mysafeghana home" tabIndex={0} onKeyDown={e=>e.key==="Enter"&&setShowSplash(true)}>
          <div style={S.logo} aria-hidden="true">
            <i className="ti ti-shield-check" style={{color:"#fff",fontSize:17}}/>
          </div>
          <span style={{color:"#fff",fontWeight:700,fontSize:14,whiteSpace:"nowrap"}}>mysafeghana</span>
        </div>

        {/* Actions - absolutely positioned right */}
        <div className="sg-topnav-actions">
          {activeAlerts.length>0&&(
            <button onClick={()=>setTab("alerts")} style={{background:"#7F0000",border:"1px solid #CE1126",borderRadius:20,padding:"4px 8px",fontSize:11,color:"#fff",display:"flex",alignItems:"center",gap:3,cursor:"pointer"}}>
              <i className="ti ti-bell-ringing" style={{fontSize:11}}/>{activeAlerts.length}
            </button>
          )}
          {incidents.filter(i=>["high","critical"].includes(i.severity)).length>0&&(
            <button onClick={()=>setTab("incidents")} style={{background:"rgba(252,209,22,0.12)",border:"1px solid rgba(252,209,22,0.3)",borderRadius:20,padding:"4px 8px",fontSize:11,color:"#FCD116",display:"flex",alignItems:"center",gap:3,cursor:"pointer"}}>
              <i className="ti ti-alert-triangle" style={{fontSize:11}}/>{incidents.filter(i=>["high","critical"].includes(i.severity)).length}
            </button>
          )}
          <button onClick={()=>setTab("sos")} style={{background:"#B71C1C",border:"2px solid #FF5252",color:"#fff",borderRadius:20,padding:"6px 12px",fontSize:11,fontWeight:800,cursor:"pointer",display:"flex",alignItems:"center",gap:4,boxShadow:"0 2px 8px rgba(183,28,28,0.6)",letterSpacing:"0.5px"}}>
            <i className="ti ti-sos" style={{fontSize:13}}/>SOS
          </button>
          <button onClick={()=>setTab("sources")} style={{background:"rgba(255,255,255,0.08)",border:"1px solid rgba(255,255,255,0.2)",color:"rgba(255,255,255,0.85)",borderRadius:20,padding:"6px 11px",fontSize:11,fontWeight:500,cursor:"pointer",display:"flex",alignItems:"center",gap:4}}>
            <i className="ti ti-database" style={{fontSize:12}}/>Sources
          </button>
          <button onClick={()=>setTab("report")} style={{background:"#CE1126",border:"none",color:"#fff",borderRadius:20,padding:"6px 12px",fontSize:11,fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",gap:4,boxShadow:"0 2px 8px rgba(206,17,38,0.45)"}}>
            <i className="ti ti-plus" style={{fontSize:12}}/><span>Report</span>
          </button>
          <select value={lang} onChange={e=>setLanguage(e.target.value)} style={{background:"rgba(255,255,255,0.08)",border:"1px solid rgba(255,255,255,0.15)",color:"#fff",borderRadius:8,padding:"4px 5px",fontSize:10,cursor:"pointer",outline:"none"}}>
            <option value="en" style={{color:"#000"}}>EN</option>
            <option value="ga" style={{color:"#000"}}>Ga</option>
            <option value="tw" style={{color:"#000"}}>Twi</option>
            <option value="ee" style={{color:"#000"}}>Ewe</option>
            <option value="ha" style={{color:"#000"}}>Hausa</option>
          </select>
          {!loggedInUser?(
            <button onClick={()=>setShowLogin(true)} style={{background:"transparent",border:"1.5px solid rgba(255,255,255,0.25)",color:"#fff",borderRadius:20,padding:"5px 10px",fontSize:11,cursor:"pointer",display:"flex",alignItems:"center",gap:4}}>
              <i className="ti ti-user" style={{fontSize:12}}/>{t("signIn")}
            </button>
          ):(
            <div style={{display:"flex",alignItems:"center",gap:6,background:"rgba(255,255,255,0.08)",borderRadius:20,padding:"4px 10px",cursor:"pointer",border:"1px solid rgba(255,255,255,0.12)"}} onClick={()=>setLoggedInUser(null)}>
              <div style={{width:24,height:24,borderRadius:"50%",background:"#CE1126",display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700,color:"#fff",overflow:"hidden"}}>
                {loggedInUser.avatarUrl?<img src={loggedInUser.avatarUrl} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:loggedInUser.avatar}
              </div>
              <span style={{color:"#fff",fontSize:11,fontWeight:500}}>{loggedInUser.name.split(" ")[0]}</span>
            </div>
          )}
        </div>

        {/* Tabs - centered in the bar */}
        <nav aria-label="Main navigation" className="sg-topnav-tabs">
          {TABS.map(tb=>{
            const active=tab===tb.id;
            return(
              <button key={tb.id} role="tab"
                aria-selected={active}
                aria-controls={`panel-${tb.id}`}
                onClick={()=>setTab(tb.id)}
                onKeyDown={e=>{
                  if(e.key==="ArrowRight"){const i=TABS.findIndex(x=>x.id===tb.id);setTab(TABS[(i+1)%TABS.length].id);}
                  if(e.key==="ArrowLeft"){const i=TABS.findIndex(x=>x.id===tb.id);setTab(TABS[(i-1+TABS.length)%TABS.length].id);}
                }}
                tabIndex={active?0:-1}
                className={active?"sg-tabnav-btn sg-tabnav-btn--active":"sg-tabnav-btn"}>
                <i className={`ti ${tb.icon}`} aria-hidden="true"/>
                <span>{tb.label}</span>
              </button>
            );
          })}
        </nav>
      </header>

      <main id="main-content" role="main" style={S.content} aria-live="polite">

        {/* ==== MAP ==== */}
        {tab==="map"&&(<div role="tabpanel" id="panel-map" aria-label="Safety Map" style={{display:"flex",flexDirection:"column",height:"calc(100vh - 52px)"}}> 

          {/* PWA install banner */}
          {showInstallBanner&&(
            <div style={{background:"#0D2137",borderBottom:"1px solid #FCD11644",padding:"8px 14px",display:"flex",alignItems:"center",gap:10,flexShrink:0}}>
              <div style={{width:32,height:32,borderRadius:8,background:"#CE1126",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                <i className="ti ti-device-mobile" style={{color:"#FCD116",fontSize:16}}/>
              </div>
              <div style={{flex:1}}>
                <div style={{color:"#fff",fontSize:12,fontWeight:600}}>Add mysafeghana to your home screen</div>
                <div style={{color:"#9BAEC8",fontSize:10}}>Get instant alerts and offline access</div>
              </div>
              <button onClick={async()=>{
                if(installPrompt){await installPrompt.prompt();setInstallPrompt(null);}
                setShowInstallBanner(false);
              }} style={{background:"#FCD116",border:"none",color:"#0A1628",borderRadius:16,padding:"5px 12px",fontSize:11,fontWeight:700,cursor:"pointer",flexShrink:0}}>
                Install
              </button>
              <button onClick={()=>setShowInstallBanner(false)} style={{background:"none",border:"none",color:"#556",cursor:"pointer",fontSize:16,padding:"0 4px"}}>×</button>
            </div>
          )}

          {/* - Map Search Bar - */}
          <div style={{padding:"10px 14px",background:"#fff",borderBottom:"1px solid #e0e4ed",flexShrink:0,zIndex:600,boxShadow:"0 2px 6px rgba(0,0,0,0.06)"}}>
            {/* Input row */}
            <div style={{display:"flex",gap:8,alignItems:"center"}}>
              <div style={{flex:1,position:"relative"}}>
                <i className={`ti ${mapSearchStatus==="searching"?"ti-loader-2 spin":"ti-search"}`}
                  style={{position:"absolute",left:12,top:"50%",transform:"translateY(-50%)",fontSize:16,
                    color:mapSearchStatus==="error"?"#F44336":mapSearchStatus==="ok"?"#4CAF50":mapSearchStatus==="searching"?"#1565C0":"#9BAEC8",
                    pointerEvents:"none",zIndex:2}}/>
                <input
                  value={mapSearchQuery}
                  onChange={e=>{
                    const v=e.target.value;
                    setMapSearchQuery(v);
                    buildSearchResults(v);
                  }}
                  onKeyDown={e=>{
                    if(e.key==="Escape")clearMapSearch();
                    if(e.key==="Enter"){e.preventDefault();handleSearchEnter(mapSearchQuery);}
                  }}
                  placeholder="Search place, Ghana Post address, business, hospital…"
                  style={{width:"100%",padding:"10px 40px 10px 40px",border:"1.5px solid #d0d7e3",borderRadius:10,
                    fontSize:13,outline:"none",background:"#f8fafc",color:"#111",boxSizing:"border-box",
                    boxShadow:"inset 0 1px 3px rgba(0,0,0,0.06)"}}/>
                {mapSearchQuery&&(
                  <button onClick={clearMapSearch}
                    style={{position:"absolute",right:10,top:"50%",transform:"translateY(-50%)",
                      background:"#e0e4ed",border:"none",borderRadius:"50%",width:22,height:22,
                      cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",
                      color:"#555",fontSize:13,lineHeight:1,zIndex:2}}>
                    <i className="ti ti-x"/>
                  </button>
                )}
              </div>
              <button onClick={()=>handleSearchEnter(mapSearchQuery.trim()||mapSearchQuery)} aria-label="Search"
                style={{padding:"10px 18px",background:"#1565C0",color:"#fff",border:"none",
                  borderRadius:10,fontSize:13,fontWeight:600,cursor:"pointer",
                  display:"flex",alignItems:"center",gap:6,flexShrink:0,whiteSpace:"nowrap",
                  boxShadow:"0 2px 8px rgba(21,101,192,0.3)"}}>
                <i className="ti ti-search" style={{fontSize:14}}/>Search
              </button>
              <button onClick={()=>{
                clearMapSearch();
                const L=window.L;const map=leafMapRef.current;
                if(L&&map)try{map.setView([7.9,-1.0],7,{animate:true});}catch(e){}
              }} title="Reset map to default view"
                style={{padding:"10px 12px",background:"#fff",color:"#555",
                  border:"1.5px solid #d0d7e3",borderRadius:10,fontSize:13,cursor:"pointer",
                  display:"flex",alignItems:"center",gap:5,flexShrink:0,
                  boxShadow:"0 1px 4px rgba(0,0,0,0.08)"}}>
                <i className="ti ti-home" style={{fontSize:16,color:"#1565C0"}}/>
              </button>
            </div>
            {/* Status message */}
            {mapSearchMsg&&(
              <div style={{marginTop:6,padding:"5px 10px",borderRadius:6,fontSize:11,
                display:"flex",alignItems:"center",gap:5,
                background:mapSearchStatus==="error"?"#FFEBEE":"#E8F5E9",
                color:mapSearchStatus==="error"?"#C62828":"#2E7D32"}}>
                <i className={`ti ${mapSearchStatus==="error"?"ti-alert-circle":"ti-circle-check"}`} style={{fontSize:12}}/>
                {mapSearchMsg}
              </div>
            )}
            {/* Results - inline list, no popup, plain onClick */}
            {mapSearchResults.length>0&&(
              <div style={{marginTop:8,background:"#fff",border:"1.5px solid #d0d7e3",
                borderRadius:10,overflow:"hidden",boxShadow:"0 4px 16px rgba(0,0,0,0.12)",
                maxHeight:300,overflowY:"auto"}}>
                {mapSearchResults.map((result,idx)=>(
                  <div key={idx}
                    onClick={()=>{resolveSearchResult(result);setMapSearchResults([]);}}
                    style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",
                      cursor:"pointer",borderBottom:"1px solid #f0f2f5",background:"#fff"}}
                    onMouseEnter={e=>e.currentTarget.style.background="#EEF4FF"}
                    onMouseLeave={e=>e.currentTarget.style.background="#fff"}>
                    <div style={{width:34,height:34,borderRadius:9,flexShrink:0,
                      background:result.color+"18",border:`1.5px solid ${result.color}55`,
                      display:"flex",alignItems:"center",justifyContent:"center"}}>
                      <i className={`ti ${result.icon}`} style={{fontSize:16,color:result.color}}/>
                    </div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:13,fontWeight:700,color:"#111",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{result.label}</div>
                      <div style={{fontSize:11,color:"#667",marginTop:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{result.sublabel}</div>
                    </div>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:3,flexShrink:0}}>
                      {result.ghanaPost&&<span style={{fontSize:9,background:"#E8F5E9",color:"#2E7D32",padding:"1px 6px",borderRadius:4,fontFamily:"monospace"}}>{result.ghanaPost}</span>}
                      <span style={{fontSize:9,background:result.color+"15",color:result.color,padding:"1px 6px",borderRadius:4,fontWeight:600,textTransform:"capitalize"}}>{result.type}</span>
                    </div>
                  </div>
                ))}
                <div style={{padding:"6px 14px",background:"#f8fafc",borderTop:"1px solid #e8ecf0",
                  fontSize:10,color:"#9BAEC8",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                  <span>{mapSearchResults.length} result{mapSearchResults.length!==1?"s":""} - click any to zoom</span>
                  <button onClick={()=>setMapSearchResults([])} style={{background:"none",border:"none",color:"#9BAEC8",cursor:"pointer",fontSize:11}}>✕ close</button>
                </div>
              </div>
            )}
          </div>
          {/* Two-column layout below search */}
          {/* Two-column layout below search */}
          <div className="sg-map-two-col" style={{display:"flex",flex:1,overflow:"hidden",position:"relative"}}>

          {/* Mobile bottom-sheet toggle button */}
          <button className="sg-sheet-toggle" onClick={()=>setMobileSheetOpen(o=>!o)} title="View incidents">
            <i className={`ti ${mobileSheetOpen?"ti-x":"ti-list-details"}`}/>
          </button>

          {/* ========== LEFT COLUMN: Map ========== */}
          <div className="sg-map-left" style={{flex:"0 0 52%",display:"flex",flexDirection:"column",borderRight:"1px solid #e4e7ed",overflow:"hidden"}}>

            {/* Compact filter bar (no search - search is above columns) */}
            <div style={{padding:"6px 10px",background:"#f8f9fc",borderBottom:"1px solid #e4e7ed",display:"flex",gap:6,alignItems:"center",flexShrink:0}}>
              <select value={ft} onChange={e=>setFt(e.target.value)} style={{flex:"1 1 120px",fontSize:11,padding:"4px 6px"}}><option value="All">{t("allCrimeTypes")}</option>{incidentTypes.map(t=><option key={t}>{t}</option>)}</select>
              <select value={fs} onChange={e=>setFs(e.target.value)} style={{flex:"1 1 90px",fontSize:11,padding:"4px 6px"}}><option value="All">{t("allSeverities")}</option>{["low","medium","high","critical"].map(s=><option key={s} value={s}>{s[0].toUpperCase()+s.slice(1)}</option>)}</select>
              <span style={{fontSize:10,color:"#888",flexShrink:0}}>{filtered.length} incidents</span>
              {lastFetched&&<span style={{fontSize:9,color:"#4CAF50",flexShrink:0,display:"flex",alignItems:"center",gap:2,marginLeft:"auto"}}>
                <i className="ti ti-refresh" style={{fontSize:10}}/>{timeAgo(lastFetched)}
              </span>}
            </div>
            {/* Trust indicator bar */}
            <div style={{padding:"4px 12px",background:"#EEF2FF",borderBottom:"1px solid #C7D2FE",display:"flex",gap:10,alignItems:"center",flexShrink:0,flexWrap:"wrap"}}>
              <div style={{display:"flex",alignItems:"center",gap:4}}>
                <i className="ti ti-shield-check" style={{fontSize:11,color:"#3730A3"}}/>
                <span style={{fontSize:9,color:"#3730A3",fontWeight:600}}>VERIFIED DATA</span>
              </div>
              <div style={{width:1,height:10,background:"#C7D2FE"}}/>
              <div style={{display:"flex",alignItems:"center",gap:4}}>
                <i className="ti ti-database" style={{fontSize:10,color:"#4338CA"}}/>
                <span style={{fontSize:9,color:"#4338CA"}}>Community reports · Ghana Police Service · NADMO · Emergency Services</span>
              </div>
              <div style={{width:1,height:10,background:"#C7D2FE"}}/>
              <div style={{display:"flex",alignItems:"center",gap:4}}>
                <i className="ti ti-clock" style={{fontSize:10,color:"#4338CA"}}/>
                <span style={{fontSize:9,color:"#4338CA"}}>Updated: {new Date().toLocaleTimeString("en-GB",{hour:"2-digit",minute:"2-digit"})}</span>
              </div>
              <div style={{marginLeft:"auto",display:"flex",alignItems:"center",gap:4}}>
                <div style={{width:6,height:6,borderRadius:"50%",background:"#16A34A"}}/>
                <span style={{fontSize:9,color:"#16A34A",fontWeight:600}}>LIVE</span>
              </div>
            </div>

            {/* Layer toggles */}
            <div style={{padding:"6px 10px",background:"#fff",borderBottom:"1px solid #e4e7ed",display:"flex",gap:5,flexWrap:"wrap",flexShrink:0,alignItems:"center"}}>

              {[
                [showCameras,setShowCameras,"ti-video","Cameras","#00695C","#E8F5E9","#00C853"],
                [showFloodLayer,setShowFloodLayer,"ti-ripple","Floods","#1565C0","#E3F2FD","#1565C0"],
                [showBoundaries,setShowBoundaries,"ti-map-2","Borders","#0288D1","rgba(79,195,247,0.15)","#4FC3F7"],
                [showPOI,setShowPOI,"ti-map-pin","POI","#6A1B9A","#F3E5F5","#9C27B0"],
                [showHeatmap,setShowHeatmap,"ti-flame","Heatmap","#BF360C","#FBE9E7","#FF5722"],
              ].map(([on,set,icon,label,col,bg,dot])=>(
                <button key={label} onClick={()=>set(p=>!p)} style={{padding:"4px 9px",border:`1.5px solid ${on?dot:"#ddd"}`,borderRadius:20,background:on?bg:"#fff",color:on?col:"#aaa",fontSize:10,cursor:"pointer",display:"flex",alignItems:"center",gap:4,fontWeight:on?600:400,transition:"all .15s"}}>
                  <i className={`ti ${icon}`} style={{fontSize:11}}/>{on?label+" ON":label+" OFF"}
                </button>
              ))}
              {/* Polygon tools */}
              {!drawMode&&!showPolyPanel&&polyClosed&&(
                <button onClick={startLeafletDraw} style={{padding:"4px 9px",border:"1.5px solid #FCD116",borderRadius:20,background:"rgba(252,209,22,0.1)",color:"#B8860B",fontSize:10,fontWeight:600,cursor:"pointer",display:"flex",alignItems:"center",gap:4,marginLeft:"auto"}}>
                  <i className="ti ti-polygon" style={{fontSize:11}}/>Polygon Filter
                </button>
              )}
              {!drawMode&&!showPolyPanel&&!polyClosed&&(
                <button onClick={startLeafletDraw} style={{padding:"4px 9px",border:"1.5px solid #FCD116",borderRadius:20,background:"rgba(252,209,22,0.1)",color:"#B8860B",fontSize:10,fontWeight:600,cursor:"pointer",display:"flex",alignItems:"center",gap:4,marginLeft:"auto"}}>
                  <i className="ti ti-polygon" style={{fontSize:11}}/>Draw Polygon
                </button>
              )}
              <button onClick={()=>setShowOnboarding(true)} style={{background:"rgba(21,101,192,0.1)",border:"1px solid rgba(21,101,192,0.3)",borderRadius:20,padding:"4px 10px",fontSize:10,color:"#1565C0",cursor:"pointer",display:"flex",alignItems:"center",gap:4,flexShrink:0,marginLeft:drawMode||showPolyPanel||polyClosed?"auto":"6px"}}>
                <i className="ti ti-help-circle" style={{fontSize:11}}/>Guide
              </button>
              {!drawMode&&showPolyPanel&&(
                <div style={{marginLeft:"auto",display:"flex",gap:4}}>
                  <button onClick={startLeafletDraw} style={{padding:"4px 9px",border:"1.5px solid #FCD116",borderRadius:20,background:"rgba(252,209,22,0.1)",color:"#B8860B",fontSize:10,fontWeight:600,cursor:"pointer",display:"flex",alignItems:"center",gap:4}}>
                    <i className="ti ti-polygon" style={{fontSize:11}}/>New Polygon
                  </button>
                  <button onClick={clearLeafletPolygon} style={{padding:"4px 9px",border:"1.5px solid #F44336",borderRadius:20,background:"rgba(244,67,54,0.08)",color:"#F44336",fontSize:10,fontWeight:600,cursor:"pointer",display:"flex",alignItems:"center",gap:4}}>
                    <i className="ti ti-trash" style={{fontSize:11}}/>Delete
                  </button>
                </div>
              )}
              {drawMode&&(
                <div style={{marginLeft:"auto",display:"flex",gap:4,alignItems:"center"}}>
                  <span style={{fontSize:10,color:"#B8860B",fontWeight:600,display:"flex",alignItems:"center",gap:4}}>
                    <i className="ti ti-pencil" style={{fontSize:11}}/>{t("clickToAddPoints")}
                  </span>
                  <button onClick={clearLeafletPolygon} style={{padding:"4px 9px",border:"1.5px solid #F44336",borderRadius:20,background:"rgba(244,67,54,0.08)",color:"#F44336",fontSize:10,fontWeight:600,cursor:"pointer"}}>{t("cancel")}</button>
                </div>
              )}
            </div>

            {/* Active alerts strip */}
            {activeAlerts.length>0&&<div style={{padding:"4px 10px",background:"#FFF3E0",borderBottom:"1px solid #FFB74D",display:"flex",gap:6,flexWrap:"wrap",flexShrink:0}}>
              {activeAlerts.map(a=>(
                <div key={a.id} style={{display:"flex",alignItems:"center",gap:5,background:"#fff",border:`1px solid ${SEV_COLOR[a.type.severity]}`,borderRadius:20,padding:"3px 10px",fontSize:10}}>
                  <i className={`ti ${a.type.icon}`} style={{fontSize:11,color:SEV_COLOR[a.type.severity]}}/>
                  <span style={{color:SEV_COLOR[a.type.severity],fontWeight:600}}>{a.type.label}</span>
                  <button onClick={()=>dismissAlert(a.id)} style={{background:"none",border:"none",cursor:"pointer",color:"#bbb",fontSize:12,lineHeight:1,padding:0,marginLeft:2}} aria-label="Close"><i className="ti ti-x"/></button>
                </div>
              ))}
            </div>}

            {/* Leaflet map container */}
            <div style={{flex:1,position:"relative",overflow:"hidden"}}>
              <div ref={el=>{
                if(el){
                  mapElRef.current=el;
                  if(!leafMapRef.current)setTimeout(initLeaflet,300);
                } else {
                  // Cleanup on unmount
                  if(leafMapRef.current){leafMapRef.current.remove();leafMapRef.current=null;leafReadyRef.current=false;window._sgMapInitializing=false;}
                  mapElRef.current=null;
                }
              }}
                style={{position:"absolute",inset:0,zIndex:0}}/>
              {/* polygon draw mode: cursor set via map.getContainer().style.cursor in startLeafletDraw */}

                {/* Leaflet handles tooltips via popups */}

                {/* Legend panel = floating over Leaflet map */}
                <div style={{position:"absolute",top:10,left:10,bottom:10,width:176,background:"rgba(255,255,255,0.97)",display:"flex",flexDirection:"column",backdropFilter:"blur(8px)",borderRight:"1px solid rgba(255,255,255,0.08)",overflowY:"auto",zIndex:30}}>
                  {/* Crime Intensity */}
                  <div style={{padding:"10px 12px 6px"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:7}}>
                      <span style={{color:"#CE1126",fontSize:9,fontWeight:700,letterSpacing:1.5,textTransform:"uppercase"}}>Crime Intensity</span>
                      {legendSevFilter&&<button onClick={()=>setLegendSevFilter(null)} style={{background:"rgba(252,209,22,0.15)",border:"1px solid #FCD116",color:"#FCD116",fontSize:8,cursor:"pointer",borderRadius:4,padding:"1px 5px"}}>✕</button>}
                    </div>
                    {[["Critical","#9C27B0","critical"],["High","#F44336","high"],["Medium","#FF9800","medium"],["Low","#4CAF50","low"]].map(([l,c,k])=>{
                      const active=legendSevFilter===k;
                      return(<div key={l} onClick={()=>setLegendSevFilter(active?null:k)} style={{display:"flex",alignItems:"center",gap:7,marginBottom:5,cursor:"pointer",padding:"4px 7px",borderRadius:7,background:active?`${c}22`:"transparent",border:active?`1px solid ${c}77`:"1px solid transparent"}}>
                        <div style={{width:11,height:11,borderRadius:"50%",background:c,boxShadow:active?`0 0 7px ${c}`:"none",flexShrink:0}}/>
                        <span style={{color:active?"#111":"#555",fontSize:11,fontWeight:active?600:400,flex:1}}>{l}</span>
                        {active&&<i className="ti ti-check" style={{fontSize:10,color:c}}/>}
                      </div>);
                    })}
                  </div>
                  {/* Cameras */}
                  {showCameras&&<div style={{padding:"6px 12px",borderTop:"1px solid #f0f0f0"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:7}}>
                      <span style={{color:"#555",fontSize:9,fontWeight:700,letterSpacing:1.5,textTransform:"uppercase"}}>Cameras</span>
                      {legendCamFilter&&<button onClick={()=>setLegendCamFilter(null)} style={{background:"rgba(252,209,22,0.12)",border:"1px solid #FCD116",color:"#FCD116",fontSize:8,cursor:"pointer",borderRadius:4,padding:"1px 5px"}}>✕</button>}
                    </div>
                    {[["Online","#00C853","online"],["Offline","#F44336","offline"],["Maintenance","#FF9800","maintenance"]].map(([l,c,k])=>{
                      const active=legendCamFilter===k;
                      return(<div key={l} onClick={()=>setLegendCamFilter(active?null:k)} style={{display:"flex",alignItems:"center",gap:7,marginBottom:5,cursor:"pointer",padding:"4px 7px",borderRadius:7,background:active?`${c}22`:"transparent",border:active?`1px solid ${c}77`:"1px solid transparent"}}>
                        <div style={{width:9,height:9,borderRadius:"50%",background:c,boxShadow:active?`0 0 6px ${c}`:"none",flexShrink:0}}/>
                        <span style={{color:active?"#111":"#555",fontSize:11,fontWeight:active?600:400,flex:1}}>{l}</span>
                        {active&&<i className="ti ti-check" style={{fontSize:10,color:c}}/>}
                      </div>);
                    })}
                  </div>}
                  {/* Flood Zones */}
                  {showFloodLayer&&<div style={{padding:"6px 12px",borderTop:"1px solid #f0f0f0"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:7}}>
                      <span style={{color:"#1565C0",fontSize:9,fontWeight:700,letterSpacing:1.5,textTransform:"uppercase"}}>Flood Zones</span>
                      {legendFloodFilter&&<button onClick={()=>setLegendFloodFilter(null)} style={{background:"rgba(252,209,22,0.12)",border:"1px solid #FCD116",color:"#FCD116",fontSize:8,cursor:"pointer",borderRadius:4,padding:"1px 5px"}}>✕</button>}
                    </div>
                    {[["Severe","#B71C1C","severe"],["Moderate","#E65100","moderate"],["Mild","#1B5E20","mild"]].map(([l,c,k])=>{
                      const active=legendFloodFilter===k;
                      return(<div key={l} onClick={()=>setLegendFloodFilter(active?null:k)} style={{display:"flex",alignItems:"center",gap:7,marginBottom:5,cursor:"pointer",padding:"4px 7px",borderRadius:7,background:active?`${c}22`:"transparent",border:active?`1px solid ${c}77`:"1px solid transparent"}}>
                        <div style={{width:9,height:9,borderRadius:"50%",background:c,boxShadow:active?`0 0 6px ${c}`:"none",flexShrink:0}}/>
                        <span style={{color:active?"#111":"#555",fontSize:11,fontWeight:active?600:400,flex:1}}>{l}</span>
                        {active&&<i className="ti ti-check" style={{fontSize:10,color:c}}/>}
                      </div>);
                    })}
                    <div style={{display:"flex",alignItems:"center",gap:5,marginTop:4,padding:"3px 5px",borderRadius:5,background:"rgba(252,209,22,0.08)"}}>
                      <div style={{width:10,height:10,borderRadius:"50%",background:"#FCD116",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                        <div style={{width:0,height:0,borderTop:"3px solid transparent",borderBottom:"3px solid transparent",borderLeft:"4px solid #0A1628",marginLeft:1}}/>
                      </div>
                      <span style={{color:"#FCD116",fontSize:9}}>= Video</span>
                    </div>
                  </div>}
                  {/* POI categories */}
                  {showPOI&&<div style={{padding:"6px 12px 10px",borderTop:"1px solid #f0f0f0",flex:1,minHeight:0,display:"flex",flexDirection:"column"}}>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:7}}>
                      <span style={{color:"#6A1B9A",fontSize:9,fontWeight:700,letterSpacing:1.5,textTransform:"uppercase"}}>Points of Interest</span>
                      {activePOICategories.length>0&&<button onClick={()=>setActivePOICategories([])} style={{background:"rgba(252,209,22,0.12)",border:"1px solid #FCD116",color:"#FCD116",fontSize:8,cursor:"pointer",borderRadius:4,padding:"1px 5px"}}>✕</button>}
                    </div>
                    <div style={{overflowY:"auto",flex:1}}>
                      {Object.keys(POI_CATEGORY_COLORS).map(cat=>{
                        const col=POI_CATEGORY_COLORS[cat];
                        const icon=BIZ_CATEGORY_ICONS[cat]||"ti-building";
                        const count=GHANA_BUSINESSES.filter(b=>b.category===cat).length;
                        if(!count)return null;
                        const selected=activePOICategories.includes(cat);
                        const dimmed=activePOICategories.length>0&&!selected;
                        return(<div key={cat} onClick={()=>setActivePOICategories(prev=>prev.includes(cat)?prev.filter(x=>x!==cat):[...prev,cat])}
                          style={{display:"flex",alignItems:"center",gap:7,marginBottom:4,cursor:"pointer",padding:"5px 7px",borderRadius:7,background:selected?`${col}22`:"rgba(0,0,0,0.02)",border:selected?`1px solid ${col}77`:"1px solid rgba(255,255,255,0.04)",opacity:dimmed?0.3:1,transition:"all .15s"}}>
                          <div style={{width:22,height:22,borderRadius:6,background:col,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,boxShadow:selected?`0 0 7px ${col}66`:"none"}}>
                            <i className={`ti ${icon}`} style={{color:"#fff",fontSize:11}}/>
                          </div>
                          <span style={{color:selected?"#111":"#777",fontSize:10,fontWeight:selected?600:400,flex:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{cat}</span>
                          <span style={{fontSize:9,color:selected?"#fff":"#555",background:selected?col+"44":"rgba(255,255,255,0.05)",padding:"1px 5px",borderRadius:6,fontWeight:600,flexShrink:0}}>{count}</span>
                        </div>);
                      })}
                    </div>
                    <div style={{fontSize:8,color:"#444",marginTop:5,paddingTop:5,borderTop:"1px solid #f0f0f0"}}>Click to filter · multi-select</div>
                  </div>}
                </div>

                {/* Leaflet zoom is built-in; just add fullscreen toggle */}
                <div style={{position:"absolute",top:10,left:10,zIndex:1000,background:"rgba(255,255,255,0.95)",borderRadius:10,padding:"8px 12px",minWidth:130,boxShadow:"0 2px 12px rgba(0,0,0,0.12)"}}>
                  <div style={{color:"#CE1126",fontSize:9,fontWeight:700,letterSpacing:1,marginBottom:6,textTransform:"uppercase"}}>Top Risk Zones</div>
                  {[...GHANA_REGIONS].sort((a,b)=>b.crimeScore-a.crimeScore).slice(0,5).map(r=>(
                    <div key={r.id} style={{display:"flex",justifyContent:"space-between",marginBottom:4,alignItems:"center"}}>
                      <span style={{color:"#333",fontSize:10}}>{r.name}</span>
                      <span style={{color:r.crimeScore>80?"#F44336":r.crimeScore>60?"#FF9800":"#4CAF50",fontSize:10,fontWeight:700}}>{r.crimeScore}</span>
                    </div>
                  ))}
                </div>
            </div>
          </div>

          {/* ========== RIGHT COLUMN: Intelligence Panel ========== */}
          <div className={`sg-map-right${mobileSheetOpen?" sheet-open":""}`} style={{flex:"0 0 48%",display:"flex",flexDirection:"column",overflowY:"auto",background:"#f4f6fb"}}>
            {/* Mobile sheet handle */}
            <div className="sg-sheet-handle" onClick={()=>setMobileSheetOpen(false)} role="button" tabIndex={0} aria-label="Close panel" onKeyDown={e=>e.key==="Enter"&&setMobileSheetOpen(false)}/>

            {/* Polygon results panel (when active) */}
            {showPolyPanel&&polyFilteredList!==null&&(
              <div id="poly-results-panel" style={{margin:"10px 12px 0",background:"#fff",borderRadius:12,border:"2px solid #FCD116",overflow:"hidden",boxShadow:"0 2px 12px rgba(0,0,0,0.08)",flexShrink:0}}>
                <div style={{background:"#0A1628",padding:"10px 14px",display:"flex",alignItems:"center",gap:8}}>
                  <i className="ti ti-polygon" style={{color:"#FCD116",fontSize:15}}/>
                  <div style={{flex:1}}>
                    <div style={{color:"#fff",fontWeight:700,fontSize:12}}>Polygon Filter</div>
                    <div style={{color:"#9BAEC8",fontSize:10}}>{polyFilteredList.length} events = {polyEvents?.incidents?.length||0} inc = {polyEvents?.floods?.length||0} flood = {polyEvents?.cameras?.length||0} cam</div>
                  </div>
                  <button onClick={clearLeafletPolygon} style={{background:"rgba(244,67,54,0.15)",border:"1px solid rgba(244,67,54,0.4)",color:"#F44336",borderRadius:6,padding:"3px 8px",cursor:"pointer",fontSize:10,display:"flex",alignItems:"center",gap:3}}><i className="ti ti-trash" style={{fontSize:10}}/>Delete</button>
                  <button onClick={()=>setShowPolyPanel(false)} style={{background:"none",border:"none",color:"#9BAEC8",cursor:"pointer",fontSize:16,lineHeight:1}} aria-label="Close"><i className="ti ti-x"/></button>
                </div>
                <div style={{padding:"8px 12px",borderBottom:"1px solid #f0f0f0",background:"#fafafa"}}>
                  <select onChange={e=>{const inc=incidents.find(i=>String(i.id)===e.target.value);if(inc)addToPolyList(inc);e.target.value="";}} style={{width:"100%",fontSize:10,padding:"4px 7px"}}>
                    <option value="">+ Add incident to list</option>
                    {incidents.filter(i=>!polyFilteredList.find(e=>String(e.id)===String(i.id))).map(i=><option key={i.id} value={i.id}>#{i.id} {i.type} = {i.area}</option>)}
                  </select>
                </div>
                <div style={{maxHeight:200,overflowY:"auto"}}>
                  {polyFilteredList.length===0?<div style={{padding:"16px",textAlign:"center",color:"#aaa",fontSize:11}}><i className="ti ti-inbox" style={{fontSize:24,display:"block",marginBottom:4}}/>No events in polygon</div>
                  :["incident","flood","camera"].map(kind=>{
                    const group=polyFilteredList.filter(e=>e.kind===kind);if(!group.length)return null;
                    const kindLabel=kind==="incident"?"Incidents":kind==="flood"?"Flood Zones":"Cameras";
                    const kindIcon=kind==="incident"?"ti-alert-triangle":kind==="flood"?"ti-ripple":"ti-video";
                    return(<div key={kind}>
                      <div style={{padding:"5px 12px",background:"#f5f5f5",fontSize:9,fontWeight:700,color:"#555",letterSpacing:1,display:"flex",alignItems:"center",gap:4}}><i className={`ti ${kindIcon}`} style={{fontSize:10}}/>{kindLabel.toUpperCase()} ({group.length})</div>
                      {group.map(ev=>(
                        <div key={ev.id} className="poly-event-row" style={{display:"flex",alignItems:"center",padding:"6px 12px",gap:8,borderBottom:"1px solid #f5f5f5",cursor:"pointer"}} onClick={()=>{if(ev.kind==="incident"){setSelInc(ev.raw);setTab("incidents");}else if(ev.kind==="flood"){setSelectedFlood(ev.raw);}else if(ev.kind==="camera"){setSelectedCam(ev.raw);}}}>
                          <div style={{width:8,height:8,borderRadius:"50%",background:ev.color,flexShrink:0}}/>
                          <div style={{flex:1,minWidth:0}}><div style={{fontSize:11,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{ev.label}</div><div style={{fontSize:9,color:"#777"}}>{ev.sub}</div></div>
                          {ev.kind==="flood"&&ev.raw.videoUrl&&<i className="ti ti-video" style={{fontSize:11,color:"#FCD116",flexShrink:0}}/>}
                          <button onClick={e=>{e.stopPropagation();removeFromPolyList(ev.id);}} style={{background:"none",border:"none",color:"#bbb",cursor:"pointer",fontSize:13,lineHeight:1,padding:"0 2px",flexShrink:0}} title="Remove" aria-label="Close"><i className="ti ti-x"/></button>
                        </div>
                      ))}
                    </div>);
                  })}
                </div>
                <div style={{padding:"8px 12px",borderTop:"1px solid #f0f0f0",display:"flex",gap:6,background:"#fafafa"}}>
                  <button onClick={()=>{const map=leafMapRef.current;const M=markersRef.current;if(map&&M.polyLayer){try{map.fitBounds(M.polyLayer.getBounds().pad(0.15));}catch(e){}}}} style={{background:"#2E7D32",color:"#fff",border:"none",borderRadius:6,padding:"5px 10px",cursor:"pointer",fontSize:10,fontWeight:600,display:"flex",alignItems:"center",gap:3}}><i className="ti ti-zoom-in" style={{fontSize:11}}/>Zoom to Polygon</button>
                  <button onClick={()=>{const lines=["SafeGhana Polygon Export","========================","Exported: "+new Date().toLocaleString(),"Events: "+polyFilteredList.length,""].concat(polyFilteredList.map(e=>"["+e.kind.toUpperCase()+"] "+e.label+" = "+e.sub));const txt=lines.join("\n");const a=document.createElement("a");a.href=URL.createObjectURL(new Blob([txt],{type:"text/plain"}));a.download="polygon_export.txt";document.body.appendChild(a);a.click();document.body.removeChild(a);}} style={{background:"#1565C0",color:"#fff",border:"none",borderRadius:6,padding:"5px 10px",cursor:"pointer",fontSize:10,fontWeight:600,display:"flex",alignItems:"center",gap:3}}><i className="ti ti-download" style={{fontSize:11}}/>Export</button>
                  <div style={{fontSize:9,color:"#aaa",alignSelf:"center",marginLeft:"auto"}}>Click event to open details</div>
                </div>
              </div>
            )}

            {/* == Stats summary row == */}
            <div style={{padding:"10px 12px 0",display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,flexShrink:0}} className="sg-stat-grid">
              {mapStatsLoading?[1,2,3,4].map(i=>(
                <div key={i} style={{background:"#fff",borderRadius:10,padding:"10px 8px",textAlign:"center",border:"0.5px solid #e0e0e0"}}>
                  <span className="skeleton" style={{width:24,height:24,borderRadius:"50%",margin:"0 auto 6px"}}/>
                  <span className="skeleton" style={{width:32,height:22,margin:"0 auto 4px"}}/>
                  <span className="skeleton" style={{width:"80%",height:9,margin:"0 auto"}}/>
                </div>
              )):[
                {label:"Total Incidents",value:incidents.length,icon:"ti-list",color:"#1565C0",bg:"#E3F2FD"},
                {label:"High / Critical",value:incidents.filter(i=>["high","critical"].includes(i.severity)).length,icon:"ti-alert-triangle",color:"#C62828",bg:"#FFEBEE"},
                {label:"Flood Reports",value:floodReports.length,icon:"ti-ripple",color:"#0277BD",bg:"#E1F5FE"},
                {label:"Cameras Online",value:cameras.filter(c=>c.status==="online").length,icon:"ti-video",color:"#2E7D32",bg:"#E8F5E9"},
              ].map(s=>(
                <div key={s.label} style={{background:"#fff",borderRadius:10,padding:"10px 8px",textAlign:"center",border:`0.5px solid ${s.color}22`,boxShadow:"0 1px 4px rgba(0,0,0,0.06)"}}>
                  <i className={`ti ${s.icon}`} style={{fontSize:18,color:s.color,display:"block",marginBottom:3}}/>
                  <div style={{fontSize:22,fontWeight:700,color:s.color,lineHeight:1}}>{s.value}</div>
                  <div style={{fontSize:9,color:"#888",marginTop:2,lineHeight:1.2}}>{s.label}</div>
                </div>
              ))}
            </div>

            {/* == Recent incidents feed == */}
            <div style={{margin:"10px 12px 0",background:"#fff",borderRadius:10,overflow:"hidden",border:"0.5px solid #e4e7ed",boxShadow:"0 1px 4px rgba(0,0,0,0.06)",flexShrink:0}}>
              <div style={{padding:"10px 14px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center",gap:8}}>
                <i className="ti ti-list" style={{fontSize:14,color:"#CE1126"}}/>
                <span style={{fontWeight:700,fontSize:13,color:"#111"}}>{t("recentIncidents")}</span>
                <button onClick={()=>setTab("incidents")} style={{marginLeft:"auto",background:"none",border:"none",color:"#1565C0",cursor:"pointer",fontSize:11,fontWeight:600}}>View all </button>
              </div>
              <div style={{maxHeight:200,overflowY:"auto"}}>
                {incidents.slice(0,8).map(inc=>{
                  const sev={low:{c:"#4CAF50",shape:"●"},medium:{c:"#FF9800",shape:"◆"},high:{c:"#F44336",shape:"▲"},critical:{c:"#9C27B0",shape:"!"}};
                  return(<div key={inc.id} style={{display:"flex",alignItems:"center",gap:10,padding:"10px 14px",borderBottom:"1px solid #f5f5f5",cursor:"pointer",transition:"background .1s"}}
                    onMouseEnter={e=>e.currentTarget.style.background="#f8f9ff"}
                    onMouseLeave={e=>e.currentTarget.style.background="transparent"}
                    onClick={()=>{setSelInc(inc);setTab("incidents");}}>
                    <div style={{width:36,height:36,borderRadius:9,background:sev[inc.severity]?.c+"15",border:`1.5px solid ${sev[inc.severity]?.c||"#999"}44`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                      <i className="ti ti-alert-triangle" style={{fontSize:16,color:sev[inc.severity]?.c||"#999"}}/>
                    </div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{fontSize:12,fontWeight:700,color:"#111",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{inc.type}</div>
                      <div style={{fontSize:10,color:"#888",marginTop:1}}>{inc.area} · {inc.date}</div>
                    </div>
                    <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:3,flexShrink:0}}>
                      <span style={{fontSize:9,background:sev[inc.severity]?.c+"22",color:sev[inc.severity]?.c,padding:"2px 7px",borderRadius:8,fontWeight:700,display:"flex",alignItems:"center",gap:2}}><span>{sev[inc.severity]?.shape||"●"}</span><span style={{textTransform:"uppercase"}}>{inc.severity}</span></span>
                      {inc.verified&&<span style={{fontSize:8,background:"#E3F2FD",color:"#1565C0",padding:"1px 6px",borderRadius:6,fontWeight:600}}>✓ Verified</span>}
                    </div>
                  </div>);
                })}
              </div>
            </div>

            {/* == Region risk scores == */}
            <div style={{margin:"10px 12px 0",background:"#fff",borderRadius:10,overflow:"hidden",border:"0.5px solid #e4e7ed",boxShadow:"0 1px 4px rgba(0,0,0,0.06)",flexShrink:0}}>
              <div style={{padding:"10px 14px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center",gap:8}}>
                <i className="ti ti-map-2" style={{fontSize:14,color:"#1565C0"}}/>
                <span style={{fontWeight:700,fontSize:13,color:"#111"}}>Regional Risk Scores</span>
              </div>
              <div style={{padding:"8px 14px"}}>
                {[...GHANA_REGIONS].sort((a,b)=>b.crimeScore-a.crimeScore).slice(0,8).map(r=>{
                  const cnt=filtered.filter(i=>i.region===r.id).length;
                  const heat=r.crimeScore>80?"#F44336":r.crimeScore>60?"#FF9800":"#4CAF50";
                  return(<div key={r.id} style={{display:"flex",alignItems:"center",gap:8,marginBottom:7}}>
                    <div style={{width:7,height:7,borderRadius:"50%",background:heat,flexShrink:0}}/>
                    <span style={{fontSize:11,flex:1,color:"#333"}}>{r.name}</span>
                    <div style={{flex:"0 0 80px",height:5,background:"#f0f0f0",borderRadius:3,overflow:"hidden"}}>
                      <div style={{height:"100%",width:`${r.crimeScore}%`,background:heat,borderRadius:3}}/>
                    </div>
                    <span style={{fontSize:10,fontWeight:700,color:heat,minWidth:22,textAlign:"right"}}>{r.crimeScore}</span>
                    <span style={{fontSize:9,color:"#aaa",minWidth:18,textAlign:"right"}}>{cnt} inc</span>
                  </div>);
                })}
              </div>
            </div>

            {/* == Flood summary == */}
            <div style={{margin:"10px 12px 10px",background:"#fff",borderRadius:10,overflow:"hidden",border:"0.5px solid #e4e7ed",boxShadow:"0 1px 4px rgba(0,0,0,0.06)"}}>
              <div style={{padding:"10px 14px",borderBottom:"1px solid #f0f0f0",display:"flex",alignItems:"center",gap:8}}>
                <i className="ti ti-ripple" style={{fontSize:14,color:"#1565C0"}}/>
                <span style={{fontWeight:700,fontSize:13,color:"#111"}}>Flood Reports</span>
                <button onClick={()=>setTab("floods")} style={{marginLeft:"auto",background:"none",border:"none",color:"#1565C0",cursor:"pointer",fontSize:11,fontWeight:600}}>View all </button>
              </div>
              <div style={{padding:"10px 14px",display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8}}>
                {[["Severe","#B71C1C","severe"],["Moderate","#E65100","moderate"],["Mild","#1B5E20","mild"]].map(([l,c,k])=>(
                  <div key={k} style={{textAlign:"center",padding:"8px 4px",borderRadius:8,background:c+"0F",border:`0.5px solid ${c}44`}}>
                    <div style={{fontSize:22,fontWeight:700,color:c}}>{floodReports.filter(f=>f.severity===k).length}</div>
                    <div style={{fontSize:9,color:c,fontWeight:600}}>{l}</div>
                  </div>
                ))}
              </div>
              <div style={{padding:"0 14px 10px",fontSize:10,color:"#888",display:"flex",alignItems:"center",gap:4}}>
                <i className="ti ti-video" style={{fontSize:11,color:"#1565C0"}}/>
                {floodReports.filter(f=>f.videoUrl||f.videoName).length} reports with video evidence
              </div>
            </div>

          </div>

          </div>
        </div>)}

        {/* ==== INCIDENTS ==== */}
        {tab==="incidents"&&(<div role="tabpanel" id="panel-incidents" aria-label="Incidents">
          {/* Info banner */}
          <div style={{background:"linear-gradient(135deg,#1565C0,#0D47A1)",borderRadius:12,padding:"14px 18px",marginBottom:14,display:"flex",alignItems:"center",gap:12}}>
            <div style={{width:42,height:42,borderRadius:11,background:"rgba(255,255,255,0.15)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className="ti ti-list" style={{fontSize:20,color:"#fff"}}/>
            </div>
            <div style={{flex:1}}>
              <div style={{color:"#fff",fontWeight:700,fontSize:14}}>Community Incident Reports</div>
              <div style={{color:"#90CAF9",fontSize:11,marginTop:2}}>Reports submitted by citizens and verified by Ghana Police Service · Updated in real-time</div>
              <div style={{display:"flex",gap:8,marginTop:6,flexWrap:"wrap"}}>
                <span style={{background:"rgba(255,255,255,0.1)",borderRadius:20,padding:"2px 8px",fontSize:9,display:"flex",alignItems:"center",gap:3}}>
                  <i className="ti ti-shield-check" style={{fontSize:9,color:"#4ADE80"}}/><span style={{color:"#4ADE80",fontWeight:600}}>Verified Source</span>
                </span>
                <span style={{background:"rgba(255,255,255,0.1)",borderRadius:20,padding:"2px 8px",fontSize:9,display:"flex",alignItems:"center",gap:3}}>
                  <div style={{width:5,height:5,borderRadius:"50%",background:"#4ADE80"}}/><span style={{color:"#fff"}}>Live Data</span>
                </span>
                <span style={{background:"rgba(255,255,255,0.1)",borderRadius:20,padding:"2px 8px",fontSize:9,display:"flex",alignItems:"center",gap:3}}>
                  <i className="ti ti-building" style={{fontSize:9,color:"#93C5FD"}}/><span style={{color:"#fff"}}>Ghana Police Service</span>
                </span>
              </div>
            </div>
            <button onClick={()=>setTab("report")} style={{background:"#fff",color:"#1565C0",border:"none",borderRadius:20,padding:"7px 14px",fontSize:12,fontWeight:700,cursor:"pointer",flexShrink:0,display:"flex",alignItems:"center",gap:5}}>
              <i className="ti ti-plus" style={{fontSize:13}}/>Report New
            </button>
          </div>

          <div style={{display:"flex",gap:8,marginBottom:10,flexWrap:"wrap"}}>
            <select value={ft} onChange={e=>setFt(e.target.value)} style={{flex:"1 1 110px"}}><option value="All">All Types</option>{incidentTypes.map(t=><option key={t}>{t}</option>)}</select>
            <select value={fr} onChange={e=>setFr(e.target.value)} style={{flex:"1 1 100px"}}><option value="All">All Regions</option>{GHANA_REGIONS.map(r=><option key={r.id} value={r.id}>{r.name}</option>)}</select>
            <select value={fs} onChange={e=>setFs(e.target.value)} style={{flex:"1 1 80px"}}><option value="All">{t("allSeverities")}</option>{["low","medium","high","critical"].map(s=><option key={s} value={s}>{s[0].toUpperCase()+s.slice(1)}</option>)}</select>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:9,maxHeight:520,overflowY:"auto"}}>
            {incidentsLoading?[1,2,3,4,5].map(i=>(
              <div key={i} style={{background:"#fff",borderRadius:10,padding:"11px 13px",border:"0.5px solid #e0e0e0",borderLeft:"3px solid #e0e0e0"}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                  <span className="skeleton" style={{width:120,height:14}}/>
                  <span className="skeleton" style={{width:60,height:18,borderRadius:10}}/>
                </div>
                <span className="skeleton" style={{width:"70%",height:11,marginBottom:6}}/>
                <span className="skeleton" style={{width:"90%",height:11,marginBottom:6}}/>
                <span className="skeleton" style={{width:"50%",height:11}}/>
              </div>
            )):filtered.map(inc=>{
              const sev=SEV_CFG[inc.severity];const stat=STAT_CFG[inc.status];const reg=GHANA_REGIONS.find(r=>r.id===inc.region);const open=selInc?.id===inc.id;
              return(<div key={inc.id} onClick={()=>setSelInc(open?null:inc)} style={{background:"#fff",borderRadius:10,padding:"11px 13px",border:"0.5px solid #e0e0e0",cursor:"pointer",borderLeft:`3px solid ${sev.color}`}}>
                <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:5}}>
                  <div style={{display:"flex",alignItems:"center",gap:6}}><span style={{fontSize:13,fontWeight:600}}>{inc.type}</span>{inc.verified&&<i className="ti ti-shield-check" style={{color:"#2196F3",fontSize:13}}/>}</div>
                  <span style={S.tag(sev.bg,sev.color)}>{sev.label}</span>
                </div>
                <div style={{fontSize:11,color:"#777",marginBottom:5}}><i className="ti ti-map-pin" style={{fontSize:11}}/> {inc.area}, {reg?.name}{inc.ghanaPost&&<span style={{marginLeft:6,background:"#E8F5E9",color:"#2E7D32",padding:"1px 6px",borderRadius:6,fontSize:10,fontFamily:"monospace"}}>{inc.ghanaPost}</span>}<span style={{marginLeft:4}}>· {inc.date}</span></div>
                <div style={{fontSize:11,color:"#555",marginBottom:7,lineHeight:1.5}}>{inc.description.substring(0,100)}{inc.description.length>100?"=":""}</div>
                <div style={{display:"flex",alignItems:"center",gap:8,flexWrap:"wrap"}}>
                  <span style={{fontSize:10,color:stat.color,fontWeight:600}}>= {stat.label}</span>
                  {inc.mediaCount>0&&<span style={{fontSize:10,color:"#999"}}><i className="ti ti-photo" style={{fontSize:10}}/> {inc.mediaCount}</span>}
                  {(()=>{const vt=getVerificationTier(inc);return(<span style={{fontSize:9,background:vt.bg,color:vt.color,padding:"1px 7px",borderRadius:8,fontWeight:600,display:"flex",alignItems:"center",gap:2}}><i className={`ti ${vt.icon}`} style={{fontSize:9}}/>{vt.label}</span>);})()}
                  <div style={{marginLeft:"auto",display:"flex",gap:4}}>
                    <button onClick={e=>{e.stopPropagation();handleUpvote(inc.id);}} disabled={upvotedIds.has(String(inc.id))}
                      style={{background:upvotedIds.has(String(inc.id))?"#E3F2FD":"#f5f5f5",border:"none",borderRadius:6,padding:"2px 7px",fontSize:10,cursor:upvotedIds.has(String(inc.id))?"default":"pointer",color:upvotedIds.has(String(inc.id))?"#1565C0":"#888",display:"flex",alignItems:"center",gap:3}}>
                      <i className="ti ti-thumb-up" style={{fontSize:10}}/>{inc.upvotes||0}
                    </button>
                    <button onClick={e=>{e.stopPropagation();handleConfirm(inc.id);}} disabled={confirmedIds.has(String(inc.id))}
                      style={{background:confirmedIds.has(String(inc.id))?"#E8F5E9":"#f5f5f5",border:"none",borderRadius:6,padding:"2px 7px",fontSize:10,cursor:confirmedIds.has(String(inc.id))?"default":"pointer",color:confirmedIds.has(String(inc.id))?"#2E7D32":"#888",display:"flex",alignItems:"center",gap:3}}>
                      <i className="ti ti-check" style={{fontSize:10}}/>{inc.confirms||0}
                    </button>
                  </div>
                </div>
                {open&&<div style={{marginTop:10,paddingTop:10,borderTop:"0.5px solid #eee"}}>
                  <div style={{fontSize:11,marginBottom:8,lineHeight:1.65}}>{inc.description}</div>
                  <button onClick={e=>{e.stopPropagation();setAiSel(String(inc.id));setTab("ai");}} style={{...S.btn("#9C27B0"),width:"auto",padding:"7px 14px",fontSize:12}}><i className="ti ti-brain" style={{fontSize:12,marginRight:4}}/>Deep AI Analysis</button>
                </div>}
              </div>);
            })}
          </div>
        </div>)}

        {/* ==== REPORT ==== */}
        {tab==="report"&&(<div role="tabpanel" id="panel-report" aria-label="Report Incident" style={{maxWidth:600,margin:"0 auto"}}>
          <div style={S.card}>
            <div style={{fontSize:15,fontWeight:600,marginBottom:3}}>Report a New Incident</div>
            <div style={{fontSize:12,color:"#777",marginBottom:16}}>Anonymous · AI-classified · plotted on heatmap via Ghana Post GPS</div>
            <div style={{background:"#f9f9f9",borderRadius:8,padding:12,marginBottom:14,border:"1px solid #eee"}}>
              <div style={{fontSize:11,fontWeight:600,color:"#444",marginBottom:10,display:"flex",alignItems:"center",gap:6}}><span style={{background:"#006B3F",color:"#fff",width:18,height:18,borderRadius:"50%",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:10}}>1</span>Incident Details</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
                <div><label style={S.lbl}>Incident Type *</label><select value={form.type} onChange={e=>setForm(p=>({...p,type:e.target.value}))} style={{width:"100%"}}><option value="">Select</option>{incidentTypes.map(t=><option key={t}>{t}</option>)}</select></div>
                <div><label style={S.lbl}>Severity</label><select value={form.severity} onChange={e=>setForm(p=>({...p,severity:e.target.value}))} style={{width:"100%"}}>{["low","medium","high","critical"].map(s=><option key={s} value={s}>{s[0].toUpperCase()+s.slice(1)}</option>)}</select></div>
                <div><label style={S.lbl}>Date</label><input type="date" value={form.date} onChange={e=>setForm(p=>({...p,date:e.target.value}))} style={{width:"100%"}}/></div>
                <div><label style={S.lbl}>Time</label><input type="time" value={form.time} onChange={e=>setForm(p=>({...p,time:e.target.value}))} style={{width:"100%"}}/></div>
              </div>
              {/* Description with voice/text toggle */}
              <div>
                <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:8}}>
                  <label style={{...S.lbl,margin:0,flex:1}}>Description *</label>
                  <button className={`voice-tab-btn${descMode==="text"?" active":""}`} onClick={()=>{setDescMode("text");if(voiceStatus==="recording")stopRecording();}}>
                    <i className="ti ti-keyboard" style={{fontSize:13}}/>Type
                  </button>
                  <button className={`voice-tab-btn${descMode==="voice"?" active":""}`} onClick={()=>setDescMode("voice")}>
                    <i className="ti ti-microphone" style={{fontSize:13}}/>Speak
                  </button>
                </div>

                {descMode==="text"&&(
                  <textarea value={form.description} onChange={e=>setForm(p=>({...p,description:e.target.value}))} placeholder="Describe what happened in detail=" rows={4}/>
                )}

                {descMode==="voice"&&(
                  <div style={{border:"1.5px solid #e0e0e0",borderRadius:10,overflow:"hidden"}}>
                    {/* Voice recorder panel */}
                    <div style={{background:"#0A1628",padding:"16px",textAlign:"center",minHeight:120,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:10}}>

                      {voiceStatus==="idle"&&(
                        <>
                          <button onClick={startRecording} style={{width:64,height:64,borderRadius:"50%",background:"#CE1126",border:"none",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",boxShadow:"0 4px 20px rgba(206,17,38,0.5)"}}>
                            <i className="ti ti-microphone" style={{fontSize:28,color:"#fff"}}/>
                          </button>
                          <div style={{color:"#9BAEC8",fontSize:12}}>Tap to start recording your incident report</div>
                          <div style={{color:"#556",fontSize:10}}>Max 2 minutes · AI will transcribe automatically</div>
                        </>
                      )}

                      {voiceStatus==="recording"&&(
                        <>
                          <button onClick={stopRecording} className="voice-pulse" style={{width:64,height:64,borderRadius:"50%",background:"#CE1126",border:"4px solid rgba(206,17,38,0.3)",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center"}}>
                            <i className="ti ti-player-stop" style={{fontSize:26,color:"#fff"}}/>
                          </button>
                          <div style={{display:"flex",alignItems:"flex-end",height:28,gap:1,marginTop:4}}>
                            {[1,2,3,4,5,6,7].map(i=><div key={i} className="wave-bar" style={{animationDelay:`${i*0.08}s`}}/>)}
                          </div>
                          <div style={{color:"#fff",fontSize:13,fontWeight:600}}>Recording= {formatDuration(voiceDuration)}</div>
                          <div style={{color:"#9BAEC8",fontSize:10}}>Tap stop when done · AI will transcribe</div>
                        </>
                      )}

                      {voiceStatus==="processing"&&(
                        <>
                          <div style={{width:56,height:56,borderRadius:"50%",background:"rgba(156,39,176,0.2)",border:"3px solid #9C27B0",display:"flex",alignItems:"center",justifyContent:"center"}}>
                            <i className="ti ti-loader-2 spin" style={{fontSize:26,color:"#9C27B0"}}/>
                          </div>
                          <div style={{color:"#CE93D8",fontSize:13,fontWeight:500}}>Transcribing with AI</div>
                          <div style={{color:"#777",fontSize:10}}>Claude is processing your voice recording</div>
                        </>
                      )}

                      {voiceStatus==="done"&&(
                        <>
                          <div style={{width:48,height:48,borderRadius:"50%",background:"rgba(76,175,80,0.2)",border:"3px solid #4CAF50",display:"flex",alignItems:"center",justifyContent:"center"}}>
                            <i className="ti ti-check" style={{fontSize:24,color:"#4CAF50"}}/>
                          </div>
                          <div style={{color:"#81C784",fontSize:13,fontWeight:500}}>Transcription complete!</div>
                        </>
                      )}

                      {voiceStatus==="error"&&(
                        <>
                          <i className="ti ti-microphone-off" style={{fontSize:36,color:"#F44336"}}/>
                          <div style={{color:"#EF9A9A",fontSize:12,maxWidth:260,lineHeight:1.5}}>{voiceError}</div>
                        </>
                      )}
                    </div>

                    {/* Transcript display */}
                    {voiceTranscript&&(
                      <div style={{padding:"10px 12px",background:"#F3E5F5",borderTop:"1px solid #CE93D8"}}>
                        <div style={{display:"flex",alignItems:"center",gap:5,marginBottom:5}}>
                          <i className="ti ti-sparkles" style={{fontSize:12,color:"#9C27B0"}}/>
                          <span style={{fontSize:10,fontWeight:600,color:"#7B1FA2"}}>AI Transcription</span>
                          <button onClick={clearVoice} style={{marginLeft:"auto",background:"none",border:"none",cursor:"pointer",color:"#9C27B0",fontSize:10,textDecoration:"underline"}}>Re-record</button>
                        </div>
                        <div style={{fontSize:12,color:"#4A148C",lineHeight:1.65}}>{voiceTranscript}</div>
                      </div>
                    )}

                    {/* Bottom controls */}
                    <div style={{padding:"10px 12px",borderTop:"1px solid #eee",display:"flex",gap:6,alignItems:"center"}}>
                      {(voiceStatus==="done"||voiceStatus==="error")&&(
                        <button onClick={clearVoice} style={{background:"none",border:"1px solid #ddd",borderRadius:6,padding:"5px 10px",cursor:"pointer",fontSize:11,color:"#777",display:"flex",alignItems:"center",gap:4}}>
                          <i className="ti ti-refresh" style={{fontSize:12}}/>Try again
                        </button>
                      )}
                      <div style={{flex:1,fontSize:11,color:"#999"}}>
                        {voiceStatus==="idle"&&"Voice will be added to your description"}
                        {voiceStatus==="recording"&&<span style={{color:"#CE1126",fontWeight:600}}>= Recording {formatDuration(voiceDuration)} / 2:00</span>}
                        {voiceStatus==="processing"&&<span style={{color:"#9C27B0"}}>Processing</span>}
                        {voiceStatus==="done"&&<span style={{color:"#4CAF50"}}>✓ Added to description</span>}
                      </div>
                    </div>
                  </div>
                )}

                {/* Show typed + voice description together */}
                {descMode==="voice"&&(form.description||voiceTranscript)&&(
                  <div style={{marginTop:8}}>
                    <label style={{...S.lbl,marginBottom:4}}>Full description (edit if needed)</label>
                    <textarea value={form.description} onChange={e=>setForm(p=>({...p,description:e.target.value}))} rows={3} style={{fontSize:12}}/>
                  </div>
                )}
              </div>
            </div>
            <div style={{background:"#f9f9f9",borderRadius:8,padding:12,marginBottom:14,border:"1px solid #eee"}}>
              <div style={{fontSize:11,fontWeight:600,color:"#444",marginBottom:12,display:"flex",alignItems:"center",gap:6}}><span style={{background:"#006B3F",color:"#fff",width:18,height:18,borderRadius:"50%",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:10}}>2</span>Incident Location</div>
              {locStep==="ask"&&<div><div style={{fontSize:12,color:"#555",marginBottom:12,lineHeight:1.6}}>Is the incident at <strong>your current location</strong>?</div><div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10}}><button className="loc-btn" onClick={()=>{setUseCurrentLoc(true);requestGPS();}}><i className="ti ti-current-location" style={{fontSize:24,color:"#006B3F",display:"block",marginBottom:6}}/><div style={{fontSize:13,fontWeight:600,color:"#006B3F"}}>Yes, use my location</div><div style={{fontSize:10,color:"#888",marginTop:3}}>Auto-detect via GPS</div></button><button className="loc-btn" onClick={()=>{setUseCurrentLoc(false);setLocStep("manual");}}><i className="ti ti-map-pin" style={{fontSize:24,color:"#CE1126",display:"block",marginBottom:6}}/><div style={{fontSize:13,fontWeight:600,color:"#CE1126"}}>No, enter address</div><div style={{fontSize:10,color:"#888",marginTop:3}}>Enter Ghana Post address</div></button></div></div>}
              {locStep==="gps-loading"&&<div style={{textAlign:"center",padding:"20px 0"}}><i className="ti ti-current-location spin" style={{fontSize:32,color:"#006B3F",display:"block",marginBottom:8}}/><div style={{fontSize:13,fontWeight:500,color:"#006B3F"}}>Detecting your location</div></div>}
              {locStep==="gps-done"&&gpsCoords&&<div>
                <div style={{background:"#E8F5E9",borderRadius:8,padding:"10px 12px",marginBottom:10,border:"1px solid #A5D6A7"}}><div style={{display:"flex",alignItems:"center",gap:6,marginBottom:4}}><i className="ti ti-circle-check" style={{color:"#2E7D32",fontSize:15}}/><span style={{fontSize:12,fontWeight:600,color:"#2E7D32"}}>Location detected</span></div><div style={{fontSize:11,color:"#388E3C",lineHeight:1.6,marginBottom:4}}>{gpsAddress}</div><div style={{fontSize:10,color:"#555"}}>{gpsCoords.lat.toFixed(5)}, {gpsCoords.lng.toFixed(5)}</div></div>
                
                {/* Business/location search */}
                <div style={{marginBottom:10}}>
                  <label style={{...S.lbl,fontWeight:600,color:"#333"}}>Location / Business <span style={{fontSize:9,background:"#EDE7F6",color:"#7B1FA2",padding:"1px 5px",borderRadius:4,fontWeight:600,marginLeft:4}}>type b/ to search</span></label>
                  <div className="biz-input-wrap">
                    <input value={bizQuery} onChange={e=>handleBizChange(e.target.value,setBizQuery,setBizMatches,setBizDropOpen)}
                      onBlur={()=>setTimeout(()=>setBizDropOpen(false),200)}
                      placeholder="Area name  =  or  b/k  for businesses starting with K="
                      style={{width:"100%",borderColor:bizQuery.startsWith("b/")?"#9C27B0":"#ccc"}}/>
                    {bizDropOpen&&bizMatches.length>0&&(
                      <div className="biz-dropdown">
                        {bizMatches.map(biz=>(
                          <div key={biz.name} className="biz-item" onMouseDown={()=>chooseBiz(biz,setBizDropOpen,setBizMatches,setBizQuery,setForm,"area")}>
                            <i className={`ti ${BIZ_CATEGORY_ICONS[biz.category]||"ti-building"}`} style={{fontSize:15,color:"#9C27B0",flexShrink:0}}/>
                            <div style={{flex:1,minWidth:0}}>
                              <div style={{fontSize:12,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{biz.name}</div>
                              <div style={{fontSize:10,color:"#888"}}>{biz.area} = {GHANA_REGIONS.find(r=>r.id===biz.region)?.name||biz.region}</div>
                            </div>
                            <span className="biz-badge">{biz.category}</span>
                          </div>
                        ))}
                      </div>
                    )}
                    {bizQuery.startsWith("b/")&&bizQuery.length>2&&bizMatches.length===0&&(
                      <div style={{fontSize:10,color:"#aaa",marginTop:3}}>No businesses found - try a different letter</div>
                    )}
                  </div>
                </div>
                <label style={{...S.lbl,fontWeight:600,color:"#333"}}>Ghana Post Digital Address</label>
                <input className={`gp-input${gpsGhanaPost&&isValidGhanaPost(gpsGhanaPost)?" gp-valid":""}`} value={gpsGhanaPost} onChange={e=>{const v=e.target.value.toUpperCase();setGpsGhanaPost(v);if(isValidGhanaPost(v)){const r=regionFromGhanaPost(v);if(r)setForm(p=>({...p,region:r}));}}} placeholder="XX-XXXX-XXXX" style={{width:"100%"}}/>
                {form.region&&<div style={{marginTop:6,fontSize:11,color:"#006B3F",background:"#F0FAF5",padding:"5px 9px",borderRadius:6}}>Region: <strong>{GHANA_REGIONS.find(r=>r.id===form.region)?.name}</strong></div>}
                <button onClick={()=>{setLocStep("ask");setUseCurrentLoc(null);setGpsCoords(null);setGpsGhanaPost("");setGpsAddress("");}} style={{...S.btn("#f0f0f0","#555"),marginTop:8,fontSize:11,padding:"6px 12px",width:"auto"}}><i className="ti ti-refresh" style={{fontSize:11,marginRight:4}}/>Change method</button>
              </div>}
              {gpsError&&<div style={{background:"#FFF3E0",borderRadius:8,padding:"10px 12px",marginBottom:10,border:"1px solid #FFE0B2",fontSize:12,color:"#E65100"}}><i className="ti ti-alert-triangle" style={{fontSize:13,marginRight:4}}/>{gpsError}</div>}
              {locStep==="manual"&&<div>
                <div style={{background:"#E3F2FD",borderRadius:8,padding:"10px 12px",marginBottom:12,border:"1px solid #90CAF9"}}><div style={{fontSize:12,fontWeight:600,color:"#1565C0",marginBottom:3}}><i className="ti ti-info-circle" style={{fontSize:13,marginRight:4}}/>What is Ghana Post GPS?</div><div style={{fontSize:11,color:"#1976D2",lineHeight:1.65}}>A unique digital address for every location in Ghana. Find yours on the <em>GhanaPostGPS</em> app or <em>ghanapostgps.com</em>.</div></div>
                
                {/* Business/location search */}
                <div style={{marginBottom:10}}>
                  <label style={{...S.lbl,fontWeight:600,color:"#333"}}>Location / Business <span style={{fontSize:9,background:"#EDE7F6",color:"#7B1FA2",padding:"1px 5px",borderRadius:4,fontWeight:600,marginLeft:4}}>type b/ to search</span></label>
                  <div className="biz-input-wrap">
                    <input value={bizQuery} onChange={e=>handleBizChange(e.target.value,setBizQuery,setBizMatches,setBizDropOpen)}
                      onBlur={()=>setTimeout(()=>setBizDropOpen(false),200)}
                      placeholder="Area name  =  or  b/k  for businesses starting with K="
                      style={{width:"100%",borderColor:bizQuery.startsWith("b/")?"#9C27B0":"#ccc"}}/>
                    {bizDropOpen&&bizMatches.length>0&&(
                      <div className="biz-dropdown">
                        {bizMatches.map(biz=>(
                          <div key={biz.name} className="biz-item" onMouseDown={()=>chooseBiz(biz,setBizDropOpen,setBizMatches,setBizQuery,setForm,"area")}>
                            <i className={`ti ${BIZ_CATEGORY_ICONS[biz.category]||"ti-building"}`} style={{fontSize:15,color:"#9C27B0",flexShrink:0}}/>
                            <div style={{flex:1,minWidth:0}}>
                              <div style={{fontSize:12,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{biz.name}</div>
                              <div style={{fontSize:10,color:"#888"}}>{biz.area} = {GHANA_REGIONS.find(r=>r.id===biz.region)?.name||biz.region}</div>
                            </div>
                            <span className="biz-badge">{biz.category}</span>
                          </div>
                        ))}
                      </div>
                    )}
                    {bizQuery.startsWith("b/")&&bizQuery.length>2&&bizMatches.length===0&&(
                      <div style={{fontSize:10,color:"#aaa",marginTop:3}}>No businesses found - try a different letter</div>
                    )}
                  </div>
                </div>
                <label style={{...S.lbl,fontWeight:600,color:"#333"}}>Ghana Post Digital Address *</label>
                <input className={`gp-input${manualPost&&isValidGhanaPost(manualPost)?" gp-valid":manualPost&&manualPost.length>=10?" gp-invalid":""}`} value={manualPost} onChange={e=>handleManualPost(e.target.value.toUpperCase())} placeholder="XX-XXXX-XXXX" maxLength={12} style={{width:"100%"}}/>
                {postError&&<div style={{color:"#F44336",fontSize:11,marginTop:4}}><i className="ti ti-alert-circle" style={{fontSize:11,marginRight:3}}/>{postError}</div>}
                {manualPost&&isValidGhanaPost(manualPost)&&<div style={{marginTop:6,fontSize:11,color:"#006B3F",background:"#F0FAF5",padding:"5px 9px",borderRadius:6}}><i className="ti ti-circle-check" style={{fontSize:11,marginRight:4}}/>Valid{form.region&&<> = Region: <strong>{GHANA_REGIONS.find(r=>r.id===form.region)?.name}</strong></>}</div>}
                {!form.region&&manualPost&&isValidGhanaPost(manualPost)&&<div style={{marginTop:10}}><label style={S.lbl}>Select region manually</label><select value={form.region} onChange={e=>setForm(p=>({...p,region:e.target.value}))} style={{width:"100%"}}><option value="">Select</option>{GHANA_REGIONS.map(r=><option key={r.id} value={r.id}>{r.name}</option>)}</select></div>}
                <div style={{fontSize:10,color:"#888",marginTop:8}}>Examples: GA-182-6027 (Accra) = AK-459-3821 (Kumasi) = CA-053-8891 (Cape Coast)</div>
                <button onClick={()=>{setLocStep("ask");setUseCurrentLoc(null);setManualPost("");setPostError("");}} style={{...S.btn("#f0f0f0","#555"),marginTop:8,fontSize:11,padding:"6px 12px",width:"auto"}}><i className="ti ti-arrow-left" style={{fontSize:11,marginRight:4}}/>Back</button>
              </div>}
            </div>
            <div style={{background:"#f9f9f9",borderRadius:8,padding:12,marginBottom:14,border:"1px solid #eee"}}>
              <div style={{fontSize:11,fontWeight:600,color:"#444",marginBottom:10,display:"flex",alignItems:"center",gap:6}}><span style={{background:"#006B3F",color:"#fff",width:18,height:18,borderRadius:"50%",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:10}}>3</span>Upload Evidence (optional)</div>
              <label style={{display:"flex",alignItems:"center",gap:8,padding:"10px",border:"1.5px dashed #ccc",borderRadius:8,cursor:"pointer",color:"#888",fontSize:12}}>
                <i className="ti ti-cloud-upload" style={{fontSize:20}}/>Upload photos or videos
                <input type="file" multiple accept="image/*,video/*" onChange={e=>{setUploadedFiles(p=>[...p,...Array.from(e.target.files).map(x=>({name:x.name,type:x.type.startsWith("image")?"image":"video"}))]);}} style={{display:"none"}}/>
              </label>
              {uploadedFiles.length>0&&<div style={{display:"flex",flexWrap:"wrap",gap:5,marginTop:8}}>{uploadedFiles.map((f,i)=><div key={i} style={{background:"#eee",borderRadius:6,padding:"3px 9px",fontSize:11,display:"flex",alignItems:"center",gap:4}}><i className={`ti ${f.type==="image"?"ti-photo":"ti-video"}`} style={{fontSize:12}}/>{f.name.substring(0,20)}</div>)}</div>}
            </div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={goBack} style={{flex:"0 0 auto",background:"#F5F5F5",border:"1px solid #ddd",color:"#555",borderRadius:8,padding:"11px 18px",fontSize:13,fontWeight:600,cursor:"pointer",display:"flex",alignItems:"center",gap:6}}>
                <i className="ti ti-arrow-left" style={{fontSize:14}}/>Cancel
              </button>
              <button onClick={submitReport} disabled={!canSubmit} style={{...S.btn(canSubmit?"#CE1126":"#aaa"),opacity:canSubmit?1:0.55,flex:1}}><i className="ti ti-send" style={{fontSize:14,marginRight:6}}/>Submit & Plot on Heatmap</button>
            </div>
          </div>
          <div style={{background:"#FFF3E0",borderRadius:10,padding:"10px 14px",border:"1px solid #FFE0B2"}}><div style={{fontSize:12,color:"#E65100",fontWeight:600,marginBottom:2}}><i className="ti ti-alert-triangle" style={{fontSize:13,marginRight:4}}/>Emergency? Call Ghana Police</div><div style={{fontSize:11,color:"#BF360C"}}>Emergency: <b>191</b> = CID: <b>030-773-2020</b> = Fire: <b>192</b> = Ambulance: <b>193</b></div></div>
        </div>)}

        {/* ==== ALERTS TAB ==== */}
        {tab==="alerts"&&(<div role="tabpanel" id="panel-alerts" aria-label="Alerts">
          {/* Citizen alert banner */}
          <div style={{background:"linear-gradient(135deg,#0D1B2A,#1565C0)",borderRadius:12,padding:"16px 18px",marginBottom:14,display:"flex",alignItems:"center",gap:12}}>
            <div style={{width:44,height:44,borderRadius:12,background:"rgba(255,255,255,0.15)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className="ti ti-bell-ringing" style={{fontSize:22,color:"#FCD116"}}/>
            </div>
            <div style={{flex:1}}>
              <div style={{color:"#fff",fontWeight:700,fontSize:14}}>{t("publicSafetyAlerts")}</div>
              <div style={{color:"#9BAEC8",fontSize:11,marginTop:2}}>Official alerts from Ghana Police Service, NADMO and Emergency Services</div>
            </div>
            {activeAlerts.length>0&&<div style={{background:"#B71C1C",borderRadius:20,padding:"4px 10px",fontSize:11,color:"#fff",fontWeight:600}}>{activeAlerts.length} Active</div>}
          </div>

          <div style={{display:"flex",gap:10,marginBottom:14}}>
            {isAdmin&&<button onClick={()=>setShowAlertModal(true)} style={{...S.btn("#E65100"),flex:1,display:"flex",alignItems:"center",justifyContent:"center",gap:6}}>
              <i className="ti ti-bell-plus" style={{fontSize:16}}/>Send New Public Alert
            </button>}
            {!isAdmin&&<div style={{flex:1,background:"#FFF8E1",border:"1px solid #FFE082",borderRadius:8,padding:"10px 14px",display:"flex",alignItems:"center",gap:8}}>
              <i className="ti ti-info-circle" style={{color:"#F9A825",fontSize:16,flexShrink:0}}/>
              <div style={{fontSize:11,color:"#795548"}}>Alerts are issued by authorised emergency services only. You can view active and past alerts below.</div>
            </div>}
          </div>

          {/* SMS subscription */}
          <div style={{background:"#E8F5E9",border:"1px solid #A5D6A7",borderRadius:10,padding:"12px 14px",marginBottom:14}}>
            <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:8}}>
              <i className="ti ti-device-mobile-message" style={{color:"#2E7D32",fontSize:18}}/>
              <div style={{fontSize:12,fontWeight:700,color:"#1B5E20"}}>{t("getSmsAlerts")}</div>
            </div>
            <div style={{fontSize:11,color:"#388E3C",marginBottom:10}}>Receive critical safety alerts via SMS even without internet. Ghana numbers only (+233).</div>
            <div style={{display:"flex",gap:6}}>
              <input id="sms-phone-input" type="tel" placeholder="+233 XX XXX XXXX" style={{flex:1,padding:"7px 10px",border:"1px solid #A5D6A7",borderRadius:7,fontSize:12,outline:"none"}}/>
              <button onClick={async()=>{
                const phone=document.getElementById("sms-phone-input").value.trim();
                if(!phone)return;
                try{
                  const r=await fetch(`${API_BASE}/alerts/subscribe`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({phone,regions:[]})});
                  const d=await r.json();
                  alert(d.message||"Subscribed! You will receive SMS alerts.");
                }catch(e){alert("Subscription saved. You will receive alerts when service is available.");}
              }} style={{background:"#2E7D32",color:"#fff",border:"none",borderRadius:7,padding:"7px 14px",fontSize:12,fontWeight:600,cursor:"pointer",whiteSpace:"nowrap"}}>
                <i className="ti ti-check" style={{fontSize:13,marginRight:4}}/>Subscribe
              </button>
            </div>
          </div>

          {/* Active alerts */}
          {activeAlerts.length>0&&(<div style={{marginBottom:14}}>
            <div style={{fontSize:13,fontWeight:600,marginBottom:8,display:"flex",alignItems:"center",gap:6}}><i className="ti ti-bell-ringing" style={{color:"#B71C1C",fontSize:15}}/>Active Alerts ({activeAlerts.length})</div>
            {activeAlerts.map(a=>(
              <div key={a.id} style={{background:SEV_BG[a.type.severity],border:`1.5px solid ${SEV_COLOR[a.type.severity]}`,borderRadius:10,padding:"12px 14px",marginBottom:8}}>
                <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
                  <i className={`ti ${a.type.icon}`} style={{fontSize:20,color:SEV_COLOR[a.type.severity]}}/>
                  <div style={{flex:1}}>
                    <div style={{display:"flex",alignItems:"center",gap:6}}>
                      <span style={{fontWeight:700,fontSize:12,color:SEV_COLOR[a.type.severity]}}>{SEV_LABEL[a.type.severity]}</span>
                      <span style={{fontWeight:600,fontSize:13,color:"#111"}}>{a.type.label}</span>
                    </div>
                    <div style={{fontSize:10,color:"#666",marginTop:1}}>Regions: {a.regions.join(", ")} = {a.timestamp.toLocaleTimeString()}</div>
                  </div>
                  <button onClick={()=>replaySound(a)} title="Replay alert sound" style={{background:"none",border:`1px solid ${SEV_COLOR[a.type.severity]}44`,borderRadius:6,padding:"4px 8px",cursor:"pointer",color:SEV_COLOR[a.type.severity],fontSize:11}}><i className="ti ti-volume" style={{fontSize:13}}/></button>
                  <button onClick={()=>dismissAlert(a.id)} style={{background:"none",border:"none",cursor:"pointer",color:"#888",fontSize:18,lineHeight:1}} aria-label="Close"><i className="ti ti-x"/></button>
                </div>
                <div style={{fontSize:12,color:"#444",lineHeight:1.5}}>{a.message}</div>
              </div>
            ))}
          </div>)}

          {/* Alert history */}
          <div style={{fontSize:13,fontWeight:600,marginBottom:8,display:"flex",alignItems:"center",gap:6}}><i className="ti ti-history" style={{color:"#777",fontSize:15}}/>Alert History ({alertHistory.length})</div>
          {alertHistory.length===0&&<div style={{...S.card,textAlign:"center",color:"#aaa",padding:"30px"}}>
            <i className="ti ti-bell-off" style={{fontSize:32,display:"block",marginBottom:8}}/>No alerts sent yet
          </div>}
          {alertHistory.map(a=>{
            const isActive=activeAlerts.some(x=>x.id===a.id);
            return(<div key={a.id} style={{...S.card,opacity:isActive?1:0.7,borderLeft:`3px solid ${SEV_COLOR[a.type.severity]}`}}>
              <div style={{display:"flex",alignItems:"center",gap:8}}>
                <i className={`ti ${a.type.icon}`} style={{fontSize:18,color:SEV_COLOR[a.type.severity]}}/>
                <div style={{flex:1}}>
                  <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:2}}>
                    <span style={{fontWeight:600,fontSize:12}}>{a.type.label}</span>
                    <span className="alert-badge" style={{background:SEV_BG[a.type.severity],color:SEV_COLOR[a.type.severity]}}>{SEV_LABEL[a.type.severity]}</span>
                    {isActive&&<span className="alert-badge" style={{background:"#FFEBEE",color:"#B71C1C"}}>= ACTIVE</span>}
                  </div>
                  <div style={{fontSize:11,color:"#777"}}>{a.regions.join(", ")} = {a.timestamp.toLocaleString()}</div>
                  <div style={{fontSize:11,color:"#555",marginTop:3,lineHeight:1.4}}>{a.message}</div>
                </div>
                <button onClick={()=>replaySound(a)} title="Replay sound" style={{background:"none",border:"1px solid #ddd",borderRadius:6,padding:"4px 8px",cursor:"pointer",color:"#666",fontSize:11}}><i className="ti ti-volume" style={{fontSize:13}}/></button>
              </div>
            </div>);
          })}
        </div>)}

        {/* ==== FLOODS ==== */}
        {tab==="floods"&&(<div role="tabpanel" id="panel-floods" aria-label="Floods">
          {/* Header */}
          <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14}}>
            <div style={{flex:1}}>
              <div style={{fontSize:15,fontWeight:700,color:"#0D47A1"}}>
                <i className="ti ti-ripple" style={{fontSize:16,marginRight:6}}/>Flood Prone Areas
              </div>
              <div style={{fontSize:11,color:"#777",marginTop:2}}>{floodReports.length} community reports = {floodReports.filter(f=>f.verified).length} verified</div>
            </div>
            <button onClick={()=>setShowFloodModal(true)} style={{background:"#0D47A1",color:"#fff",border:"none",borderRadius:8,padding:"8px 14px",fontSize:12,fontWeight:600,cursor:"pointer",display:"flex",alignItems:"center",gap:5}}>
              <i className="ti ti-video-plus" style={{fontSize:14}}/>Report Flooding
            </button>
          </div>

          {/* Auth bar = optional, never blocks reporting */}
          {loggedInUser?(
            <div style={{background:"#E8F5E9",borderRadius:10,padding:"10px 14px",marginBottom:14,border:"1px solid #A5D6A7",display:"flex",alignItems:"center",gap:10}}>
              <div className="user-avatar" style={{background:"#1565C0",color:"#fff",overflow:"hidden"}}>
                {loggedInUser.avatarUrl?<img src={loggedInUser.avatarUrl} alt="" style={{width:"100%",height:"100%",objectFit:"cover"}}/>:loggedInUser.avatar}
              </div>
              <div style={{flex:1}}>
                <div style={{fontSize:12,fontWeight:600,color:"#2E7D32"}}>Signed in as {loggedInUser.name}</div>
                <div style={{fontSize:10,color:"#555"}}>{loggedInUser.reports} report(s) submitted = {loggedInUser.region}</div>
              </div>
              <button onClick={()=>setLoggedInUser(null)} style={{background:"none",border:"1px solid #ccc",borderRadius:6,padding:"4px 10px",cursor:"pointer",fontSize:11,color:"#777"}}>Sign Out</button>
            </div>
          ):(
            <div style={{background:"#E3F2FD",borderRadius:10,padding:"10px 14px",marginBottom:12,border:"1px solid #90CAF9",display:"flex",alignItems:"center",gap:10}}>
              <i className="ti ti-info-circle" style={{fontSize:18,color:"#1565C0",flexShrink:0}}/>
              <div style={{flex:1,fontSize:11,color:"#1565C0",lineHeight:1.5}}>
                Anyone can report flooding = no account needed. <strong>Register</strong> to track your submissions and get notified.
              </div>
              <div style={{display:"flex",gap:6,flexShrink:0}}>
                <button onClick={()=>setShowLogin(true)} style={{background:"#fff",border:"1px solid #1565C0",color:"#1565C0",borderRadius:7,padding:"5px 10px",cursor:"pointer",fontSize:11,fontWeight:600}}>Sign In</button>
                <button onClick={()=>setShowRegModal(true)} style={{background:"#1565C0",border:"none",color:"#fff",borderRadius:7,padding:"5px 10px",cursor:"pointer",fontSize:11,fontWeight:600}}>Register</button>
              </div>
            </div>
          )}

          {/* Stats */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginBottom:14}}>
            {[
              {l:"Severe",  v:floodReports.filter(f=>f.severity==="severe").length,  c:"#0D47A1",i:"ti-ripple"},
              {l:"Moderate",v:floodReports.filter(f=>f.severity==="moderate").length, c:"#1565C0",i:"ti-ripple"},
              {l:"Mild",    v:floodReports.filter(f=>f.severity==="mild").length,     c:"#1976D2",i:"ti-droplet"},
            ].map(s=>(
              <div key={s.l} style={{background:"#E3F2FD",borderRadius:8,padding:"10px 8px",textAlign:"center",border:`1px solid ${s.c}33`}}>
                <i className={`ti ${s.i}`} style={{fontSize:18,color:s.c,display:"block",marginBottom:4}}/>
                <div style={{fontSize:22,fontWeight:700,color:s.c}}>{s.v}</div>
                <div style={{fontSize:9,color:"#555"}}>{s.l}</div>
              </div>
            ))}
          </div>

          {/* Filter */}
          <div style={{display:"flex",gap:6,marginBottom:12,flexWrap:"wrap"}}>
            {["all","severe","moderate","mild"].map(f=>(
              <button key={f} onClick={()=>setFloodFilter(f)} style={{padding:"5px 12px",border:"1.5px solid",borderColor:floodFilter===f?"#1565C0":"#ddd",borderRadius:18,background:floodFilter===f?"#E3F2FD":"#fff",color:floodFilter===f?"#1565C0":"#777",fontSize:11,cursor:"pointer",fontWeight:floodFilter===f?600:400}}>
                {f==="all"?"All Reports":f[0].toUpperCase()+f.slice(1)}
              </button>
            ))}
          </div>

          {/* Flood report cards */}
          {(floodFilter==="all"?floodReports:floodReports.filter(f=>f.severity===floodFilter)).map(flood=>{
            const sev=FLOOD_SEVERITY_CFG[flood.severity]||{color:"#1565C0",bg:"#E3F2FD",label:"Flood",icon:"ti-droplet"};
            const reg=GHANA_REGIONS.find(r=>r.id===flood.region);
            return(
              <div key={flood.id} className="flood-card" onClick={()=>setSelectedFlood(flood)} style={{borderLeftColor:sev.color}}>
                <div style={{display:"flex",alignItems:"flex-start",gap:10}}>
                  <div className="user-avatar" style={{background:sev.bg,color:sev.color,fontSize:12}}>{flood.avatar}</div>
                  <div style={{flex:1,minWidth:0}}>
                    <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:3}}>
                      <span style={{fontWeight:600,fontSize:13}}>{flood.userName}</span>
                      {flood.verified&&<i className="ti ti-shield-check" style={{color:"#2196F3",fontSize:13}}/>}
                      <span style={{fontSize:9,background:sev.bg,color:sev.color,padding:"2px 8px",borderRadius:10,fontWeight:600,marginLeft:"auto"}}>{sev.label}</span>
                    </div>
                    <div style={{fontSize:11,color:"#777",marginBottom:4}}>
                      <i className="ti ti-map-pin" style={{fontSize:11}}/> {flood.area}, {reg?.name}
                      <span style={{marginLeft:6,background:"#E3F2FD",color:"#1565C0",padding:"1px 6px",borderRadius:5,fontFamily:"monospace",fontSize:10}}>{flood.ghanaPost}</span>
                    </div>
                    <div style={{fontSize:11,color:"#555",marginBottom:6,lineHeight:1.5}}>{flood.description.substring(0,90)}{flood.description.length>90?"=":""}</div>
                    <div style={{display:"flex",gap:8,flexWrap:"wrap",alignItems:"center"}}>
                      <span style={{fontSize:10,color:"#555"}}><i className="ti ti-ripple" style={{fontSize:10}}/> {flood.depth}</span>
                      {flood.duration&&<span style={{fontSize:10,color:"#555"}}><i className="ti ti-clock" style={{fontSize:10}}/> {flood.duration}</span>}
                      <span style={{fontSize:10,color:"#555"}}>{flood.date}</span>
                      <span style={{fontSize:10,background:"#E3F2FD",color:"#1565C0",padding:"1px 6px",borderRadius:8,marginLeft:"auto",display:"flex",alignItems:"center",gap:3}}>
                        <i className="ti ti-video" style={{fontSize:10}}/>Video attached
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>)}

        {/* ==== CAMERAS ==== */}
        {tab==="cameras"&&(<div role="tabpanel" id="panel-cameras" aria-label="Cameras">
          {/* Citizen notice */}
          <div style={{background:"#E3F2FD",borderRadius:10,padding:"10px 14px",marginBottom:12,border:"1px solid #90CAF9",display:"flex",alignItems:"center",gap:10}}>
            <i className="ti ti-info-circle" style={{fontSize:18,color:"#1565C0",flexShrink:0}}/>
            <div>
              <div style={{fontSize:12,fontWeight:600,color:"#1565C0"}}>Community Safety Cameras</div>
              <div style={{fontSize:11,color:"#555",marginTop:1}}>These cameras help keep Ghana safe. Live feed access is restricted to authorised security personnel.</div>
            </div>
          </div>
          {/* Summary stats */}
          <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:8,marginBottom:14}}>
            {[{l:"Total",v:cameras.length,c:"#2196F3",i:"ti-video"},{l:"Online",v:cameras.filter(c=>c.status==="online").length,c:"#4CAF50",i:"ti-circle-check"},{l:"Offline/Maint.",v:cameras.filter(c=>c.status!=="online").length,c:"#F44336",i:"ti-circle-x"}].map(s=>(
              <div key={s.l} style={{background:"#fff",borderRadius:8,padding:"10px 8px",textAlign:"center",border:"0.5px solid #e0e0e0"}}>
                <i className={`ti ${s.i}`} style={{fontSize:18,color:s.c,display:"block",marginBottom:4}}/>
                <div style={{fontSize:22,fontWeight:700,color:s.c}}>{s.v}</div>
                <div style={{fontSize:9,color:"#777"}}>{s.l}</div>
              </div>
            ))}
          </div>

          {/* Filter */}
          <div style={{display:"flex",gap:6,marginBottom:12,flexWrap:"wrap"}}>
            {["all","online","offline","maintenance"].map(f=>(
              <button key={f} onClick={()=>setCamFilter(f)} style={{padding:"5px 12px",border:"1.5px solid",borderColor:camFilter===f?"#006B3F":"#ddd",borderRadius:18,background:camFilter===f?"#E8F5E9":"#fff",color:camFilter===f?"#006B3F":"#777",fontSize:11,cursor:"pointer",fontWeight:camFilter===f?600:400}}>
                {f==="all"?"All Cameras":f[0].toUpperCase()+f.slice(1)}
              </button>
            ))}
            <div style={{marginLeft:"auto",fontSize:11,color:"#777",alignSelf:"center"}}>
              {cameras.filter(c=>camFilter==="all"||c.status===camFilter).length} cameras
            </div>
          </div>

          {/* Camera list */}
          <div style={{display:"flex",flexDirection:"column",gap:8}}>
            {cameras.filter(c=>camFilter==="all"||c.status===camFilter).map(cam=>{
              const st=CAM_STATUS_CFG[cam.status];
              const reg=GHANA_REGIONS.find(r=>r.id===cam.region);
              return(
                <div key={cam.id} className="cam-card" onClick={()=>{setSelectedCam(cam);setCamFeedPlaying(false);}} style={{borderLeft:`3px solid ${st.color}`}}>
                  <div style={{display:"flex",alignItems:"flex-start",gap:10}}>
                    <div style={{width:40,height:40,borderRadius:8,background:st.bg,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,position:"relative"}}>
                      <i className="ti ti-video" style={{fontSize:20,color:st.color}}/>
                      {cam.status==="online"&&<div style={{position:"absolute",bottom:2,right:2,width:7,height:7,borderRadius:"50%",background:"#4CAF50",border:"1.5px solid #fff"}} className="cam-online-pulse"/>}
                    </div>
                    <div style={{flex:1,minWidth:0}}>
                      <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:3}}>
                        <span style={{fontWeight:600,fontSize:13}}>{cam.name}</span>
                        <span style={{fontSize:9,background:st.bg,color:st.color,padding:"2px 7px",borderRadius:10,fontWeight:600}}>{st.label}</span>
                      </div>
                      <div style={{fontSize:11,color:"#777",marginBottom:4}}>
                        <i className="ti ti-map-pin" style={{fontSize:11}}/> {cam.area}, {reg?.name}
                        <span style={{marginLeft:6,background:"#E8F5E9",color:"#2E7D32",padding:"1px 6px",borderRadius:5,fontFamily:"monospace",fontSize:10}}>{cam.ghanaPost}</span>
                      </div>
                      <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                        <span style={{fontSize:10,color:"#555"}}><i className="ti ti-device-tv" style={{fontSize:10}}/> {cam.resolution}</span>
                        <span style={{fontSize:10,color:"#555"}}><i className="ti ti-arrows-move" style={{fontSize:10}}/> {cam.coverage}</span>
                        <span style={{fontSize:10,color:"#555"}}><i className="ti ti-clock" style={{fontSize:10}}/> {cam.fps}fps</span>
                        {cam.incidents_nearby>0&&<span style={{fontSize:10,color:"#F44336",fontWeight:600}}><i className="ti ti-alert-triangle" style={{fontSize:10}}/> {cam.incidents_nearby} nearby</span>}
                      </div>
                    </div>
                    <div style={{display:"flex",flexDirection:"column",gap:5,flexShrink:0}}>
                      <button onClick={e=>{e.stopPropagation();setSelectedCam(cam);setCamFeedPlaying(false);}} style={{background:cam.status==="online"?"#006B3F":"#9E9E9E",color:"#fff",border:"none",borderRadius:6,padding:"5px 10px",fontSize:11,cursor:cam.status==="online"?"pointer":"default",display:"flex",alignItems:"center",gap:4}}>
                        <i className="ti ti-player-play" style={{fontSize:12}}/>{cam.status==="online"?"View":"Offline"}
                      </button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>)}

        {/* ==== DASHBOARD ==== */}
        {tab==="dashboard"&&(<div>
          <div style={{display:"grid",gridTemplateColumns:"repeat(4,1fr)",gap:8,marginBottom:14}}>
            {[{l:"Total",v:incidents.length,i:"ti-list",c:"#2196F3"},{l:"High/Critical",v:incidents.filter(i=>["high","critical"].includes(i.severity)).length,i:"ti-alert-triangle",c:"#F44336"},{l:"Verified",v:incidents.filter(i=>i.verified).length,i:"ti-shield-check",c:"#4CAF50"},{l:"Alerts Sent",v:alertHistory.length,i:"ti-bell",c:"#E65100"}].map(s=>(
              <div key={s.l} style={S.metric}><i className={`ti ${s.i}`} style={{fontSize:18,color:s.c,display:"block",marginBottom:4}}/><div style={{fontSize:22,fontWeight:700,color:s.c}}>{s.v}</div><div style={{fontSize:9,color:"#777",lineHeight:1.3}}>{s.l}</div></div>
            ))}
          </div>
          <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:12}}><span style={{fontSize:11,color:"#777"}}>Filter:</span><select value={dbFilter} onChange={e=>setDbFilter(e.target.value)} style={{fontSize:11}}><option value="All">All Types</option>{incidentTypes.map(t=><option key={t}>{t}</option>)}</select></div>
          <div style={S.card}>
            <div style={{fontSize:13,fontWeight:600,marginBottom:12}}>Incidents by crime type</div>
            {Object.entries(typeCounts).sort((a,b)=>b[1]-a[1]).map(([type,count])=>{const max=Math.max(...Object.values(typeCounts))||1;const hi=dbFilter==="All"||dbFilter===type;return(<div key={type} style={{marginBottom:8}}><div style={{display:"flex",justifyContent:"space-between",fontSize:11,marginBottom:3}}><span style={{color:hi?"#111":"#bbb"}}>{type}</span><span style={{fontWeight:600,color:hi?"#CE1126":"#ccc"}}>{count}</span></div><div style={{height:6,background:"#eee",borderRadius:3,overflow:"hidden"}}><div style={{height:"100%",width:`${(count/max)*100}%`,background:hi?"#CE1126":"#ddd",borderRadius:3}}/></div></div>);})}
          </div>
          <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:10,marginBottom:10}}>
            <div style={S.card}><div style={{fontSize:12,fontWeight:600,marginBottom:10}}>By severity</div>{Object.entries(sevCounts).map(([s,c])=>(
              <div key={s} style={{display:"flex",alignItems:"center",gap:8,marginBottom:7}}><div style={{width:9,height:9,borderRadius:"50%",background:SEV_CFG[s].color}}/><span style={{fontSize:11,flex:1}}>{SEV_CFG[s].label}</span><span style={{fontSize:13,fontWeight:600,color:SEV_CFG[s].color}}>{c}</span></div>
            ))}</div>
            <div style={S.card}><div style={{fontSize:12,fontWeight:600,marginBottom:10}}>Alerts by type</div>
              {alertHistory.length===0&&<div style={{fontSize:11,color:"#aaa",textAlign:"center",paddingTop:8}}>No alerts yet</div>}
              {Object.entries(alertHistory.reduce((a,x)=>{a[x.type.severity]=(a[x.type.severity]||0)+1;return a},{})).map(([sev,cnt])=>(
                <div key={sev} style={{display:"flex",alignItems:"center",gap:8,marginBottom:7}}><div style={{width:9,height:9,borderRadius:"50%",background:SEV_COLOR[sev]}}/><span style={{fontSize:11,flex:1}}>{SEV_LABEL[sev]}</span><span style={{fontSize:13,fontWeight:600,color:SEV_COLOR[sev]}}>{cnt}</span></div>
              ))}
            </div>
          </div>
          <div style={S.card}><div style={{fontSize:13,fontWeight:600,marginBottom:10}}>Incidents by region</div>
            {(()=>{const di=dbFilter==="All"?incidents:incidents.filter(i=>i.type===dbFilter);const counts=GHANA_REGIONS.map(r=>di.filter(i=>i.region===r.id).length);const max=Math.max(...counts)||1;return GHANA_REGIONS.map((r,idx)=>{const cnt=counts[idx];if(!cnt)return null;const heat=r.crimeScore>80?"#F44336":r.crimeScore>60?"#FF9800":"#4CAF50";return(<div key={r.id} style={{display:"flex",alignItems:"center",gap:8,marginBottom:7}}><span style={{fontSize:10,minWidth:110}}>{r.name}</span><div style={{flex:1,height:5,background:"#eee",borderRadius:3}}><div style={{height:"100%",width:`${(cnt/max)*100}%`,background:heat,borderRadius:3}}/></div><span style={{fontSize:11,fontWeight:600,minWidth:16,textAlign:"right"}}>{cnt}</span></div>);});})()}
          </div>
        </div>)}

        {/* ==== MY DASHBOARD ==== */}
        {tab==="mydash"&&(<div role="tabpanel" id="panel-mydash" aria-label="My Dashboard" style={{maxWidth:860,margin:"0 auto",padding:16}}>

          {/* === NOT LOGGED IN === */}
          {!loggedInUser&&(
            <div style={{textAlign:"center",padding:"48px 20px"}}>
              <div style={{width:72,height:72,borderRadius:"50%",background:"#E3F2FD",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 16px"}}>
                <i className="ti ti-user-circle" style={{fontSize:36,color:"#1565C0"}}/>
              </div>
              <div style={{fontSize:18,fontWeight:700,color:"#1A2332",marginBottom:8}}>Sign in to access your dashboard</div>
              <div style={{fontSize:13,color:"#666",marginBottom:24}}>Track your reports, save locations, and manage your safety preferences.</div>
              <div style={{display:"flex",gap:10,justifyContent:"center"}}>
                <button onClick={()=>setShowLogin(true)} style={{background:"#1565C0",color:"#fff",border:"none",borderRadius:10,padding:"10px 24px",fontSize:13,fontWeight:700,cursor:"pointer"}}>Sign In</button>
                <button onClick={()=>setShowRegModal(true)} style={{background:"#FCD116",color:"#0A1628",border:"none",borderRadius:10,padding:"10px 24px",fontSize:13,fontWeight:700,cursor:"pointer"}}>Register Free</button>
              </div>
            </div>
          )}

          {/* === LOGGED IN === */}
          {loggedInUser&&(<>

            {/* Profile header banner */}
            <div style={{background:"linear-gradient(135deg,#0D47A1,#1565C0)",borderRadius:16,padding:"20px 24px",marginBottom:16,display:"flex",alignItems:"center",gap:16}}>
            {/* Clickable avatar with upload */}
            <div style={{position:"relative",flexShrink:0,cursor:"pointer"}} onClick={()=>document.getElementById("avatar-upload-input").click()}>
              {loggedInUser.avatarUrl?(
                <img src={loggedInUser.avatarUrl} alt="Profile" style={{width:56,height:56,borderRadius:"50%",objectFit:"cover",border:"3px solid #FCD116"}}/>
              ):(
                <div style={{width:56,height:56,borderRadius:"50%",background:"#FCD116",display:"flex",alignItems:"center",justifyContent:"center",fontSize:22,fontWeight:800,color:"#0A1628",border:"3px solid rgba(255,255,255,0.3)"}}>
                  {avatarUploading?<i className="ti ti-loader-2 spin" style={{fontSize:20,color:"#0A1628"}}/>:loggedInUser.avatar||loggedInUser.name?.substring(0,2).toUpperCase()||"U"}
                </div>
              )}
              <div style={{position:"absolute",bottom:0,right:0,width:20,height:20,borderRadius:"50%",background:"#fff",display:"flex",alignItems:"center",justifyContent:"center",boxShadow:"0 1px 4px rgba(0,0,0,0.3)"}}>
                <i className="ti ti-camera" style={{fontSize:11,color:"#1565C0"}}/>
              </div>
              <input id="avatar-upload-input" type="file" accept="image/*" style={{display:"none"}} onChange={e=>e.target.files[0]&&handleAvatarUpload(e.target.files[0])}/>
            </div>
              <div style={{flex:1}}>
                <div style={{color:"#fff",fontSize:17,fontWeight:800}}>{loggedInUser.name}</div>
                <div style={{color:"rgba(255,255,255,0.7)",fontSize:11,marginTop:2}}>{loggedInUser.email}</div>
                <div style={{display:"flex",gap:12,marginTop:6}}>
                  <span style={{color:"#FCD116",fontSize:11,fontWeight:600}}><i className="ti ti-map-pin" style={{marginRight:3}}/>{loggedInUser.region?.replace(/-/g," ").replace(/\b\w/g,c=>c.toUpperCase())||"Ghana"}</span>
                  <span style={{color:"rgba(255,255,255,0.6)",fontSize:11}}>Member since {loggedInUser.joined||"2026"}</span>
                </div>
              </div>
              <div style={{textAlign:"center"}}>
                <div style={{color:"#FCD116",fontSize:28,fontWeight:800}}>{loggedInUser.reports||0}</div>
                <div style={{color:"rgba(255,255,255,0.7)",fontSize:10}}>Reports</div>
              </div>
            </div>

            {/* Tab nav */}
            <div style={{display:"flex",gap:4,marginBottom:16,background:"#F0F4FF",borderRadius:10,padding:4}}>
              {[
                {id:"profile",icon:"ti-user",label:"Profile"},
                {id:"reports",icon:"ti-list",label:"My Reports"},
                {id:"saved",icon:"ti-bookmark",label:"Saved"},
                {id:"notifs",icon:"ti-bell",label:"Notifications"},
                {id:"widgets",icon:"ti-layout-dashboard",label:"Widgets"},
              ].map(t=>(
                <button key={t.id} onClick={()=>setDashUserTab(t.id)} style={{flex:1,background:dashUserTab===t.id?"#fff":"transparent",border:"none",borderRadius:8,padding:"8px 4px",fontSize:11,fontWeight:dashUserTab===t.id?700:400,color:dashUserTab===t.id?"#1565C0":"#666",cursor:"pointer",display:"flex",flexDirection:"column",alignItems:"center",gap:3,boxShadow:dashUserTab===t.id?"0 1px 4px rgba(0,0,0,0.1)":"none",transition:"all .15s"}}>
                  <i className={`ti ${t.icon}`} style={{fontSize:16}}/>
                  <span style={{fontSize:9}}>{t.label}</span>
                </button>
              ))}
            </div>

            {/* ── PROFILE TAB ── */}
            {dashUserTab==="profile"&&(
              <div style={{background:"#fff",borderRadius:14,border:"1px solid #E8EDF2",padding:20}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:16}}>
                  <div style={{fontSize:14,fontWeight:700,color:"#1A2332"}}>Account Details</div>
                  <button onClick={()=>{setEditingProfile(p=>!p);setProfileForm({name:loggedInUser.name,phone:loggedInUser.phone||"",region:loggedInUser.region||"",area:loggedInUser.area||""});}} style={{background:editingProfile?"#E8F5E9":"#E3F2FD",border:"none",borderRadius:8,padding:"6px 12px",fontSize:11,fontWeight:600,color:editingProfile?"#2E7D32":"#1565C0",cursor:"pointer"}}>
                    <i className={`ti ${editingProfile?"ti-x":"ti-pencil"}`} style={{marginRight:4}}/>{editingProfile?"Cancel":"Edit Profile"}
                  </button>
                </div>
                {[
                  {label:"Full Name",value:loggedInUser.name,field:"name",icon:"ti-user"},
                  {label:"Email",value:loggedInUser.email,field:"email",icon:"ti-mail",readonly:true},
                  {label:"Phone",value:loggedInUser.phone||"Not set",field:"phone",icon:"ti-phone"},
                  {label:"Region",value:loggedInUser.region?.replace(/-/g," ").replace(/\b\w/g,c=>c.toUpperCase())||"Not set",field:"region",icon:"ti-map-pin"},
                ].map((f,i)=>(
                  <div key={i} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 0",borderBottom:"1px solid #F0F4FF"}}>
                    <div style={{width:36,height:36,borderRadius:8,background:"#F0F4FF",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                      <i className={`ti ${f.icon}`} style={{color:"#1565C0",fontSize:16}}/>
                    </div>
                    <div style={{flex:1}}>
                      <div style={{fontSize:10,color:"#888",marginBottom:2}}>{f.label}</div>
                      {editingProfile&&!f.readonly?(
                        <input value={profileForm[f.field]||""} onChange={e=>setProfileForm(p=>({...p,[f.field]:e.target.value}))} style={{fontSize:13,border:"1px solid #1565C0",borderRadius:6,padding:"4px 8px",width:"100%",outline:"none"}}/>
                      ):(
                        <div style={{fontSize:13,color:"#1A2332",fontWeight:500}}>{f.value}</div>
                      )}
                    </div>
                    {f.readonly&&<span style={{fontSize:9,background:"#E8F5E9",color:"#2E7D32",padding:"2px 6px",borderRadius:10,fontWeight:600}}>VERIFIED</span>}
                  </div>
                ))}
                {editingProfile&&(
                  <button onClick={async()=>{
                    const updated={...loggedInUser,...profileForm};
                    setLoggedInUser(updated);
                    setEditingProfile(false);
                    try{await fetch(`${API_BASE}/users/${loggedInUser.id}`,{method:"PATCH",headers:{"Content-Type":"application/json"},body:JSON.stringify(profileForm)});}catch(e){}
                  }} style={{marginTop:14,background:"#1565C0",color:"#fff",border:"none",borderRadius:8,padding:"10px",fontSize:13,fontWeight:700,cursor:"pointer",width:"100%"}}>
                    <i className="ti ti-check" style={{marginRight:6}}/>Save Changes
                  </button>
                )}
                <div style={{marginTop:16,paddingTop:16,borderTop:"1px solid #F0F4FF",display:"flex",gap:8}}>
                  <button onClick={()=>setShowLogin(true)} style={{flex:1,background:"#FFF3E0",color:"#E65100",border:"1px solid #FFCC80",borderRadius:8,padding:"8px",fontSize:11,fontWeight:600,cursor:"pointer"}}>
                    <i className="ti ti-lock" style={{marginRight:4}}/>Change Password
                  </button>
                  <button onClick={()=>{setLoggedInUser(null);setTab("map");}} style={{flex:1,background:"#FFEBEE",color:"#C62828",border:"1px solid #FFCDD2",borderRadius:8,padding:"8px",fontSize:11,fontWeight:600,cursor:"pointer"}}>
                    <i className="ti ti-logout" style={{marginRight:4}}/>Sign Out
                  </button>
                </div>
              </div>
            )}

            {/* ── MY REPORTS TAB ── */}
            {dashUserTab==="reports"&&(
              <div>
                <div style={{background:"#fff",borderRadius:14,border:"1px solid #E8EDF2",padding:16,marginBottom:12}}>
                  <div style={{fontSize:14,fontWeight:700,color:"#1A2332",marginBottom:12}}>My Submitted Reports</div>
                  {incidents.filter(i=>i.reporterEmail===loggedInUser.email||i.reporter===loggedInUser.name).length===0?(
                    <div style={{textAlign:"center",padding:"32px 0",color:"#aaa"}}>
                      <i className="ti ti-clipboard-off" style={{fontSize:36,display:"block",marginBottom:8}}/>
                      <div style={{fontSize:13}}>No reports yet</div>
                      <button onClick={()=>setTab("report")} style={{marginTop:12,background:"#CE1126",color:"#fff",border:"none",borderRadius:8,padding:"8px 16px",fontSize:12,fontWeight:600,cursor:"pointer"}}>Submit First Report</button>
                    </div>
                  ):(
                    incidents.filter(i=>i.reporterEmail===loggedInUser.email||i.reporter===loggedInUser.name).map((inc,i)=>(
                      <div key={i} style={{padding:"10px 0",borderBottom:"1px solid #F0F4FF",display:"flex",gap:10,alignItems:"flex-start"}}>
                        <div style={{width:8,height:8,borderRadius:"50%",background:inc.severity==="High"?"#F44336":inc.severity==="Medium"?"#FF9800":"#4CAF50",marginTop:5,flexShrink:0}}/>
                        <div style={{flex:1}}>
                          <div style={{fontSize:12,fontWeight:600,color:"#1A2332"}}>{inc.type}</div>
                          <div style={{fontSize:11,color:"#666"}}>{inc.location} · {inc.time||inc.timestamp}</div>
                        </div>
                        <span style={{fontSize:10,background:inc.verified?"#E8F5E9":"#FFF3E0",color:inc.verified?"#2E7D32":"#E65100",padding:"2px 6px",borderRadius:10,fontWeight:600}}>{inc.verified?"Verified":"Pending"}</span>
                      </div>
                    ))
                  )}
                </div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10}}>
                  {[
                    {label:"Total Reports",value:loggedInUser.reports||0,icon:"ti-clipboard",color:"#1565C0"},
                    {label:"Verified",value:incidents.filter(i=>i.reporter===loggedInUser.name&&i.verified).length,icon:"ti-circle-check",color:"#2E7D32"},
                    {label:"This Month",value:incidents.filter(i=>i.reporter===loggedInUser.name&&new Date(i.timestamp||i.time)>new Date(Date.now()-30*24*60*60*1000)).length,icon:"ti-calendar",color:"#9C27B0"},
                  ].map((s,i)=>(
                    <div key={i} style={{background:"#fff",borderRadius:12,border:"1px solid #E8EDF2",padding:"14px",textAlign:"center"}}>
                      <i className={`ti ${s.icon}`} style={{fontSize:22,color:s.color,display:"block",marginBottom:6}}/>
                      <div style={{fontSize:22,fontWeight:800,color:"#1A2332"}}>{s.value}</div>
                      <div style={{fontSize:10,color:"#888"}}>{s.label}</div>
                    </div>
                  ))}
                </div>
              </div>
            )}

            {/* ── SAVED LOCATIONS TAB ── */}
            {dashUserTab==="saved"&&(
              <div style={{background:"#fff",borderRadius:14,border:"1px solid #E8EDF2",padding:16}}>
                <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:14}}>
                  <div style={{fontSize:14,fontWeight:700,color:"#1A2332"}}>Saved Locations</div>
                  <button onClick={()=>{
                    const name=prompt("Location name (e.g. Home, Work):");
                    const gps=prompt("Ghana Post GPS code (e.g. GA-123-4567):");
                    if(name&&gps){
                      const updated=[...savedLocations,{id:Date.now(),name,gps,saved:new Date().toLocaleDateString()}];
                      setSavedLocations(updated);
                      localStorage.setItem('sg_saved_locs',JSON.stringify(updated));
                    }
                  }} style={{background:"#E3F2FD",border:"none",borderRadius:8,padding:"6px 12px",fontSize:11,fontWeight:600,color:"#1565C0",cursor:"pointer"}}>
                    <i className="ti ti-plus" style={{marginRight:4}}/>Add Location
                  </button>
                </div>
                {savedLocations.length===0?(
                  <div style={{textAlign:"center",padding:"32px 0",color:"#aaa"}}>
                    <i className="ti ti-bookmark-off" style={{fontSize:36,display:"block",marginBottom:8}}/>
                    <div style={{fontSize:13}}>No saved locations yet</div>
                    <div style={{fontSize:11,marginTop:4}}>Save home, work or school to get targeted alerts</div>
                  </div>
                ):(
                  savedLocations.map((loc,i)=>(
                    <div key={loc.id} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 0",borderBottom:"1px solid #F0F4FF"}}>
                      <div style={{width:36,height:36,borderRadius:8,background:"#E3F2FD",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                        <i className="ti ti-map-pin" style={{color:"#1565C0",fontSize:16}}/>
                      </div>
                      <div style={{flex:1}}>
                        <div style={{fontSize:13,fontWeight:600,color:"#1A2332"}}>{loc.name}</div>
                        <div style={{fontSize:11,color:"#888"}}>{loc.gps} · Saved {loc.saved}</div>
                      </div>
                      <button onClick={()=>{
                        const updated=savedLocations.filter(l=>l.id!==loc.id);
                        setSavedLocations(updated);
                        localStorage.setItem('sg_saved_locs',JSON.stringify(updated));
                      }} style={{background:"none",border:"none",cursor:"pointer",color:"#ccc",fontSize:16}} aria-label="Remove location">
                        <i className="ti ti-x"/>
                      </button>
                    </div>
                  ))
                )}
              </div>
            )}

            {/* ── NOTIFICATIONS TAB ── */}
            {dashUserTab==="notifs"&&(
              <div style={{background:"#fff",borderRadius:14,border:"1px solid #E8EDF2",padding:20}}>
                <div style={{fontSize:14,fontWeight:700,color:"#1A2332",marginBottom:4}}>Notification Preferences</div>
                <div style={{fontSize:11,color:"#888",marginBottom:16}}>Choose what alerts you receive</div>

                <div style={{fontSize:11,fontWeight:700,color:"#555",marginBottom:8,textTransform:"uppercase",letterSpacing:"0.05em"}}>Alert Types</div>
                {[
                  {key:"floods",label:"Flood Reports",desc:"Water level warnings and flood zone alerts",icon:"ti-ripple",color:"#0277BD"},
                  {key:"crime",label:"Crime Incidents",desc:"Theft, assault and security alerts",icon:"ti-shield-exclamation",color:"#C62828"},
                  {key:"fire",label:"Fire Alerts",desc:"Fire and smoke emergency notifications",icon:"ti-flame",color:"#E65100"},
                  {key:"alerts",label:"Public Safety",desc:"Official Ghana Police and NADMO alerts",icon:"ti-bell-ringing",color:"#6A1B9A"},
                ].map(n=>(
                  <div key={n.key} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 0",borderBottom:"1px solid #F0F4FF"}}>
                    <div style={{width:36,height:36,borderRadius:8,background:"#F7F9FC",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                      <i className={`ti ${n.icon}`} style={{color:n.color,fontSize:16}}/>
                    </div>
                    <div style={{flex:1}}>
                      <div style={{fontSize:12,fontWeight:600,color:"#1A2332"}}>{n.label}</div>
                      <div style={{fontSize:10,color:"#888"}}>{n.desc}</div>
                    </div>
                    <div onClick={()=>{
                      const updated={...notifPrefs,[n.key]:!notifPrefs[n.key]};
                      setNotifPrefs(updated);
                      localStorage.setItem('sg_notif_prefs',JSON.stringify(updated));
                    }} style={{width:44,height:24,borderRadius:12,background:notifPrefs[n.key]?"#1565C0":"#ccc",cursor:"pointer",position:"relative",transition:"background .2s",flexShrink:0}}>
                      <div style={{position:"absolute",top:2,left:notifPrefs[n.key]?20:2,width:20,height:20,borderRadius:"50%",background:"#fff",transition:"left .2s",boxShadow:"0 1px 3px rgba(0,0,0,0.2)"}}/>
                    </div>
                  </div>
                ))}

                <div style={{fontSize:11,fontWeight:700,color:"#555",margin:"16px 0 8px",textTransform:"uppercase",letterSpacing:"0.05em"}}>Delivery Method</div>
                {[
                  {key:"email",label:"Email Notifications",desc:loggedInUser.email,icon:"ti-mail"},
                  {key:"sms",label:"SMS Notifications",desc:loggedInUser.phone||"Add phone number in profile",icon:"ti-message"},
                ].map(n=>(
                  <div key={n.key} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 0",borderBottom:"1px solid #F0F4FF"}}>
                    <div style={{width:36,height:36,borderRadius:8,background:"#F7F9FC",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                      <i className={`ti ${n.icon}`} style={{color:"#1565C0",fontSize:16}}/>
                    </div>
                    <div style={{flex:1}}>
                      <div style={{fontSize:12,fontWeight:600,color:"#1A2332"}}>{n.label}</div>
                      <div style={{fontSize:10,color:"#888"}}>{n.desc}</div>
                    </div>
                    <div onClick={()=>{
                      const updated={...notifPrefs,[n.key]:!notifPrefs[n.key]};
                      setNotifPrefs(updated);
                      localStorage.setItem('sg_notif_prefs',JSON.stringify(updated));
                    }} style={{width:44,height:24,borderRadius:12,background:notifPrefs[n.key]?"#1565C0":"#ccc",cursor:"pointer",position:"relative",transition:"background .2s",flexShrink:0}}>
                      <div style={{position:"absolute",top:2,left:notifPrefs[n.key]?20:2,width:20,height:20,borderRadius:"50%",background:"#fff",transition:"left .2s",boxShadow:"0 1px 3px rgba(0,0,0,0.2)"}}/>
                    </div>
                  </div>
                ))}
              </div>
            )}

            {/* ── WIDGETS TAB ── */}
            {dashUserTab==="widgets"&&(
              <div>
                <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:14}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:14,fontWeight:700,color:"#1A2332"}}>Dashboard Widgets</div>
                    <div style={{fontSize:11,color:"#777",marginTop:2}}>Add, remove and drag to reorder</div>
                  </div>
                  <button onClick={()=>setShowWidgetPicker(p=>!p)} style={{background:"#9C27B0",color:"#fff",border:"none",borderRadius:8,padding:"7px 14px",fontSize:12,fontWeight:600,cursor:"pointer",display:"flex",alignItems:"center",gap:5}}>
                    <i className="ti ti-plus" style={{fontSize:13}}/>Add Widget
                  </button>
                  <button onClick={saveDashboard} style={{background:dashSaved?"#4CAF50":"#1565C0",color:"#fff",border:"none",borderRadius:8,padding:"7px 14px",fontSize:12,fontWeight:600,cursor:"pointer",display:"flex",alignItems:"center",gap:5,transition:"background .3s"}}>
                    <i className={`ti ${dashSaved?"ti-check":"ti-device-floppy"}`} style={{fontSize:13}}/>{dashSaved?"Saved!":"Save Layout"}
                  </button>
                </div>
                {showWidgetPicker&&(
                  <div style={{background:"#fff",borderRadius:12,border:"2px solid #9C27B0",padding:14,marginBottom:14,boxShadow:"0 4px 20px rgba(0,0,0,0.1)"}}>
                    <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:10}}>
                      <span style={{fontSize:13,fontWeight:600,color:"#9C27B0"}}>Widget Library</span>
                      <span style={{fontSize:11,color:"#777"}}>— click to add or remove</span>
                      <button onClick={()=>setShowWidgetPicker(false)} style={{marginLeft:"auto",background:"none",border:"none",cursor:"pointer",color:"#999",fontSize:18}} aria-label="Close"><i className="ti ti-x"/></button>
                    </div>
                    <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(200px,1fr))",gap:8}}>
                      {WIDGET_LIBRARY.map(w=>{
                        const added=myWidgets.includes(w.id);
                        return(
                          <div key={w.id} onClick={()=>{if(!added)setMyWidgets(p=>[...p,w.id]);else setMyWidgets(p=>p.filter(x=>x!==w.id));}}
                            style={{border:`2px solid ${added?"#9C27B0":"#e0e0e0"}`,borderRadius:10,padding:"10px 12px",cursor:"pointer",background:added?"#F3E5F5":"#fff",transition:"all .15s"}}>
                            <div style={{display:"flex",alignItems:"center",gap:7,marginBottom:4}}>
                              <i className={`ti ${w.icon}`} style={{fontSize:18,color:added?"#9C27B0":"#777"}}/>
                              <span style={{fontSize:12,fontWeight:600,color:added?"#9C27B0":"#333"}}>{w.label}</span>
                              {added&&<i className="ti ti-check" style={{fontSize:12,color:"#9C27B0",marginLeft:"auto"}}/>}
                            </div>
                            <div style={{fontSize:10,color:"#888",lineHeight:1.4}}>{w.desc}</div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                )}
                {myWidgets.length===0&&(
                  <div style={{textAlign:"center",padding:"40px 20px",color:"#aaa"}}>
                    <i className="ti ti-layout-dashboard" style={{fontSize:48,display:"block",marginBottom:12,color:"#ddd"}}/>
                    <div style={{fontSize:14,fontWeight:600,marginBottom:6}}>No widgets added yet</div>
                    <div style={{fontSize:12}}>Click "Add Widget" to build your dashboard</div>
                  </div>
                )}
                <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(300px,1fr))",gap:12}}>
                  {myWidgets.map((wid,idx)=>{
                    const meta=WIDGET_LIBRARY.find(w=>w.id===wid);
                    if(!meta)return null;
                    const isDragging=dragIdx===idx;
                    const isOver=dragOverIdx===idx;
                    return(
                      <div key={wid}
                        draggable
                        onDragStart={()=>setDragIdx(idx)}
                        onDragOver={e=>{e.preventDefault();setDragOverIdx(idx);}}
                        onDrop={()=>{
                          if(dragIdx===null||dragIdx===idx)return;
                          const arr=[...myWidgets];
                          arr.splice(idx,0,arr.splice(dragIdx,1)[0]);
                          setMyWidgets(arr);setDragIdx(null);setDragOverIdx(null);
                        }}
                        onDragEnd={()=>{setDragIdx(null);setDragOverIdx(null);}}
                        style={{background:"#fff",borderRadius:12,border:`2px solid ${isOver?"#9C27B0":"#e8e8e8"}`,overflow:"hidden",opacity:isDragging?0.5:1,boxShadow:isOver?"0 4px 20px rgba(156,39,176,0.2)":"0 2px 8px rgba(0,0,0,0.06)",transition:"box-shadow .15s,border-color .15s",cursor:"grab"}}>
                        <div style={{background:"#f9f9f9",padding:"10px 14px",display:"flex",alignItems:"center",gap:8,borderBottom:"1px solid #f0f0f0"}}>
                          <i className="ti ti-grip-vertical" style={{fontSize:14,color:"#ccc"}}/>
                          <i className={`ti ${meta.icon}`} style={{fontSize:15,color:"#9C27B0"}}/>
                          <span style={{fontSize:12,fontWeight:700,flex:1,color:"#333"}}>{meta.label}</span>
                          <button onClick={()=>setMyWidgets(p=>p.filter(x=>x!==wid))} style={{background:"none",border:"none",cursor:"pointer",color:"#ccc",fontSize:16,lineHeight:1}} aria-label="Close"><i className="ti ti-x"/></button>
                        </div>
                        <div style={{padding:"12px 14px"}}>
                          <DashWidget id={wid} incidents={incidents} floodReports={floodReports} alertHistory={alertHistory} typeCounts={typeCounts} sevCounts={sevCounts} dbFilter={dbFilter} setDbFilter={setDbFilter}/>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}

          </>)}
        </div>)}

        {/* ==== SOS / EMERGENCY NUMBERS ==== */}
        {tab==="sos"&&(<div style={{maxWidth:680,margin:"0 auto",padding:16}}>

          {/* Header */}
          <div style={{background:"linear-gradient(135deg,#B71C1C,#CE1126)",borderRadius:16,padding:"20px 24px",marginBottom:16,display:"flex",alignItems:"center",gap:16}}>
            <div style={{width:56,height:56,borderRadius:"50%",background:"rgba(255,255,255,0.15)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className="ti ti-sos" style={{color:"#fff",fontSize:28}}/>
            </div>
            <div>
              <div style={{color:"#fff",fontSize:20,fontWeight:800}}>Emergency Numbers</div>
              <div style={{color:"rgba(255,255,255,0.8)",fontSize:12,marginTop:2}}>Ghana emergency contacts — available 24/7</div>
            </div>
            <div style={{marginLeft:"auto",display:"flex",flexDirection:"column",alignItems:"center"}}>
              <div style={{width:12,height:12,borderRadius:"50%",background:"#4ADE80",animation:"pulse 2s infinite",marginBottom:4}}/>
              <span style={{color:"#fff",fontSize:9,fontWeight:600}}>LIVE</span>
            </div>
          </div>

          {/* Primary emergency numbers */}
          <div style={{marginBottom:12}}>
            <div style={{fontSize:11,fontWeight:700,color:"#CE1126",letterSpacing:"0.05em",marginBottom:8,textTransform:"uppercase"}}>Primary Emergency</div>
            {[
              {name:"Ghana Police Service",number:"191",icon:"ti-shield-check",color:"#1565C0",desc:"Crime, accidents, public safety"},
              {name:"Ghana Fire Service",number:"192",icon:"ti-flame",color:"#E53935",desc:"Fire emergencies, rescue operations"},
              {name:"Ghana Ambulance Service",number:"193",icon:"ti-ambulance",color:"#2E7D32",desc:"Medical emergencies, trauma"},
              {name:"National Emergency (NADMO)",number:"0800-111-222",icon:"ti-alert-triangle",color:"#E65100",desc:"Natural disasters, floods, national emergencies"},
            ].map((item,i)=>(
              <a key={i} href={`tel:${item.number.replace(/-/g,"")}`}
                style={{display:"flex",alignItems:"center",gap:14,padding:"14px 16px",background:"#fff",borderRadius:12,marginBottom:8,border:`1.5px solid ${item.color}22`,boxShadow:"0 1px 4px rgba(0,0,0,0.06)",textDecoration:"none",cursor:"pointer"}}>
                <div style={{width:44,height:44,borderRadius:12,background:`${item.color}15`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  <i className={`ti ${item.icon}`} style={{color:item.color,fontSize:22}}/>
                </div>
                <div style={{flex:1}}>
                  <div style={{fontSize:13,fontWeight:700,color:"#111"}}>{item.name}</div>
                  <div style={{fontSize:11,color:"#666",marginTop:1}}>{item.desc}</div>
                </div>
                <div style={{display:"flex",flexDirection:"column",alignItems:"flex-end",gap:4}}>
                  <div style={{fontSize:20,fontWeight:800,color:item.color,fontFamily:"monospace"}}>{item.number}</div>
                  <div style={{background:item.color,color:"#fff",borderRadius:20,padding:"2px 10px",fontSize:10,fontWeight:600,display:"flex",alignItems:"center",gap:4}}>
                    <i className="ti ti-phone-call" style={{fontSize:10}}/>CALL
                  </div>
                </div>
              </a>
            ))}
          </div>

          {/* Secondary contacts */}
          <div style={{marginBottom:12}}>
            <div style={{fontSize:11,fontWeight:700,color:"#555",letterSpacing:"0.05em",marginBottom:8,textTransform:"uppercase"}}>Other Important Numbers</div>
            {[
              {name:"Ghana Health Service",number:"0800-111-222",icon:"ti-heart-rate-monitor",color:"#00838F",desc:"Health emergencies, hospitals"},
              {name:"Electricity Emergency",number:"0302-611-611",icon:"ti-bolt",color:"#F9A825",desc:"Power outages, electrical hazards"},
              {name:"Ghana Water Company",number:"0302-666-781",icon:"ti-droplet",color:"#1565C0",desc:"Water supply emergencies"},
              {name:"Road Safety Commission",number:"0302-758-700",icon:"ti-road",color:"#4E342E",desc:"Road accidents, traffic emergencies"},
              {name:"Interpol Ghana",number:"0302-773-906",icon:"ti-world",color:"#6A1B9A",desc:"International crime, missing persons"},
            ].map((item,i)=>(
              <a key={i} href={`tel:${item.number.replace(/-/g,"")}`}
                style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",background:"#fff",borderRadius:10,marginBottom:6,border:"0.5px solid #e0e0e0",textDecoration:"none"}}>
                <div style={{width:36,height:36,borderRadius:10,background:`${item.color}15`,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  <i className={`ti ${item.icon}`} style={{color:item.color,fontSize:18}}/>
                </div>
                <div style={{flex:1}}>
                  <div style={{fontSize:12,fontWeight:600,color:"#111"}}>{item.name}</div>
                  <div style={{fontSize:10,color:"#888",marginTop:1}}>{item.desc}</div>
                </div>
                <div style={{fontSize:14,fontWeight:700,color:item.color,fontFamily:"monospace"}}>{item.number}</div>
              </a>
            ))}
          </div>

          {/* WhatsApp tip line */}
          <div style={{background:"#E8F5E9",border:"1px solid #A5D6A7",borderRadius:12,padding:"14px 16px",display:"flex",alignItems:"center",gap:12,marginBottom:12}}>
            <div style={{width:40,height:40,borderRadius:10,background:"#25D366",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className="ti ti-brand-whatsapp" style={{color:"#fff",fontSize:22}}/>
            </div>
            <div style={{flex:1}}>
              <div style={{fontSize:13,fontWeight:700,color:"#1B5E20"}}>mysafeghana Tip Line</div>
              <div style={{fontSize:11,color:"#2E7D32",marginTop:1}}>Report anonymously via WhatsApp</div>
            </div>
            <a href="https://wa.me/233552242244" target="_blank" rel="noopener noreferrer"
              style={{background:"#25D366",color:"#fff",borderRadius:20,padding:"8px 16px",fontSize:12,fontWeight:700,textDecoration:"none",display:"flex",alignItems:"center",gap:6}}>
              <i className="ti ti-send" style={{fontSize:12}}/>Message
            </a>
          </div>

          {/* Safety tips */}
          <div style={{background:"#FFF8E1",border:"1px solid #FFE082",borderRadius:12,padding:"14px 16px"}}>
            <div style={{fontSize:12,fontWeight:700,color:"#E65100",marginBottom:8,display:"flex",alignItems:"center",gap:6}}>
              <i className="ti ti-info-circle" style={{fontSize:14}}/>Safety Tips
            </div>
            {[
              "Stay calm and speak clearly when calling emergency services",
              "Give your exact location including landmarks or Ghana Post address",
              "Do not hang up until the operator tells you to",
              "Keep these numbers saved in your phone",
            ].map((tip,i)=>(
              <div key={i} style={{display:"flex",gap:8,marginBottom:6,fontSize:11,color:"#5D4037"}}>
                <span style={{color:"#FF8F00",fontWeight:700,flexShrink:0}}>{i+1}.</span>
                <span>{tip}</span>
              </div>
            ))}
          </div>

        </div>)}

        {/* ==== DATA SOURCES ==== */}
        {tab==="sources"&&(<div style={{maxWidth:760,margin:"0 auto",padding:16}}>
          <div style={{background:"linear-gradient(135deg,#0D47A1,#1565C0)",borderRadius:16,padding:"20px 24px",marginBottom:20,display:"flex",alignItems:"center",gap:16}}>
            <div style={{width:48,height:48,borderRadius:12,background:"rgba(255,255,255,0.15)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
              <i className="ti ti-database" style={{color:"#fff",fontSize:26}}/>
            </div>
            <div>
              <div style={{color:"#fff",fontSize:18,fontWeight:800}}>Data Sources & Verification</div>
              <div style={{color:"rgba(255,255,255,0.75)",fontSize:12,marginTop:3}}>How mysafeghana collects, verifies, and displays safety data</div>
            </div>
          </div>

          <div style={{background:"#E8F5E9",border:"1px solid #A5D6A7",borderRadius:12,padding:"12px 16px",marginBottom:20,display:"flex",gap:10,alignItems:"flex-start"}}>
            <i className="ti ti-shield-check" style={{color:"#2E7D32",fontSize:20,flexShrink:0,marginTop:2}}/>
            <div>
              <div style={{fontSize:13,fontWeight:700,color:"#1B5E20"}}>Our Verification Standard</div>
              <div style={{fontSize:12,color:"#2E7D32",marginTop:3,lineHeight:1.6}}>Every incident requires a minimum of 2 independent confirmations before being marked verified. Community reports are cross-referenced with official sources where available. Unverified reports are clearly labelled.</div>
            </div>
          </div>

          {[
            {icon:"ti-users",color:"#1565C0",bg:"#E3F2FD",title:"Community Reports",badge:"Primary Source",badgeColor:"#1565C0",desc:"Citizens submit incidents directly via the Report tab. Each submission captures location (Ghana Post GPS code), incident type, severity, description, and optional video evidence.",stats:[{k:"Avg. response time",v:"< 8 min"},{k:"Verification rate",v:"78%"},{k:"Daily submissions",v:"40–120"}],process:"Submitted → Auto-geocoded → Community cross-check → Moderator review → Published"},
            {icon:"ti-building-bank",color:"#6A1B9A",bg:"#F3E5F5",title:"Ghana Police Service (GPS)",badge:"Official",badgeColor:"#6A1B9A",desc:"Incident data shared through the GPS public communications office. Includes confirmed crime reports, road incidents, and public safety announcements for all 16 regions.",stats:[{k:"Update frequency",v:"Twice daily"},{k:"Coverage",v:"All 16 regions"},{k:"Data since",v:"2023"}],process:"GPS bulletin → Data parsing → Severity tagging → Map integration"},
            {icon:"ti-ripple",color:"#0277BD",bg:"#E1F5FE",title:"NADMO Flood Intelligence",badge:"Official",badgeColor:"#0277BD",desc:"National Disaster Management Organisation provides flood zone classifications, water depth readings, and evacuation status for active flood events across Ghana.",stats:[{k:"Flood zones tracked",v:"47 active"},{k:"Depth accuracy",v:"± 5 cm"},{k:"Alert latency",v:"< 15 min"}],process:"NADMO field report → Severity classification → Flood layer update → SMS alert trigger"},
            {icon:"ti-video",color:"#00695C",bg:"#E0F2F1",title:"CCTV Network",badge:"Live Feed",badgeColor:"#00695C",desc:"Integration with the Greater Accra CCTV surveillance network operated by the Ministry of Interior. Camera feeds are anonymised and shown with a 90-second delay for privacy compliance.",stats:[{k:"Active cameras",v:"124"},{k:"Coverage",v:"Accra Metro"},{k:"Feed delay",v:"90 seconds"}],process:"Live feed → Privacy filter → 90s buffer → Stream embed"},
            {icon:"ti-world",color:"#E65100",bg:"#FFF3E0",title:"Open Data & NGO Partners",badge:"Supplementary",badgeColor:"#E65100",desc:"Supplementary data from OpenStreetMap, Ghana Statistical Service, and partner NGOs including CARE Ghana and Oxfam. Used for basemap layers, population density overlays, and historical incident context.",stats:[{k:"OSM contributors",v:"2,400+"},{k:"NGO partners",v:"6"},{k:"Historical records",v:"5 years"}],process:"Partner API → Normalisation → Layer integration → Weekly refresh"},
          ].map((s,i)=>(
            <div key={i} style={{background:"#fff",border:"1px solid #E8EDF2",borderRadius:14,padding:"18px 20px",marginBottom:14,boxShadow:"0 1px 4px rgba(0,0,0,0.05)"}}>
              <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:12}}>
                <div style={{width:40,height:40,borderRadius:10,background:s.bg,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  <i className={`ti ${s.icon}`} style={{color:s.color,fontSize:20}}/>
                </div>
                <div style={{flex:1}}>
                  <div style={{display:"flex",alignItems:"center",gap:8}}>
                    <span style={{fontSize:14,fontWeight:700,color:"#1A2332"}}>{s.title}</span>
                    <span style={{fontSize:10,fontWeight:700,color:s.badgeColor,background:s.bg,borderRadius:20,padding:"2px 8px"}}>{s.badge}</span>
                  </div>
                </div>
              </div>
              <div style={{fontSize:12,color:"#4A5568",lineHeight:1.65,marginBottom:12}}>{s.desc}</div>
              <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:12}}>
                {s.stats.map((st,j)=>(<div key={j} style={{background:"#F7F9FC",borderRadius:8,padding:"6px 12px",fontSize:11}}><span style={{color:"#888"}}>{st.k}: </span><span style={{color:"#1A2332",fontWeight:700}}>{st.v}</span></div>))}
              </div>
              <div style={{fontSize:11,color:"#888",background:"#F7F9FC",borderRadius:8,padding:"7px 12px"}}>
                <span style={{color:s.color,fontWeight:700}}>Pipeline: </span>{s.process}
              </div>
            </div>
          ))}

          <div style={{background:"#F7F9FC",borderRadius:12,padding:"14px 16px",fontSize:12,color:"#556B8A",lineHeight:1.7,textAlign:"center",marginTop:4}}>
            <i className="ti ti-info-circle" style={{marginRight:6,color:"#1565C0"}}/>
            Data accuracy is continuously improved. To report a data error or suggest a new source, use the{" "}
            <span style={{color:"#CE1126",fontWeight:700,cursor:"pointer"}} role="button" tabIndex={0} aria-label="Go to Report tab" onClick={()=>setTab("report")} onKeyDown={e=>e.key==="Enter"&&setTab("report")}>Report tab</span>{" "}
            or email <span style={{color:"#1565C0",fontWeight:600}}>data@mysafeghana.com</span>
          </div>
        </div>)}

        {/* ==== AI ==== */}
        {tab==="ai"&&(<div>
          <div style={S.card}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:12}}><div style={{width:32,height:32,borderRadius:8,background:"#9C27B0",display:"flex",alignItems:"center",justifyContent:"center"}}><i className="ti ti-brain" style={{color:"#fff",fontSize:17}}/></div><div><div style={{fontSize:14,fontWeight:600}}>AI Incident Classifier</div><div style={{fontSize:11,color:"#777"}}>Powered by Claude · real-time classification</div></div></div>
            <div style={{marginBottom:10}}><label style={S.lbl}>Select incident to analyze</label><select value={aiSel} onChange={e=>{setAiSel(e.target.value);setAiRes(null);}} style={{width:"100%",fontSize:12}}><option value="">Choose incident</option>{incidents.map(i=><option key={i.id} value={String(i.id)}>#{i.id} = {i.type} ({i.area}{i.ghanaPost?` = ${i.ghanaPost}`:""})</option>)}</select></div>
            {aiSel&&<div style={{background:"#f7f7f7",borderRadius:8,padding:"9px 12px",marginBottom:10,fontSize:12,lineHeight:1.65,color:"#444"}}>{incidents.find(i=>String(i.id)===aiSel)?.description}</div>}
            <button onClick={runAI} disabled={!aiSel||aiLoading} style={{...S.btn(aiLoading?"#7B1FA2":"#9C27B0"),opacity:aiSel?1:0.5}}>
              {aiLoading?<><i className="ti ti-loader-2 spin" style={{fontSize:14,marginRight:6}}/>Analyzing</>:<><i className="ti ti-brain" style={{fontSize:14,marginRight:6}}/>Run AI Classification</>}
            </button>
          </div>
          {aiRes&&(<div style={{...S.card,border:"1px solid #CE93D8",marginBottom:10}}>
            <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:12}}><i className="ti ti-sparkles" style={{color:"#9C27B0",fontSize:16}}/><span style={{fontSize:13,fontWeight:600,color:"#9C27B0"}}>AI Analysis Result</span></div>
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:12}}>
              {[["Classification",aiRes.classification],["Crime Category",aiRes.crimeCategory],["AI Severity",aiRes.severity?.toUpperCase()],["Risk Level",`${aiRes.riskLevel}/10`]].map(([l,v])=>(
                <div key={l} style={{background:"#F3E5F5",borderRadius:8,padding:"8px 10px"}}><div style={{fontSize:9,color:"#7B1FA2",marginBottom:2}}>{l}</div><div style={{fontSize:12,fontWeight:600,color:"#4A148C"}}>{v}</div></div>
              ))}
            </div>
            <div style={{marginBottom:10}}><div style={{fontSize:10,color:"#777",marginBottom:3}}>Summary</div><div style={{fontSize:12,lineHeight:1.65}}>{aiRes.summary}</div></div>
            <div style={{marginBottom:10}}><div style={{fontSize:10,color:"#777",marginBottom:3}}>Recommended Action</div><div style={{fontSize:12,background:"#E8F5E9",borderRadius:6,padding:"8px 10px",color:"#1B5E20",lineHeight:1.5}}><i className="ti ti-check" style={{fontSize:12,marginRight:4}}/>{aiRes.recommendedAction}</div></div>
            <div><div style={{fontSize:10,color:"#777",marginBottom:3}}>Related Patterns</div><div style={{fontSize:12,lineHeight:1.55,color:"#555"}}>{aiRes.relatedPatterns}</div></div>
          </div>)}
          <div style={S.card}><div style={{fontSize:13,fontWeight:600,marginBottom:8}}>AI Classification Summary</div><div style={{fontSize:11,color:"#777",marginBottom:10}}>{incidents.filter(i=>i.verified).length} of {incidents.length} incidents verified</div>
            {[["Violent Crimes","#F44336",["Armed Robbery","Robbery","Assault","Kidnapping","Domestic Violence"]],["Property Crimes","#FF9800",["Burglary","Vehicle Theft","Vandalism"]],["Financial Crimes","#2196F3",["Fraud/Cybercrime"]],["Drug Offenses","#9C27B0",["Drug Trafficking"]]].map(([l,c,types])=>(
              <div key={l} style={{display:"flex",alignItems:"center",gap:10,marginBottom:8}}><div style={{width:9,height:9,borderRadius:2,background:c}}/><span style={{fontSize:11,flex:1}}>{l}</span><span style={{fontSize:13,fontWeight:600,color:c}}>{incidents.filter(i=>types.includes(i.type)).length}</span></div>
            ))}
          </div>
        </div>)}

      </main>

      {/* ==== ONBOARDING MODAL ==== */}
      {/* ==== MOBILE BOTTOM NAV ==== */}
      <nav className="sg-bottom-nav" aria-label="Mobile navigation">
        {[
          {id:"map",icon:"ti-map-2",label:"Map"},
          {id:"alerts",icon:"ti-bell-ringing",label:"Alerts"},
          {id:"report",icon:"ti-circle-plus",label:"Report",isReport:true},
          {id:"sos",icon:"ti-sos",label:"SOS",isSOS:true},
          {id:"mydash",icon:"ti-layout-dashboard",label:"Dashboard"},
        ].map(item=>(
          <button key={item.id}
            className={`sg-bottom-nav-item${item.isReport?" report-btn":item.isSOS?" sos-btn":""}${tab===item.id&&!item.isReport&&!item.isSOS?" active":""}`} aria-label={item.label} aria-pressed={tab===item.id}
            onClick={()=>setTab(item.id)}
            aria-label={item.label}
            aria-current={tab===item.id?"page":undefined}>
            <i className={`ti ${item.icon}`} aria-hidden="true"/>
            <span>{item.label}</span>
          </button>
        ))}
      </nav>

      {showOnboarding&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.75)",zIndex:4000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={()=>setShowOnboarding(false)}>
          <div style={{background:"#fff",borderRadius:16,width:"100%",maxWidth:520,maxHeight:"90vh",overflowY:"auto",boxShadow:"0 20px 60px rgba(0,0,0,0.4)"}} onClick={e=>e.stopPropagation()}>
            {/* Header */}
            <div style={{background:"linear-gradient(135deg,#0A1628,#1A3A5C)",padding:"20px 24px",borderRadius:"16px 16px 0 0",display:"flex",alignItems:"center",justifyContent:"space-between"}}>
              <div>
                <div style={{color:"#FCD116",fontWeight:800,fontSize:18}}>Welcome to mysafeghana</div>
                <div style={{color:"#9BAEC8",fontSize:12,marginTop:2}}>Here's what you can do on the map</div>
              </div>
              <button onClick={()=>setShowOnboarding(false)} style={{background:"rgba(255,255,255,0.1)",border:"none",color:"#fff",borderRadius:8,width:32,height:32,cursor:"pointer",fontSize:18,display:"flex",alignItems:"center",justifyContent:"center"}}>×</button>
            </div>

            {/* Map legend */}
            <div style={{padding:"20px 24px"}}>
              <div style={{fontWeight:700,fontSize:13,color:"#333",marginBottom:12}}>Map Icons</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:20}}>
                {[
                  {color:"#CE1126",label:"Critical Incident",desc:"Immediate danger"},
                  {color:"#FF6F00",label:"High Severity",desc:"Serious threat"},
                  {color:"#F9A825",label:"Medium Severity",desc:"Moderate risk"},
                  {color:"#388E3C",label:"Low Severity",desc:"Minor incident"},
                  {color:"#1565C0",label:"Flood Zone",desc:"Flooding reported"},
                  {color:"#4CAF50",label:"Camera Online",desc:"Live CCTV feed"},
                ].map((item,i)=>(
                  <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 10px",background:"#F8FAFC",borderRadius:8,border:"1px solid #E2E8F0"}}>
                    <div style={{width:20,height:26,background:item.color,clipPath:"polygon(50% 0%,100% 35%,100% 70%,50% 100%,0% 70%,0% 35%)",flexShrink:0}}/>
                    <div>
                      <div style={{fontSize:11,fontWeight:600,color:"#1A202C"}}>{item.label}</div>
                      <div style={{fontSize:10,color:"#718096"}}>{item.desc}</div>
                    </div>
                  </div>
                ))}
              </div>

              {/* How to use */}
              <div style={{fontWeight:700,fontSize:13,color:"#333",marginBottom:12}}>How to use</div>
              <div style={{display:"flex",flexDirection:"column",gap:8,marginBottom:20}}>
                {[
                  {icon:"ti-hand-click",text:"Click any marker to see incident details"},
                  {icon:"ti-zoom-in",text:"Zoom in to see individual incidents, zoom out to see clusters"},
                  {icon:"ti-filter",text:"Use the dropdowns above the map to filter by type or severity"},
                  {icon:"ti-polygon",text:"Use Draw Polygon to analyse incidents in a specific area"},
                  {icon:"ti-flame",text:"Toggle Heatmap to see crime density across Ghana"},
                  {icon:"ti-circle-plus",text:"Click Report to submit a new incident"},
                ].map((step,i)=>(
                  <div key={i} style={{display:"flex",alignItems:"center",gap:10,padding:"8px 12px",background:"#F0F7FF",borderRadius:8}}>
                    <div style={{width:28,height:28,borderRadius:8,background:"#1565C0",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                      <i className={`ti ${step.icon}`} style={{color:"#fff",fontSize:13}}/>
                    </div>
                    <span style={{fontSize:12,color:"#2D3748"}}>{step.text}</span>
                  </div>
                ))}
              </div>

              {/* Data trust */}
              <div style={{background:"#F0FDF4",border:"1px solid #BBF7D0",borderRadius:10,padding:"12px 14px",display:"flex",gap:10,alignItems:"flex-start"}}>
                <i className="ti ti-shield-check" style={{color:"#16A34A",fontSize:18,flexShrink:0,marginTop:1}}/>
                <div>
                  <div style={{fontWeight:600,fontSize:12,color:"#15803D"}}>Verified Data Sources</div>
                  <div style={{fontSize:11,color:"#166534",marginTop:2}}>All incidents are sourced from community reports and cross-verified with Ghana Police Service, NADMO, and Emergency Services before being published. <span style={{color:"#1565C0",fontWeight:700,cursor:"pointer",textDecoration:"underline"}} onClick={()=>{setShowOnboarding(false);setTab("sources");}}>View all sources →</span></div>
                </div>
              </div>
            </div>

            {/* Footer */}
            <div style={{padding:"12px 24px",borderTop:"1px solid #E2E8F0",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <button onClick={()=>setShowOnboarding(false)} style={{background:"transparent",border:"none",color:"#718096",fontSize:12,cursor:"pointer"}}>
                Don't show again
              </button>
              <button onClick={()=>setShowOnboarding(false)} style={{background:"#0A1628",border:"none",color:"#FCD116",borderRadius:20,padding:"10px 28px",fontSize:13,fontWeight:700,cursor:"pointer"}}>
                Got it, explore the map →
              </button>
            </div>
          </div>
        </div>
      )}
      {showRegModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:3000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={()=>setShowRegModal(false)}>
          <div style={{background:"#fff",borderRadius:16,padding:20,width:"100%",maxWidth:480,maxHeight:"92vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()} onMouseDown={e=>e.stopPropagation()}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
              <div style={{width:38,height:38,borderRadius:10,background:"#1565C0",display:"flex",alignItems:"center",justifyContent:"center"}}><i className="ti ti-user-plus" style={{color:"#fff",fontSize:20}}/></div>
              <div><div style={{fontSize:16,fontWeight:700}}>Create mysafeghana Account</div><div style={{fontSize:11,color:"#777"}}>Register to report floods & incidents</div></div>
              <button onClick={()=>setShowRegModal(false)} style={{marginLeft:"auto",background:"none",border:"none",cursor:"pointer",fontSize:22,color:"#999"}} aria-label="Close"><i className="ti ti-x"/></button>
            </div>
            {/* Step indicators */}
            <div style={{display:"flex",gap:0,marginBottom:16}}>
              {["Account","Location","Verify"].map((s,i)=>(
                <div key={s} style={{flex:1,textAlign:"center"}}>
                  <div style={{width:24,height:24,borderRadius:"50%",background:regStep>i+1?"#2E7D32":regStep===i+1?"#1565C0":"#e0e0e0",color:regStep>i||regStep===i+1?"#fff":"#999",fontSize:11,fontWeight:600,display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 4px"}}>
                    {regStep>i+1?<i className="ti ti-check" style={{fontSize:12}}/>:i+1}
                  </div>
                  <div style={{fontSize:9,color:regStep===i+1?"#1565C0":"#999",fontWeight:regStep===i+1?600:400}}>{s}</div>
                </div>
              ))}
            </div>

            {regStep===1&&(
              <div>
                <div className="reg-step">
                  <div style={{fontSize:12,fontWeight:700,color:"#333",marginBottom:10}}><span className="reg-step-num">1</span>Account Details</div>
                  {[["Full Name","name","text","e.g. Kwame Mensah"],["Email Address","email","email","you@gmail.com"],["Phone Number","phone","tel","+233244123456"],["Password","password","password","Min. 8 chars, upper+lower+number+symbol"]].map(([lbl,key,type,ph])=>(
                    <div key={key} style={{marginBottom:10}}>
                      <label style={{fontSize:10,color:"#777",display:"block",marginBottom:3}}>{lbl}</label>
                      <input type={type} value={regForm[key]} onChange={e=>setRegForm(p=>({...p,[key]:e.target.value}))} placeholder={ph} style={{width:"100%"}}/>
                      {regErrors[key]&&<div style={{color:"#F44336",fontSize:10,marginTop:2}}>{regErrors[key]}</div>}
                    </div>
                  ))}
                </div>
                <button onClick={()=>{const e=validateReg();if(Object.keys(e).length){setRegErrors(e);}else{setRegErrors({});setRegStep(2);}}} style={{background:"#1565C0",color:"#fff",border:"none",borderRadius:8,padding:"11px",fontSize:13,fontWeight:600,cursor:"pointer",width:"100%"}}>
                  Continue <i className="ti ti-arrow-right" style={{fontSize:14,marginLeft:4}}/>
                </button>
              </div>
            )}

            {regStep===2&&(
              <div>
                <div className="reg-step">
                  <div style={{fontSize:12,fontWeight:700,color:"#333",marginBottom:10}}><span className="reg-step-num">2</span>Your Location</div>
                  <div style={{marginBottom:10}}>
                    <label style={{fontSize:10,color:"#777",display:"block",marginBottom:3}}>Region</label>
                    <select value={regForm.region} onChange={e=>setRegForm(p=>({...p,region:e.target.value}))} style={{width:"100%"}}>
                      <option value="">Select your region</option>
                      {GHANA_REGIONS.map(r=><option key={r.id} value={r.id}>{r.name}</option>)}
                    </select>
                  </div>
                  <div style={{marginBottom:10}}>
                    <label style={{fontSize:10,color:"#777",display:"block",marginBottom:3}}>Area / Town</label>
                    <input value={regForm.area} onChange={e=>setRegForm(p=>({...p,area:e.target.value}))} placeholder="e.g. Madina, Kumasi Central" style={{width:"100%"}}/>
                  </div>
                  <div>
                    <label style={{fontSize:10,color:"#777",display:"block",marginBottom:3}}>Ghana Post Address (optional)</label>
                    <input value={regForm.ghanaPost} onChange={e=>setRegForm(p=>({...p,ghanaPost:e.target.value.toUpperCase()}))} placeholder="XX-XXXX-XXXX" style={{width:"100%",fontFamily:"monospace"}}/>
                  </div>
                </div>
                <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                  <button onClick={()=>setRegStep(1)} style={{background:"#f0f0f0",color:"#555",border:"none",borderRadius:8,padding:"11px",fontSize:13,cursor:"pointer"}}><i className="ti ti-arrow-left" style={{fontSize:13,marginRight:4}}/>Back</button>
                  <button onClick={submitRegistration} style={{background:"#1565C0",color:"#fff",border:"none",borderRadius:8,padding:"11px",fontSize:13,fontWeight:600,cursor:"pointer"}}>Create Account <i className="ti ti-check" style={{fontSize:13,marginLeft:4}}/></button>
                </div>
              </div>
            )}

            {regStep===3&&(
              <div>
                <div style={{textAlign:"center",padding:"20px 0 16px"}}>
                  <div style={{width:64,height:64,borderRadius:"50%",background:"#E3F2FD",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 16px"}}>
                    <i className="ti ti-mail-check" style={{fontSize:32,color:"#1565C0"}}/>
                  </div>
                  <div style={{fontSize:16,fontWeight:700,color:"#1A2332",marginBottom:6}}>Check your email</div>
                  <div style={{fontSize:12,color:"#666",lineHeight:1.6}}>
                    We sent a 6-digit verification code to<br/>
                    <strong style={{color:"#1565C0"}}>{regForm.email}</strong>
                  </div>
                </div>
                <div style={{marginBottom:16}}>
                  <label style={{fontSize:11,color:"#555",display:"block",marginBottom:6,fontWeight:600}}>Enter verification code</label>
                  <input
                    value={verifyCode}
                    onChange={e=>setVerifyCode(e.target.value.replace(/\D/g,"").substring(0,6))}
                    placeholder="000000"
                    maxLength={6}
                    style={{width:"100%",fontSize:28,letterSpacing:12,textAlign:"center",fontWeight:700,fontFamily:"monospace",padding:"12px",border:"2px solid #e0e0e0",borderRadius:10,outline:"none"}}
                    autoFocus
                  />
                  {verifyError&&<div style={{color:verifyError.includes("resent")?"#2E7D32":"#F44336",fontSize:11,marginTop:6,textAlign:"center"}}>{verifyError}</div>}
                </div>
                <button onClick={submitVerification} disabled={verifyLoading||verifyCode.length!==6} style={{background:verifyCode.length===6?"#1565C0":"#ccc",color:"#fff",border:"none",borderRadius:8,padding:"12px",fontSize:14,fontWeight:700,cursor:verifyCode.length===6?"pointer":"default",width:"100%",marginBottom:12}}>
                  {verifyLoading?<><i className="ti ti-loader-2 spin" style={{marginRight:6}}/>Verifying...</>:<><i className="ti ti-circle-check" style={{marginRight:6}}/>Verify & Create Account</>}
                </button>
                <div style={{textAlign:"center",fontSize:11,color:"#888"}}>
                  Didn't receive it?{" "}
                  <button onClick={resendVerification} style={{background:"none",border:"none",color:"#1565C0",cursor:"pointer",fontSize:11,fontWeight:600,textDecoration:"underline"}}>Resend code</button>
                  {" "}· Check your spam folder
                </div>
              </div>
            )}

            <div style={{textAlign:"center",marginTop:14,fontSize:11,color:"#777"}}>
              Already have an account? <button onClick={()=>{setShowRegModal(false);setShowLogin(true);}} style={{background:"none",border:"none",color:"#1565C0",cursor:"pointer",fontSize:11,fontWeight:600,textDecoration:"underline"}}>Sign In</button>
            </div>
          </div>
        </div>
      )}

      {/* ==== LOGIN MODAL ==== */}
      {showLogin&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:3000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={()=>{setShowLogin(false);setLoginView("signin");setResetMsg("");}}>
          <div style={{background:"#fff",borderRadius:16,padding:20,width:"100%",maxWidth:380}} onClick={e=>e.stopPropagation()} onMouseDown={e=>e.stopPropagation()}>

            {/* ==== SIGN IN ==== */}
            {loginView==="signin"&&(<>
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
                <div style={{width:36,height:36,borderRadius:10,background:"#1565C0",display:"flex",alignItems:"center",justifyContent:"center"}}><i className="ti ti-login" style={{color:"#fff",fontSize:18}}/></div>
                <div><div style={{fontSize:15,fontWeight:700}}>Sign In</div><div style={{fontSize:11,color:"#777"}}>mysafeghana account</div></div>
                <button onClick={()=>setShowLogin(false)} style={{marginLeft:"auto",background:"none",border:"none",cursor:"pointer",fontSize:22,color:"#999"}} aria-label="Close"><i className="ti ti-x"/></button>
              </div>
              <div style={{marginBottom:10}}><label style={{fontSize:10,color:"#777",display:"block",marginBottom:3}}>Email</label><input type="email" value={loginForm.email} onChange={e=>setLoginForm(p=>({...p,email:e.target.value}))} placeholder="your@email.com" style={{width:"100%"}}/></div>
              <div style={{marginBottom:6}}><label style={{fontSize:10,color:"#777",display:"block",marginBottom:3}}>Password</label><input type="password" value={loginForm.password} onChange={e=>setLoginForm(p=>({...p,password:e.target.value}))} onKeyDown={e=>e.key==="Enter"&&handleLogin()} placeholder="······" style={{width:"100%"}}/></div>
              <div style={{textAlign:"right",marginBottom:12}}>
                <button onClick={()=>{setResetEmail(loginForm.email);setLoginView("forgot");setResetMsg("");}} style={{background:"none",border:"none",color:"#1565C0",cursor:"pointer",fontSize:11,textDecoration:"underline"}}>Forgot password?</button>
              </div>
              {loginError&&(
                <div style={{color:"#C62828",fontSize:11,marginBottom:10,background:"#FFEBEE",padding:"8px 10px",borderRadius:6,lineHeight:1.5}}>
                  {loginError}
                  {loginError.includes("verify")&&(
                    <div style={{marginTop:6}}>
                      <button onClick={async()=>{
                        try{
                          await fetch(`${API_BASE}/public/send-verification`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({email:loginForm.email,name:""})});
                          setLoginError("Verification code resent! Check your inbox.");
                        }catch(e){setLoginError("Could not resend. Please try again.");}
                      }} style={{background:"none",border:"none",color:"#1565C0",cursor:"pointer",fontSize:11,fontWeight:600,textDecoration:"underline",padding:0}}>
                        Resend verification email →
                      </button>
                    </div>
                  )}
                </div>
              )}
              <button onClick={handleLogin} style={{background:"#1565C0",color:"#fff",border:"none",borderRadius:8,padding:"11px",fontSize:13,fontWeight:600,cursor:"pointer",width:"100%"}}>Sign In</button>
              <div style={{textAlign:"center",marginTop:12,fontSize:11,color:"#777"}}>
                No account? <button onClick={()=>{setShowLogin(false);setShowRegModal(true);}} style={{background:"none",border:"none",color:"#1565C0",cursor:"pointer",fontSize:11,fontWeight:600,textDecoration:"underline"}}>Register here</button>
              </div>
            </>)}

            {/* ==== FORGOT PASSWORD ==== */}
            {loginView==="forgot"&&(<>
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
                <div style={{width:36,height:36,borderRadius:10,background:"#E65100",display:"flex",alignItems:"center",justifyContent:"center"}}><i className="ti ti-lock" style={{color:"#fff",fontSize:18}}/></div>
                <div><div style={{fontSize:15,fontWeight:700}}>Reset Password</div><div style={{fontSize:11,color:"#777"}}>We'll send a code to your email</div></div>
                <button onClick={()=>setShowLogin(false)} style={{marginLeft:"auto",background:"none",border:"none",cursor:"pointer",fontSize:22,color:"#999"}} aria-label="Close"><i className="ti ti-x"/></button>
              </div>
              <div style={{marginBottom:14}}>
                <label style={{fontSize:10,color:"#777",display:"block",marginBottom:3}}>Email address</label>
                <input type="email" value={resetEmail} onChange={e=>setResetEmail(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handleForgotPassword()} placeholder="your@email.com" style={{width:"100%"}} autoFocus/>
              </div>
              {resetMsg&&<div style={{color:resetMsg.includes("sent")?"#2E7D32":"#F44336",fontSize:11,marginBottom:10,background:resetMsg.includes("sent")?"#E8F5E9":"#FFEBEE",padding:"6px 10px",borderRadius:6}}>{resetMsg}</div>}
              <button onClick={handleForgotPassword} disabled={resetLoading} style={{background:"#E65100",color:"#fff",border:"none",borderRadius:8,padding:"11px",fontSize:13,fontWeight:600,cursor:"pointer",width:"100%",marginBottom:10}}>
                {resetLoading?<><i className="ti ti-loader-2 spin" style={{marginRight:6}}/>Sending...</>:<><i className="ti ti-send" style={{marginRight:6}}/>Send Reset Code</>}
              </button>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:11}}>
                <button onClick={()=>setLoginView("signin")} style={{background:"none",border:"none",color:"#666",cursor:"pointer",textDecoration:"underline"}}>← Back to Sign In</button>
                <button onClick={()=>setLoginView("reset")} style={{background:"none",border:"none",color:"#1565C0",cursor:"pointer",textDecoration:"underline"}}>Already have a code?</button>
              </div>
            </>)}

            {/* ==== ENTER CODE + NEW PASSWORD ==== */}
            {loginView==="reset"&&(<>
              <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
                <div style={{width:36,height:36,borderRadius:10,background:"#2E7D32",display:"flex",alignItems:"center",justifyContent:"center"}}><i className="ti ti-key" style={{color:"#fff",fontSize:18}}/></div>
                <div><div style={{fontSize:15,fontWeight:700}}>New Password</div><div style={{fontSize:11,color:"#777"}}>Enter the code from your email</div></div>
                <button onClick={()=>setShowLogin(false)} style={{marginLeft:"auto",background:"none",border:"none",cursor:"pointer",fontSize:22,color:"#999"}} aria-label="Close"><i className="ti ti-x"/></button>
              </div>
              <div style={{marginBottom:10}}>
                <label style={{fontSize:10,color:"#777",display:"block",marginBottom:3}}>6-digit code</label>
                <input value={resetCode} onChange={e=>setResetCode(e.target.value.replace(/\D/g,"").substring(0,6))} placeholder="000000" maxLength={6} style={{width:"100%",fontSize:22,letterSpacing:8,textAlign:"center",fontWeight:700,fontFamily:"monospace",padding:"10px"}} autoFocus/>
              </div>
              <div style={{marginBottom:10}}>
                <label style={{fontSize:10,color:"#777",display:"block",marginBottom:3}}>New password</label>
                <input type="password" value={resetPassword} onChange={e=>setResetPassword(e.target.value)} placeholder="Min. 8 chars, upper+lower+number+symbol" style={{width:"100%"}}/>
              </div>
              <div style={{marginBottom:14}}>
                <label style={{fontSize:10,color:"#777",display:"block",marginBottom:3}}>Confirm new password</label>
                <input type="password" value={resetConfirm} onChange={e=>setResetConfirm(e.target.value)} onKeyDown={e=>e.key==="Enter"&&handleResetPassword()} placeholder="Repeat password" style={{width:"100%"}}/>
              </div>
              {resetMsg&&<div style={{color:resetMsg.includes("reset!")?"#2E7D32":"#F44336",fontSize:11,marginBottom:10,background:resetMsg.includes("reset!")?"#E8F5E9":"#FFEBEE",padding:"6px 10px",borderRadius:6}}>{resetMsg}</div>}
              <button onClick={handleResetPassword} disabled={resetLoading||resetCode.length!==6||checkPasswordPolicy(resetPassword).length>0} style={{background:resetCode.length===6&&checkPasswordPolicy(resetPassword).length===0?"#2E7D32":"#aaa",color:"#fff",border:"none",borderRadius:8,padding:"11px",fontSize:13,fontWeight:600,cursor:"pointer",width:"100%",marginBottom:10}}>
                {resetLoading?<><i className="ti ti-loader-2 spin" style={{marginRight:6}}/>Resetting...</>:<><i className="ti ti-circle-check" style={{marginRight:6}}/>Reset Password</>}
              </button>
              <div style={{display:"flex",justifyContent:"space-between",fontSize:11}}>
                <button onClick={()=>setLoginView("forgot")} style={{background:"none",border:"none",color:"#666",cursor:"pointer",textDecoration:"underline"}}>← Resend code</button>
                <button onClick={()=>setLoginView("signin")} style={{background:"none",border:"none",color:"#1565C0",cursor:"pointer",textDecoration:"underline"}}>Back to Sign In</button>
              </div>
            </>)}

          </div>
        </div>
      )}

      {/* ==== FLOOD REPORT MODAL ==== */}
      {showFloodModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.75)",zIndex:3000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={()=>setShowFloodModal(false)}>
          <div style={{background:"#fff",borderRadius:16,padding:20,width:"100%",maxWidth:520,maxHeight:"92vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:16}}>
              <div style={{width:38,height:38,borderRadius:10,background:"#0D47A1",display:"flex",alignItems:"center",justifyContent:"center"}}><i className="ti ti-ripple" style={{color:"#fff",fontSize:20}}/></div>
              <div><div style={{fontSize:16,fontWeight:700,color:"#0D47A1"}}>Report Flooding</div><div style={{fontSize:11,color:"#777"}}>Upload a flood video · plotted on heatmap</div></div>
              <button onClick={()=>setShowFloodModal(false)} style={{marginLeft:"auto",background:"none",border:"none",cursor:"pointer",fontSize:22,color:"#999"}} aria-label="Close"><i className="ti ti-x"/></button>
            </div>

            {/* Video upload */}
            <div className="reg-step" style={{borderColor:"#90CAF9"}}>
              <div style={{fontSize:12,fontWeight:700,color:"#1565C0",marginBottom:10}}><span style={{...{},background:"#1565C0",color:"#fff",width:20,height:20,borderRadius:"50%",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700,marginRight:8}}>1</span>Upload Flood Video</div>
              {!floodVideo?(
                <label className="video-drop">
                  <input type="file" accept="video/*" style={{display:"none"}} onChange={e=>e.target.files[0]&&handleFloodVideo(e.target.files[0])}/>
                  <i className="ti ti-video-plus" style={{fontSize:36,color:"#1565C0",display:"block",marginBottom:8}}/>
                  <div style={{fontSize:13,fontWeight:600,color:"#1565C0",marginBottom:4}}>Tap to upload flooding video</div>
                  <div style={{fontSize:11,color:"#777"}}>MP4, MOV, AVI, MKV, 3GP, WebM · max 2GB · any duration</div>
                </label>
              ):(
                <div style={{background:"#E3F2FD",borderRadius:10,padding:"12px 14px",border:"1.5px solid #1565C0"}}>
                  <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:6}}>
                    <i className="ti ti-circle-check" style={{color:"#4CAF50",fontSize:18}}/>
                    <div style={{flex:1}}>
                      <div style={{fontSize:12,fontWeight:600,color:"#0D47A1"}}>{floodVideo.name}</div>
                      <div style={{fontSize:10,color:"#555"}}>{floodVideo.size}{floodVideo.durationLabel ? " = " + floodVideo.durationLabel : ""}</div>
                    </div>
                    <button onClick={()=>setFloodVideo(null)} style={{background:"none",border:"none",cursor:"pointer",color:"#F44336",fontSize:18}} aria-label="Close"><i className="ti ti-x"/></button>
                  </div>
                  <video src={floodVideo.url} controls style={{width:"100%",borderRadius:6,maxHeight:160}}/>
                </div>
              )}
              {floodVideoError&&<div style={{color:"#F44336",fontSize:11,marginTop:6,background:"#FFEBEE",padding:"6px 10px",borderRadius:6}}><i className="ti ti-alert-circle" style={{fontSize:12,marginRight:4}}/>{floodVideoError}</div>}
            </div>

            {/* Location */}
            <div className="reg-step">
              <div style={{fontSize:12,fontWeight:700,color:"#1565C0",marginBottom:10}}><span style={{background:"#1565C0",color:"#fff",width:20,height:20,borderRadius:"50%",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700,marginRight:8}}>2</span>Flood Location</div>
              <button onClick={getFloodGPS} disabled={floodGPSLoading} style={{width:"100%",background:floodGPS?"#E8F5E9":"#E3F2FD",border:`1.5px solid ${floodGPS?"#4CAF50":"#90CAF9"}`,borderRadius:8,padding:"10px",cursor:"pointer",fontSize:12,marginBottom:10,display:"flex",alignItems:"center",justifyContent:"center",gap:6,color:floodGPS?"#2E7D32":"#1565C0",fontWeight:600}}>
                {floodGPSLoading?<><i className="ti ti-loader-2 spin" style={{fontSize:14}}/>Detecting</>:floodGPS?<><i className="ti ti-circle-check" style={{fontSize:14}}/>GPS Detected ({floodGPS.lat.toFixed(4)}, {floodGPS.lng.toFixed(4)})</>:<><i className="ti ti-current-location" style={{fontSize:14}}/>Use My Current Location</>}
              </button>
              <div style={{marginBottom:10}}>
                
                {/* Business/location search for flood */}
                <div style={{marginBottom:8}}>
                  <label style={{fontSize:10,color:"#777",display:"block",marginBottom:3}}>Location / Business <span style={{fontSize:9,background:"#EDE7F6",color:"#7B1FA2",padding:"1px 5px",borderRadius:4,fontWeight:600,marginLeft:2}}>b/ to search</span></label>
                  <div className="biz-input-wrap">
                    <input value={floodBizQuery} onChange={e=>handleBizChange(e.target.value,setFloodBizQuery,setFloodBizMatches,setFloodBizDropOpen)}
                      onBlur={()=>setTimeout(()=>setFloodBizDropOpen(false),200)}
                      placeholder="Area name  =  or  b/a  for businesses starting with A="
                      style={{width:"100%",borderColor:floodBizQuery.startsWith("b/")?"#9C27B0":"#ccc"}}/>
                    {floodBizDropOpen&&floodBizMatches.length>0&&(
                      <div className="biz-dropdown">
                        {floodBizMatches.map(biz=>(
                          <div key={biz.name} className="biz-item" onMouseDown={()=>chooseBiz(biz,setFloodBizDropOpen,setFloodBizMatches,setFloodBizQuery,setFloodForm,"area")}>
                            <i className={`ti ${BIZ_CATEGORY_ICONS[biz.category]||"ti-building"}`} style={{fontSize:15,color:"#9C27B0",flexShrink:0}}/>
                            <div style={{flex:1,minWidth:0}}>
                              <div style={{fontSize:12,fontWeight:600,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{biz.name}</div>
                              <div style={{fontSize:10,color:"#888"}}>{biz.area} = {GHANA_REGIONS.find(r=>r.id===biz.region)?.name||biz.region}</div>
                            </div>
                            <span className="biz-badge">{biz.category}</span>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
                <label style={{fontSize:10,color:"#777",display:"block",marginBottom:3}}>Ghana Post Address *</label>
                <input value={floodForm.ghanaPost} onChange={e=>{const v=e.target.value.toUpperCase();setFloodForm(p=>({...p,ghanaPost:v}));if(isValidGhanaPost(v)){const r=regionFromGhanaPost(v);if(r)setFloodForm(p=>({...p,region:r}));}}} placeholder="XX-XXXX-XXXX" style={{width:"100%",fontFamily:"monospace",letterSpacing:2}}/>
                {floodPostError&&<div style={{color:"#F44336",fontSize:10,marginTop:2}}>{floodPostError}</div>}
              </div>
              <div style={{marginBottom:10}}>
                <label style={{fontSize:10,color:"#777",display:"block",marginBottom:3}}>Area Description</label>
                <input value={floodForm.area} onChange={e=>setFloodForm(p=>({...p,area:e.target.value}))} placeholder="e.g. Odaw River Basin, Accra" style={{width:"100%"}}/>
              </div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8}}>
                <div><label style={{fontSize:10,color:"#777",display:"block",marginBottom:3}}>Region</label>
                  <select value={floodForm.region} onChange={e=>setFloodForm(p=>({...p,region:e.target.value}))} style={{width:"100%"}}>
                    <option value="">Select</option>{GHANA_REGIONS.map(r=><option key={r.id} value={r.id}>{r.name}</option>)}
                  </select></div>
                <div><label style={{fontSize:10,color:"#777",display:"block",marginBottom:3}}>Severity</label>
                  <select value={floodForm.severity} onChange={e=>setFloodForm(p=>({...p,severity:e.target.value}))} style={{width:"100%"}}>
                    <option value="mild">Mild - Ankle-deep</option>
                    <option value="moderate">Moderate - Knee-deep</option>
                    <option value="severe">Severe - Waist-deep+</option>
                  </select></div>
              </div>
            </div>

            {/* Details */}
            <div className="reg-step">
              <div style={{fontSize:12,fontWeight:700,color:"#1565C0",marginBottom:10}}><span style={{background:"#1565C0",color:"#fff",width:20,height:20,borderRadius:"50%",display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700,marginRight:8}}>3</span>Flood Details</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:8}}>
                <div><label style={{fontSize:10,color:"#777",display:"block",marginBottom:3}}>Water Depth</label>
                  <select value={floodForm.depth} onChange={e=>setFloodForm(p=>({...p,depth:e.target.value}))} style={{width:"100%"}}>
                    {["Ankle-deep","Knee-deep","Waist-deep","Chest-deep","Completely submerged"].map(d=><option key={d}>{d}</option>)}
                  </select></div>
                <div><label style={{fontSize:10,color:"#777",display:"block",marginBottom:3}}>Duration (if ongoing, leave blank)</label>
                  <input value={floodForm.duration} onChange={e=>setFloodForm(p=>({...p,duration:e.target.value}))} placeholder="e.g. 3 hours" style={{width:"100%"}}/></div>
              </div>
              <div><label style={{fontSize:10,color:"#777",display:"block",marginBottom:3}}>Description</label>
                <textarea value={floodForm.description} onChange={e=>setFloodForm(p=>({...p,description:e.target.value}))} placeholder="Describe the flooding situation, affected areas, any danger=" rows={3}/></div>
            </div>

            {/* Upload progress */}
            {floodUploading&&(
              <div style={{marginBottom:12,background:"#E3F2FD",borderRadius:8,padding:"10px 14px",border:"1px solid #90CAF9"}}>
                <div style={{display:"flex",justifyContent:"space-between",fontSize:11,color:"#1565C0",marginBottom:6,fontWeight:600}}>
                  <span><i className="ti ti-loader-2 spin" style={{fontSize:12,marginRight:4}}/>Uploading flood report</span>
                  <span>{floodUploadProgress}%</span>
                </div>
                <div style={{height:4,background:"#BBDEFB",borderRadius:2,overflow:"hidden"}}>
                  <div style={{height:"100%",width:`${floodUploadProgress}%`,background:"#1565C0",borderRadius:2,transition:"width .2s"}}/>
                </div>
              </div>
            )}

            <button onClick={submitFloodReport} disabled={floodUploading} style={{background:floodUploading?"#78909C":"#0D47A1",color:"#fff",border:"none",borderRadius:8,padding:"12px",fontSize:13,fontWeight:600,cursor:floodUploading?"default":"pointer",width:"100%",display:"flex",alignItems:"center",justifyContent:"center",gap:6}}>
              <i className="ti ti-ripple" style={{fontSize:15}}/>{floodUploading?"Uploading…":"Submit Flood Report & Plot on Map"}
            </button>
            <button onClick={goBack} style={{width:"100%",marginTop:8,background:"#F5F5F5",border:"1px solid #ddd",color:"#555",borderRadius:8,padding:"11px",fontSize:13,fontWeight:600,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:6}}>
              <i className="ti ti-arrow-left" style={{fontSize:14}}/>Cancel
            </button>
          </div>
        </div>
      )}

      {/* ==== FLOOD DETAIL MODAL ==== */}
      {selectedFlood&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.8)",zIndex:3000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={()=>setSelectedFlood(null)}>
          <div style={{background:"#0A1628",borderRadius:16,width:"100%",maxWidth:540,maxHeight:"92vh",overflowY:"auto",border:"1px solid rgba(255,255,255,0.12)"}} onClick={e=>e.stopPropagation()}>
            {/* Header */}
            <div style={{display:"flex",alignItems:"center",gap:10,padding:"14px 16px",borderBottom:"1px solid rgba(255,255,255,0.1)"}}>
              <div className="user-avatar" style={{background:FLOOD_SEVERITY_CFG[selectedFlood.severity]?.color||"#1565C0",color:"#fff"}}>{selectedFlood.avatar}</div>
              <div style={{flex:1}}>
                <div style={{color:"#fff",fontWeight:700,fontSize:14}}>{selectedFlood.userName}</div>
                <div style={{color:"#9BAEC8",fontSize:10}}>{selectedFlood.area} · {selectedFlood.date}</div>
              </div>
              <span style={{fontSize:10,background:FLOOD_SEVERITY_CFG[selectedFlood.severity]?.bg||"#E3F2FD",color:FLOOD_SEVERITY_CFG[selectedFlood.severity]?.color||"#1565C0",padding:"3px 10px",borderRadius:10,fontWeight:700,marginRight:8}}>{(FLOOD_SEVERITY_CFG[selectedFlood.severity]?.label||"Flood").toUpperCase()} FLOOD</span>
              <button onClick={()=>setSelectedFlood(null)} style={{background:"none",border:"none",color:"#9BAEC8",cursor:"pointer",fontSize:22,lineHeight:1}} aria-label="Close"><i className="ti ti-x"/></button>
            </div>
            {/* Video player */}
            <div style={{background:"#000",position:"relative"}}>
              {selectedFlood.videoUrl?(
                <video src={selectedFlood.videoUrl} controls autoPlay muted style={{width:"100%",maxHeight:280,display:"block"}}/>
              ):(
                <div style={{height:200,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",gap:8}}>
                  <i className="ti ti-video" style={{fontSize:40,color:"#1565C0"}}/>
                  <div style={{color:"#9BAEC8",fontSize:12}}>{selectedFlood.videoName}</div>
                  <div style={{color:"#666",fontSize:11}}>{selectedFlood.videoSize}</div>
                </div>
              )}
              <div style={{position:"absolute",top:8,left:8,background:"rgba(13,71,161,0.85)",borderRadius:6,padding:"3px 8px",fontSize:10,color:"#fff",fontFamily:"monospace"}}>
                <i className="ti ti-ripple" style={{fontSize:10,marginRight:3}}/>FLOOD FOOTAGE
              </div>
            </div>
            {/* Details */}
            <div style={{padding:"14px 16px"}}>
              <div style={{color:"#ccc",fontSize:12,lineHeight:1.65,marginBottom:12}}>{selectedFlood.description}</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:8,marginBottom:12}}>
                {[["Water Depth",selectedFlood.depth],["Duration",selectedFlood.duration||"Ongoing"],["Ghana Post",selectedFlood.ghanaPost],["Coordinates",`${selectedFlood.lat?.toFixed(4)}, ${selectedFlood.lng?.toFixed(4)}`]].map(([l,v])=>(
                  <div key={l} style={{background:"rgba(255,255,255,0.06)",borderRadius:7,padding:"8px 10px"}}>
                    <div style={{fontSize:9,color:"#9BAEC8",marginBottom:2}}>{l}</div>
                    <div style={{fontSize:11,color:"#fff",fontWeight:500}}>{v}</div>
                  </div>
                ))}
              </div>
              {/* Download buttons */}
              {selectedFlood.videoUrl?(
                <button onClick={()=>{
                  const a=document.createElement("a");
                  a.href=selectedFlood.videoUrl;
                  a.download=selectedFlood.videoName||"flood_video.mp4";
                  document.body.appendChild(a);a.click();document.body.removeChild(a);
                }} style={{background:"#1565C0",color:"#fff",border:"none",borderRadius:8,padding:"10px 14px",fontSize:12,fontWeight:600,cursor:"pointer",width:"100%",display:"flex",alignItems:"center",justifyContent:"center",gap:6,marginBottom:8}}>
                  <i className="ti ti-download" style={{fontSize:14}}/>Download Flood Video ({selectedFlood.videoSize})
                </button>
              ):(
                <div style={{background:"rgba(255,255,255,0.06)",border:"1px solid rgba(255,255,255,0.12)",borderRadius:8,padding:"10px 14px",marginBottom:8,display:"flex",alignItems:"center",gap:8}}>
                  <i className="ti ti-video-off" style={{fontSize:16,color:"#9BAEC8"}}/>
                  <div>
                    <div style={{color:"#ccc",fontSize:12,fontWeight:500}}>{selectedFlood.videoName||"No video uploaded"}</div>
                    <div style={{color:"#777",fontSize:10,marginTop:2}}>
                      {selectedFlood.videoName
                        ?"Video on file - contact operator to retrieve: "+selectedFlood.videoSize
                        :"This report was submitted without a video attachment"}
                    </div>
                  </div>
                </div>
              )}
              {/* Always allow report summary download */}
              <button onClick={()=>{
                const lines=[
                  "SafeGhana Flood Report",
                  "======================",
                  "Report ID:   "+selectedFlood.id,
                  "Reporter:    "+selectedFlood.userName,
                  "Date/Time:   "+selectedFlood.date+" "+selectedFlood.time,
                  "Area:        "+selectedFlood.area,
                  "Region:      "+(GHANA_REGIONS.find(r=>r.id===selectedFlood.region)?.name||selectedFlood.region),
                  "Ghana Post:  "+selectedFlood.ghanaPost,
                  "Coordinates: "+(selectedFlood.lat?.toFixed(5))+", "+(selectedFlood.lng?.toFixed(5)),
                  "Severity:    "+selectedFlood.severity.toUpperCase(),
                  "Water Depth: "+selectedFlood.depth,
                  "Duration:    "+(selectedFlood.duration||"Ongoing"),
                  "Verified:    "+(selectedFlood.verified?"Yes":"No"),
                  "Video:       "+(selectedFlood.videoName||"None"),
                  "",
                  "Description:",
                  selectedFlood.description,
                ];
                const txt=lines.join("\n");
                const a=document.createElement("a");
                a.href=URL.createObjectURL(new Blob([txt],{type:"text/plain"}));
                a.download="flood_report_"+selectedFlood.id+".txt";
                document.body.appendChild(a);a.click();document.body.removeChild(a);
              }} style={{background:"rgba(255,255,255,0.08)",border:"1px solid rgba(255,255,255,0.18)",color:"#ccc",borderRadius:8,padding:"8px 14px",fontSize:11,cursor:"pointer",width:"100%",display:"flex",alignItems:"center",justifyContent:"center",gap:5,marginBottom:8}}>
                <i className="ti ti-file-text" style={{fontSize:13}}/>Download Report Summary (.txt)
              </button>
              <button onClick={()=>{setTab("map");setShowFloodLayer(true);setSelectedFlood(null);}} style={{background:"rgba(255,255,255,0.08)",border:"1px solid rgba(255,255,255,0.15)",color:"#fff",borderRadius:8,padding:"9px 14px",fontSize:12,cursor:"pointer",width:"100%",display:"flex",alignItems:"center",justifyContent:"center",gap:6}}>
                <i className="ti ti-map-2" style={{fontSize:14}}/>View on Heatmap
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ==== POI DETAIL MODAL ==== */}
      {selectedPOI&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.65)",zIndex:2500,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={()=>setSelectedPOI(null)}>
          <div style={{background:"#0A1628",borderRadius:14,padding:0,width:"100%",maxWidth:420,border:"1px solid rgba(255,255,255,0.12)"}} onClick={e=>e.stopPropagation()}>
            {/* Header */}
            <div style={{display:"flex",alignItems:"center",gap:12,padding:"14px 16px",borderBottom:"1px solid rgba(255,255,255,0.08)"}}>
              <div style={{width:40,height:40,borderRadius:10,background:POI_CATEGORY_COLORS[selectedPOI.category]||"#607D8B",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                <i className={`ti ${BIZ_CATEGORY_ICONS[selectedPOI.category]||"ti-building"}`} style={{color:"#fff",fontSize:20}}/>
              </div>
              <div style={{flex:1,minWidth:0}}>
                <div style={{color:"#fff",fontWeight:700,fontSize:15,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{selectedPOI.name}</div>
                <span style={{fontSize:10,background:(POI_CATEGORY_COLORS[selectedPOI.category]||"#607D8B")+"44",color:POI_CATEGORY_COLORS[selectedPOI.category]||"#aaa",padding:"2px 8px",borderRadius:8,fontWeight:600,marginTop:3,display:"inline-block"}}>{selectedPOI.category}</span>
              </div>
              <button onClick={()=>setSelectedPOI(null)} style={{background:"none",border:"none",color:"#9BAEC8",cursor:"pointer",fontSize:22,lineHeight:1}} aria-label="Close"><i className="ti ti-x"/></button>
            </div>
            {/* Details */}
            <div style={{padding:"14px 16px"}}>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:12}}>
                {[
                  ["Location",selectedPOI.area],
                  ["Region",GHANA_REGIONS.find(r=>r.id===selectedPOI.region)?.name||selectedPOI.region],
                  ["Ghana Post",selectedPOI.ghanaPost||"N/A"],
                  ["Coordinates",selectedPOI.lat?`${selectedPOI.lat.toFixed(4)}, ${selectedPOI.lng.toFixed(4)}`:"N/A"],
                ].map(([l,v])=>(
                  <div key={l} style={{background:"rgba(255,255,255,0.05)",borderRadius:7,padding:"7px 10px"}}>
                    <div style={{fontSize:9,color:"#9BAEC8",marginBottom:2}}>{l}</div>
                    <div style={{fontSize:11,color:"#fff",fontWeight:500}}>{v}</div>
                  </div>
                ))}
              </div>
              {/* Nearby incidents */}
              {(()=>{
                const nearby=incidents.filter(inc=>{
                  if(!inc.lat||!inc.lng||!selectedPOI.lat||!selectedPOI.lng)return false;
                  const dlat=inc.lat-selectedPOI.lat,dlng=inc.lng-selectedPOI.lng;
                  return Math.sqrt(dlat*dlat+dlng*dlng)<0.05;
                });
                if(!nearby.length)return null;
                return(<div style={{marginBottom:12}}>
                  <div style={{color:"#F44336",fontSize:11,fontWeight:600,marginBottom:6,display:"flex",alignItems:"center",gap:5}}>
                    <i className="ti ti-alert-triangle" style={{fontSize:13}}/>
                    {nearby.length} incident{nearby.length>1?"s":""} reported nearby
                  </div>
                  {nearby.slice(0,3).map(inc=>(
                    <div key={inc.id} style={{display:"flex",alignItems:"center",gap:7,padding:"5px 0",borderBottom:"0.5px solid rgba(255,255,255,0.08)"}}>
                      <div style={{width:7,height:7,borderRadius:"50%",background:SEV_CFG[inc.severity]?.color||"#999",flexShrink:0}}/>
                      <div style={{flex:1,minWidth:0}}>
                        <div style={{fontSize:10,color:"#ccc",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{inc.type}</div>
                        <div style={{fontSize:9,color:"#777"}}>{inc.date}</div>
                      </div>
                    </div>
                  ))}
                </div>);
              })()}
              <div style={{display:"flex",gap:8}}>
                <button onClick={()=>{
                  setBizQuery(selectedPOI.name);
                  setForm(p=>({...p,area:selectedPOI.name,region:selectedPOI.region,ghanaPost:selectedPOI.ghanaPost||""}));
                  setSelectedPOI(null);setTab("report");
                }} style={{flex:1,background:"#CE1126",color:"#fff",border:"none",borderRadius:8,padding:"9px",cursor:"pointer",fontSize:12,fontWeight:600,display:"flex",alignItems:"center",justifyContent:"center",gap:5}}>
                  <i className="ti ti-plus" style={{fontSize:13}}/>Report Incident Here
                </button>
                <button onClick={()=>setSelectedPOI(null)} style={{background:"rgba(255,255,255,0.08)",border:"1px solid rgba(255,255,255,0.15)",color:"#fff",borderRadius:8,padding:"9px 14px",cursor:"pointer",fontSize:12}}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ==== CAMERA VIEWER MODAL ==== */}
      {selectedCam&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.85)",zIndex:2000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={()=>setSelectedCam(null)}>
          <div style={{background:"#0A1628",borderRadius:16,padding:0,width:"100%",maxWidth:640,maxHeight:"92vh",overflowY:"auto",border:"1px solid rgba(255,255,255,0.1)"}} onClick={e=>e.stopPropagation()}>

            {/* Modal header */}
            <div style={{display:"flex",alignItems:"center",gap:10,padding:"14px 16px",borderBottom:"1px solid rgba(255,255,255,0.1)"}}>
              <div style={{width:36,height:36,borderRadius:8,background:CAM_STATUS_CFG[selectedCam.status].bg,display:"flex",alignItems:"center",justifyContent:"center"}}>
                <i className="ti ti-video" style={{fontSize:20,color:CAM_STATUS_CFG[selectedCam.status].color}}/>
              </div>
              <div style={{flex:1}}>
                <div style={{color:"#fff",fontWeight:700,fontSize:15}}>{selectedCam.name}</div>
                <div style={{color:"#9BAEC8",fontSize:11}}>{selectedCam.area}, {GHANA_REGIONS.find(r=>r.id===selectedCam.region)?.name} = {selectedCam.ghanaPost}</div>
              </div>
              <span style={{fontSize:10,background:CAM_STATUS_CFG[selectedCam.status].bg,color:CAM_STATUS_CFG[selectedCam.status].color,padding:"3px 10px",borderRadius:10,fontWeight:600,marginRight:8}}>{CAM_STATUS_CFG[selectedCam.status].label}</span>
              <button onClick={()=>setSelectedCam(null)} style={{background:"none",border:"none",color:"#9BAEC8",cursor:"pointer",fontSize:22,lineHeight:1}} aria-label="Close"><i className="ti ti-x"/></button>
            </div>

            {/* Feed viewer */}
            <div style={{position:"relative",background:"#000",aspectRatio:"16/9",overflow:"hidden"}}>
              {selectedCam.status==="online"?(
                <>
                  <canvas ref={feedCanvasRef} style={{width:"100%",height:"100%",display:"block"}}/>
                  <div className="scanline"/>
                  {!camFeedPlaying&&(
                    <div style={{position:"absolute",inset:0,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",background:"rgba(0,0,0,0.6)"}}>
                      <button onClick={()=>startFeed(selectedCam)} style={{width:64,height:64,borderRadius:"50%",background:"rgba(0,200,80,0.9)",border:"none",cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",marginBottom:10}}>
                        <i className="ti ti-player-play" style={{fontSize:28,color:"#fff"}}/>
                      </button>
                      <div style={{color:"#fff",fontSize:13,fontWeight:500}}>Click to start live feed</div>
                      <div style={{color:"#9BAEC8",fontSize:11,marginTop:4}}>{selectedCam.resolution} @ {selectedCam.fps}fps = {selectedCam.coverage} coverage</div>
                    </div>
                  )}
                  {camFeedPlaying&&(
                    <div style={{position:"absolute",top:6,right:8,display:"flex",alignItems:"center",gap:5}}>
                      <div className="rec-dot"/>
                      <span style={{color:"#fff",fontSize:9,fontFamily:"monospace",fontWeight:600}}>LIVE</span>
                    </div>
                  )}
                </>
              ):(
                <div style={{position:"absolute",inset:0,display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",background:"#0a0a0a"}}>
                  <div style={{fontSize:48,marginBottom:12}}>📷</div>
                  <div style={{color:CAM_STATUS_CFG[selectedCam.status].color,fontSize:16,fontWeight:600,marginBottom:6}}>Camera {selectedCam.status==="offline"?"Offline":"Under Maintenance"}</div>
                  <div style={{color:"#777",fontSize:12,textAlign:"center",maxWidth:260,lineHeight:1.6}}>{selectedCam.status==="offline"?"Feed unavailable. The camera may be experiencing a technical fault.":"This camera is currently undergoing scheduled maintenance and will be back online shortly."}</div>
                </div>
              )}
            </div>

            {/* Controls */}
            {camFeedPlaying&&(
              <div style={{padding:"10px 16px",borderBottom:"1px solid rgba(255,255,255,0.08)",display:"flex",gap:8}}>
                <button onClick={stopFeed} style={{background:"rgba(255,255,255,0.1)",border:"1px solid rgba(255,255,255,0.2)",color:"#fff",borderRadius:6,padding:"6px 12px",cursor:"pointer",fontSize:12,display:"flex",alignItems:"center",gap:5}}>
                  <i className="ti ti-player-stop" style={{fontSize:13}}/>Stop Feed
                </button>
                <button onClick={()=>downloadFeed(selectedCam)} disabled={camDownloading} style={{background:camDownloading?"rgba(21,101,192,0.5)":"#1565C0",border:"none",color:"#fff",borderRadius:6,padding:"6px 12px",cursor:camDownloading?"default":"pointer",fontSize:12,display:"flex",alignItems:"center",gap:5,flex:1,justifyContent:"center"}}>
                  {camDownloading?(
                    <><i className="ti ti-loader-2 spin" style={{fontSize:13}}/>Downloading {camDownloadProgress}%</>
                  ):(
                    <><i className="ti ti-download" style={{fontSize:13}}/>Download Last 30 min</>
                  )}
                </button>
              </div>
            )}
            {!camFeedPlaying&&selectedCam.status==="online"&&(
              <div style={{padding:"10px 16px",borderBottom:"1px solid rgba(255,255,255,0.08)"}}>
                <button onClick={()=>downloadFeed(selectedCam)} disabled={camDownloading} style={{background:camDownloading?"rgba(21,101,192,0.5)":"#1565C0",border:"none",color:"#fff",borderRadius:6,padding:"8px 14px",cursor:camDownloading?"default":"pointer",fontSize:12,display:"flex",alignItems:"center",gap:6,width:"100%",justifyContent:"center"}}>
                  {camDownloading?(
                    <>
                      <i className="ti ti-loader-2 spin" style={{fontSize:14}}/>Downloading {camDownloadProgress}%
                      <div style={{flex:1,height:4,background:"rgba(255,255,255,0.15)",borderRadius:2,marginLeft:8,overflow:"hidden"}}>
                        <div style={{height:"100%",width:`${camDownloadProgress}%`,background:"#90CAF9",borderRadius:2,transition:"width .2s"}}/>
                      </div>
                    </>
                  ):(
                    <><i className="ti ti-download" style={{fontSize:14}}/>Download Feed (Last 30 min)</>
                  )}
                </button>
              </div>
            )}

            {/* Camera details */}
            <div style={{padding:"14px 16px"}}>
              <div style={{fontSize:12,fontWeight:600,color:"#9BAEC8",marginBottom:10,letterSpacing:1}}>CAMERA DETAILS</div>
              <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:8,marginBottom:12}}>
                {[["Camera ID",selectedCam.id.toUpperCase()],["Installed",selectedCam.installed],["Operator",selectedCam.operator],["Resolution",selectedCam.resolution+" @ "+selectedCam.fps+"fps"],["Coverage",selectedCam.coverage],["Coordinates",selectedCam.lat.toFixed(4)+", "+selectedCam.lng.toFixed(4)]].map(([l,v])=>(
                  <div key={l} style={{background:"rgba(255,255,255,0.05)",borderRadius:6,padding:"7px 10px"}}>
                    <div style={{fontSize:9,color:"#9BAEC8",marginBottom:2}}>{l}</div>
                    <div style={{fontSize:11,color:"#fff",fontWeight:500}}>{v}</div>
                  </div>
                ))}
              </div>
              {selectedCam.incidents_nearby>0&&(
                <div style={{background:"rgba(244,67,54,0.12)",border:"1px solid rgba(244,67,54,0.3)",borderRadius:8,padding:"8px 12px",marginBottom:12,display:"flex",alignItems:"center",gap:8}}>
                  <i className="ti ti-alert-triangle" style={{color:"#F44336",fontSize:16}}/>
                  <div>
                    <div style={{color:"#F44336",fontSize:12,fontWeight:600}}>{selectedCam.incidents_nearby} incident(s) reported within camera range</div>
                    <div style={{color:"#9BAEC8",fontSize:10,marginTop:2}}>Review incident reports for this area in the Incidents tab</div>
                  </div>
                </div>
              )}
              <button onClick={()=>{setTab("incidents");setFr(selectedCam.region);setSelectedCam(null);}} style={{background:"rgba(255,255,255,0.08)",border:"1px solid rgba(255,255,255,0.15)",color:"#fff",borderRadius:8,padding:"9px 14px",cursor:"pointer",fontSize:12,width:"100%",display:"flex",alignItems:"center",justifyContent:"center",gap:6}}>
                <i className="ti ti-list" style={{fontSize:14}}/>View Incidents in This Region
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ==== SEND ALERT MODAL ==== */}
      {/* - Splash Screen - */}
      {showSplash&&(
        <div style={{position:"fixed",inset:0,zIndex:9999,background:"linear-gradient(135deg,#0A1628 0%,#0D2137 50%,#0A1628 100%)",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",padding:"40px 24px",boxSizing:"border-box"}}>
          <style>{`
            @keyframes fadeUp{from{opacity:0;transform:translateY(24px)}to{opacity:1;transform:translateY(0)}}
            .splash-fade{animation:fadeUp .7s ease forwards;opacity:0}
            .splash-feature{display:flex;align-items:center;gap:14px;padding:16px 20px;background:rgba(255,255,255,0.06);border:1px solid rgba(255,255,255,0.1);border-radius:12px;color:#fff;transition:background .2s,border .2s;cursor:pointer;}
            .splash-feature:hover{background:rgba(252,209,22,0.1);border-color:rgba(252,209,22,0.3);}
          `}</style>

          {/* Logo */}
          <div className="splash-fade" style={{display:"flex",alignItems:"center",gap:16,marginBottom:12,animationDelay:".1s"}}>
            <div style={{width:64,height:64,borderRadius:18,background:"linear-gradient(135deg,#CE1126,#8B0000)",display:"flex",alignItems:"center",justifyContent:"center",boxShadow:"0 0 40px rgba(206,17,38,0.5)"}}>
              <i className="ti ti-shield-check" style={{fontSize:34,color:"#FCD116"}}/>
            </div>
            <div>
              <div style={{color:"#FCD116",fontSize:32,fontWeight:800,letterSpacing:-1}}>mysafeghana</div>
              <div style={{color:"#9BAEC8",fontSize:13,marginTop:2}}>Your Community Safety Platform · Ghana</div>
            </div>
          </div>

          <div className="splash-fade" style={{color:"#556B8A",fontSize:13,marginBottom:36,textAlign:"center",animationDelay:".3s"}}>
            Real-time safety intelligence for all 16 regions
          </div>

          {/* Feature grid */}
          <div className="splash-fade" style={{display:"grid",gridTemplateColumns:"repeat(2,1fr)",gap:12,width:"min(640px,100%)",marginBottom:36,animationDelay:".5s"}}>
            {[
              {icon:"ti-map-pin",label:"Live Incident Map",sub:"Real-time crime & flood tracking",tab:"map"},
              {icon:"ti-bell-ringing",label:"Public Safety Alerts",sub:"Instant emergency notifications",tab:"alerts"},
              {icon:"ti-layout-dashboard",label:"My Dashboard",sub:"Personalised safety overview",tab:"mydash"},
              {icon:"ti-video",label:"CCTV Cameras",sub:"Live surveillance network",tab:"cameras"},
              {icon:"ti-droplet",label:"Flood Video Reports",sub:"Community-submitted footage",tab:"floods"},
              {icon:"ti-sos",label:"Emergency Numbers",sub:"Ghana SOS & emergency contacts",tab:"sos"},
            ].map((f,i)=>(
              <div key={i} className="splash-feature"
                onClick={()=>{setTab(f.tab);setShowSplash(false);}}>
                <div style={{width:40,height:40,borderRadius:10,background:"rgba(252,209,22,0.15)",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0}}>
                  <i className={`ti ${f.icon}`} style={{color:"#FCD116",fontSize:20}}/>
                </div>
                <div>
                  <div style={{color:"#fff",fontSize:13,fontWeight:600}}>{f.label}</div>
                  <div style={{color:"#556B8A",fontSize:11,marginTop:2}}>{f.sub}</div>
                </div>
              </div>
            ))}
          </div>

          {/* CTAs */}
          <div className="splash-fade" style={{display:"flex",gap:14,flexWrap:"wrap",justifyContent:"center",animationDelay:".7s"}}>
            <button onClick={()=>{setShowSplash(false);setShowOnboarding(true);}} style={{background:"linear-gradient(135deg,#FCD116,#F9A825)",border:"none",color:"#0A1628",borderRadius:28,padding:"14px 40px",fontSize:15,fontWeight:800,cursor:"pointer",boxShadow:"0 4px 24px rgba(252,209,22,0.4)"}}>
              <i className="ti ti-map" style={{marginRight:8}}/>Explore the Map
            </button>
            <button onClick={()=>{setShowSplash(false);setShowDemoModal(true);}} style={{background:"transparent",border:"1.5px solid rgba(252,209,22,0.4)",color:"#FCD116",borderRadius:28,padding:"14px 36px",fontSize:15,fontWeight:600,cursor:"pointer"}}>
              <i className="ti ti-presentation" style={{marginRight:8}}/>Request a Demo
            </button>
          </div>

          <div style={{color:"#2A3A50",fontSize:11,marginTop:24}}>Powered by <span style={{color:"#FCD116"}}>clickitsystems ltd.</span></div>
        </div>
      )}

      {/* - Request Demo Modal - */}
      {showDemoModal&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:3500,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={()=>setShowDemoModal(false)}>
          <div style={{background:"#fff",borderRadius:16,padding:24,width:"100%",maxWidth:500,maxHeight:"90vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
            {!demoSent?(<>
              <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:20}}>
                <div style={{width:44,height:44,borderRadius:12,background:"linear-gradient(135deg,#CE1126,#8B0000)",display:"flex",alignItems:"center",justifyContent:"center"}}>
                  <i className="ti ti-presentation" style={{color:"#FCD116",fontSize:22}}/>
                </div>
                <div>
                  <div style={{fontSize:18,fontWeight:800,color:"#0A1628"}}>Request a Demo</div>
                  <div style={{fontSize:11,color:"#888",marginTop:1}}>See mysafeghana in action for your organisation</div>
                </div>
                <button onClick={()=>setShowDemoModal(false)} style={{marginLeft:"auto",background:"none",border:"none",fontSize:20,cursor:"pointer",color:"#aaa"}}>×</button>
              </div>
              {[
                {key:"name",label:"Full Name *",placeholder:"e.g. Kwame Mensah",type:"text"},
                {key:"org",label:"Organisation *",placeholder:"e.g. Ghana Police Service, NADMO, City of Accra"},
                {key:"email",label:"Email Address *",placeholder:"your@email.com",type:"email"},
                {key:"phone",label:"Phone / WhatsApp",placeholder:"+233 XX XXX XXXX",type:"tel"},
              ].map(f=>(
                <div key={f.key} style={{marginBottom:12}}>
                  <label style={{fontSize:11,fontWeight:600,color:"#444",display:"block",marginBottom:4}}>{f.label}</label>
                  <input type={f.type||"text"} placeholder={f.placeholder} value={demoForm[f.key]}
                    onChange={e=>setDemoForm(p=>({...p,[f.key]:e.target.value}))}
                    style={{width:"100%",padding:"9px 12px",border:"1.5px solid #e0e0e0",borderRadius:8,fontSize:12,boxSizing:"border-box",outline:"none"}}/>
                </div>
              ))}
              <div style={{marginBottom:16}}>
                <label style={{fontSize:11,fontWeight:600,color:"#444",display:"block",marginBottom:4}}>How can mysafeghana help you?</label>
                <textarea placeholder="Tell us about your safety monitoring needs..." value={demoForm.message}
                  onChange={e=>setDemoForm(p=>({...p,message:e.target.value}))}
                  rows={3} style={{width:"100%",padding:"9px 12px",border:"1.5px solid #e0e0e0",borderRadius:8,fontSize:12,boxSizing:"border-box",resize:"vertical",outline:"none"}}/>
              </div>
              <button disabled={!demoForm.name||!demoForm.org||!demoForm.email||demoSending}
                onClick={async()=>{
                  if(!demoForm.name||!demoForm.org||!demoForm.email)return;
                  setDemoSending(true);
                  // Send via WhatsApp API link + store locally
                  const msg=`🛡️ *mysafeghana Demo Request*\n\n*Name:* ${demoForm.name}\n*Organisation:* ${demoForm.org}\n*Email:* ${demoForm.email}\n*Phone:* ${demoForm.phone||"N/A"}\n*Message:* ${demoForm.message||"N/A"}`;
                  try{await fetch(`https://api.mysafeghana.com/api/public/demo-request`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(demoForm)});}catch(e){}
                  setTimeout(()=>{setDemoSending(false);setDemoSent(true);},800);
                }}
                style={{width:"100%",background:demoForm.name&&demoForm.org&&demoForm.email?"linear-gradient(135deg,#CE1126,#8B0000)":"#ccc",color:"#fff",border:"none",borderRadius:10,padding:"13px",fontSize:14,fontWeight:700,cursor:demoForm.name&&demoForm.org&&demoForm.email?"pointer":"not-allowed",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
                {demoSending?<><i className="ti ti-loader-2 spin"/>Sending...</>:<><i className="ti ti-send"/>Submit Demo Request</>}
              </button>
              <button onClick={goBack} style={{width:"100%",marginTop:8,background:"#F5F5F5",border:"1px solid #ddd",color:"#555",borderRadius:8,padding:"11px",fontSize:13,fontWeight:600,cursor:"pointer",display:"flex",alignItems:"center",justifyContent:"center",gap:6}}>
                <i className="ti ti-arrow-left" style={{fontSize:14}}/>Cancel
              </button>
            </>):(
              <div style={{textAlign:"center",padding:"24px 0"}}>
                <div style={{width:64,height:64,borderRadius:"50%",background:"#E8F5E9",display:"flex",alignItems:"center",justifyContent:"center",margin:"0 auto 16px"}}>
                  <i className="ti ti-check" style={{fontSize:32,color:"#2E7D32"}}/>
                </div>
                <div style={{fontSize:18,fontWeight:800,color:"#0A1628",marginBottom:8}}>Request Received!</div>
                <div style={{fontSize:12,color:"#666",marginBottom:20,lineHeight:1.6}}>
                  Thank you, <b>{demoForm.name}</b>. Our team will contact you within 24 hours to schedule your personalised demo.
                </div>
                <a href={`https://wa.me/233552242244?text=${encodeURIComponent(`Hi, I just submitted a demo request for mysafeghana. My name is ${demoForm.name} from ${demoForm.org}.`)}`}
                  target="_blank" rel="noopener noreferrer"
                  style={{display:"inline-flex",alignItems:"center",gap:8,background:"#25D366",color:"#fff",borderRadius:10,padding:"10px 20px",fontSize:13,fontWeight:600,textDecoration:"none",marginBottom:12}}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="#fff"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                  Chat on WhatsApp
                </a>
                <br/>
                <button onClick={()=>{setShowDemoModal(false);setDemoSent(false);setDemoForm({name:"",org:"",email:"",phone:"",message:""});}}
                  style={{background:"none",border:"1px solid #ddd",borderRadius:8,padding:"8px 20px",cursor:"pointer",fontSize:12,color:"#666"}}>
                  Close
                </button>
              </div>
            )}
          </div>
        </div>
      )}

      {showAlertModal&&isAdmin&&(
        <div style={{position:"fixed",inset:0,background:"rgba(0,0,0,0.65)",zIndex:2000,display:"flex",alignItems:"center",justifyContent:"center",padding:16}} onClick={()=>setShowAlertModal(false)}>
          <div style={{background:"#fff",borderRadius:16,padding:20,width:"100%",maxWidth:580,maxHeight:"90vh",overflowY:"auto"}} onClick={e=>e.stopPropagation()}>
            <div style={{display:"flex",alignItems:"center",gap:10,marginBottom:4}}>
              <div style={{width:36,height:36,borderRadius:10,background:"#E65100",display:"flex",alignItems:"center",justifyContent:"center"}}><i className="ti ti-bell-plus" style={{color:"#fff",fontSize:20}}/></div>
              <div>
                <div style={{fontSize:16,fontWeight:700}}>Send Public Safety Alert</div>
                <div style={{fontSize:11,color:"#777"}}>Alert will trigger a unique notification sound</div>
              </div>
              <button onClick={()=>setShowAlertModal(false)} style={{marginLeft:"auto",background:"none",border:"none",cursor:"pointer",fontSize:22,color:"#999",lineHeight:1}} aria-label="Close"><i className="ti ti-x"/></button>
            </div>

            {/* Step 1: Alert type */}
            <div style={{background:"#f9f9f9",borderRadius:10,padding:14,marginBottom:14,border:"1px solid #eee"}}>
              <div style={{fontSize:12,fontWeight:700,color:"#333",marginBottom:12}}>1. Select Alert Type</div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(130px,1fr))",gap:8}}>
                {ALERT_TYPES.map(at=>(
                  <button key={at.id} className={`alert-type-btn${alertType?.id===at.id?" selected":""}`}
                    style={{borderColor:alertType?.id===at.id?at.color:"#e0e0e0",background:alertType?.id===at.id?at.bg:"#fff"}}
                    onClick={()=>setAlertType(at)}>
                    <i className={`ti ${at.icon}`} style={{fontSize:22,color:at.color,display:"block",marginBottom:5}}/>
                    <div style={{fontSize:11,fontWeight:600,color:alertType?.id===at.id?at.color:"#333",lineHeight:1.3}}>{at.label}</div>
                    <div style={{fontSize:9,color:"#999",marginTop:3,padding:"1px 6px",background:SEV_BG[at.severity],borderRadius:8,display:"inline-block",color:SEV_COLOR[at.severity],fontWeight:600}}>{SEV_LABEL[at.severity]}</div>
                  </button>
                ))}
              </div>
            </div>

            {/* Step 2: Regions */}
            <div style={{background:"#f9f9f9",borderRadius:10,padding:14,marginBottom:14,border:"1px solid #eee"}}>
              <div style={{fontSize:12,fontWeight:700,color:"#333",marginBottom:10}}>2. Target Regions <span style={{fontWeight:400,color:"#999"}}>(leave blank = all Ghana)</span></div>
              <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(130px,1fr))",gap:6}}>
                {GHANA_REGIONS.map(r=>{
                  const sel=alertRegions.includes(r.name);
                  return(<button key={r.id} onClick={()=>setAlertRegions(prev=>sel?prev.filter(x=>x!==r.name):[...prev,r.name])} style={{padding:"6px 8px",border:`1.5px solid ${sel?"#006B3F":"#ddd"}`,borderRadius:7,background:sel?"#E8F5E9":"#fff",color:sel?"#006B3F":"#555",fontSize:11,cursor:"pointer",fontWeight:sel?600:400,transition:"all .15s"}}>
                    {sel&&<i className="ti ti-check" style={{fontSize:10,marginRight:3}}/>}{r.name}
                  </button>);
                })}
              </div>
            </div>

            {/* Step 3: Custom message */}
            <div style={{background:"#f9f9f9",borderRadius:10,padding:14,marginBottom:16,border:"1px solid #eee"}}>
              <div style={{fontSize:12,fontWeight:700,color:"#333",marginBottom:8}}>3. Alert Message <span style={{fontWeight:400,color:"#999"}}>(optional - auto-filled from type)</span></div>
              {alertType&&<div style={{fontSize:11,color:"#888",marginBottom:8,background:alertType.bg,padding:"6px 10px",borderRadius:6,border:`1px solid ${alertType.color}22`}}>Default: {alertType.desc}</div>}
              <textarea value={alertMsg} onChange={e=>setAlertMsg(e.target.value)} placeholder={alertType?alertType.desc:"Select an alert type first="} rows={3} style={{width:"100%",fontSize:12}}/>
            </div>

            {/* Preview */}
            {alertType&&(
              <div style={{background:SEV_BG[alertType.severity],border:`2px solid ${SEV_COLOR[alertType.severity]}`,borderRadius:10,padding:"12px 14px",marginBottom:16,display:"flex",alignItems:"center",gap:10}}>
                <i className={`ti ${alertType.icon}`} style={{fontSize:24,color:SEV_COLOR[alertType.severity],flexShrink:0}}/>
                <div>
                  <div style={{fontSize:12,fontWeight:700,color:SEV_COLOR[alertType.severity]}}>{SEV_LABEL[alertType.severity]} = {alertType.label}</div>
                  <div style={{fontSize:11,color:"#333",marginTop:2}}>{alertMsg||alertType.desc}</div>
                  <div style={{fontSize:10,color:"#888",marginTop:2}}>= {alertRegions.length>0?alertRegions.join(", "):"All regions of Ghana"}</div>
                </div>
                <div style={{marginLeft:"auto",textAlign:"center",flexShrink:0}}>
                  <i className="ti ti-volume" style={{fontSize:18,color:SEV_COLOR[alertType.severity],display:"block"}}/>
                  <div style={{fontSize:9,color:"#888",marginTop:2}}>Sound: {alertType.sound}</div>
                </div>
              </div>
            )}

            <button onClick={sendAlert} disabled={!alertType||alertSending} style={{...S.btn(alertType?SEV_COLOR[alertType?.severity||"advisory"]:"#aaa"),opacity:alertType?1:0.5,fontSize:14,padding:"12px",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}>
              {alertSending?<><i className="ti ti-loader-2 spin" style={{fontSize:16}}/>Sending Alert</>:<><i className="ti ti-bell-ringing" style={{fontSize:16}}/>Send Alert Now</>}
            </button>
          </div>
        </div>
      )}

      {/* Footer */}
      <div style={{background:"#0A1628",padding:"16px 20px",marginTop:"auto",borderTop:"1px solid rgba(255,255,255,0.08)"}}>
        <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",flexWrap:"wrap",gap:10}}>
          <div style={{display:"flex",alignItems:"center",gap:8}}>
            <div style={{width:24,height:24,borderRadius:6,background:"#CE1126",display:"flex",alignItems:"center",justifyContent:"center"}}>
              <i className="ti ti-shield-check" style={{color:"#fff",fontSize:12}}/>
            </div>
            <div>
              <div style={{color:"#fff",fontSize:12,fontWeight:600}}>mysafeghana</div>
              <div style={{color:"#556",fontSize:9}}>mysafeghana.com</div>
            </div>
          </div>
          <div style={{display:"flex",gap:16,flexWrap:"wrap"}}>
            {["About","Privacy Policy","Terms of Use","Contact Us","Report a Problem"].map(l=>(
              <span key={l} style={{color:"#556",fontSize:10,cursor:"pointer"}}>{l}</span>
            ))}
          </div>
          <div style={{color:"#333",fontSize:9}}>© 2025 mysafeghana · All 16 Regions of Ghana</div>
        </div>
        {/* Powered by */}
        <div style={{borderTop:"1px solid rgba(255,255,255,0.05)",marginTop:10,paddingTop:8,display:"flex",alignItems:"center",gap:6,color:"#445",fontSize:9}}>
          <span>{t("poweredBy")}</span>
          <span style={{color:"#FCD116",fontWeight:700}}>clickitsystems ltd.</span>
          <span>·</span>
          <span>4 Kojo Sro Link</span>
          <span>·</span>
          <a href="https://wa.me/233552242244" target="_blank" rel="noopener noreferrer"
            style={{display:"flex",alignItems:"center",gap:4,color:"#25D366",textDecoration:"none",fontWeight:600,fontSize:9}}>
            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="#25D366"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
            +233552242244
          </a>
        </div>
      </div>
    </div>
  );
}
